webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/R5cFjP/%3F1733037878617&title=Spider%20Webs&summary=In%20this%20lavishly%20illustrated%2C%20first-ever%20book%20on%20how%20spider%20webs%20are%20built%2C%20function%2C%20and%20evolved%2C%20William%20Eberhard%20provides%20a%20comprehensive%20overview%20of%20spider%20functional%20morphology%20and%20behavior%20related%20to%20web%20building%2C%20and%20of%20the%20surprising%20physical%20agil&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/R5cFjP/%3F1733037878617",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=In%20this%20lavishly%20illustrated%2C%20first-ever%20book%20on%20how%20spider%20webs%20are%20built%2C%20function%2C%20and%20evolved%2C%20William%20Eberhard%20provides%20a%20comprehensive%20ove%0Dhttps://textcafe.co/books/R5cFjP/%3F1733037878617&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/R5cFjP/%3F1733037878617&posttype=link&caption=In%20this%20lavishly%20illustrated%2C%20first-ever%20book%20on%20how%20spider%20webs%20are%20built%2C%20function%2C%20and%20evolved%2C%20William%20Eberhard%20provides%20a%20comprehensive%20overview%20of%20spider%20functional%20morphology%20and%20behavior%20related%20to%20web%20building%2C%20and%20of%20the%20surprising%20physical%20agil",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/R5cFjP/%3F1733037878617&description=In%20this%20lavishly%20illustrated%2C%20first-ever%20book%20on%20how%20spider%20webs%20are%20built%2C%20function%2C%20and%20evolved%2C%20William%20Eberhard%20provides%20a%20comprehensive%20overview%20of%20spider%20functional%20morphology%20and%20behavior%20related%20to%20web%20building%2C%20and%20of%20the%20surprising%20physical%20agil&media=https://textcafe.co/books/R5cFjP/tc-custom/9780226534749.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9780226534749&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=FpAEEAAAQBAJ&amp;rdid=book-FpAEEAAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9780226534749').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/R5cFjP/tc-custom/9780226534749.jpg?1733037878617',
        alt: 'Spider Webs'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "chi-eberhard-0001", "chi-eberhard-0002", "chi-eberhard-0003", "chi-eberhard-0004", "chi-eberhard-0005", "chi-eberhard-0006", "chi-eberhard-0007", "chi-eberhard-0008", "chi-eberhard-0009", "chi-eberhard-0010", "chi-eberhard-0011", "chi-eberhard-0012", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/R5cFjP/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_chi_eberhard_0001__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_chi_eberhard_0001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_chi_eberhard_0001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_chi_eberhard_0002__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_chi_eberhard_0002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_chi_eberhard_0002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_chi_eberhard_0003__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_chi_eberhard_0003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_chi_eberhard_0003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_chi_eberhard_0004__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_chi_eberhard_0004___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_chi_eberhard_0004__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_chi_eberhard_0005__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_chi_eberhard_0005___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_chi_eberhard_0005__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_chi_eberhard_0006__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_chi_eberhard_0006___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_chi_eberhard_0006__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_chi_eberhard_0007__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_chi_eberhard_0007___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_chi_eberhard_0007__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_chi_eberhard_0008__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_chi_eberhard_0008___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_chi_eberhard_0008__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_chi_eberhard_0009__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_chi_eberhard_0009___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_chi_eberhard_0009__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_chi_eberhard_0010__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_chi_eberhard_0010___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_chi_eberhard_0010__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_chi_eberhard_0011__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_chi_eberhard_0011___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_chi_eberhard_0011__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_chi_eberhard_0012__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_chi_eberhard_0012___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_chi_eberhard_0012__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_chi_eberhard_0013__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_chi_eberhard_0013___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_chi_eberhard_0013__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_chi_eberhard_0014__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_chi_eberhard_0014___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_chi_eberhard_0014__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_chi_eberhard_0015__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_chi_eberhard_0015___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_chi_eberhard_0015__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_chi_eberhard_0016__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_chi_eberhard_0016___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_chi_eberhard_0016__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_chi_eberhard_0017__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_chi_eberhard_0017___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_chi_eberhard_0017__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_chi_eberhard_0018__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_chi_eberhard_0018___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_chi_eberhard_0018__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_chi_eberhard_0019__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_chi_eberhard_0019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_chi_eberhard_0019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_chi_eberhard_0020__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_chi_eberhard_0020___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_chi_eberhard_0020__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_chi_eberhard_0021__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_chi_eberhard_0021___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_chi_eberhard_0021__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_chi_eberhard_0022__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_chi_eberhard_0022___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_chi_eberhard_0022__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_chi_eberhard_0023__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_chi_eberhard_0023___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_chi_eberhard_0023__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_chi_eberhard_0024__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_chi_eberhard_0024___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_chi_eberhard_0024__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_chi_eberhard_0025__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_chi_eberhard_0025___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_chi_eberhard_0025__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_chi_eberhard_0026__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_chi_eberhard_0026___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_chi_eberhard_0026__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_chi_eberhard_0027__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_chi_eberhard_0027___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_chi_eberhard_0027__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_chi_eberhard_0028__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_chi_eberhard_0028___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_chi_eberhard_0028__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_chi_eberhard_0029__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_chi_eberhard_0029___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_chi_eberhard_0029__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_chi_eberhard_0030__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_chi_eberhard_0030___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_chi_eberhard_0030__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_chi_eberhard_0031__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_chi_eberhard_0031___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_chi_eberhard_0031__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_chi_eberhard_0032__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_chi_eberhard_0032___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_chi_eberhard_0032__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_last__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_last__);
/*jshint esversion: 6 */







































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/chi-eberhard-0001",
    "name": "chi-eberhard-0001",
    "component": __WEBPACK_IMPORTED_MODULE_4__components_chi_eberhard_0001___default.a
  }, {
    "path": "/chi-eberhard-0002",
    "name": "chi-eberhard-0002",
    "component": __WEBPACK_IMPORTED_MODULE_5__components_chi_eberhard_0002___default.a
  }, {
    "path": "/chi-eberhard-0003",
    "name": "chi-eberhard-0003",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_chi_eberhard_0003___default.a
  }, {
    "path": "/chi-eberhard-0004",
    "name": "chi-eberhard-0004",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_chi_eberhard_0004___default.a
  }, {
    "path": "/chi-eberhard-0005",
    "name": "chi-eberhard-0005",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_chi_eberhard_0005___default.a
  }, {
    "path": "/chi-eberhard-0006",
    "name": "chi-eberhard-0006",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_chi_eberhard_0006___default.a
  }, {
    "path": "/chi-eberhard-0007",
    "name": "chi-eberhard-0007",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_chi_eberhard_0007___default.a
  }, {
    "path": "/chi-eberhard-0008",
    "name": "chi-eberhard-0008",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_chi_eberhard_0008___default.a
  }, {
    "path": "/chi-eberhard-0009",
    "name": "chi-eberhard-0009",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_chi_eberhard_0009___default.a
  }, {
    "path": "/chi-eberhard-0010",
    "name": "chi-eberhard-0010",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_chi_eberhard_0010___default.a
  }, {
    "path": "/chi-eberhard-0011",
    "name": "chi-eberhard-0011",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_chi_eberhard_0011___default.a
  }, {
    "path": "/chi-eberhard-0012",
    "name": "chi-eberhard-0012",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_chi_eberhard_0012___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_36__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      William Eberhard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("William Eberhard")]), _vm._v(" is an emeritus scientist at the Smithsonian Tropical Research Institute in Panama and emeritus professor at the Universidad de Costa Rica.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/R5cFjP/tc-custom/9780226534749.jpg?1733037878617",
      "alt": "This image is the cover for the book Spider Webs"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Spider Webs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this lavishly illustrated, first-ever book on how spider webs are built, function, and evolved, William Eberhard provides a comprehensive overview of spider functional morphology and behavior related to web building, and of the surprising physical agility and mental abilities of orb weavers. For instance, one spider spins more than three precisely spaced, morphologically complex spiral attachments per second for up to fifteen minutes at a time. Spiders even adjust the mechanical properties of their famously strong silken lines to different parts of their webs and different environments, and make dramatic modifications in orb designs to adapt to available spaces. This extensive adaptive flexibility, involving decisions influenced by up to sixteen different cues, is unexpected in such small, supposedly simple animals."), _c('br'), _c('br'), _vm._v(" As Eberhard reveals, the extraordinary diversity of webs includes ingenious solutions to gain access to prey in esoteric habitats, from blazing hot and shifting sand dunes (to capture ants) to the surfaces of tropical lakes (to capture water striders). Some webs are nets that are cast onto prey, while others form baskets into which the spider flicks prey. Some aerial webs are tramways used by spiders searching for chemical cues from their prey below, while others feature landing sites for flying insects and spiders where the spider then stalks its prey. In some webs, long trip lines are delicately sustained just above the ground by tiny rigid silk poles."), _c('br'), _c('br'), _vm._v(" Stemming from the author’s more than five decades observing spider webs, this book will be the definitive reference for years to come.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "cover",
      "id": "cvi"
    }
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "role": "doc-cover",
      "src": "images/chi-eberhard-cover.jpg"
    }
  })])])])])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "halftitlepage",
      "id": "bkht"
    }
  }, [_c('h1', {
    staticClass: "bkht"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "i",
      "id": "pi",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Spider Webs")])])])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "frontispiece",
      "role": "doc-chapter"
    }
  }, [_c('figure', {
    staticClass: "figure"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "436",
      "src": "images/chi-eberhard-frontispiece.jpeg",
      "width": "600"
    }
  })])])])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "titlepage",
      "id": "bk"
    }
  }, [_c('h1', {
    staticClass: "bk"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "ii",
      "id": "pii",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "iii",
      "id": "piii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Spider Webs")]), _vm._v(" "), _c('h1', {
    staticClass: "bk1"
  }, [_vm._v("Behavior, Function, and Evolution")]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("William Eberhard")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_vm._v("The University of Chicago Press")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_vm._v("Chicago and London")])])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "iv",
      "id": "piv",
      "role": "doc-pagebreak"
    }
  }), _c('b', [_vm._v("Frontispiece:")]), _vm._v(" The recently discovered “pseudo-orb” of the New Guinean psechrid "), _c('i', [_vm._v("Fecenia ochracea")]), _vm._v(" is a spectacular example of a major theme of this book, evolutionary convergence. Although the spider is not closely related to the “true” orb weavers (Orbiculariae) its web shares with orbs a planar, aerial array of non-sticky radial lines that converge on a hub, frame lines that support the radii, and a uniformly spaced array of more or less circular sticky lines laid on the radii. The recent nature of this discovery, and the mystery of the ribbon-like nature of the sticky lines in the inner portion of the web (such band-like cribellum lines have never been described in any other species) emphasize a second general theme: our knowledge of spider webs (especially non-orb webs) is still profoundly incomplete (from Agnarsson et al. 2012; courtesy Ingi Agnarsson)")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "piv"
    }
  }), _vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Cover design and text design © 2020 The University of Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("All rights reserved. No copyright is claimed for the original text of "), _c('i', [_vm._v("Spider Webs: Behavior, Function, and Evolution")]), _vm._v(", although some text and illustrations included in the book may be copyright protected.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Published 2020")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("29 28 27 26 25 24 23 22 21 20 1 2 3 4 5")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-53460-2 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-53474-9 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("DOI")]), _vm._v(": "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://doi.org/10.7208/chicago/9780226534749.001.0001",
      "target": "_blank"
    }
  }, [_vm._v("https://doi.org/10.7208/chicago/9780226534749.001.0001")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Additional parts of this large project are archived online at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.press.uchicago.edu/sites/eberhard/",
      "target": "_blank"
    }
  }, [_vm._v("press.uchicago.edu/sites/eberhard/")]), _vm._v("; these portions are designated in the text with a capital O followed by the book chapter to which they refer (e.g., section O6.1; table O3.3; fig. O9.1).")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Names: Eberhard, William G., author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: Spider webs : behavior, function, and evolution / William Eberhard.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: Chicago : University of Chicago Press, 2020. | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LCCN")]), _vm._v(" 2019050065 | "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 9780226534602 (cloth) | "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 9780226534749 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LCSH")]), _vm._v(": Spider webs. | Spiders—Behavior.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LCC")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("QL")]), _vm._v("458.4 ."), _c('span', {
    staticClass: "sm"
  }, [_vm._v("E")]), _vm._v("24 2020 | "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DDC")]), _vm._v(" 595.4/4156—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("LC")]), _vm._v(" record available at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://lccn.loc.gov/2019050065",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2019050065")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("♾ This paper meets the requirements of "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ANSI/NISO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("Z")]), _vm._v("39.48-1992 (Permanence of Paper).")])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "dedication",
      "id": "ded",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "dedf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "v",
      "id": "pv",
      "role": "doc-pagebreak"
    }
  }), _c('i', [_vm._v("To the memory of three great naturalists of web-building spiders:")])]), _vm._v(" "), _c('p', {
    staticClass: "dedf"
  }, [_vm._v("R"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EV.")]), _vm._v(" H"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" M"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("C")]), _vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OOK,")]), _vm._v(" M"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AJ.")]), _vm._v(" R"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" W"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" G"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" H"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("INGSTON,")]), _vm._v(" "), _c('i', [_vm._v("and")]), _vm._v(" E"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" N"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IELSEN")])])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "epigraph",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("A Noiseless patient spider")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("A noiseless, patient spider,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("I mark’d, where, on a little promontory, it stood, isolated;")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("Mark’d how, to explore the vacant, vast surrounding,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("It lauch’d forth filament, filament, filament, out of itself;")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("Ever unreeling them—ever tirelessly speeding them.")]), _vm._v(" "), _c('p', {
    staticClass: "slf"
  }, [_vm._v("And you, O my Soul, where you stand,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("Surrounded, surrounded, in measureless oceans of space,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("Ceaselessly musing, venturing, throwing,—seeking spheres, to connect them;")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("Till the bridge you will need, be form’d—till the ductile anchor hold;")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("Till the gossamer thread you fling, catch somewhere, O my Soul.")]), _vm._v(" "), _c('p', {
    staticClass: "slt"
  }, [_vm._v("—Walt Whitman")])])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "viii",
      "id": "pviii",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "ix",
      "id": "pix",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#ch01"
    }
  }, [_vm._v("Chapter 1. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec01.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#sec01.01"
    }
  }, [_vm._v("1.1 Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec01.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#sec01.02"
    }
  }, [_vm._v("1.2 A foreign world: life tied to silk lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec01.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#sec01.03"
    }
  }, [_vm._v("1.3 A brief history of spider web studies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec01.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#sec01.04"
    }
  }, [_vm._v("1.4 Emphasis on behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec01.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#sec01.05"
    }
  }, [_vm._v("1.5 The scope of this book and tactics in presentation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec01.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#sec01.06"
    }
  }, [_vm._v("1.6 Evolutionary history and phylogeny")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec01.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#sec01.07"
    }
  }, [_vm._v("1.7 Terminology and other procedural matters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec01.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#sec01.08"
    }
  }, [_vm._v("1.8 Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#ch02"
    }
  }, [_vm._v("Chapter 2. The “hardware” of web-building spiders: morphology, silk, and behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.01"
    }
  }, [_vm._v("2.1 Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02"
    }
  }, [_vm._v("2.2 Silk glands and silk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.01"
    }
  }, [_vm._v("2.2.1 Origins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.02"
    }
  }, [_vm._v("2.2.2 Mechanical properties and how they are determined")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.03"
    }
  }, [_vm._v("2.2.3 Major ampullate glands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.02.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.04"
    }
  }, [_vm._v("2.2.4 Minor ampullate glands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.02.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.05"
    }
  }, [_vm._v("2.2.5 Aciniform glands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.02.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.06"
    }
  }, [_vm._v("2.2.6 Flagelliform glands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.02.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.07"
    }
  }, [_vm._v("2.2.7 Pseudoflagelliform glands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.02.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.08"
    }
  }, [_vm._v("2.2.8 Sticky silk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec02.02.08.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.08.01"
    }
  }, [_vm._v("2.2.8.1 Cribellum glands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec02.02.08.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.08.02"
    }
  }, [_vm._v("2.2.8.2 Aggregate glands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec02.02.08.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.08.03"
    }
  }, [_vm._v("2.2.8.3 Venom glands that produce contractile sticky “webs” in Scytodidae")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec02.02.08.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.08.04"
    }
  }, [_vm._v("2.2.8.4 Ampullate glands in "), _c('i', [_vm._v("Loxosceles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.02.09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.09"
    }
  }, [_vm._v("2.2.9 Piriform glands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec02.02.09.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.09.01"
    }
  }, [_vm._v("2.2.9.1 Spinneret morphology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec02.02.09.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.09.02"
    }
  }, [_vm._v("2.2.9.2 Morphology of attachment discs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec02.02.09.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.09.03"
    }
  }, [_vm._v("2.2.9.3 Different attachment disc morphologies result from spinneret behavior and morphology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec02.02.09.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.09.04"
    }
  }, [_vm._v("2.2.9.4 The “piriform queen”—"), _c('i', [_vm._v("Cyrtophora citricola")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.02.10"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.10"
    }
  }, [_vm._v("2.2.10 Epiandrous glands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.02.11"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.11"
    }
  }, [_vm._v("2.2.11 Other products associated with silk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.02.12"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.12"
    }
  }, [_vm._v("2.2.12 Control of rates of silk secretion in glands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.02.13"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.13"
    }
  }, [_vm._v("2.2.13 Forming bridge lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.03"
    }
  }, [_vm._v("2.3 Spinnerets as high-precision instruments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.03.01"
    }
  }, [_vm._v("2.3.1 Ancestral morphology and behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.03.02"
    }
  }, [_vm._v("2.3.2 Strategic placements of spigots on the spinnerets of araneomorphs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec02.03.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.03.02.01"
    }
  }, [_vm._v("2.3.2.1 General considerations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec02.03.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.03.02.02"
    }
  }, [_vm._v("2.3.2.2 Special cases involving web designs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec02.03.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.03.02.03"
    }
  }, [_vm._v("2.3.2.3 Additional complications")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.03.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.03.03"
    }
  }, [_vm._v("2.3.3 Phylogenetic inertia?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.03.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.03.04"
    }
  }, [_vm._v("2.3.4 Behavior of the spinnerets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.03.05"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "x",
      "id": "px",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.03.05"
    }
  }, [_vm._v("2.3.5 How are lines terminated?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec02.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.04"
    }
  }, [_vm._v("2.4 Leg morphology and behavior: grasping lines precisely and securely")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.04.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.04.01"
    }
  }, [_vm._v("2.4.1 Grasping lines in a web; tarsal morphology and leg movements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.04.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.04.02"
    }
  }, [_vm._v("2.4.2 Complementary searching and grasping behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec02.04.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.04.02.01"
    }
  }, [_vm._v("2.4.2.1 The blind man’s cane and the art of following")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec02.04.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.04.02.02"
    }
  }, [_vm._v("2.4.2.2 Asymmetric searching movements that match asymmetric tarsal morphology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec02.04.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.04.02.03"
    }
  }, [_vm._v("2.4.2.3 An additional detail: rotating legs to grasp lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.04.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.04.03"
    }
  }, [_vm._v("2.4.3 Grasping a line prior to attaching the dragline")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec02.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.05"
    }
  }, [_vm._v("2.5 Cutting lines and recycling silk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.05.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.05.01"
    }
  }, [_vm._v("2.5.1 Cutting lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec02.05.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.05.02"
    }
  }, [_vm._v("2.5.2 Recycling silk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec02.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.06"
    }
  }, [_vm._v("2.6 How spiders avoid adhering to their own webs: a mystery partly solved")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec02.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0011#sec02.07"
    }
  }, [_vm._v("2.7 Central nervous system basis for web construction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec02.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0011#sec02.08"
    }
  }, [_vm._v("2.8 Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#ch03"
    }
  }, [_vm._v("Chapter 3. Functions of orb web designs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.01"
    }
  }, [_vm._v("3.1 Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02"
    }
  }, [_vm._v("3.2 Correcting common misconceptions about orb webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.01"
    }
  }, [_vm._v("3.2.1 Orbs are neither sieves nor sound detectors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.02"
    }
  }, [_vm._v("3.2.2 Orb webs are not the pinacle of web evolution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.03"
    }
  }, [_vm._v("3.2.3 Orbs have never been demonstrated to be “optimum” structures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.02.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.04"
    }
  }, [_vm._v("3.2.4 The trajectories, diameters, and velocities of prey are diverse and poorly known")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.02.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.05"
    }
  }, [_vm._v("3.2.5 Most differences in orb designs are probably not specializations for particular prey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.05.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.05.01"
    }
  }, [_vm._v("3.2.5.1 Long lists of prey captured argue against strong specialization")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.05.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.05.02"
    }
  }, [_vm._v("3.2.5.2 Strong habitat effects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.05.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.05.03"
    }
  }, [_vm._v("3.2.5.3 Data from prey counts generally have serious flaws")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.05.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.05.04"
    }
  }, [_vm._v("3.2.5.4 Measuring “available” prey is also difficult")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.05.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.05.05"
    }
  }, [_vm._v("3.2.5.5 Ontogenetic changes in web design (and lack of such changes) can introduce noise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.05.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.05.06"
    }
  }, [_vm._v("3.2.5.6 Ecological settings of studies need to be evolutionarily realistic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.05.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.05.07"
    }
  }, [_vm._v("3.2.5.7 Flexible construction behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.05.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.05.08"
    }
  }, [_vm._v("3.2.5.8 Possible exceptions: relative prey specialization")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.05.09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.05.09"
    }
  }, [_vm._v("3.2.5.9 A summary regarding prey specialization in orb webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.02.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.06"
    }
  }, [_vm._v("3.2.6 Interspecific competition for prey is probably not common")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.02.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.07"
    }
  }, [_vm._v("3.2.7 Sticky spiral spacing is not uniform")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.02.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.08"
    }
  }, [_vm._v("3.2.8 Orb designs are probably not taxon-specific")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.08.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.08.01"
    }
  }, [_vm._v("3.2.8.1 Species-specificity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.08.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.08.02"
    }
  }, [_vm._v("3.2.8.2 Effects of intra-specific genetic differences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.08.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.08.03"
    }
  }, [_vm._v("3.2.8.3 Genus-specificity?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.08.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.08.04"
    }
  }, [_vm._v("3.2.8.4 Differences at higher taxonomic levels and a summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.02.09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.09"
    }
  }, [_vm._v("3.2.9 The properties of homologous lines are not invariable")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.09.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.09.01"
    }
  }, [_vm._v("3.2.9.1 Differences between species")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.09.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.09.02"
    }
  }, [_vm._v("3.2.9.2 Differences within species")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.09.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.09.03"
    }
  }, [_vm._v("3.2.9.3 Consequences for understanding orb web designs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.02.10"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.10"
    }
  }, [_vm._v("3.2.10 Correlations between orb design and details of attack behavior are inconsistent")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.10.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.10.01"
    }
  }, [_vm._v("3.2.10.1 Inconsistent relationships")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.10.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.10.02"
    }
  }, [_vm._v("3.2.10.2 More likely correlations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.02.11"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "xi",
      "id": "pxi",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.11"
    }
  }, [_vm._v("3.2.11 Orb movements in wind may not be generally significant in intercepting prey (but may affect orb designs)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.11.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.11.01"
    }
  }, [_vm._v("3.2.11.1 Web movements and the encounter model")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.11.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.11.02"
    }
  }, [_vm._v("3.2.11.2 Different types of orb web movement in the wind")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.02.11.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.11.03"
    }
  }, [_vm._v("3.2.11.3 Orb movements in the wind: are they important?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.02.11.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.11.03.01"
    }
  }, [_vm._v("3.2.11.3.1 Prey capture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.02.11.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.11.03.02"
    }
  }, [_vm._v("3.2.11.3.2 Web damage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.02.12"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.12"
    }
  }, [_vm._v("3.2.12 Prey are not defenseless: protection from the spider’s own prey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.02.13"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.02.13"
    }
  }, [_vm._v("3.2.13 Design details are likely to be selectively important")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.02.14"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.02.14"
    }
  }, [_vm._v("3.2.14 Adultophilia: a serious arachnological problem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec03.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03"
    }
  }, [_vm._v("3.3 How orbs function")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.01"
    }
  }, [_vm._v("3.3.1 Intercepting prey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02"
    }
  }, [_vm._v("3.3.2 Functions for non-sticky lines (radii, hub and frame lines)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.03.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.01"
    }
  }, [_vm._v("3.3.2.1 Stop prey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.03.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.02"
    }
  }, [_vm._v("3.3.2.2 Transmit vibration cues for arousal and orientation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.02.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.02.01"
    }
  }, [_vm._v("3.3.2.2.1 Longitudinal vibrations and their amplitudes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.02.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.02.02"
    }
  }, [_vm._v("3.3.2.2.2 Precision of orientation and the importance (?) of radial organization")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.02.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.02.03"
    }
  }, [_vm._v("3.3.2.2.3 Types of prey vibration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.03.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.03"
    }
  }, [_vm._v("3.3.2.3 Support the spider and facilitate her movements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.03.02.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.04"
    }
  }, [_vm._v("3.3.2.4 Primary frame lines: adapt to variable spaces, increase extensibility, and avoid resonant vibrations (?)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.02.04.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.04.01"
    }
  }, [_vm._v("3.3.2.4.1 Theoretical expectations of benefits and costs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.02.04.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.04.02"
    }
  }, [_vm._v("3.3.2.4.2 Tests of predictions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.03.02.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.05"
    }
  }, [_vm._v("3.3.2.5 Secondary and tertiary frame lines: increase extensibility")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.02.05.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.05.01"
    }
  }, [_vm._v("3.3.2.5.1 Tests of hypotheses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.03.02.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.06"
    }
  }, [_vm._v("3.3.2.6 The hub: mechanical stabilizer, information center, and launching platform")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.02.06.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.06.01"
    }
  }, [_vm._v("3.3.2.6.1 Attack behavior and hub designs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.02.06.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.06.02"
    }
  }, [_vm._v("3.3.2.6.2 Lines to pull, push against, and grasp while turning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.02.06.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.06.03"
    }
  }, [_vm._v("3.3.2.6.3 Tensing (and relaxing) functions of the hub")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.03.02.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.07"
    }
  }, [_vm._v("3.3.2.7 Functions of the tertiary radii")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.03.02.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.08"
    }
  }, [_vm._v("3.3.2.8 Functions of the temporary spiral")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.02.08.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.08.01"
    }
  }, [_vm._v("3.3.2.8.1 Patterns in temporary spiral spacing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.02.08.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.08.02"
    }
  }, [_vm._v("3.3.2.8.2 Probable functions of the temporary spiral (hand rail and others)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.02.08.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.08.03"
    }
  }, [_vm._v("3.3.2.8.3 Patterns in temporary spiral spacing in orbs and their possible significance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.03.02.09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.09"
    }
  }, [_vm._v("3.3.2.9 The other side of the coin: how best to fail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.03.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03"
    }
  }, [_vm._v("3.3.3 Functions for sticky lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.03.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.01"
    }
  }, [_vm._v("3.3.3.1 Retain prey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.03.01.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.01.01"
    }
  }, [_vm._v("3.3.3.1.1 Selection favors longer retention times")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.03.01.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.01.02"
    }
  }, [_vm._v("3.3.3.1.2 Means by which prey are retained: adhesion, extension, and resistance to breaking")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.03.01.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.01.03"
    }
  }, [_vm._v("3.3.3.1.3 Means of escape: prey behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.03.01.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.01.04"
    }
  }, [_vm._v("3.3.3.1.4 Spaces between sticky lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.03.01.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.01.05"
    }
  }, [_vm._v("3.3.3.1.5 An orb’s slant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.03.01.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.01.06"
    }
  }, [_vm._v("3.3.3.1.6 “Pulley” attachments of the sticky spiral to the radii")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.03.01.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.01.07"
    }
  }, [_vm._v("3.3.3.1.7 Variations in retention times and their consequences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.03.01.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.01.08"
    }
  }, [_vm._v("3.3.3.1.8 Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.03.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.02"
    }
  }, [_vm._v("3.3.3.2 Reduce the web’s visibility")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.03.02.01"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "xii",
      "id": "pxii",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.02.01"
    }
  }, [_vm._v("3.3.3.2.1 Some insects can see orb webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.03.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.02.02"
    }
  }, [_vm._v("3.3.3.2.2 Does visibility affect prey capture in the field?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.03.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.02.03"
    }
  }, [_vm._v("3.3.3.2.3 Yellow silk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.03.03.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.03"
    }
  }, [_vm._v("3.3.3.3 Other functions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.03.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.03.01"
    }
  }, [_vm._v("3.3.3.3.1 Survive environmental insults")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.03.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.03.02"
    }
  }, [_vm._v("3.3.3.3.2 Reduce construction costs and physical constraints")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rsec03.03.03.03.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.03.02.01"
    }
  }, [_vm._v("3.3.3.3.2.1 Behavioral costs?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rsec03.03.03.03.02.01.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.03.02.01.01"
    }
  }, [_vm._v("3.3.3.3.2.1.1 Orb weavers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rsec03.03.03.03.02.01.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.03.02.01.02"
    }
  }, [_vm._v("3.3.3.3.2.1.2 The special case of uloborids")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rsec03.03.03.03.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.03.02.02"
    }
  }, [_vm._v("3.3.3.3.2.2 Energetic constraints?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rsec03.03.03.03.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.03.02.03"
    }
  }, [_vm._v("3.3.3.3.2.3 Material costs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rsec03.03.03.03.02.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.03.02.04"
    }
  }, [_vm._v("3.3.3.3.2.4 The (unknown) costs of vigilance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.03.03.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.03.03"
    }
  }, [_vm._v("3.3.3.3.3 Non-orb weavers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.03.03.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.03.04"
    }
  }, [_vm._v("3.3.3.3.4 Defense against predators")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.03.03.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.03.03.05"
    }
  }, [_vm._v("3.3.3.3.5 Other possible variables and functions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.03.03.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.03.04"
    }
  }, [_vm._v("3.3.3.4 Planar and non-planar orbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec03.03.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04"
    }
  }, [_vm._v("3.3.4 The function(s) of stabilimenta")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.03.04.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04.01"
    }
  }, [_vm._v("3.3.4.1 Egg sac and detritus stabilimenta")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec03.03.04.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04.02"
    }
  }, [_vm._v("3.3.4.2 Silk stabilimenta")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.04.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04.02.01"
    }
  }, [_vm._v("3.3.4.2.1 The hypotheses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.04.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04.02.02"
    }
  }, [_vm._v("3.3.4.2.2 Problems interpreting the data")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rsec03.03.04.02.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04.02.02.01"
    }
  }, [_vm._v("3.3.4.2.2.1 Inconsistent support and behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rsec03.03.04.02.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04.02.02.02"
    }
  }, [_vm._v("3.3.4.2.2.2 Difficulties with direct measurements I: ecological realism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rsec03.03.04.02.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04.02.02.03"
    }
  }, [_vm._v("3.3.4.2.2.3 Direct measurements II: behavioral contexts, defensive behaviors, species differences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rsec03.03.04.02.02.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04.02.02.04"
    }
  }, [_vm._v("3.3.4.2.2.4 Direct measurements III: inappropriate measurements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rsec03.03.04.02.02.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04.02.02.05"
    }
  }, [_vm._v("3.3.4.2.2.5 The importance of UV reflectance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rsec03.03.04.02.02.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04.02.02.06"
    }
  }, [_vm._v("3.3.4.2.2.6 The hypotheses are not mutually exclusive")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rsec03.03.04.02.02.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04.02.02.07"
    }
  }, [_vm._v("3.3.4.2.2.7 Some crucial behavioral phenomena are poorly understood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rsec03.03.04.02.02.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04.02.02.08"
    }
  }, [_vm._v("3.3.4.2.2.8 Comparing many apples with many oranges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rsec03.03.04.02.02.09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04.02.02.09"
    }
  }, [_vm._v("3.3.4.2.2.9 Summary of weaknesses of direct measurements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.04.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04.02.03"
    }
  }, [_vm._v("3.3.4.2.3 Further complications: angles of view, illumination, and background")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec03.03.04.02.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04.02.04"
    }
  }, [_vm._v("3.3.4.2.4 Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec03.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.04"
    }
  }, [_vm._v("3.4 Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#ch04"
    }
  }, [_vm._v("Chapter 4. Putting pieces together: tradeoffs and remaining puzzles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec04.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.01"
    }
  }, [_vm._v("4.1 Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec04.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.02"
    }
  }, [_vm._v("4.2 “Optimal” orb designs: tradeoffs between functions are difficult to measure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.02.01"
    }
  }, [_vm._v("4.2.1 Tradeoffs between functions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.02.02"
    }
  }, [_vm._v("4.2.2 The “rare large prey hypothesis”: a dominant role for the stopping function?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.02.03"
    }
  }, [_vm._v("4.2.3 Investments in foraging")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.02.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.02.04"
    }
  }, [_vm._v("4.2.4 Overview")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec04.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03"
    }
  }, [_vm._v("4.3 “Multiple trap” design: a new way to view orb webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.01"
    }
  }, [_vm._v("4.3.1 Unequal spacing of radii is ubiquitous")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.02"
    }
  }, [_vm._v("4.3.2 Edge-to-hub patterns in sticky spiral spacing are also common—why?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec04.03.02.01"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "xiii",
      "id": "pxiii",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.02.01"
    }
  }, [_vm._v("4.3.2.1 Constraint by cues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec04.03.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.02.02"
    }
  }, [_vm._v("4.3.2.2 Speed of attacks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec04.03.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.02.03"
    }
  }, [_vm._v("4.3.2.3 Stopping prey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec04.03.02.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.02.04"
    }
  }, [_vm._v("4.3.2.4 Sticky spiral entanglement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.03.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.03"
    }
  }, [_vm._v("4.3.3 Illumination from exceptions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec04.03.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.03.01"
    }
  }, [_vm._v("4.3.3.1 Low prey velocities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec04.03.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.03.02"
    }
  }, [_vm._v("4.3.3.2 Tightly and widely spaced radii")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec04.03.03.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.03.03"
    }
  }, [_vm._v("4.3.3.3 Other patterns, other explanations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec04.03.03.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.03.03.01"
    }
  }, [_vm._v("4.3.3.3.1 Above vs. below the hub")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec04.03.03.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.03.03.02"
    }
  }, [_vm._v("4.3.3.3.2 Inner edge of the capture zone, “flimsy” orbs, turnbacks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.03.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.04"
    }
  }, [_vm._v("4.3.4 A limitation of current data: heterogeneity of lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.03.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.05"
    }
  }, [_vm._v("4.3.5 Conclusions regarding within-web patterns of sticky spiral spacing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.03.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.06"
    }
  }, [_vm._v("4.3.6 Consequences for understanding how orbs function")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec04.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.04"
    }
  }, [_vm._v("4.4 Tensions and stresses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.04.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.04.01"
    }
  }, [_vm._v("4.4.1 Theoretical expectations of uniformity in homologous lines are not confirmed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.04.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.04.02"
    }
  }, [_vm._v("4.4.2 Tensions vary despite abilities to adjust them")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec04.04.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.04.02.01"
    }
  }, [_vm._v("4.4.2.1 Tensions on non-sticky lines in finished orbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec04.04.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.04.02.02"
    }
  }, [_vm._v("4.4.2.2 Different tensions along the length of a single radius")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec04.04.02.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.04.02.02.01"
    }
  }, [_vm._v("4.4.2.2.1 Web modifications that produce tension changes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec04.04.02.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.04.02.02.02"
    }
  }, [_vm._v("4.4.2.2.2 Functions of altered tensions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec04.04.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.04.02.03"
    }
  }, [_vm._v("4.4.2.3 Some spiders manipulate tensions in finished orbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec04.04.02.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.04.02.04"
    }
  }, [_vm._v("4.4.2.4 Tensions on sticky lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec04.04.02.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.04.02.05"
    }
  }, [_vm._v("4.4.2.5 Experimental manipulation of tensions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec04.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.05"
    }
  }, [_vm._v("4.5 Relative numbers of radii and sticky spiral loops")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec04.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.06"
    }
  }, [_vm._v("4.6 Testing visibility and stopping functions: the extreme case of trunk orbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec04.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.07"
    }
  }, [_vm._v("4.7 Correlations between spider size and orb design?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec04.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.08"
    }
  }, [_vm._v("4.8 Spider positions, attack behavior, and up-down asymmetries in orbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.08.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.08.01"
    }
  }, [_vm._v("4.8.1 Orb design and attack speed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.08.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.08.02"
    }
  }, [_vm._v("4.8.2 Spider orientation at the hub")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.08.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.08.03"
    }
  }, [_vm._v("4.8.3 Further factors influencing spider positions at the hub")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.08.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.08.04"
    }
  }, [_vm._v("4.8.4 Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec04.09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.09"
    }
  }, [_vm._v("4.9 Remaining puzzles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.09.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.09.01"
    }
  }, [_vm._v("4.9.1 The puzzle of temporary spiral removal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.09.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.09.02"
    }
  }, [_vm._v("4.9.2 The puzzle of hub removal and open hubs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.09.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.09.03"
    }
  }, [_vm._v("4.9.3 The puzzle of the free zone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.09.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.09.04"
    }
  }, [_vm._v("4.9.4 The puzzle of non-vertical orbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.09.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.09.05"
    }
  }, [_vm._v("4.9.5 The puzzle of provisional radii")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.09.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.09.06"
    }
  }, [_vm._v("4.9.6 The puzzle of open sectors for detritus stabilimenta")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.09.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.09.07"
    }
  }, [_vm._v("4.9.7 Exceptions to trends")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec04.10"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.10"
    }
  }, [_vm._v("4.10 Non-orb webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec04.11"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0016#sec04.11"
    }
  }, [_vm._v("4.11 Evolutionary responses by insects? A neglected aspect of prey capture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.11.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0016#sec04.11.01"
    }
  }, [_vm._v("4.11.1 Avoiding or reducing contact with webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.11.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0016#sec04.11.02"
    }
  }, [_vm._v("4.11.2 Reducing retention time after having been stopped by a web")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec04.11.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0016#sec04.11.03"
    }
  }, [_vm._v("4.11.3 Reducing the probability of being attacked immediately")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec04.12"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0016#sec04.12"
    }
  }, [_vm._v("4.12 Summary (including part of chapter 3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch05"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "xiv",
      "id": "pxiv",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#ch05"
    }
  }, [_vm._v("Chapter 5. The building behavior of non-orb weavers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec05.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.01"
    }
  }, [_vm._v("5.1 Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec05.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.02"
    }
  }, [_vm._v("5.2 Order of lines and other higher-level patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec05.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.02.01"
    }
  }, [_vm._v("5.2.1 Modularity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec05.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.02.02"
    }
  }, [_vm._v("5.2.2 Behavior deduced from patterns of lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec05.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.02.03"
    }
  }, [_vm._v("5.2.3 Other patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec05.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.03"
    }
  }, [_vm._v("5.3 Lower-level patterns: leg movements and manipulation of lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec05.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.03.01"
    }
  }, [_vm._v("5.3.1 Walk upright on the substrate or a dense sheet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec05.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.03.02"
    }
  }, [_vm._v("5.3.2 Walk under single lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec05.03.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.03.03"
    }
  }, [_vm._v("5.3.3 Hold the dragline while moving and while attaching it")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec05.03.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.03.04"
    }
  }, [_vm._v("5.3.4 Hold the line to which the dragline is being attached")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec05.03.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.03.05"
    }
  }, [_vm._v("5.3.5 Snub lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec05.03.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.03.06"
    }
  }, [_vm._v("5.3.6 Cutting and reconnecting lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec05.03.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.03.07"
    }
  }, [_vm._v("5.3.7 Finding lines and following behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec05.03.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.03.08"
    }
  }, [_vm._v("5.3.8 Rubbing, brushing, lifting, and clapping movements of the spinnerets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec05.03.09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.03.09"
    }
  }, [_vm._v("5.3.9 Dabbing and sweeping with the entire abdomen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec05.03.10"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.03.10"
    }
  }, [_vm._v("5.3.10 Other lower-level behavior patterns that are absent in orb weavers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec05.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.04"
    }
  }, [_vm._v("5.4 Stereotyped behavior in non-orb construction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec05.04.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.04.01"
    }
  }, [_vm._v("5.4.1 Building tunnels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec05.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.05"
    }
  }, [_vm._v("5.5 Adjustments to substrate-imposed constraints")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec05.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.06"
    }
  }, [_vm._v("5.6 Managing swaths of fine lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec05.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.07"
    }
  }, [_vm._v("5.7 Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec05.07.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.07.01"
    }
  }, [_vm._v("5.7.1 Higher levels of behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec05.07.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.07.02"
    }
  }, [_vm._v("5.7.2 Lower levels of behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rbox0501"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0018#box0501"
    }
  }, [_vm._v("Box 5.1 The funnel web diplurid "), _c('i', [_vm._v("Linothele macrothelifera")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#ch06"
    }
  }, [_vm._v("Chapter 6. The building behavior of orb-weavers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec06.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.01"
    }
  }, [_vm._v("6.1 Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec06.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.02"
    }
  }, [_vm._v("6.2 Simplifications for smoother reading")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec06.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.02.01"
    }
  }, [_vm._v("6.2.1 Species and topics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec06.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.02.02"
    }
  }, [_vm._v("6.2.2 Levels of detail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec06.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03"
    }
  }, [_vm._v("6.3 Behavior of two araneids")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec06.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.01"
    }
  }, [_vm._v("6.3.1 Higher level organization: the stages of construction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec06.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.02"
    }
  }, [_vm._v("6.3.2 Exploration and establishing early lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec06.03.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.02.01"
    }
  }, [_vm._v("6.3.2.1 Use previous lines or start from scratch?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec06.03.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.02.02"
    }
  }, [_vm._v("6.3.2.2 Problems in starting from scratch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec06.03.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.02.03"
    }
  }, [_vm._v("6.3.2.3 Basic operations during exploration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec06.03.02.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.02.03.01"
    }
  }, [_vm._v("6.3.2.3.1 Gathering sensory information and laying the first lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec06.03.02.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.02.03.02"
    }
  }, [_vm._v("6.3.2.3.2 The end of exploration and the “hub transition”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec06.03.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.03"
    }
  }, [_vm._v("6.3.3 Frames, secondary radii, and hub loops")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec06.03.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.03.01"
    }
  }, [_vm._v("6.3.3.1 The other “primary” frames")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec06.03.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.03.02"
    }
  }, [_vm._v("6.3.3.2 Secondary radii")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec06.03.03.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.03.03"
    }
  }, [_vm._v("6.3.3.3 Secondary frames")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec06.03.03.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.03.04"
    }
  }, [_vm._v("6.3.3.4 Hub loops")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec06.03.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.04"
    }
  }, [_vm._v("6.3.4 Temporary spiral and tertiary radii")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec06.03.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.05"
    }
  }, [_vm._v("6.3.5 Sticky spiral")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec06.03.05.01"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "xv",
      "id": "pxv",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.05.01"
    }
  }, [_vm._v("6.3.5.1 Break temporary spiral lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec06.03.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.06"
    }
  }, [_vm._v("6.3.6 Modify the hub")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec06.03.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.07"
    }
  }, [_vm._v("6.3.7 Stabilimentum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec06.03.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.08"
    }
  }, [_vm._v("6.3.8 Orb web repair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec06.03.09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.09"
    }
  }, [_vm._v("6.3.9 Web removal and recycling")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec06.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.04"
    }
  }, [_vm._v("6.4 Senility in orb construction: a new frontier?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec06.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.05"
    }
  }, [_vm._v("6.5 Detailed movements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec06.05.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.05.01"
    }
  }, [_vm._v("6.5.1 Patterns in variation: high diversity produces low diversity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec06.05.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.05.02"
    }
  }, [_vm._v("6.5.2 Variation: a caution against stereotypy and typology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec06.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.06"
    }
  }, [_vm._v("6.6 General patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec06.06.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.06.01"
    }
  }, [_vm._v("6.6.1 Dexterity, the blind man’s cane, and following other legs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec06.06.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.06.02"
    }
  }, [_vm._v("6.6.2 Patterns of tension changes during construction: a tendency to relax")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec06.06.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.06.03"
    }
  }, [_vm._v("6.6.3 Missing details")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec06.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.07"
    }
  }, [_vm._v("6.7 Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#ch07"
    }
  }, [_vm._v("Chapter 7. Cues directing web construction behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.01"
    }
  }, [_vm._v("7.1 Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.01.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.01.01"
    }
  }, [_vm._v("7.1.1 Building an orb in human terms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.02"
    }
  }, [_vm._v("7.2 Classifying the cues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.02.01"
    }
  }, [_vm._v("7.2.1 Stimuli from repeatedly sensed “reference points” vs. more nearly constant “general settings”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.02.02"
    }
  }, [_vm._v("7.2.2 Other introductory notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03"
    }
  }, [_vm._v("7.3 Cues for sticky spiral construction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.01"
    }
  }, [_vm._v("7.3.1 Distinguishing sticky from non-sticky lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.02"
    }
  }, [_vm._v("7.3.2 Rapidly changing, repeatedly sensed reference point cues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.02.01"
    }
  }, [_vm._v("7.3.2.1 Location of the inner loop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.02.02"
    }
  }, [_vm._v("7.3.2.2 Distance from the outer loop of temporary spiral (“TSP distance”)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.02.03"
    }
  }, [_vm._v("7.3.2.3 Memory of the TSP distance along the immediately preceding radius")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.02.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.02.04"
    }
  }, [_vm._v("7.3.2.4 Memory of less recent responses to changes in TSP distances")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.02.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.02.05"
    }
  }, [_vm._v("7.3.2.5 Distance between radii")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.02.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.02.06"
    }
  }, [_vm._v("7.3.2.6 Lack of influence of radius tension")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.02.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.02.07"
    }
  }, [_vm._v("7.3.2.7 Mistakes in discriminating sticky from non-sticky lines?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.03.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.03"
    }
  }, [_vm._v("7.3.3 Intermediate, more slowly changing cues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.03.01"
    }
  }, [_vm._v("7.3.3.1 Angle of the radius with gravity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.03.02"
    }
  }, [_vm._v("7.3.3.2 Amount of silk available vs. web area")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.03.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.03.03"
    }
  }, [_vm._v("7.3.3.3 Distance from the hub (?)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.03.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.04"
    }
  }, [_vm._v("7.3.4 More or less constant general settings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.04.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.04.01"
    }
  }, [_vm._v("7.3.4.1 Length of the spider’s legs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.04.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.04.02"
    }
  }, [_vm._v("7.3.4.2 Previous prey (escaped or captured)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec07.03.04.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.04.02.01"
    }
  }, [_vm._v("7.3.4.2.1 General responses to prey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec07.03.04.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.04.02.02"
    }
  }, [_vm._v("7.3.4.2.2 Prey-specific responses (?)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.04.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.04.03"
    }
  }, [_vm._v("7.3.4.3 Presence of predators (?)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.04.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.04.04"
    }
  }, [_vm._v("7.3.4.4 Wind")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.04.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.04.05"
    }
  }, [_vm._v("7.3.4.5 Time of day")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.04.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.04.06"
    }
  }, [_vm._v("7.3.4.6 Season of the year and light rain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.04.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.04.07"
    }
  }, [_vm._v("7.3.4.7 Temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.04.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.04.08"
    }
  }, [_vm._v("7.3.4.8 Humidity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.03.05"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "xvi",
      "id": "pxvi",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.05"
    }
  }, [_vm._v("7.3.5 Additional decisions by spiders building sticky spirals and cues triggering them")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.05.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.05.01"
    }
  }, [_vm._v("7.3.5.1 Turn back")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.05.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.05.02"
    }
  }, [_vm._v("7.3.5.2 Attach to each radius")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.05.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.05.03"
    }
  }, [_vm._v("7.3.5.3 Number of attachments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.05.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.05.04"
    }
  }, [_vm._v("7.3.5.4 Break temporary spiral")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.03.05.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.05.05"
    }
  }, [_vm._v("7.3.5.5 Terminate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.03.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.06"
    }
  }, [_vm._v("7.3.6 First loop of sticky spiral: a special case")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.03.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.07"
    }
  }, [_vm._v("7.3.7 Interactions among cues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.04"
    }
  }, [_vm._v("7.4 Temporary spiral")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.04.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.04.01"
    }
  }, [_vm._v("7.4.1 Distances traveled and path integration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.04.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.04.02"
    }
  }, [_vm._v("7.4.2 Gravity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.04.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.04.03"
    }
  }, [_vm._v("7.4.3 Distance from the hub")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.04.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.04.04"
    }
  }, [_vm._v("7.4.4 Lack of effect of radius tension")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.04.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.04.05"
    }
  }, [_vm._v("7.4.5 Additional possible cues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.05"
    }
  }, [_vm._v("7.5 Hub")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.05.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.05.01"
    }
  }, [_vm._v("7.5.1 Spaces between hub spiral loops")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.05.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.05.02"
    }
  }, [_vm._v("7.5.2 Termination of the hub spiral")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.06"
    }
  }, [_vm._v("7.6 Stabilimentum construction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.06.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.06.01"
    }
  }, [_vm._v("7.6.1 Build a stabilimentum or not?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.06.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.06.02"
    }
  }, [_vm._v("7.6.2 Where to place the stabilimentum?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.06.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.06.03"
    }
  }, [_vm._v("7.6.3 Which stabilimentum design?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.07"
    }
  }, [_vm._v("7.7 Radii, frames, and anchor lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.07.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.07.01"
    }
  }, [_vm._v("7.7.1 Secondary radii")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.07.01.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.07.01.01"
    }
  }, [_vm._v("7.7.1.1 Choosing an “open” sector")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec07.07.01.01.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.07.01.01.01"
    }
  }, [_vm._v("7.7.1.1.1 Radius length")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec07.07.01.01.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.07.01.01.02"
    }
  }, [_vm._v("7.7.1.1.2 False starts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.07.01.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.07.01.02"
    }
  }, [_vm._v("7.7.1.2 Choosing an exit radius")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.07.01.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.07.01.03"
    }
  }, [_vm._v("7.7.1.3 Choosing a final angle: how far to move along the frame")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.07.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.07.02"
    }
  }, [_vm._v("7.7.2 Secondary frame construction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.08"
    }
  }, [_vm._v("7.8 Early radii, and frames and anchor lines: determining web size, shape, and design")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.08.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.08.01"
    }
  }, [_vm._v("7.8.1 Position of the hub")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.08.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.08.02"
    }
  }, [_vm._v("7.8.2 Size and shape of the space in which to build")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.08.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.08.02.01"
    }
  }, [_vm._v("7.8.2.1 The decisions the spider makes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec07.08.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.08.02.02"
    }
  }, [_vm._v("7.8.2.2 The cues used in decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.08.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.08.03"
    }
  }, [_vm._v("7.8.3 Spider size and weight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.08.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.08.04"
    }
  }, [_vm._v("7.8.4 Silk available in the glands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.09"
    }
  }, [_vm._v("7.9 To build or not to build: triggering orb construction and destruction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.10"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.10"
    }
  }, [_vm._v("7.10 Cues that trigger transitions between stages of orb construction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.11"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.11"
    }
  }, [_vm._v("7.11 Other stimuli that spiders can sense but that are not (yet) known to guide orb construction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.11.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.11.01"
    }
  }, [_vm._v("7.11.1 Tensions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.11.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.11.02"
    }
  }, [_vm._v("7.11.2 Handedness?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.12"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.12"
    }
  }, [_vm._v("7.12 Hints of abilities: follow circular paths and sense radius lengths")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.13"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.13"
    }
  }, [_vm._v("7.13 Effects of psychotropic drugs on orb construction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.14"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.14"
    }
  }, [_vm._v("7.14 Coordinating different adjustments to different cues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.15"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.15"
    }
  }, [_vm._v("7.15 The (limited) role of simulations in understanding orb construction behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.16"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.16"
    }
  }, [_vm._v("7.16 A missing link: translating cues into attachment sites")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.17"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "xvii",
      "id": "pxvii",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.17"
    }
  }, [_vm._v("7.17 Summarizing the behavioral challenges met by orb weavers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.17.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.17.01"
    }
  }, [_vm._v("7.17.1 Mechanical agility and precision")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.17.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.17.02"
    }
  }, [_vm._v("7.17.2 Analytical abilities: multiple cues and decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.17.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.17.03"
    }
  }, [_vm._v("7.17.3 Sustained attention—where orb weavers truly shine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.18"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.18"
    }
  }, [_vm._v("7.18 Independence (?) of the spider’s responses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.19"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.19"
    }
  }, [_vm._v("7.19 Changes in responses to cues: learning and maturation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.20"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.20"
    }
  }, [_vm._v("7.20 Cues guiding the construction of non-orbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.20.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.20.01"
    }
  }, [_vm._v("7.20.1 Path integration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.20.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.20.02"
    }
  }, [_vm._v("7.20.2 Smooth substrates for gumfoot lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.20.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.20.03"
    }
  }, [_vm._v("7.20.3 Rigidity of supports")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.20.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.20.04"
    }
  }, [_vm._v("7.20.4 Locations of supporting objects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.20.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.20.05"
    }
  }, [_vm._v("7.20.5 Radial symmetry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.20.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.20.06"
    }
  }, [_vm._v("7.20.6 Differences in tensions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.20.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.20.07"
    }
  }, [_vm._v("7.20.7 Temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.20.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.20.08"
    }
  }, [_vm._v("7.20.8 Apparent sensory movements of legs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.20.09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.20.09"
    }
  }, [_vm._v("7.20.9 Reserves from previous feeding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.20.10"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.20.10"
    }
  }, [_vm._v("7.20.10 Conspecifics (gregarious and social species) and possible constraints imposed by orbs on sociality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.20.11"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.20.11"
    }
  }, [_vm._v("7.20.11 Web repair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec07.21"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.21"
    }
  }, [_vm._v("7.21 Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.21.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.21.01"
    }
  }, [_vm._v("7.21.1 Surprising patterns in orb construction, especially sticky spiral construction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.21.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.21.02"
    }
  }, [_vm._v("7.21.2 Other stages of construction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec07.21.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.21.03"
    }
  }, [_vm._v("7.21.3 Non-orb webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#ch08"
    }
  }, [_vm._v("Chapter 8. Web ecology and website selection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec08.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.01"
    }
  }, [_vm._v("8.1 Introduction: what is and is not included")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec08.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.02"
    }
  }, [_vm._v("8.2 Webs and ecological foraging theories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec08.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.03"
    }
  }, [_vm._v("8.3 What is enough? “Fast lane” and “slow lane” spiders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec08.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04"
    }
  }, [_vm._v("8.4 Processes that produce habitat biases")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec08.04.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.01"
    }
  }, [_vm._v("8.4.1 Searching with lines floated on the breeze")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec08.04.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.02"
    }
  }, [_vm._v("8.4.2 Sensory biases: “satisficing” and special problems for aerial webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec08.04.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03"
    }
  }, [_vm._v("8.4.3 Biases in choosing websites")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec08.04.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.01"
    }
  }, [_vm._v("8.4.3.1 Philopatry—remain near the natal web")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec08.04.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02"
    }
  }, [_vm._v("8.4.3.2 Disperse and then settle selectively—possible cues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec08.04.03.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.01"
    }
  }, [_vm._v("8.4.3.2.1 Problems quantifying websites in the field")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rsec08.04.03.02.01.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.01.01"
    }
  }, [_vm._v("8.4.3.2.1.1 Website choice in simple field situations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5",
    attrs: {
      "id": "rsec08.04.03.02.01.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.01.02"
    }
  }, [_vm._v("8.4.3.2.1.2 Experimental evidence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec08.04.03.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.02"
    }
  }, [_vm._v("8.4.3.2.2 Rigidity, spacing, and surface characteristics of supports")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec08.04.03.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.03"
    }
  }, [_vm._v("8.4.3.2.3 Temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec08.04.03.02.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.04"
    }
  }, [_vm._v("8.4.3.2.4 Egg sacs and retreats")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec08.04.03.02.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.05"
    }
  }, [_vm._v("8.4.3.2.5 Light—artificial and otherwise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec08.04.03.02.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.06"
    }
  }, [_vm._v("8.4.3.2.6 The presence of prey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec08.04.03.02.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.07"
    }
  }, [_vm._v("8.4.3.2.7 Preexisting webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec08.04.03.02.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.08"
    }
  }, [_vm._v("8.4.3.2.8 Isolation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec08.04.03.02.09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.09"
    }
  }, [_vm._v("8.4.3.2.9 The presence of predators")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec08.04.03.02.10"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.10"
    }
  }, [_vm._v("8.4.3.2.10 Humidity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec08.04.03.02.11"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "xviii",
      "id": "pxviii",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.11"
    }
  }, [_vm._v("8.4.3.2.11 Plant species")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec08.04.03.02.12"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.12"
    }
  }, [_vm._v("8.4.3.2.12 Wind and other factors that may bias insect movements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec08.04.03.02.13"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.13"
    }
  }, [_vm._v("8.4.3.2.13 Height above the ground")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec08.04.03.02.14"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.14"
    }
  }, [_vm._v("8.4.3.2.14 Food quality and satiation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec08.04.03.02.15"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.15"
    }
  }, [_vm._v("8.4.3.2.15 Season of the year")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec08.04.03.02.16"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.16"
    }
  }, [_vm._v("8.4.3.2.16 Possibility of damage (?)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4",
    attrs: {
      "id": "rsec08.04.03.02.17"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.17"
    }
  }, [_vm._v("8.4.3.2.17 Ant nests")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec08.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.05"
    }
  }, [_vm._v("8.5 A general correlation between website selectivity and web design flexibility?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec08.05.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.05.01"
    }
  }, [_vm._v("8.5.1 Post-building selectivity and cues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec08.05.01.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.05.01.01"
    }
  }, [_vm._v("8.5.1.1 Prey capture success")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec08.05.01.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.05.01.02"
    }
  }, [_vm._v("8.5.1.2 Learning "), _c('i', [_vm._v("how")]), _vm._v(" to adjust")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec08.05.01.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.05.01.03"
    }
  }, [_vm._v("8.5.1.3 Web damage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec08.05.01.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.05.01.04"
    }
  }, [_vm._v("8.5.1.4 Material fatigue in silk lines?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec08.05.01.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.05.01.05"
    }
  }, [_vm._v("8.5.1.5 Kleptoparasites")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec08.05.01.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.05.01.06"
    }
  }, [_vm._v("8.5.1.6 “Pilot” webs—a risk-minimizing tactic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec08.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.06"
    }
  }, [_vm._v("8.6 Website tenacity, web durability, and recycling")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec08.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.07"
    }
  }, [_vm._v("8.7 Web durability")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec08.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.08"
    }
  }, [_vm._v("8.8 Limited by websites? Possible competition for prey and websites")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec08.08.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.08.01"
    }
  }, [_vm._v("8.8.1 Inter-specific competition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec08.08.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.08.02"
    }
  }, [_vm._v("8.8.2 Intra-specific competition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec08.09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.09"
    }
  }, [_vm._v("8.9 Problems in attempts to study cues that guide website choices")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec08.09.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.09.01"
    }
  }, [_vm._v("8.9.1 Experimental tests need controls: how to count unoccupied sites?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec08.09.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.09.02"
    }
  }, [_vm._v("8.9.2 Measuring habitat richness: sticky traps do NOT mimic spider webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec08.10"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.10"
    }
  }, [_vm._v("8.10 Time of day: day webs vs. night webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec08.10.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0023#sec08.10.01"
    }
  }, [_vm._v("8.10.1 Multiple orbs in a single day")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec08.11"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0023#sec08.11"
    }
  }, [_vm._v("8.11 Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#ch09"
    }
  }, [_vm._v("Chapter 9. Evolutionary patterns: an ancient success that produced high diversity and rampant convergence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec09.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#sec09.01"
    }
  }, [_vm._v("9.1 Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec09.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#sec09.02"
    }
  }, [_vm._v("9.2 Patterns in the diversity of webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec09.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#sec09.02.01"
    }
  }, [_vm._v("9.2.1 High diversity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec09.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#sec09.02.02"
    }
  }, [_vm._v("9.2.2 Frequent convergence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec09.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#sec09.02.03"
    }
  }, [_vm._v("9.2.3 Abundant intermediate forms and a summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec09.02.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#sec09.02.04"
    }
  }, [_vm._v("9.2.4 Intra-specific alternative web designs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec09.02.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.02.05"
    }
  }, [_vm._v("9.2.5 Behavioral bricks and buildings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec09.02.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.02.06"
    }
  }, [_vm._v("9.2.6 Adaptive chemical diversity of silk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec09.02.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.02.07"
    }
  }, [_vm._v("9.2.7 Differences between conspecifics: are there “individual styles” of web design?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec09.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.03"
    }
  }, [_vm._v("9.3 Consequences of the failure of the prey specialist hypothesis for understanding diversity and convergence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec09.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.04"
    }
  }, [_vm._v("9.4 What is a sheet web? Problems inherited from previous imprecision")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec09.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.05"
    }
  }, [_vm._v("9.5 Mygalomorphs: similar patterns of diversity and rampant convergence in a different world")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec09.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.06"
    }
  }, [_vm._v("9.6 Diversity of relations with insects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec09.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.07"
    }
  }, [_vm._v("9.7 Lack of miniaturization effects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec09.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.08"
    }
  }, [_vm._v("9.8 Paths not followed: alternative web forms in other animals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec09.09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.09"
    }
  }, [_vm._v("9.9 Summary and a new synthesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rbox0901"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "xix",
      "id": "pxix",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#box0901"
    }
  }, [_vm._v("Box 9.1 The most spectacular convergence of all: "), _c('i', [_vm._v("Fecenia")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rbox0902"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#box0902"
    }
  }, [_vm._v("Box 9.2 The most spectacular divergence of all: Theridiidae")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rbox0903"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#box0903"
    }
  }, [_vm._v("Box 9.3 Sand castles: extreme modifications of "), _c('i', [_vm._v("Seothyra henscheli")]), _vm._v(" webs to shifting sand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rbox0904"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#box0904"
    }
  }, [_vm._v("Box 9.4 Relation between web design and silk properties: stiff silk in "), _c('i', [_vm._v("Uroctea durandi")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch10"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#ch10"
    }
  }, [_vm._v("Chapter 10. Ontogeny, modularity, and the evolution of web building")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec10.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.01"
    }
  }, [_vm._v("10.1 Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec10.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.02"
    }
  }, [_vm._v("10.2 Web ontogeny and evolution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.02.01"
    }
  }, [_vm._v("10.2.1 Limits of interpretations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.02.02"
    }
  }, [_vm._v("10.2.2 A new hypothesis for ontogenic changes: consistent selection associated with smaller size")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec10.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.03"
    }
  }, [_vm._v("10.3 Early web evolution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.03.01"
    }
  }, [_vm._v("10.3.1 Burrow entrances vs. egg sacs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.03.02"
    }
  }, [_vm._v("10.3.2 Interception function for earliest webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.03.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.03.03"
    }
  }, [_vm._v("10.3.3 Retention function in early webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.03.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.03.04"
    }
  }, [_vm._v("10.3.4 Webs without retreats in the substrate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec10.03.04.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.03.04.01"
    }
  }, [_vm._v("10.3.4.1 Independence from the substrate is not a qualitative trait")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.03.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.03.05"
    }
  }, [_vm._v("10.3.5 Sheets with sticky lines and tangles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.03.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.03.06"
    }
  }, [_vm._v("10.3.6 Early-branching araneomorph lineages with derived webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.03.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.03.07"
    }
  }, [_vm._v("10.3.7 Spider webs and insect flight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.03.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.03.08"
    }
  }, [_vm._v("10.3.8 Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec10.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.04"
    }
  }, [_vm._v("10.4 The behavior patterns used to build early webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.04.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.04.01"
    }
  }, [_vm._v("10.4.1 Male sperm webs, burrow closures, and the origin of prey capture webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.04.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.04.02"
    }
  }, [_vm._v("10.4.2 Moving upside down below silk lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.04.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.04.03"
    }
  }, [_vm._v("10.4.3 Using legs to manipulate lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.04.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.04.04"
    }
  }, [_vm._v("10.4.4 Managing swaths of fine lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.04.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.04.05"
    }
  }, [_vm._v("10.4.5 Diplurid behavior: a possible guide to ancestral traits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec10.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.05"
    }
  }, [_vm._v("10.5 Evolution of later non-orb webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.05.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.05.01"
    }
  }, [_vm._v("10.5.1 Consequences of cribellum silk loss in labidognaths")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.05.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.05.02"
    }
  }, [_vm._v("10.5.2 Problems categorizing web types in evolution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.05.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.05.03"
    }
  }, [_vm._v("10.5.3 Problems with key innovation arguments in general")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.05.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.05.04"
    }
  }, [_vm._v("10.5.4 Silk glands and other morphological traits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.05.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.05.05"
    }
  }, [_vm._v("10.5.5 Visibility of silk to prey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.05.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.05.06"
    }
  }, [_vm._v("10.5.6 Web evolution in two small groups")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec10.05.06.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.05.06.01"
    }
  }, [_vm._v("10.5.6.1 Filistatid webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec10.05.06.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.05.06.02"
    }
  }, [_vm._v("10.5.6.2 Interception vs. retention in oecobiid webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec10.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.06"
    }
  }, [_vm._v("10.6 Inconsistent evolutionary trends in non-orb webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec10.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.07"
    }
  }, [_vm._v("10.7 Diversity in non-orbs that results from behavioral stability")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec10.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.08"
    }
  }, [_vm._v("10.8 The (probably) monophyletic origin of orb webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.08.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.08.01"
    }
  }, [_vm._v("10.8.1 Evolutionary origins when behavior is modular")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.08.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.08.02"
    }
  }, [_vm._v("10.8.2 Morphology, molecules, and behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.08.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.08.03"
    }
  }, [_vm._v("10.8.3 Fossils and possible precursor webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.08.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.08.04"
    }
  }, [_vm._v("10.8.4 Speculations on the origins and consequences of cut and reel behavior (and the possible role of males)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.08.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.08.05"
    }
  }, [_vm._v("10.8.5 Derivation of ecribellate sticky lines from cribellate sticky lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.08.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.08.06"
    }
  }, [_vm._v("10.8.6 Summary regarding orb monophyly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec10.09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.09"
    }
  }, [_vm._v("10.9 Evolutionary changes in orb designs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.09.01"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "xx",
      "id": "pxx",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.09.01"
    }
  }, [_vm._v("10.9.1. Horizontal vs. vertical and nearly vertical orbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.09.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.09.02"
    }
  }, [_vm._v("10.9.2 Small derived lineages: ladder and trunk webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.09.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.09.03"
    }
  }, [_vm._v("10.9.3 Derivation of deinopid webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.09.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.09.04"
    }
  }, [_vm._v("10.9.4 Theridiosomatids and their allies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.09.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.09.05"
    }
  }, [_vm._v("10.9.5 The reduced webs of "), _c('i', [_vm._v("Hyptiotes")]), _vm._v(" and "), _c('i', [_vm._v("Miagrammopes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.09.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.09.06"
    }
  }, [_vm._v("10.9.6 “Twig orbs”: an object projects through the hub")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec10.10"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.10"
    }
  }, [_vm._v("10.10 “Post-orb” web evolution in Orbiculariae")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.10.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.10.01"
    }
  }, [_vm._v("10.10.1 Possible derivation of other web types from orbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec10.10.01.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.10.01.01"
    }
  }, [_vm._v("10.10.1.1 Gumfoot webs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec10.10.01.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.10.01.02"
    }
  }, [_vm._v("10.10.1.2 Other web types")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.10.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.10.02"
    }
  }, [_vm._v("10.10.2 Webs combined with prey attractants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec10.11"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.11"
    }
  }, [_vm._v("10.11 Coevolution between attack behavior and web design (and its lack)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec10.12"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.12"
    }
  }, [_vm._v("10.12 What "), _c('i', [_vm._v("didn’t")]), _vm._v(" happen, possible synapomorphies, and further puzzles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec10.13"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.13"
    }
  }, [_vm._v("10.13 Modularity and adaptive flexibility")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.13.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.13.01"
    }
  }, [_vm._v("10.13.1 Modularity is a central pattern in web construction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec10.13.01.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.13.01.01"
    }
  }, [_vm._v("10.13.1.1 Direct observations of behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec10.13.01.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.13.01.02"
    }
  }, [_vm._v("10.13.1.2 Finished structures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec10.13.01.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.13.01.03"
    }
  }, [_vm._v("10.13.1.3 Ontogenetic and experimentally induced changes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec10.13.01.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.13.01.04"
    }
  }, [_vm._v("10.13.1.4 Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec10.14"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.14"
    }
  }, [_vm._v("10.14 Modules and evolutionary transitions in web-building behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rsec10.14.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.14.01"
    }
  }, [_vm._v("10.14.1 Use of web construction behavior in taxonomy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec10.14.01.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.14.01.01"
    }
  }, [_vm._v("10.14.1.1 Historical successes and failures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "rsec10.14.01.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.14.01.02"
    }
  }, [_vm._v("10.14.1.2 Implications of modularity for orb monophyly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rsec10.15"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.15"
    }
  }, [_vm._v("10.15 Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf",
    attrs: {
      "id": "rrefs"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0028#refs"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rindex"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0030#index"
    }
  }, [_vm._v("Index")])])])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "header0101",
      "epub:type": "chapter",
      "id": "ch01",
      "role": "doc-chapter"
    }
  }, [_c('header', {
    attrs: {
      "id": "header0101"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "1",
      "id": "p1",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rch01"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ahaft",
    attrs: {
      "id": "sec01.01"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p1"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec01.01"
    }
  }, [_vm._v("1.1 Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("This book is about how spider webs are built, and how and why they have evolved their many different forms. It was conceived during a field trip in a spider biology course, when a student asked me why I had not written a book on spider webs. She noted that such a book would have been useful for the course but did not exist. She was right on both counts, and also that I was well-placed to produce it. I am an evolutionary biologist particularly interested in behavior. I have had the great fortune of living most of my working life in the tropics, and have spent just over 50 years watching a diverse array of spiders and thinking about their webs. Writing this book represents a chance both to contribute general summaries of data and ideas that are currently lacking, and to organize and develop new ideas that grew out of producing these summaries.")]), _vm._v(" "), _c('p', [_vm._v("Inevitably, the book’s coverage is idiosyncratic. I propose more new ideas, give more new data, and discuss more extensively those topics related to behavior and evolution; some discussions in other areas, like the biochemistry and mechanics of silk, are more standard and less original. I focus on behavior and evolution partly because spider webs have the potential to make especially important contributions to resolving central questions in behavior and evolution, just as they did in the past in understanding the characteristic and limits of innate behavior (Fabre 1912, Hingston 1929). An orb web can be easily photographed with perfect precision, and it constitutes an accurate record of a series of behavioral decisions made by a free-ranging animal under natural conditions. And because a web-building spider’s sensory world is so centered on silk lines, the orb is also a precise record of some of the most important stimuli that the spider used to guide those decisions; in addition, these stimuli can be experimentally altered by making simple modifications of webs. These advantages offer unusual chances to study some basic questions in animal behavior with especially fine detail and precision.")]), _vm._v(" "), _c('p', [_vm._v("I hope that this book may help future observers to see how web-building spiders can be exploited to investigate exciting new questions in animal behavior. It is a fragment of a larger project that originally included several additional topics: the role of behavioral canalization and “errors” in the evolution of behavior; the importance of "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "2",
      "id": "p2",
      "role": "doc-pagebreak"
    }
  }), _vm._v("scaling problems in the absolute and relative brain sizes of tiny animals and the limitations in behavioral capabilities that they may impose; the organization and evolution of independent behavior units in the nervous system; the implications of chemical manipulations performed by parasitoid wasps on their spider hosts and of additional experimental manipulations of webs for how behavioral subunits are organized and controlled in the spider; and the possibility that small invertebrates understand, at least to some limited degree, the physical consequences of their actions and the role that such understanding may play in the evolution of new behavior patterns. Other fragments of this larger project are archived online at the University of Chicago Press at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.press.uchicago.edu/sites/eberhard/",
      "target": "_blank"
    }
  }, [_vm._v("press.uchicago.edu/sites/eberhard/")]), _vm._v("; these portions are designated in the text with a capital O followed by the book chapter to which they refer (e.g., section O6.1; table O3.3; fig. O9.1). My hope is that this book will help to project the study of spider webs back onto the forefront of studies of animal behavior.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "sec01.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec01.02"
    }
  }, [_vm._v("1.2 A foreign world: life tied to silk lines")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Spiders are ecologically extremely important: for instance, a recent estimate suggests that they capture 400–800 million metric tons of prey each year, or about 1% of global terrestrial net primary production (Nyffeler and Birkhofer 2017). Web spiders live in a world that is ruled by their silk lines. This world is so different from ours, with respect both to their sensory impressions and to the basic facts of what is and what is not feasible for them to do, and they have such exquisite adaptations to this world, that it is useful to briefly describe these differences here, anticipating more detailed descriptions in later chapters (references documenting these statements will be given later). My aim is to help give the reader the kinds of intuition that are needed to understand their behavior.")]), _vm._v(" "), _c('p', [_vm._v("Orb weavers are functionally blind with respect to their web lines. Their eyes are neither designed nor positioned correctly to resolve fine objects like their lines, and in any case many spiders build their webs at night. Watching an orb weaver waving her legs as she moves is thus like watching a blind man use his cane, with two differences: the spider is usually limited to moving along only the lines she has laid (and thus has to use her “canes” to search for each new foothold); and the lines are in three rather than two dimensions. Slow motion recordings reveal a further level of elegance. Spiders economize on searching as they walk through a web; one leg often carefully passes the line that it has grasped to the next leg back on the same side before moving on to search for the next line. Each more posterior leg needs to make only a quick, small searching movement in the vicinity of the point that is being grasped by the leg just ahead of it.")]), _vm._v(" "), _c('p', [_vm._v("This dominance of the sense of touch gives observations of orb weaver behavior a dimension that is largely missing in many other animals, because the spider’s intentions can be intuited from the movements of her legs. One can deduce a blind man’s intentions by watching the movements of his cane; when he taps toward the left just after he hears a sudden growling sound from that direction, he is probably wondering about the origin of that sound. And it is also clear what he has found out; if his cane has not yet touched the dog that growled, he probably does not yet know its precise location. The searching movements that a spider’s legs make to find lines, especially at moments during orb web construction, when one can predict the next operations that she will perform, make it possible to confidently deduce both her intentions and the information that she has perceived. For instance, when the orb weaver "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(" is moving back toward the hub after attaching the first radial line to a primary frame while she is building a secondary frame (when she is at approximately the site of the head of the inward arrow from point p in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#fig0605"
    }
  }, [_vm._v("fig. 6.5j")]), _vm._v("), she consistently begins to tap laterally with her anterior legs on the side toward the adjacent radius (o in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#fig0605"
    }
  }, [_vm._v("fig. 6.5j")]), _vm._v(") that she is about to use as an exit to reach the second primary frame. The movements and their timing leave no doubt about what she is attempting to do: she is searching for the adjacent radius. In some cases it is possible to deduce, even in a finished web, what the spider may or may not have sensed at particular moments during the web’s construction by taking into account leg lengths and the distances between lines. This access to both the intentions and the information that an animal has (or lacks) offers special advantages in studies of animal behavior.")]), _vm._v(" "), _c('p', [_vm._v("An orb weaver is also largely chained to its own lines. "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "3",
      "id": "p3",
      "role": "doc-pagebreak"
    }
  }), _vm._v("In one sense, the spider lives a life similar to that of a blind person who is constrained to move only along preexisting train tracks. And just like a blind man walks around and taps objects in a room to sense its size and the presence or absence of furniture in it, the spider searching for a site in which to build a web must explore it physically, rather than surveying it visually. Much of this exploration must occur by following lines that were already laid previously; the spider cannot simply set out in any arbitrary direction. While spiders sometimes lay new lines by walking along a branch or a leaf and attaching the dragline line, at other times the only way for the spider to lay a new line from one distant point to another is by floating a line on a breeze and waiting until it snags somewhere. The spider has no control over the strength or direction of the wind, nor how or where the line snags. If the line fails to snag firmly on a useful support object, the spider’s only recourse is discard it and try again. To evaluate a possible website (is it too large? too small? does it have a projecting branch that would interfere with a web?), the spider probably remembers the distances and directions she has moved while exploring it ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.02"
    }
  }, [_vm._v("sections 6.3.2")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.08"
    }
  }, [_vm._v("7.8")]), _vm._v(").")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0101"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "277",
      "src": "images/chi-eberhard-fig0101.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p3"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 1.1.")]), _vm._v(" Three outstanding observers of spider webs and building behavior from the late nineteenth and early twentieth century (left to right): Rev. Henry C. McCook, Major R. W. G. Hingston, and Emil Nielsen (the last two courtesy of, respectively, Royal Geographic Society, and Nicolas Scharff).")])]), _vm._v(" "), _c('p', [_vm._v("And then there is the web itself. Orbs are famously strong, and able to resist both the general loads imposed by wind and the local stresses from high-energy prey impacts. But they are also foreign to some human intuitions. The lines are extremely light, and because air is relatively viscous at the scale of a small animal like a spider, transverse vibrations that would dominate a web at a human scale are strongly damped in spider webs. A more appropriate image is an orb of flexible lines strung under water. Not unexpectedly, spiders rely mainly on longitudinal rather than transverse vibrations of their lines to sense prey and other spiders. And while an orb is strong, it is also delicate in unexpected ways. A few drops of rain, a fog, or even dew can be enough to ruin it: the sticky spiral lines adhere to each other, the radii, and the frame lines, and the sticky material on the lines of most species washes off in water. Wind can cause individual sticky lines to flutter and become damaged when they swing into contact with each other. Some patterns in sticky spiral spacing in orbs may represent adaptations to reduce this type of damage ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.11"
    }
  }, [_vm._v("section 3.2.11")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("In sum, web-building spiders live a life that is limited by their own senses, and tightly bound to the silken lines in their webs. To understand these spiders, it is necessary to understand their webs, and vice versa.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "sec01.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec01.03"
    }
  }, [_vm._v("1.3 A brief history of spider web studies")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Spider webs are, of course, common and easily observed. The history of scientific inquiry regarding webs and spider building behavior begins, as with that of many other fields in biology, with descriptions by field naturalists. Important early works, now difficult to obtain and which I have not read, included Quatremére-Disjonval 1792, 1795, Reimarus and Reimarus 1798, Blackwall 1835, Dahl 1885, and Wagner 1894. The American clergyman H. C. McCook ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0101"
    }
  }, [_vm._v("Fig. 1.1")]), _vm._v(") (in addition to providing distinguished service in the American Civil War and writing popular children’s books on insects, religion, and leaf cutter ants) described many details of natural history and behavior in unprecedented detail (McCook 1889). The nineteenth-century giant of spider taxonomy, Eugene Simon, also contributed scattered but precise observations of webs (Simon 1892–1903). Also important, with acute observations and the first collections of good photographs of webs, were the books of Emerton (1902), Comstock (originally published in 1912, revised in 1967), and Fabre (1912).")]), _vm._v(" "), _c('p', [_vm._v("Somewhat later, perhaps the two best naturalist observers of spider orb webs and of building behavior were the Irish medical doctor and explorer Maj. R. W. G. Hingston (Hingston 1920, 1929, 1932) and the Danish school teacher Emil Nielsen (Nielsen 1932) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0101"
    }
  }, [_vm._v("Fig. 1.1")]), _vm._v("). Hingston parlayed military assignments in India, Pakistan, and "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "4",
      "id": "p4",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Iraq, and subsequent expeditions to British Guyana and other sites, into opportunities to observe tropical spiders (and other animals) and describe their behavior. His careful observations of the details of web construction, his incisive simple experiments, and his thoughtful analyses are particularly striking in light of his energetic physical undertakings, which included participation in an expedition to climb Mount Everest and scaling tropical trees to collect specimens on the trunks and in the canopy. The other giant contrasted in many ways. Emil Nielsen was a Danish secondary school teacher who did not travel to exotic places to study spiders, but instead made thorough, careful comparative studies of web-building spiders in Denmark. He published an especially thorough book-length study in Danish and, mercifully for English-speakers, combined it with a condensed companion volume in English (Nielsen 1932). Nielsen’s work on the parasitoid wasps that induce changes in the web-building behavior of their host spiders was also exceptionally thorough and insightful. Both Hingston and Fabre discussed general questions regarding “instinctual” behavior and the limits of the mental and behavioral capabilities of invertebrates, comparing them with other animals and humans.")]), _vm._v(" "), _c('p', [_vm._v("Other especially important general studies in the field of webs and their diversity were those by Herman Wiehle (1927, 1928, 1929, 1931) in northern Europe and the Mediterranean, Hans Peters (1931, 1936, 1937, 1939, 1953, 1954, 1955) in Germany, the Mediterranean, and tropical America, and B. J. and M. Marples in Europe and Oceania (Marples and Marples 1937; Marples 1955). Additional laboratory studies of orb web construction behavior during this and the following generation mostly centered on two European araneids, "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" and "), _c('i', [_vm._v("Zygiella x-notata")]), _vm._v(" (e.g., Peters 1931, 1936, 1937, 1939; Tilquin 1942; König 1951; Mayer 1952; Jacobi-Kleemann 1953; Witt 1963; Le Guelte 1966, 1968; Witt et al. 1968), and the American uloborid "), _c('i', [_vm._v("Uloborus diversus")]), _vm._v(" (Eberhard 1971a, 1972a). Studies of the webs of isolated species continued, and began to include more tropical species (e.g., Robinson and Robinson 1971, 1972, 1973a, 1975, 1976a).")]), _vm._v(" "), _c('p', [_vm._v("Up to about 1960, one might say that the history of spider web studies was pretty typical of many topics in zoology. Kaston (1964) presented a pre-cladistic hypothesis concerning spider web evolution, based almost entirely on observations of North temperate zone species. But long after the time had seemingly come for a detailed general, in-depth summary of what was known about webs and construction behavior, it was still missing. Theodore Savory produced a short general popular book (Savory 1952) with an admirable tendency to emphasize general questions, but with many undocumented and sometimes imprecise statements. Peter Witt, Charles Reed, and David Peakall wrote a more scholarly book (Witt et al. 1968), but it was limited almost entirely to laboratory observations of two species, "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" and "), _c('i', [_vm._v("Zygiella x-notata.")]), _vm._v(" An important summary published 24 years later continued this unfortunate tradition, specifically omitting data on any species other than "), _c('i', [_vm._v("A. diadematus")]), _vm._v(" (Vollrath 1992). Ernst Kullmann published large numbers of beautiful photographs of the webs of many heretofore unstudied species (Kullmann 1971/1972, 1975; Kullmann and Stern 1981) but did not produce a general overview. An edited book (Shear 1986) provided detailed and thorough summaries of some aspects of the webs and building behavior in particular groups (e.g., Coyle 1986; Lubin 1986) and included a brief summary (Shear 1986), but there was no synthetic, in-depth overview. A more recent general, synthetic book (Craig 2003) emphasized chemical and physical properties of silk, rather than behavior, but was unfortunately largely confined to summarizing the author’s own studies (Vollrath 2003; Higgins 2004).")]), _vm._v(" "), _c('p', [_vm._v("A few large, general papers and chapters giving overviews of webs and building behavior have appeared recently. Some have emphasized their use as taxonomic characters (Griswold et al. 2005; Kuntner et al. 2008a) and have tended to ignore function. Others give more general reviews (Viera et al. 2007; Blackledge et al. 2009c, 2011; Harmer et al. 2011; Herberstein and Tso 2011) but have been necessarily incomplete, especially with respect to behavior and to web designs other than orbs. A thorough, book-length review of spider webs, and of their functions and construction behavior, has yet to be written. This book attempts to fill that niche.")]), _vm._v(" "), _c('p', [_vm._v("The lack of a general summary on spider webs is having unfortunate consequences. Several aspects of the current academic environment favor neglect of older work: the relatively greater ease of obtaining electronic copies of more recent as opposed to old papers; the widespread emphasis in hiring and promotion decisions on quantity rather than quality of publications; and trends "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "5",
      "id": "p5",
      "role": "doc-pagebreak"
    }
  }), _vm._v("that favor claims to originality over thorough historical research and integration of new data with prior knowledge. Some recent papers on spider web biology have carried the modern trend of neglecting previous work to new heights (or depths), either lacking relevant citations of earlier literature, or simply citing one or two recent papers or a review to “cover” all other previous work. Here are four examples. The clear leader in the field of orb web construction biology in the 1950s and 1960s was Peter Witt; yet three large recent reviews cited only 3, 1, and 0 of his publications. Only one of these three reviews even cited the two old but revolutionary papers, Riechert and Cady (1983) and Wise and Barata (1983), that up-ended most previous attempts to relate web designs to inter-specific competition and the kinds of prey that they capture. In a squabble over whether one group of spiders (theridiids) are capable of the highly coordinated movements that are used in the specialized “cut and reel” behavior ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#fig0603"
    }
  }, [_vm._v("Fig. 6.3")]), _vm._v(") (Benjamin and Zschokke 2002, 2003, 2004; Eberhard et al. 2008a), none of the authors cited the clear, complete older descriptions of this behavior in theridiids (Marples 1955; Bradoo 1972). And none of several recent major reviews of the vexed problem of stabilimentum function even cited the 1932 book of Hingston, in which he devoted 60 full pages to stabilimenta in tropical species.")]), _vm._v(" "), _c('p', [_vm._v("I believe there is a real danger that much earlier knowledge is being lost. A comprehensive summary may be more important in spider webs than in some other fields. I have thus attempted to minimize citing only recent summaries (which, of course, are often less than complete, and sometimes include imprecise or even erroneous interpretations of previous work). I have made a special effort to be more complete with non-orb webs, because they have been less-studied, and show some previously unrecognized patterns (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0102"
    }
  }, [_vm._v("Figs. 1.2")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0103"
    }
  }, [_vm._v("1.3")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("Nevertheless, I am certain that I have not covered the sprawling published literature completely. In the best of all possible worlds, with the best of all possible minds and memories, and fluency in other languages (especially German and Japanese), I would have liked to have rendered this service. But I have no illusions of having made a truly thorough review (in any case, it would make very dull reading). I find that even when I read papers a second or third time, I routinely find additional important points that I missed previously; I have had quite different interests and ideas in my head at different stages of this project. My review of recent literature tailed off in late 2016. The MS was delivered to the press in August 2017, and after that I mostly only completed “in press” citations as they were published. I apologize in advance to all the authors whose work I cited only partially or missed completely, and warn the reader of this limitation.")]), _vm._v(" "), _c('p', [_vm._v("I have also added bits of unpublished information that I have accumulated during nearly 50 years of observing spiders and their webs (cited as “WE”). One result of writing this book was to make me aware of many lacunae in our current knowledge, and the book has launched me on several projects along the way that were designed to fill some of these holes. Several species that are abundant where I live, including the filistatid "), _c('i', [_vm._v("Kukulcania hibernalis")]), _vm._v(", the araneid "), _c('i', [_vm._v("Micrathena duodecimspinosa")]), _vm._v(", the tetragnathid "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(", and the uloborid "), _c('i', [_vm._v("Zosis geniculata")]), _vm._v(" are thus over-represented in the text. I have also pointed out many remaining gaps in our understanding, and compiled outstanding questions and promising research topics, in the online Table O10.1 in the hope that this will be useful to future researchers.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "sec01.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec01.04"
    }
  }, [_vm._v("1.4 Emphasis on behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The emphases here on behavior and behavioral evolution come naturally. Orb web construction behavior has long been considered an iconic example of stereotyped innate behavior, and details of orb construction behavior provide especially valuable traits for higher-level taxonomy (Eberhard 1982; Kuntner et al. 2008a). In addition, orbs offer unusually favorable conditions for studying behavior at especially fine levels of detail and precision and testing general ideas (Ades 1986). This is because an orb web is an exquisitely precise, detailed record of many aspects of the spider’s construction behavior ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0104"
    }
  }, [_vm._v("Fig. 1.4")]), _vm._v("). Both the animal’s behavior and some of the crucial stimuli that were used to guide that behavior are “frozen” in the pattern of lines in the web (Zschokke and Vollrath 1995a). Behavioral decisions are easily recorded in photographs, because orbs are generally two-dimensional. In addition, the spider is guided largely by the positions of other web lines as she builds, especially during temporary spiral and sticky spiral construction, "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "7",
      "id": "p7",
      "role": "doc-pagebreak"
    }
  }), _vm._v("so many of the stimuli that guide her behavior can be deduced from web photos ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#ch07"
    }
  }, [_vm._v("chapter 7")]), _vm._v("). Other possible stimuli from the web that would be more difficult to quantify from photographs, such as tensions and patterns of vibrations, appear not to provide important stimuli, at least during the latter stages of web construction ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.02.06"
    }
  }, [_vm._v("section 7.3.2.6")]), _vm._v("). Instead, orb construction is probably largely guided by aspects of an orb such as distances and angles between lines and that can be measured precisely in photos. The precision with which both potential stimuli from an orb web and the spider’s behavioral responses can be measured is something that behaviorists studying most other animals can only dream about. And these fine analyses can be conducted on behavior that was performed in the natural context of building its web, rather than some highly constrained or artificial situation.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0102"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "6",
      "id": "p6",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "450",
      "src": "images/chi-eberhard-fig0102.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 1.2.")]), _vm._v(" Beautiful complexity and diversity is not limited to orbs, as illustrated by the aerial sheet webs of the linyphiids "), _c('i', [_vm._v("Frontinella")]), _vm._v(" sp. ("), _c('i', [_vm._v("a")]), _vm._v("), "), _c('i', [_vm._v("Labulla thoracica")]), _vm._v(" ("), _c('i', [_vm._v("b")]), _vm._v("), and "), _c('i', [_vm._v("Tapinopa bilineata")]), _vm._v(" ("), _c('i', [_vm._v("c")]), _vm._v("). The "), _c('i', [_vm._v("F")]), _vm._v(". sp. web had an unusually tall knock-down tangle above the dense horizontal sheet where the spider rested, a nearly clear space just below where a few lines pulled the sheet sharply downward into a cup, and a sparse tangle with a hint of a planar structure below this which may have served to protect the spider from predators. The “naked” horizontal sheet of "), _c('i', [_vm._v("L. thoracica")]), _vm._v(" ("), _c('i', [_vm._v("b")]), _vm._v(") lacked tangles; it had a retreat at one edge (arrow) and a more open mesh near the edges. The "), _c('i', [_vm._v("T")]), _vm._v(". "), _c('i', [_vm._v("bilineata")]), _vm._v(" sheet ("), _c('i', [_vm._v("c")]), _vm._v(") also lacked tangles, but seen from the side it proved to be a double sheet loosely joined at the edge, forming a cavity that enclosed the spider (photographs by Gustavo Hormiga).")])]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0103"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "444",
      "src": "images/chi-eberhard-fig0103.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 1.3.")]), _vm._v(" This sampler illustrates some kinds of organization that are as yet only poorly documented in non-orb webs of mature females, including lines radiating from the spider’s retreat (dashed arrow) in a linyphiid sheet web ("), _c('i', [_vm._v("Agyneta")]), _vm._v(" sp.) ("), _c('i', [_vm._v("a")]), _vm._v("), zig-zag sticky lines centered on a retreat (dashed arrow) in a desid web ("), _c('i', [_vm._v("Matachia livor")]), _vm._v(") ("), _c('i', [_vm._v("b")]), _vm._v("), and skeletons of long, more or less straight lines (arrows) that support the sheet webs and extended beyond some edges in the pisaurid "), _c('i', [_vm._v("Architis")]), _vm._v(" sp. (whose web is unusual in having two, approximately vertical sheets, connected by a short tunnel) ("), _c('i', [_vm._v("c")]), _vm._v("), and the pholcid "), _c('i', [_vm._v("Modisimus bribri")]), _vm._v(" ("), _c('i', [_vm._v("d")]), _vm._v(") (see also "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0018#fig0521"
    }
  }, [_vm._v("fig. 5.21")]), _vm._v("). The zig-zag sticky lines (strong white lines) in the web of "), _c('i', [_vm._v("M. livor")]), _vm._v(" imply two patterns seen in the construction behavior of many non-orb spiders. The sticky lines must have been built after the non-sticky lines (or at least those between which the zig-zags are built). And construction of the sticky lines, must have occurred in discrete bouts in different sectors of the web. Web construction behavior has never been observed directly in this species (or in any other desid), so these inferences remain unconfirmed ("), _c('i', [_vm._v("a")]), _vm._v(" photograph by Gustavo Hormiga, "), _c('i', [_vm._v("b")]), _vm._v(" courtesy of Brent Opell).")])]), _vm._v(" "), _c('p', [_vm._v("Orb weavers also offer additional practical advantages for a behaviorist. Because of the limitations of the spider’s sensory world and the great importance of stimuli from the lines in the web in guiding her building behavior, simple experimental manipulations of these lines can reveal how they guide the spider. With only moderate care, it is possible to observe a spider closely without alarming it. Spiders tend to build their webs at highly predictable sites and times, and construction behavior often involves many highly repetitive behavior patterns, allowing an observer in the field to observe fine behavioral details over and over, and eventually understand them. Repetition also offers unusual opportunities to evaluate the frequency with which spiders make errors and examine the conditions which promote errors ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.07"
    }
  }, [_vm._v("section 9.7")]), _vm._v("), difficult topics that are presently uncommon in studies of animal behavior but which may be important in understanding how behavior evolves (Eberhard 1990a, 2000a). While these advantages are especially clear in orb webs, non-orbs also offer scope (which has hardly been exploited) for deductions about behavior ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0104"
    }
  }, [_vm._v("Fig. 1.4")]), _vm._v("), including how behavior is organized and the effects that this organization has on behavioral evolution and the mental processes involved in compensating for previous errors ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#fig0503"
    }
  }, [_vm._v("Figs. 5.3")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#fig0504"
    }
  }, [_vm._v("5.4")]), _vm._v("). Variability is the rule in orbs, even when sequential webs are built by the same individual at exactly the same site (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#fig0741"
    }
  }, [_vm._v("Fig. 7.41")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("In sum, I believe that orb web construction behavior can be in the vanguard as studies of animal behavior move past the current, largely typological stage (focused on “the” behavior of a species), and on to population thinking in which variation and its consequences are described and analyzed (Mayr 1982). For instance, orb webs permit one to employ huge sample sizes to study the sizes and frequencies of true behavioral errors ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.07"
    }
  }, [_vm._v("section 9.7")]), _vm._v(") and possible lapses of attention (Eberhard and Hesselberg 2012), as well as variation in adaptive flexibility in behavior (which in most species has also been treated typologically, such as “the” behavior that is performed under condition "), _c('i', [_vm._v("x")]), _vm._v(", and “the” behavior under condition "), _c('i', [_vm._v("y")]), _vm._v("). Another consequence of the frozen behavior is to facilitate study of the multiple influences on the same decision. For instance, ten or more different variables influence each decision that an orb weaver makes when she attaches a loop of sticky spiral to a radius ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.20.01"
    }
  }, [_vm._v("section 7.20.1")]), _vm._v("). While the behavioral record offered by an orb is incomplete (for instance, more than one type of leg movement can produce a particular web design) (Vollrath 1992), combining observations of webs with observations of the building behavior itself can nevertheless provide a very unusual opportunity to study behavior in great detail. One objective of this book is to provide a solid base on which a new generation of behavioral studies can be built.")]), _vm._v(" "), _c('p', [_vm._v("Such “mechanistic” details, which used to be standard fare in animal behavior studies, are currently out of style; many recent studies of behavior emphasize instead ultimate causes—the effects of natural selection on behavior in terms of reproductive payoffs. Sooner or later, however, behaviorists will have to return to the study of behavioral mechanisms in order to understand how selection actually brings about its effects on behavior; in the end, the mechanisms are the traits on which selection acts. The field of morphological evolution has already entered this sort of transition, with a rebirth of interest in the previously neglected effects of developmental processes (Nijhout 1991; Raff 1996; West-Eberhard 2003).")]), _vm._v(" "), _c('p', [_vm._v("Orb web spiders have often been thought of as small automatons that are tightly programmed to build the same species-specific webs day after day, and that are completely unconscious of their own work (Fabre 1912; Hingston 1920, 1929). It is true that spiders need no previous "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "9",
      "id": "p9",
      "role": "doc-pagebreak"
    }
  }), _vm._v("learning to produce an orb, and indeed, spiderlings that have just emerged from the egg sac can spin complete webs on their first try ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0105"
    }
  }, [_vm._v("Fig. 1.5")]), _vm._v("); and there is little indication that their behavior improves with practice ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.19"
    }
  }, [_vm._v("section 7.19")]), _vm._v("). As described long ago by Hingston (1920), spiders seem unable to make even what would seem to be simple adjustments to some experimental alterations to their webs: “Introduce difficulties in its circuit . . . , build up obstructions to impede the blind routine, and the spider can do nothing to overcome them; it can only struggle in its course. It can appreciate none of these difficulties; it can understand none of these obstacles; all it can do is but circle on” (p. 134).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0104"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "8",
      "id": "p8",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-eberhard-fig0104.jpeg",
      "width": "534"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 1.4.")]), _vm._v(" This orb of a mature female "), _c('i', [_vm._v("Micrathena duodecimspinosa")]), _vm._v(" illustrates both the beautiful geometric regularity for which orb webs are famous, and subtle patterns of "), _c('i', [_vm._v("irregularity")]), _vm._v(". The graph below shows that although the spaces between the loops of sticky spiral are highly regular, those nearer the outer edges are considerably larger than those nearer the hub (except for the innermost few loops below the hub). This pattern, common in the orbs of several families (Eberhard 2014; see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0306"
    }
  }, [_vm._v("fig. 3.6")]), _vm._v("), leads to the proposal that an orb should be viewed not as a single unit prey trap, but rather as a combination of traps with different prey-catching properties in different portions of the orb ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03"
    }
  }, [_vm._v("section 4.3")]), _vm._v("). To give an idea of scale, this web of an approximately 1 cm long spider, contains the following: 18.7 m of sticky spiral; 9.6 m of radii (including the set of radii that she broke and reeled up, then later reingested when she removed the center of the hub); 0.4 m of hub loops; 1.6 m of frame lines; and 1.5 m of anchor lines. It has 3840 attachments (319 of non-sticky lines to each other, 3521 of sticky to non-sticky lines). Not bad for about 40 min of work.")])]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0105"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-eberhard-fig0105.jpeg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p9"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 1.5.")]), _vm._v(" This was the first orb web built by a spiderling of the nephilid "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" after emerging from the egg sac; it illustrates an additional pair of themes of this book—the apparently minor role of learning in web construction behavior, and the blind spot of adultophilic arachnologists. The black dots indicate intact loops of the non-sticky temporary spiral, an unusual trait that is present in this first orb of the spider’s life just as in the orbs of adults (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0404"
    }
  }, [_vm._v("fig. 4.4")]), _vm._v("). The small tangle in the foreground (which obscures the spider resting at the hub) is another unusual trait also found in adult webs. The web’s highly regular design and its similarity to the orbs of mature females show that these spiders need little or no learning to build an orb. The basic similarity between the orb designs of young spiderlings and adults, typical of most orb weavers, is also striking in view of the differences in their sizes: the spiderling weighed on the order of 1 mg, while adult females weighed on the order of 1000 mg. They must confront very different ecological problems such as distributions of prey sizes and abundances, possible websites, predators, and parasites. Arachnologists studying web designs have traditionally analyzed the costs and benefits of orb designs for the adult, and neglected the behavior and ecology of younger stages. This “adultophilic” bias needs to be overcome, because selection must act on web designs throughout a spider’s life (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.02.14"
    }
  }, [_vm._v("section 3.2.14")]), _vm._v(").")])]), _vm._v(" "), _c('p', [_vm._v("This simple automaton view has gradually eroded, however (see summaries in Herberstein and Heiling 1999; Herberstein and Tso 2011; Hesselberg 2015), and one of the themes in this book is that it must now be discarded. Spiders clearly show substantial, multi-dimensional flexibility in their web construction behavior (see, for example, "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0106"
    }
  }, [_vm._v("Figs. 1.6")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#fig0602"
    }
  }, [_vm._v("6.2")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#fig0736"
    }
  }, [_vm._v("7.36")]), _vm._v("). It is possible that these adjustments may themselves result from “pre-wired” alternative behavior patterns, implying that the appropriate change in views is from a simple to a complex automaton. It is also possible, however, that spiders have some sort of primitive understanding of the mechanical consequences of their building behavior (Eberhard 2019b).")]), _vm._v(" "), _c('p', [_vm._v("The original impression of simplicity and invariability that was associated with the early oversimplified descriptions of orb construction behavior has been followed by a gradual accumulation of exceptions to the behavioral “rules,” and an appreciation of previously unnoticed or unreported subtlety and variations. This process is incomplete, and our present understanding is undoubtedly still overly typological. In addition, there is obviously much still to be learned, even about well-studied species ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0107"
    }
  }, [_vm._v("Fig. 1.7")]), _vm._v("). The need to deal with such variation has increased the difficulty of writing this book. I have struggled to avoid two extremes: overly simplistic descriptions of behavior and webs that are clear and easy to understand but seriously underestimate variation; and overly complex descriptions that are more nearly correct but are too convoluted for even the most motivated reader to follow.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0106"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "448",
      "src": "images/chi-eberhard-fig0106.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p10"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 1.6.")]), _vm._v(" These webs illustrate the behavioral flexibility of orb weavers, a major theme of this book. The two webs built in captivity by "), _c('i', [_vm._v("Philoponella oweni")]), _vm._v(" (UL) ("), _c('i', [_vm._v("a-c")]), _vm._v(") illustrate “alternative phenotypes”: "), _c('i', [_vm._v("a")]), _vm._v(" is a complete horizontal orb with no tangle; "), _c('i', [_vm._v("b")]), _vm._v(" and "), _c('i', [_vm._v("c")]), _vm._v(" show a tangle web seen from above. In "), _c('i', [_vm._v("b")]), _vm._v(" all lines in the web are visible, while in "), _c('i', [_vm._v("c")]), _vm._v(" only the sticky lines are visible (the web was coated with white powder and photographed in "), _c('i', [_vm._v("b")]), _vm._v(", and then jarred repeatedly to remove the powder from all non-sticky lines and photographed again in "), _c('i', [_vm._v("c")]), _vm._v("). Other webs of this species included both an orb and a tangle; some individual spiders built all three web types. A second type of flexibility ("), _c('i', [_vm._v("d")]), _vm._v("), in which spiders adapt their web designs to the environments in which they find themselves, is illustrated by the horizontal web of an immature "), _c('i', [_vm._v("Tetragnatha")]), _vm._v(" sp. on a strand of barbed wire (the elongate spider was hidden under the wire at the hub).")])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "sec01.05"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "10",
      "id": "p10",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec01.05"
    }
  }, [_vm._v("1.5 The scope of this book and tactics in presentation")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("A great deal is known about spider webs, and in order to avoid an incomprehensible sprawl of endless lists, I have often emphasized only more general trends and ideas, attempting to avoid giving so much detail that the reader loses view of the most interesting aspects of the forest for the trees. Much detailed data is relegated to tables and online appendices. So much is now known about spider webs that a truly thorough summary of current knowledge would be crushingly dull. I have tried to make the text accessible to a general reader by focusing on particular illustrative examples rather than making exhaustive discussions, and by filling in some details with extensive figure captions. In many places I have avoided giving long strings of citations to document a particular statement, citing instead another section of the book where previous work on the topic is discussed more thoroughly.")]), _vm._v(" "), _c('p', [_vm._v("I have attempted to evaluate previous studies critically, because there is both imprecision and controversy in some published accounts. Presenting convincing and fair discussions of conflicting ideas sometimes posed "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "12",
      "id": "p12",
      "role": "doc-pagebreak"
    }
  }), _vm._v("a challenge, because the data and the arguments were complex and tedious. Nevertheless I wanted to avoid two tactics that are unfortunately common in recent publications: simply accepting all published claims at face value; or dismissing (or even ignoring) some views without giving any justifications. These traits can make for smooth prose, but are unfair to both readers and previous authors. Advances in science often depend on disproving hypotheses, so the reasons for discarding previous ideas are important (Popper 1970). And some imprecise ideas, if not specifically challenged, acquire lives of their own when they are repeated uncritically by subsequent authors. In a few, particularly complex topics I give only simplified discussions in the text, and detailed critical discussions in appendices. Even this tactic has its limits (there is simply not enough room, for instance, for a thorough discussion of every single function that imaginative arachnologists have proposed for the function of silk stabilimenta) (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04"
    }
  }, [_vm._v("section 3.3.4")]), _vm._v(").")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0107"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "11",
      "id": "p11",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "454",
      "src": "images/chi-eberhard-fig0107.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 1.7.")]), _vm._v(" A serious historical problem in spider webs studies has been the tendency to use typological descriptions of web designs that overlooked details and variations. This kind of problem is illustrated in these images of webs of "), _c('i', [_vm._v("Cyrtophora citricola")]), _vm._v(" (AR), whose general design was described nearly 100 years ago (Wiehle 1928) and has subsequently been studied extensively (Blanke 1972, 1975; Kullmann 1972; Lubin 1973, 1974, 1980; Sabath et al. 1974; Berry 1987; Peters 1993a; Rao and Poyyamoli 2001). Nevertheless, several previously under-appreciated details reveal further sophistication of these webs as traps. Early descriptions mentioned a dense tangle of lines above and below a horizontal, planar sheet (see "), _c('i', [_vm._v("a")]), _vm._v(", a largely finished, 4-day old web), and a clear organization of the lines in the sheet, with frequently bifurcating radial lines that converged on a central hub that were connected by an uniformly spaced, tight non-sticky spiral. The tangles above and below the sheet were said be connected to its outer edges, and also, in the case of the upper tangle, to the hub. But closer examination adds several details. An image of this same web after only a single night of building ("), _c('i', [_vm._v("b")]), _vm._v("; in this image, in contrast with the others, the web was not dusted), shows that the tangle was built by stages. The spider first built only a sparse tangle above and below the radially organized sheet. The sheet was not planar, but instead had deep, widely spaced downward-directed dimples where a few widely spaced, taut lines connected it to the tangle below; it also had a large hole at the hub, through which the spider climbed to attack prey that were trapped in the upper tangle. The “dimple” lines undoubtedly increased the tension on the sheet itself, but nonetheless left it sufficiently lax for the spider to fold it slightly with her legs, partially enclosing prey as she attempted to grasp and bite them from below the sheet. The spider added to the tangles on subsequent nights, especially above the sheet where many additional, relatively lax lines attached to the top of the sheet scarcely pulled it upward ("), _c('i', [_vm._v("d")]), _vm._v("). The dense array of looser lines just above the sheet may help retain prey on the sheet’s upper surface. The sheet itself also showed additional patterns. The circular lines were not evenly spaced as in previous descriptions, but those farther from the hub were farther apart ("), _c('i', [_vm._v("e")]), _vm._v("). In addition, the spider extended portions of the sheet with irregularly-oriented lines attached to its outer edge ("), _c('i', [_vm._v("c")]), _vm._v(", "), _c('i', [_vm._v("f")]), _vm._v("). Rarely, in webs built at sites where there were only elongate open spaces ("), _c('i', [_vm._v("f")]), _vm._v(") this irregular sheet was extended still farther, first by an additional “orb-like” portion with regularly arranged, more or less parallel “peripheral radial” lines and tightly spaced “peripheral spirals,” and then by an additional extension with irregular lines (the central, radially arranged sheet and its hub are out of sight on the right). These “peripheral radii” did not converge in a hub-like patterns. The reader should be forewarned that many or probably most web descriptions in this book likely err in being excessively typological. The webs in "), _c('i', [_vm._v("a")]), _vm._v(" and "), _c('i', [_vm._v("d–f")]), _vm._v(" were of adult females, those in "), _c('i', [_vm._v("b")]), _vm._v(" and "), _c('i', [_vm._v("c")]), _vm._v(" were of intermediate-sized spiderlings; the arrows in "), _c('i', [_vm._v("a")]), _vm._v(" indicate webs of second instar spiderlings built in the lower tangle of an adult female’s web.")])]), _vm._v(" "), _c('p', [_vm._v("Another common practice that I have tried to reduce is talking about “the” spider or about “the” web of a species. I usually give the genus and species name of each species that is mentioned. My attempts to be more specific are motivated by discoveries of how much variation exists both within and between species. To help protect readers from drowning in a sea of unfamiliar names, I include the family affiliation of each species mentioned, and use the following abbreviations for the families that are most commonly mentioned (the numbers in parentheses give the approximate numbers of described species and genera [Platnick 2014], and thus indicate some aspects of their biological importance): AN = Anapidae (154; 38); AR = Araneidae (3,045; 169); DEI = Deinopidae (60; 2); LIN = Linyphiidae (4,490; 591); MYS = Mysmenidae (131; 23); NE = Nephilidae (61; 5); SYM = Symphytognathidae (69; 7); TET = Tetragnathidae (967; 47); THD = Theridiidae (2,420; 121); TSM = Theridiosomatidae (106; 18); and UL = Uloboridae (271; 18) (Platnick 2014). I have virtually ignored, however, the large family Linyphiidae, because an extensive review of their webs will be published elsewhere (G. Hormiga and W. Eberhard in prep.). It has not been possible during the protracted process of the production of the book to keep up with the very latest (not necessarily stable) taxonomic opinions; for instance, Nephilidae has been relegated to a subfamily of Tetragnathidae or Araneidae in some recent studies.")]), _vm._v(" "), _c('p', [_vm._v("When the option was available, I have chosen web photographs of species not illustrated in previous publications, in order to increase taxonomic coverage. I often find that the patterns of web lines are easier to perceive in negative images, so I have used many negatives of web photos.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "sec01.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec01.06"
    }
  }, [_vm._v("1.6 Evolutionary history and phylogeny")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The probable evolutionary history and the phylogenetic relations between the major groups of spiders form an important general context for much of this book. Given the current uncertainties regarding phylogenetic relations (below), perhaps the most important data concern the evolutionary age of silk use in spiders. Fossils indicate that webs are quite ancient ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0108"
    }
  }, [_vm._v("Fig. 1.8")]), _vm._v(") (Vollrath and Selden 2007). Judging by fossil spinnerets, silk production was already well-developed in the early Devonian (approximately 390–400 million years ago [Mya]). Webs themselves seldom leave fossils, but the taxonomic affinities of fossil groups and the behavior of their modern relatives indicate that prey capture webs (which probably extended the spider’s sense of touch near the mouth of the burrow) were present on the order of 300–310 Mya (in Mesothelae). Funnel weavers (hexathelid mygalomorphs) were present about 240 Mya, and possible araneomorphs about 230 Mya (by this time, flying insects are abundant in the fossil record). Sticky (cribellum) lines cannot be confidently attributed to spiders before about 165 Mya, at which time orb-weavers (deinopoids and "), _c('i', [_vm._v("Nephila")]), _vm._v(") were already present (Selden et al. 2011, 2013); the earliest known araneoids date from a little later, about 140 Mya ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0108"
    }
  }, [_vm._v("Fig. 1.8")]), _vm._v("). Dates determined from molecular data are in general accord but somewhat older (Dimitrov et el. 2016). To put these dates into perspective, orb webs had apparently already evolved before or at the same time when birds originated as a branch of dinosaurs (about 150 Mya), the first of the major groups of modern mammals were first appearing (about 150 Mya), and before flowering plants first appeared (about 132 Mya) (Zimmer and Emlen 2013). The ancient nature of webs, and of orb webs in particular, is "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "13",
      "id": "p13",
      "role": "doc-pagebreak"
    }
  }), _vm._v("crucial for understanding modern patterns of diversity and evolution ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#ch09"
    }
  }, [_vm._v("chapters 9")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#ch10"
    }
  }, [_vm._v("10")]), _vm._v(").")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0108"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "373",
      "src": "images/chi-eberhard-fig0108.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p13"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 1.8.")]), _vm._v(" This summary of fossil evidence, placed on a recent phylogeny, emphasizes the ancient nature of spider webs and orb webs in particular (“Orbiculariae”) (thick lines give time ranges based on described fossil specimens; dotted lines give estimated time ranges based on ages of fossils of sister groups). Although some details of the phylogeny (and estimated time ranges) may change, several conclusions can be drawn. The Opisthothelae are, as expected, much more ancient than the araneomorphs. Webs with sticky (cribellum) lines arose early (about 230 Mya). Uloborids arose relatively early within araneomorphs, and araneoids were present soon after, thus supporting the ancient nature of orb webs. The RTA clade, in which orb webs were secondarily discarded long ago, may not have become diverse and abundant until much later (no fossils are known for the first half of its proposed existence). Several currently speciose and abundant RTA families, such as salticids, thomisids, and clubionids, are absent from cretaceous amber, where they would presumably have been trapped if they had been common (modified after Vollrath and Selden 2007, courtesy of Paul Selden).")])]), _vm._v(" "), _c('p', [_vm._v("Unfortunately, although there are many extensive studies of higher-level spider phylogeny, which have used morphological, molecular, and to a lesser extent behavioral traits, many relationships of modern spiders are currently unresolved ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0109"
    }
  }, [_vm._v("Fig. 1.9")]), _vm._v("). “Most deep clades in spider phyogenies are disputed, mainly by molecular results. Not only are new molecular studies incongruent with much ‘traditional’ knowledge but they are often incongruent with one another” (Agnarsson et al. 2013; p. 83). To date most molecular studies have relied on a small sample of 11 genes (for which primers were easily available). Hopefully, shifts to “next generation” techniques that permit the analysis of many more genes (e.g., Garrison et al. 2016, "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0110"
    }
  }, [_vm._v("Fig. 1.10")]), _vm._v(") will improve the quality of the molecular data. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0108"
    }
  }, [_vm._v("Figs. 1.8–1.15")]), _vm._v(" illustrate several recent trees; probably all will change in the future.")]), _vm._v(" "), _c('p', [_vm._v("In the face of this uncertainty, I will use some traditional groupings for descriptive purposes, without implying strict phylogenetic relationships (unless specifically stated). “Araneoidea” (a well-supported grouping in recent analyses) will refer to the orb-weaving groups Araneidae, Tetragnathidae, Nephilidae, and Symphytognathoidea, as well as to the related but probably secondarily non-orb weaving families Nesticidae, Synotaxidae, Linyphiidae, Pimoidae, and also what at the moment appears to be the sister group for all of these, the “tangle "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "15",
      "id": "p15",
      "role": "doc-pagebreak"
    }
  }), _vm._v("web” family Theridiidae. “Orbicularia” will refer to the araneoids plus the cribellate orb weaving families Deinopidae and Uloboridae (this grouping appears to be paraphyletic); Deinopoidea will refer to Uloboridae and Deinopidae (as well as the fossil families Mongolarachnidae and Juraraneidae, which may or may not be closely related—Selden et al. 2015); it may also be paraphyletic; the well-supported “RTA clade” (a large set of families that lack orbs and that generally do not build webs at all) is the sister group of Deinopoidea (Dimitrov et al. 2011; Bond et al. 2014; Fernández et al. 2014). I will also employ the term “non-orbicularian” or “non-orb weaver” to designate species whose webs are not orbs; this grouping is surely paraphyletic.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0109"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "14",
      "id": "p14",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-eberhard-fig0109.jpeg",
      "width": "572"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 1.9.")]), _vm._v(" Evolutionary perspectives are important in many portions of this book. Unfortunately, many aspects of the higher-level phylogeny of spiders are as yet uncertain, largely due to conflict between morphological and molecular data ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#sec01.06"
    }
  }, [_vm._v("section 1.6")]), _vm._v("). This uncertainty is illustrated with this morphology-based tree published fifteen years ago (Coddington 2005) on which the conclusions from recent molecular analyses have been superimposed. Basal clades that are presently controversial due to the lack of molecular support are indicated by symbols with “x” at branching points. Few of the formerly recognized groups have strong support (white circles). Many groupings in this tree and the others in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0110"
    }
  }, [_vm._v("figs. 1.10–1.15")]), _vm._v(" are only best guesses and are likely to change in the future (after Agnarsson et al. 2013).")])]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0110"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-eberhard-fig0110.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p15"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 1.10.")]), _vm._v(" This tree has the virtue of being based on an especially recent, large data set; black dots indicate orb webs or modified orbs (after Garrison et al. 2016).")])]), _vm._v(" "), _c('p', [_vm._v("Several additional, less controversial groupings are important to understanding web evolution. Mygalomorpha "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "17",
      "id": "p17",
      "role": "doc-pagebreak"
    }
  }), _vm._v("are the tarantulas and their allies, while Araneomorpha are the “true” spiders (all spiders other than Mygalomorpha and Mesothelae). At the family level, the orb weaver families Deinopidae, Uloboridae, and all of the araneoid families are “probably by and large monophyletic,” though the relations between them are as yet uncertain (Agnarsson et al. 2013). Some non-orb weaver families, such as Filistatidae and Pholcidae, are also apparently monophyletic, but others, including Agelenidae, Amaurobiidae, Hahniidae, and Dictynidae, are probably polyphyletic (Griswold et al. 2005; Agnarsson et al. 2013).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0111"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "16",
      "id": "p16",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "424",
      "src": "images/chi-eberhard-fig0111.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 1.11.")]), _vm._v(" This tentative phylogeny of orb-weaving families and their close relatives in Araneoidea is intended to help the reader place the genus names that are mentioned frequently in the text (after Garrison et al. 2016) (loosely based on Griswold et al. 1998). These characterizations of web types are seriously imprecise (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.04"
    }
  }, [_vm._v("sections 9.4")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.05.02"
    }
  }, [_vm._v("10.5.2")]), _vm._v(").")])]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0112"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "366",
      "src": "images/chi-eberhard-fig0112.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p16"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 1.12.")]), _vm._v(" This morphology-based phylogenetic tree has the advantage of including most of the orb-weaving araneoid genera mentioned in the text (modified from Scharff and Coddington 1997), but future data will probably suggest modifications. Probably the lineage of "), _c('i', [_vm._v("Zygiella")]), _vm._v(" and closely related genera originated more basally, following the splits that led to Tetragnathidae and Nephilidae; the webless genus "), _c('i', [_vm._v("Arkys")]), _vm._v(" may lie outside Araneidae (Gregorič et al. 2015).")])]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0113"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "381",
      "src": "images/chi-eberhard-fig0113.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p17"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 1.13.")]), _vm._v(" A morphology-based phylogenetic tree for the genera of the orb-weaving family Uloboridae. The genera known to build more or less typical orbs are indicated by “ORB”; genera with substantially reduced webs are indicated with “*” (tree after Coddington 1990, and Opell 2002, with web information on "), _c('i', [_vm._v("Purumitra")]), _vm._v(" from F. Soley, pers. comm.).")])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "sec01.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec01.07"
    }
  }, [_vm._v("1.7 Terminology and other procedural matters")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Throughout the book, the word “web” with any modifier refers to a prey capture device. I will add a modifier to indicate those silk structures that have other functions, such as egg sac webs, resting webs, silken retreats, silk tangles made by newly emerged spiderlings near egg sacs, sheets made by adult females to protect themselves and their offspring (Sedey and Jakob 1998). These distinctions are admittedly not always clean. For instance, prey that brush against silk retreat lines were sometimes attacked by salticids (Nelson and Jackson 2011; Jackson and Macnab 1989a) and sometimes became entangled there (Hallas and Jackson 1986). Egg sacs sometimes had sticky silk laid on their outer walls, as in the uloborid genera "), _c('i', [_vm._v("Uloborus")]), _vm._v(", "), _c('i', [_vm._v("Miagrammopes")]), _vm._v(", "), _c('i', [_vm._v("Philoponella")]), _vm._v(", and "), _c('i', [_vm._v("Zosis")]), _vm._v(" (Lubin 1986; WE), the dictynid "), _c('i', [_vm._v("Mallos hesperius")]), _vm._v(" (WE), and the theridiid "), _c('i', [_vm._v("Latrodectus geometricus")]), _vm._v(" (Triana et al. 2012). These egg sacs were all at or near the spiders’ resting sites, so it is possible that protection for the eggs may have sometimes incidentally served to capture prey. In atypid spiders, the lining of the retreat is also the prey capture web (Coyle 1986); in one atypid, "), _c('i', [_vm._v("Sphodros rufipes")]), _vm._v(", the earth that was dug from the bottom of the tunnel and applied to the wall above ground as camouflage was first broken into small pieces, possibly to facilitate prey capture when the spider strikes through the wall with her fangs (WE). Individuals of the social eresid spider "), _c('i', [_vm._v("Stegodyphus dumicola")]), _vm._v(" and the solitary "), _c('i', [_vm._v("S. lineatus")]), _vm._v(" responded to the first signs of invasion of their web by ants by laying sticky silk near the point where the ants were about to invade (Henschel 1998; Leborgne et al. 2011). Using silk for other functions is biologically important, and deserves its own discussion. Interesting biological phenomena concerning the silk are associated with egg sacs: when a mature female of the theridiid "), _c('i', [_vm._v("Theridion evexum")]), _vm._v(" is attacked in her retreat by small ants, she moves her egg sac outside the retreat and builds a tangle of sticky lines around it (Barrantes and Weng 2007b); a clubionid (in an undescribed genus) makes a delicate, transparent veil over its egg mass that has 13 evenly spaced large holes around the edges (Murphy and Murphy 2000); and females in four different araneid genera that are not obviously closely related, "), _c('i', [_vm._v("Pozonia")]), _vm._v(", "), _c('i', [_vm._v("Micrathena")]), _vm._v(", "), _c('i', [_vm._v("Acacesia")]), _vm._v(", and "), _c('i', [_vm._v("Verrucosa")]), _vm._v(", fold a dead leaf around the egg sac in a tight package and then insert it into the "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "19",
      "id": "p19",
      "role": "doc-pagebreak"
    }
  }), _vm._v("leaf litter (Moya et al. 2010; Eberhard 2015; G. Barrantes pers. comm.). The “silk kisses” of the male pholcid "), _c('i', [_vm._v("Modisimus culicinus")]), _vm._v(" are perhaps the most esoteric use of silk: “During the last 30–50 s of each copulation the male bent his opisthosoma [abdomen] ventrally and repeatedly tapped the female’s spinnerets with his; a thick, apparently viscid thread became visible between male and female spinnerets” (Huber 1996, p. 239).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0114"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "18",
      "id": "p18",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-eberhard-fig0114.jpeg",
      "width": "459"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 1.14.")]), _vm._v(" This simplified cladogram shows the complex pattern of web evolution in the four families of “Symphytognathoidea.” Planar orbs have arisen twice from three-dimensional orbs in these tiny spiders. “Sheet” webs (see text) have arisen twice from three-dimensional orbs in the species in this cladogram, and two additional times in others (in an undescribed anapid from Madagascar, and in the symphytognatid genus "), _c('i', [_vm._v("Anapistula")]), _vm._v(") (from Lopardo et al. 2011). The monophyly of symphytognathoids is uncertain (Agnarsson et al. 2013).")])]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0115"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-eberhard-fig0115.jpeg",
      "width": "432"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p19"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 1.15.")]), _vm._v(" The visual impression in this simplified analysis of the evolutionary relationships of web designs, with only a few clades labeled, shows two typical patterns: web designs are clustered in particular clades; and they have frequently converged in different lineages. The ancient nature of orb webs is also clear. Several of the web classifications are imprecise, however (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.04"
    }
  }, [_vm._v("sections 9.4")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.05.02"
    }
  }, [_vm._v("10.5.2")]), _vm._v("); the symbols at junctions indicate the most probable state of each ancestor; the scale at the bottom is in Mya (after Dimitrov et al. 2016).")])]), _vm._v(" "), _c('p', [_vm._v("In order to clarify behavioral descriptions by avoiding the use of the less specific pronoun “it,” I engage in the convenient illusion (as in Spanish, French, German, and others) that all spiders are females. In any case, the overwhelming majority of published behavioral observations have been of mature females. The legs of a spider that is moving around a central point are distinguished as “outside” legs (thus “leg oI” is the first leg that is on the side farther from the hub) or “inside” legs (“leg iI” is nearer the hub). A movement of the spider toward the hub of an orb will be described as “inward,” and movements away from the hub as “outward.” A radius along which the spider "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "20",
      "id": "p20",
      "role": "doc-pagebreak"
    }
  }), _vm._v("moves outward will be termed an “exit” radius. The word “segment” refers to that portion of a line between two successive attachments of that line (e.g., a segment of sticky spiral); the “current segment” of a line refers to the line being laid between the spider’s spinnerets and the line’s most recent point of attachment. “Sticky” lines refer to lines that can adhere strongly to smooth surfaces (not to be confused with becoming snagged or entangled on surface irregularities); “non-sticky” lines are those that do not adhere strongly unless they are entangled. Arachnologists often use “viscid” to refer to sticky lines that are coated with droplets of liquid adhesive (thus distinguishing them from “dry sticky” lines that contain instead cribellum silk) (Foelix 2011). Some even distinguish “viscid” from “sticky” (Benjamin et al. 2002). I will adhere ("), _c('i', [_vm._v("sic")]), _vm._v("!) to the simple sticky vs. non-sticky distinction, and add descriptors (e.g., cribellate sticky lines) to distinguish different mechanisms of adhesion. I will often use the past rather than the present tense in referring to behavioral observations (“spiders attached sticky spirals to radii” rather than “spiders attach sticky spirals to radii”), in order to avoid giving the potentially misleading typological impression that these behaviors always occur.")]), _vm._v(" "), _c('p', [_vm._v("Some terms have been used in unusual ways in previous publications on spider webs. One of the most confusing is that the orbs of a species are often classified as being either “horizontal” or “vertical,” when in fact only a small fraction of orb webs are truly vertical (90° slant), and perhaps an even smaller fraction are precisely horizontal (0° slant); to give an idea of this imprecision, the webs of "), _c('i', [_vm._v("Leucauge")]), _vm._v(" (TET) are typically described as “horizontal,” but the slants of 66 "), _c('i', [_vm._v("L. mariana")]), _vm._v(" webs in the field ranged from 8 to 83°, with a mean of 39.9° (Eberhard 1987b; see also Gregorič et al. 2013 on "), _c('i', [_vm._v("L. venusta")]), _vm._v("). As has been customary, I use “horizontal” to refer to webs whose slants seem to be more nearly horizontal than vertical (usually 30° or less with horizontal). I will break with custom in recognizing two types of “vertical” orbs: those whose web planes are very close to 90° with horizontal (85–90°) (“truly vertical”), and orbs whose planes are seldom if ever precisely 90°, but are typically more than about 70° with horizontal (“vertical” or “approximately vertical”) (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.01.01"
    }
  }, [_vm._v("section 3.3.3.1.1")]), _vm._v(" for reasons why this distinction may be important, and appendix O9.3 for a more detailed discussion).")]), _vm._v(" "), _c('p', [_vm._v("I use the word “fiber” to designate a single cylinder of silk produced by a single spigot. In many cases a spider produces a pair of fibers, one from each of the corresponding spigots on her bilaterally symmetrical spinnerets; I will use the word “line” to refer to such pairs of fibers (or presumed pairs; the number of fibers was not determined in most descriptions). I avoid one other possible label for multi-fiber lines, “thread,” and use “cable” to refer to objects composed of relatively high numbers of fibers. I also use “line” to specify combinations of sticky and non-sticky silk, such as the “sticky spiral lines” of uloborid which include a pair of non-sticky base line fibers and a dense mat of hundreds of fine cribellum fibers. My usage is somewhat arbitrary, and there are other reasonable alternatives (Zschokke 1999).")]), _vm._v(" "), _c('p', [_vm._v("Several other “arachnological” terms for the forms of webs have been used in confusing ways, and may have hindered understanding web evolution ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.05.02"
    }
  }, [_vm._v("section 10.5.2")]), _vm._v("). The names for spider web forms often represent attempts to apply abstract human categories, and some webs do not fit these categories; inappropriate use of such names can sometimes inadvertently suggest homologies that may not exist. I do not use “sheet web” in its most encompassing meaning, to refer to any planar array of silk (as, for instance, in Griswold et al. 2005; Blackledge et al. 2009c; Harmer et al. 2011) because I believe that imprecise use of this term has impeded recognition of important diversity ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.04"
    }
  }, [_vm._v("section 9.4")]), _vm._v("). Instead I use “sheet” to refer only to a more or less planar, approximately horizontal array, and whose lines are sufficiently dense and planar that the spider can walk on top of it (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.05.02"
    }
  }, [_vm._v("section 10.5.2")]), _vm._v(" for distinctions regarding other categories such as “brushed,” “substrate,” “aerial,” and “stereotyped” used in some recent studies).")]), _vm._v(" "), _c('p', [_vm._v("I follow the arachnological tradition of not specifying the sex or age of a spider when referring to an adult female. This unfortunate “default” custom of emphasizing the webs of only adult females and neglecting those of males and younger individuals is deeply ingrained ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.02.14"
    }
  }, [_vm._v("section 3.2.14")]), _vm._v("). Some species for which species and genus identifications were not available are indicated by the numbers of specimens that are deposited in the Museum of Comparative Zoology at Harvard University. These and a second set of specimens that I have placed in the Museo de Zoología of the Escuela de Biología of the Universidad de Costa Rica (including "), _c('i', [_vm._v("Allocyclosa bifurca")]), _vm._v(", "), _c('i', [_vm._v("Araneus expletus")]), _vm._v(", "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "21",
      "id": "p21",
      "role": "doc-pagebreak"
    }
  }), _c('i', [_vm._v("Argiope trifasciata")]), _vm._v(", "), _c('i', [_vm._v("Cyclosa jose")]), _vm._v(", "), _c('i', [_vm._v("C. monteverde")]), _vm._v(", "), _c('i', [_vm._v("C. turbinata")]), _vm._v(", "), _c('i', [_vm._v("Diplothyron simplicatus")]), _vm._v(", "), _c('i', [_vm._v("Dolichognatha")]), _vm._v(" sp., "), _c('i', [_vm._v("Emblyna")]), _vm._v(" sp., "), _c('i', [_vm._v("Epeirotypus brevipes")]), _vm._v(", "), _c('i', [_vm._v("Kukulcania hibernalis")]), _vm._v(", "), _c('i', [_vm._v("Leucauge argyra")]), _vm._v(", "), _c('i', [_vm._v("L. mariana")]), _vm._v(", "), _c('i', [_vm._v("L. venusta")]), _vm._v(", "), _c('i', [_vm._v("Mallos hesperius")]), _vm._v(", "), _c('i', [_vm._v("Mangora")]), _vm._v(" sp., "), _c('i', [_vm._v("Metazygia wittfeldae")]), _vm._v(", "), _c('i', [_vm._v("Metepeira")]), _vm._v(" sp., "), _c('i', [_vm._v("Micrathena duodecimspinosa")]), _vm._v(", "), _c('i', [_vm._v("M. molesta")]), _vm._v(", "), _c('i', [_vm._v("Modisimus bribri")]), _vm._v(", "), _c('i', [_vm._v("Neoantisea riparia")]), _vm._v(", "), _c('i', [_vm._v("Neriene coosa")]), _vm._v(", "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(", "), _c('i', [_vm._v("Philoponella vicina")]), _vm._v(", "), _c('i', [_vm._v("Physocyclus globosus")]), _vm._v(", "), _c('i', [_vm._v("Tengella radiata")]), _vm._v(", "), _c('i', [_vm._v("Uloborus diversus")]), _vm._v(", "), _c('i', [_vm._v("U. eberhardi")]), _vm._v(", "), _c('i', [_vm._v("U. glomosus")]), _vm._v(", "), _c('i', [_vm._v("U. trilineatus")]), _vm._v(", "), _c('i', [_vm._v("Wagneriana tauricornus")]), _vm._v(", "), _c('i', [_vm._v("Witica crassicauda")]), _vm._v(", and "), _c('i', [_vm._v("Zosis geniculata")]), _vm._v(") are vouchers for figures and for the previously unpublished observations in this book that are cited as “WE.”")]), _vm._v(" "), _c('p', [_vm._v("I camouflage some uncertainty regarding the araneid whose behavior Hingston (1920) observed in India by referring to it as "), _c('i', [_vm._v("Neoscona nautica")]), _vm._v(" (on the recommendation of H. W. Levi). Hingston referred to it as "), _c('i', [_vm._v("Araneus nauticus")]), _vm._v(", but did not deposit voucher specimens; he observed this species and "), _c('i', [_vm._v("Tetragnatha")]), _vm._v(" sp. at the same site, and apparently sometimes lumped them together in his descriptions.")]), _vm._v(" "), _c('p', [_vm._v("There are several synonyms in English for the terms that I use ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0104"
    }
  }, [_vm._v("Fig. 1.4")]), _vm._v("): "), _c('i', [_vm._v("anchor line")]), _vm._v(" = “guy” or “mooring” line; "), _c('i', [_vm._v("upper primary frame line")]), _vm._v(" = “bridge frame” or “foundation line”; "), _c('i', [_vm._v("radius")]), _vm._v(" = “spoke” or “ray”; "), _c('i', [_vm._v("temporary spiral")]), _vm._v(" = “provisional,” “auxiliary,” “non-sticky,” “structural,” or “scaffolding” spiral; "), _c('i', [_vm._v("sticky spiral")]), _vm._v(" = “viscid,” “permanent,” “catching,” or “capture” spiral; and "), _c('i', [_vm._v("hub spiral")]), _vm._v(" = “inner” or “strengthening” spiral (Jackson 1973, Le Guelte 1966, and Zschokke 1999 review terms in English, German, and French). For terms that have been used inconsistently in the literature, I use the following definitions (see also "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0104"
    }
  }, [_vm._v("Fig. 1.4")]), _vm._v("). "), _c('i', [_vm._v("Primary")]), _vm._v(" frame lines are those frame lines (generally longer and built earlier in construction) that end on (or are continuous with) anchor lines. "), _c('i', [_vm._v("Secondary")]), _vm._v(" (= “auxiliary, or “inner”) frame lines are those that end on other frame lines. "), _c('i', [_vm._v("Primary")]), _vm._v(" radii include those radii that are built during the process of primary frame construction, plus any other radii that were already present prior to initiation of primary frame construction (e.g., radius "), _c('i', [_vm._v("y")]), _vm._v(" in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#fig0605"
    }
  }, [_vm._v("Fig. 6.5")]), _vm._v("). "), _c('i', [_vm._v("Secondary")]), _vm._v(" radii are all the other radii that originate at the hub and that are built after the primary radii but before the temporary spiral; they include both radii built during secondary frame construction, and others (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#fig0605"
    }
  }, [_vm._v("Fig. 6.5e")]), _vm._v("). "), _c('i', [_vm._v("Tertiary")]), _vm._v(" (or “split” or “subsidiary”) radii are those built during temporary spiral construction (Fig. O6.8). Sometimes two secondary radii were fastened together by the temporary spiral near the hub (where radii were especially close to each other), giving the false impression of a tertiary radius ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#fig0610"
    }
  }, [_vm._v("Fig. 6.10")]), _vm._v("). The radial dragline that was laid on the trip away from the hub during radius construction and then immediately broken and replaced on the way back to the hub is a “provisional” radius (see Zschokke 1999 for other terminology). My use of one term rather than another is somewhat arbitrary, and is based largely on descriptive clarity; I have not attempted to trace which terms were used first.")]), _vm._v(" "), _c('p', [_vm._v("Arachnologists have usually characterized the times at which the webs of any given species are built and operated with the simple terms “nocturnal” and “diurnal,” but in fact the topic is substantially more complex. For instance, some nocturnal species build just at dusk, others later at night; some webs that are built at night are removed before dawn, while others are left in place the following day. In addition, there is often substantial intra-specific variation in the timing of web construction. I discuss these complications later ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.10"
    }
  }, [_vm._v("section 8.10")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0023#fig0813"
    }
  }, [_vm._v("Fig. 8.13")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#tab0802"
    }
  }, [_vm._v("table 8.2")]), _vm._v("), and will generally use the standard oversimplified diurnal/nocturnal classification.")]), _vm._v(" "), _c('p', [_vm._v("I use “spacing” to refer to the distances between loops of sticky spiral in orbs, and avoid the more common term “mesh.” Strictly speaking, the “mesh” of a woven structure refers to both the warp and the woof, not to just one of the two (as, indeed, “mesh” was used by Witt 1971). Substituting the terms “mesh-width” and “mesh-length” becomes confusing (at least for me) when labeling the spaces between lines below and to the sides of the hub. In addition, an orb web is emphatically "), _c('i', [_vm._v("not")]), _vm._v(" appropriately characterized as having a single mesh size; the radii are much closer together near the hub than near the outer edge, and these differences have important functional implications ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03"
    }
  }, [_vm._v("section 4.3")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("Arachnologists have generally been lax in attributing particular types of silk lines to particular glands, especially in descriptions of behavior (the careful studies of Hans Peters 1984, 1990, 1993a, 1995b are exceptions). There are several possible but labor-intensive ways to demonstrate the glands that produce different lines. One is to flash freeze the spider and check which spigots were producing lines (Peters 1984), and then trace connections between the spigots and the glands of that "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "22",
      "id": "p22",
      "role": "doc-pagebreak"
    }
  }), _vm._v("species. Others are to check the chemical properties of gland contents and lines (e.g., Townley and Tillinghast 2013), or to demonstrate that particular glands are empty or depleted immediately following production of particular types of lines (Witt et al. 1968). These techniques have been employed in only a few species. And even these techniques may be inadequate: some glands have multiple, possibly different lobes (Řezáč et al. in press; P. Michalik pers. comm.); some produce multiple products (Bittencourt et al. 2010; I. Agnarsson pers. comm.); and some spigots (e.g., of the piriform glands) produce both solid lines and liquid simultaneously (Eberhard 2010a). In addition, because nearly all work on silk has been on orbicularian spiders, glands and spigots of other groups that are thought to be homologous are only assumed to produce lines with similar properties, without experimental tests ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02"
    }
  }, [_vm._v("section 2.2")]), _vm._v("). Hesselberg and Vollrath (2012) discuss, for example, the difficulties of distinguishing lines from major and minor ampullate glands in "), _c('i', [_vm._v("Nephila edulis")]), _vm._v(" webs. For lack of better data, I follow the tradition of assuming that the loosely established associations between glands and lines are correct; the reader should keep these uncertainties in mind.")]), _vm._v(" "), _c('p', [_vm._v("Different authors have used different names for the early developmental stages of spiders outside the egg; I will follow Foelix (2011): spiders emerge from the egg within the sac as “first instar” spiderlings, then molt once and leave the sac as “second instar” spiderlings (the stage in which most build their first prey capture webs).")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "sec01.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec01.08"
    }
  }, [_vm._v("1.8 Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("I have benefited immensely from working at the Smithsonian Tropical Research Institute, whose consistent, effective, and generous support has freed me from the frenetic chasing after grants that is an unfortunate aspect of many academic jobs in biology. STRI has asked me to contribute knowledge, and has judged me on the basis of what I have produced, rather than the amount of money I have raised; this is a luxury that many modern biologists cannot afford, and one for which I am truly grateful. I also benefited greatly from working at the Universidad del Valle in Cali, Colombia, for 10 years, and then for >35 years at the Universidad de Costa Rica. Both provided freedom, stimulating colleagues, pleasant working conditions, and inspiring students. I am especially grateful to my colleagues Gilbert Barrantes and Daniel Briceño at UCR for their friendship, collaboration, and sustained, enthusiastic intellectual stimulation.")]), _vm._v(" "), _c('p', [_vm._v("I had the good fortune to be raised academically in a museum, and I have always felt closer in my spider interests to taxonomist colleagues than to ecologists or even behaviorists. I owe special thanks to the late Herbert Levi for his unstinting identifications of long series of spiders, and his patience in not seeing quick published payoffs for all his work. Others who kindly provided identifications of specimens are Ingi Agnarsson, Brent Opell, Norman Platnick, and Darrell Ubick.")]), _vm._v(" "), _c('p', [_vm._v("I have also benefited greatly from and been inspired by the high standards set for careful, meticulous, and extensive integration of massive amounts of information by spider systematists like Ingi Agnarsson, Jonathan Coddington, Charles Griswold, Gustavo Hormiga, Bernhard Huber, Matjaž Kuntner, Herbert Levi, Brent Opell, Norman Platnick, and Martin Ramírez. They have been my closest colleagues in arachnology.")]), _vm._v(" "), _c('p', [_vm._v("More specific thanks go to Ingi Agnarsson, Gilbert Barrantes, Todd Blackledge, Rainer Foelix, Gustavo Hormiga, Sean Kelly, Matjaž Kuntner, Yael Lubin, Yuri Messas, Peter Michalik, Tadashi Miyashita, Jairo Moya, John Murphy, Martin Ramírez, Nicolaj Scharff, Diego Solano-Brenes, I-Min Tso, and Samuel Zschokke for permission to use figures. Paul Selden kindly updated a previously published figure for this book. I benefited from discussions, references, and other additional information provided by Anita Aisenberg, Fernando Costa, Jessica Eberhard, Rainer Foelix, Kyle Harms, Hilton Japyassú, Stano Korenko, Peter Michalik, Brent Opell, Adelberto Santos, Fernando Soley, Rick Vetter, Eric Warrant, and Mary Jane West-Eberhard. Gilbert Barrantes, Fernando Costa, Bernhard Huber, Stano Korenko, Matjaž Kuntner, Peter Michalik, Brent Opell, Martin Ramírez, Diego Solano-Brenes, and Samuel Zschokke allowed me to use other unpublished information. I am proud and fortunate to be part of the often magnificent tradition of sharing that generally characterizes naturalists truly interested in their organisms.")]), _vm._v(" "), _c('p', [_vm._v("I thank Kenji Nishida and T. Inoue for translations from Japanese, and Angel Aguirre for digging up even the most obscure references. Special thanks to Ruth "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "23",
      "id": "p23",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Madrigal, who provided much invaluable, enthusiastic assistance in obtaining, compiling, and proofing references, to two anonymous reviewers for perceptive comments on an early draft, the World Spider Catalogue (and its originator, Norman Platnick) for making accurate use of spider names possible even for behaviorists, and to James Toftness for taking on the nightmare process of obtaining permissions to use previously published figures. I especially grateful to Ingi Agnarsson, Mariella Herberstein, Matjaž Kuntner, and especially Thomas Hesselberg, Brent Opell, and Samuel Zschokke for kindly taking the time to make helpful comments and corrections on substantial portions of the MS.")]), _vm._v(" "), _c('p', [_vm._v("Finally, I am grateful for the support, calm advice, and tolerance that my wife, Mary Jane, has shown over and over in the face of the monomaniacal dedication I have given to this project. I knew when I started that I was getting into a marathon, and that it would impose impediments to living a normal life; but I did not realize it would take nearly so long and be so difficult.")])])])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "header0201",
      "epub:type": "chapter",
      "id": "ch02",
      "role": "doc-chapter"
    }
  }, [_c('header', {
    attrs: {
      "id": "header0201"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "24",
      "id": "p24",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rch02"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("The “hardware” of web-building spiders")]), _vm._v(" "), _c('h1', {
    staticClass: "cs",
    attrs: {
      "role": "doc-subtitle"
    }
  }, [_vm._v("Morphology, silk, and behavior")]), _vm._v(" "), _c('div', {
    staticClass: "epigraph",
    attrs: {
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "epf"
  }, [_vm._v("But how much more wonderful does it all seem when we picture the web as a potential fabric, first woven into an inimitable harmony to lure to death thousands of living creatures, then, tattered and torn in the tragedy, to be again received into the maw of its voracious host, to be repurified in the strange economy of the spider’s structure, to emerge again from the spinning-wheel in fine transparent filaments, to be woven again into the same lovely texture, and to repeat day after day the same eternal drama. —Hingston 1920, p. 121")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "sec02.01"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p24"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.01"
    }
  }, [_vm._v("2.1 Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("Web spiders live in a sensory world that is alien to us in many ways. The tactile sense is dominant, and vision and hearing play only minor roles. A web spider’s physical world consists largely of her own lines, and her major tasks involve producing, finding, and holding lines. A spider must generally find the lines using her sense of touch. The different types of basic abilities important to a spider in producing a functional web can be divided into two general classes: the properties of the silk lines themselves; and the physical and behavioral equipment that spiders use to build and manage webs of silk lines.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "sec02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02"
    }
  }, [_vm._v("2.2 Silk glands and silk")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bhaft",
    attrs: {
      "id": "sec02.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.01"
    }
  }, [_vm._v("2.2.1 Origins")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("I will begin by describing spider silk in general, and then turn briefly to silk from different types of glands. This is an active, rapidly moving area of research, and much of what I say will be based on the recent, extensive summaries and reviews of Craig (2003), Harmer et al. (2011), Vollrath (2010), Blackledge et al. (2011), Townley and Tillinghast (2013), Blackledge (2012) and Mortimer and Vollrath (2015). The standard view has been that spiders utilize a relatively consistent array of glands and silks (based on gland morphology and the staining properties of the gland products) to produce a much wider array of web designs (especially in Araneoidea) (Peters and Kovoor 1991). Studies of the silk itself, while available for only a small fraction of species and web designs (e.g., Blackledge et al. 2011, 2012a,b; Mortimer and Vollrath 2015), have already revealed however a “dizzying complexity of different types of silk” (Blackledge et al. 2011). Undoubtedly the descriptions here are overly simplistic.")]), _vm._v(" "), _c('p', [_vm._v("Silks can be loosely defined as natural proteins in semi-crystalline molecular structures that are extruded outside an organism (Craig 1997); they are defined by their processing from a gel-like dope to a dry fiber (Mortimer and Vollrath 2015). In contrast to other biopolymer proteins such as collagen and keratin, silk lines are not grown inside or as part of organisms, and are used exclusively outside the body. Silk has also evolved independently in more than 20 other animal groups, including other arachnids (pseudoscorpions, mites) as well as in numerous insects. Silk has different properties "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "25",
      "id": "p25",
      "role": "doc-pagebreak"
    }
  }), _vm._v("in different groups (Sutherland et al. 2010), but in perhaps no other group is it used in such diverse ways as in spiders.")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "tab0201"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th",
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticClass: "thn"
  }, [_vm._v("Table 2.1.")]), _vm._v(" Types of silk glands, the spinnerets where their lines emerge, and the functions of their products. Spinnerets are designated as follows: AMS = anterior median; ALS = anterior lateral; PMS = posterior median; PLS = posterior lateral). Most data are from Blackledge et al. 2011 and also Peters and Kovoor 1991, Wolff et al. 2014, and Řezáč et al. 2017; those on loxoscelids are from Knight and Vollrath 2002.")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Gland")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Spinnerets where spigots are located")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Functions of the lines")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Numbers of spigots"), _c('br'), _vm._v("Many (M) or few (F)")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Major ampullate")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("ALS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Dragline, supporting lines in webs")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("F")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Minor ampullate")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("PMS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Bridge and balloon lines, temp. spiral in orbs, sometimes added to draglines"), _c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("F")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Aciniform")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("PMS, PLS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Wrap prey, stabilimentum, sheet webs, distal tip of bridge line")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("M")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Flagelliform")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("PLS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Baseline for araneoid sticky lines")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("F (1 pair)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Pseudo-flagelliform")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("PLS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Baseline support mat of cribellum fibrils")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("F (1 pair)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Cribellum")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("AMS (fused in a plate)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Sticky prey capture lines (both fine fibrils and nodules)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("M")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Aggregate")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("PLS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Liquid adhesive, salts on flagelliform lines (adhere to prey, maintain aqueous medium for flagelliform line)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("F")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Cylindrical")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("PMS, PLS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Egg sac")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("M")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Piriform")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("PMS, PLS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Attach dragline to substrate or other lines (both fine fibrils and liquid produced)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("M")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Epiandrous"), _c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Ventral surface of abdomen")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Support sperm droplet (males only)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("M")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Venom (Scytodidae)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Chelicerae")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Glue and line that are shot onto prey to wrap it and fasten it to the substrate")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("F")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("? (Loxoscelidae)"), _c('sup', [_vm._v("3")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("ALS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Sticky thin bands for prey capture")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("F")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("1")]), _vm._v(" Of nine radii from five orbs of three mature female "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" (AR), seven radii included both major and minor ampullate lines, but two had only major ampullate lines (Peters and Kovoor 1991).")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("2")]), _vm._v(" Epiandrous spigots are lacking in mature males of many spiders, especially those of very small species such as erigonine linyphiids and theridiids (Marples 1967; Agnarsson 2004; Miller 2007). The functional significance of this pattern is unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("3")]), _vm._v(" On the basis of the size and the shape of the gland and the location of its spigot, the gland is said to be homologous with the major ampullate gland, though the proportions of the gland and the duct are markedly different (Knight and Vollrath 2002).")])])])])]), _vm._v(" "), _c('p', [_vm._v("Silk production originated at least 390 million years ago in spiders (Shear et al. 1989), and is a defining character of the entire order Araneae. Some modern species produce up to eight different types of silk ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#tab0201"
    }
  }, [_vm._v("table 2.1")]), _vm._v("). The silk glands are located in the spider’s abdomen, and ducts connect them to the abdominal appendages near the rear end of the abdomen called spinnerets. Small silk glands lie within the spinnerets themselves, while larger silk glands are located more anteriorly. Ancestral spiders had eight spinnerets (anterior median and anterior lateral; posterior median and posterior lateral) that corresponded to two pairs of abdominal appendages (Vollrath and Selden 2007). In some spiders the anterior median pair of spinnerets has fused to form the plate-like cribellum, while in many other groups this pair of spinnerets has been lost. A few haplogyne spiders have lost all but one pair of spinnerets.")]), _vm._v(" "), _c('p', [_vm._v("Each spinneret has a number of hollow, approximately cylindrical spigots that are open at their tips ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0201"
    }
  }, [_vm._v("fig. 2.1")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0207"
    }
  }, [_vm._v("2.7")]), _vm._v("). The duct of each silk gland runs through the spigot and opens at its tip ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0201"
    }
  }, [_vm._v("fig. 2.1c,d")]), _vm._v("). Exquisitely preserved fossil fragments of spinnerets have been found that bear recognizable spigots, showing that silk production arose in the early Devonian (Shear et al. 1989); silk was thus present soon after spiders moved from the sea onto land (or perhaps even before) (Vollrath and Selden 2007). Current speculation (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#ch10"
    }
  }, [_vm._v("chapter 10")]), _vm._v(") supposes that silk arose from nitrogenous waste products, and that its first function was either to cover the eggs (a "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "26",
      "id": "p26",
      "role": "doc-pagebreak"
    }
  }), _vm._v("function of silk in nearly all extant spiders), or to trap a plastron or air bubble under water that the spider could use for respiration (Vollrath and Selden 2007). Silk was probably also used to line the tunnels or retreats of early terrestrial spiders (Coyle 1986). Thus, although nearly all spiders are predators, silk lines probably only secondarily came to be used in webs to capture prey.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0201"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "446",
      "src": "images/chi-eberhard-fig0201.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p26"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.1.")]), _vm._v(" The elaborate arrays of muscles associated with the long spinnerets of the sheet-building agelenid "), _c('i', [_vm._v("Eratigena atrica")]), _vm._v(" C. L. Koch ("), _c('i', [_vm._v("a")]), _vm._v(") and also with the relatively short anterior lateral spinnerets of the orb-weaving "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" (AR) ("), _c('i', [_vm._v("b")]), _vm._v(") reveal that these spinnerets are capable of complex movements. The thin cuticular silk canal is visible through the wall of the hollow spigot of the mygalomorph "), _c('i', [_vm._v("Brachypelma albiceps")]), _vm._v(" (Theraphosidae) in "), _c('i', [_vm._v("c")]), _vm._v(" and "), _c('i', [_vm._v("d")]), _vm._v(". The silk canal begins as a funnel near the exit of the silk gland, and runs all the way to the spigot tip. It is sometimes filled with silk, and sometimes empty. There may be a valve at the junction between the bulb and the shaft, where there is also a “joint membrane” that probably allows a certain amount of additional movement of the shaft with respect to the bulb. Silk gland ducts in other species have similar silk canals (R. Foelix pers. comm.) ("), _c('i', [_vm._v("a")]), _vm._v(" from Peters 1967, "), _c('i', [_vm._v("b")]), _vm._v(" from Wilson 1962a, "), _c('i', [_vm._v("c")]), _vm._v(" and "), _c('i', [_vm._v("d")]), _vm._v(" from Foelix et al. 2013b).")])]), _vm._v(" "), _c('p', [_vm._v("Although prey capture webs have come and gone repeatedly in the evolution of spiders ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#ch09"
    }
  }, [_vm._v("chapter 9")]), _vm._v("), silk itself never seems to have been completely abandoned. The silk glands constitute up to approximately 5% of the weight of the orb-weaving araneid "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" (Peakall 1969 in Prestwich 1977). The molecular genetics of silk production and the physical properties of different silk lines are tightly linked to the foraging ecology of spiders, and understanding their evolution illuminates how molecular and organismal processes interact during evolution (Craig 1992, 2003; Blackledge et al. 2011, 2012; Mortimer and Vollrath 2015).")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.02"
    }
  }, [_vm._v("2.2.2 Mechanical properties and how they are determined")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Spider silk is famous for its outstanding strength. The lines from different glands range from rubber-like non-adhesive lines (flagelliform glands) to gluey liquids (aggregate glands), from extremely fine and highly adhesive fibrils (cribellum glands) to perhaps the most tenacious natural fibers known, which combine high extensibility and resistance to breaking (ampullate glands). Dragline silk’s toughness (= work/volume; a measure of the energy a material can absorb before rupturing) is about five times that of Kevlar®, and its high strength/weight is about 5 times that of steel; these qualities plus its immunological compatibility with living tissue, and its production under environmentally benign conditions, make it interesting for a variety of practical uses (Agnarsson et al. 2009a). The toughest biomaterial yet known is the major ampullate gland silk of the araneid "), _c('i', [_vm._v("Caerostris darwini")]), _vm._v(" (Agnarsson et al. 2010).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0202"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "375",
      "src": "images/chi-eberhard-fig0202.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p27"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.2.")]), _vm._v(" Views at increasing magnification of the alignment of silk molecules in "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("β")]), _vm._v(" sheets (conferring stiffness) and loose "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("α")]), _vm._v(" helices (conferring elasticity) (from Foelix 2011, after Vollrath 1992).")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "27",
      "id": "p27",
      "role": "doc-pagebreak"
    }
  }), _vm._v("These properties have inspired repeated attempts to take practical advantage of spider silk—from early French attempts in Madagascar to culture "), _c('i', [_vm._v("Nephila")]), _vm._v(" spiders like silkworms (Savory 1952), to recent insertion of silk genes into other organisms (Allmeling et al. 2013) in order to produce silk in large quantities. There are hopes that the products of the next generation of silk studies will be useful in military, industrial, and medical applications (Blackledge et al. 2011; Allmeling et al. 2013). Possible uses include cartilage, bone, and nerve regeneration, as well as more stressful uses such as bullet-proof clothing. Synthetic polymer threads with soft and hard molecular segments that were inspired by spider silk, can have “memories” of shapes that can be recalled on demand, and promote self-healing (Li and Shojaei 2012). The variation among different types of spider silk can also help orient searches for bioinspired fibers by demonstrating which properties are feasible (Blackledge and Hayashi 2006a; Elices et al. 2009).")]), _vm._v(" "), _c('p', [_vm._v("Nearly all known spider silk proteins are coded by a single family of genes, the spidroins, which have repeatedly duplicated and then diverged over evolutionary time. Only about 5% of silk-gland specific transcripts encode fibroins, however, and some of the numerous other proteins which as yet have no annotations are likely to include novel silk-associated proteins (Chaw et al. 2015). Most spidroins are quite large, 200–350 kDa molecules (Blackledge 2013) that consist mostly of a large central region of repetitive modules ranging from about 50 to 200 amino acids in length. This central region is flanked by an N-terminus and a C-terminus. The N- and C-termini are very similar in the spidroins of different types of silk, and thus provide useful indications of deep evolutionary history (Garb et al. 2010; Dimitrov et al. 2011). In contrast, the modules in the central region, which strongly influence the physical properties of the silk, are very similar within a given molecule but sharply different between different silks; in some cases they are so different that they are difficult to homologize (Gatesy et al. 2001). The modules in the central region are typically dominated by amino acids with short residuals (especially alanine and glycine), and these motifs are thought to become highly organized and form secondary structures such as "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("β")]), _vm._v("-sheets and "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("β")]), _vm._v("–spirals in the silk ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0202"
    }
  }, [_vm._v("fig. 2.2")]), _vm._v("). The crystalline stacking of these long repeats, especially the "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("β")]), _vm._v("-sheets, is thought to be important in explaining how relatively weak hydrogen bonds can make silk so strong. In “amorphous” regions, in contrast, spidroins connect the crystal-forming domains; the hydrogen bonding and entanglement in these regions provide strength and rigidity, but they are easily disrupted as the silk is stretched, making silk both strong and stretchy. Most silks are composed of one or two types of spidroin. The major ampullate silk of orb weavers contains both major ampullate spidroin 1 (MaSp1) and major ampullate spidroin 2 (MaSp2), and its material properties vary with the proportions of these two spidroins. Much of the inter-specific variation among Orbiculariae in "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "28",
      "id": "p28",
      "role": "doc-pagebreak"
    }
  }), _vm._v("major ampullate silk properties, such as extensibility and energy damping, correlates with differences among species in the proline composition of the silk (Blackledge et al. 2012a). A complete sequence for one aciniform silk gene (AcSp1) showed less divergence in three species of "), _c('i', [_vm._v("Argiope")]), _vm._v(" (AR) in the highly repeated subunits of the central region than in the terminal regions; purifying selection was deduced to be stronger in the N-terminal than the C-terminal region (Chaw et al. 2014).")]), _vm._v(" "), _c('p', [_vm._v("Spidroin paralogs evidently originated prior to the divergence of mygalomorphs and araneomorphs ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0109"
    }
  }, [_vm._v("figs. 1.9")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0110"
    }
  }, [_vm._v("1.10")]), _vm._v("); this divergence was followed by a much greater expansion of the spidroin family in the araneomorphs, which paralleled the divergence in their silk glands (Garb et al. 2007). The total number of spidroins is currently unknown. Previous counts gave a total of 19 for all spiders; but the especially sensitive technique of constructing a relatively complete, annotated genome for a single species ("), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(") (NE) recently gave a total of at least 28 and perhaps up to 35 spidroins (Babb et al. 2017). There was also impressive diversity in the basic construction blocks of silks, including hundreds of unique repeated coding motifs and unique cassettes in "), _c('i', [_vm._v("N. clavipes")]), _vm._v(". Current knowledge of silk diversity may thus represent only the tip of an iceberg.")]), _vm._v(" "), _c('p', [_vm._v("The processes that occur in the duct from the gland to the spinneret act in combination with the chemical nature of a gland’s products to determine the physical properties of the silk line; these can vary quite substantially even in a single gland type such as the major ampullate in a given individual. Silk is converted from a highly concentrated aqueous liquid or gel-like dope inside the gland to a semi-crystalline form as it emerges from the spinneret by a combination of water resorption, secretion of K+ and H+ ions, absorption of Na+ ions, a drop in pH, and shear flow forces as it is moves down the duct. The physical force of the pull causes the silk molecules to align themselves with each other, resulting in the formation of hydrogen bonds that transform the modules in the central portions of the molecules from liquid to semi-crystals ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0202"
    }
  }, [_vm._v("fig. 2.2")]), _vm._v("); the physical properties of the resulting silk line are affected by details of this alignment. Even gross morphological differences, such as the long, winding ducts of major and minor ampullate glands (lacking in all other glands), probably affect the mechanical properties of lines. The tensile strength of a line is also positively correlated with the rate at which it is drawn (Denny 1976).")]), _vm._v(" "), _c('p', [_vm._v("Some spiders appear able to control, perhaps by means of valves in the major ampullate ducts (Wilson 1962), the shear force applied to the silk line as it is drawn down. This force can strongly affect the degree of alignment of the silk molecules, and thus how stiff and extensible the lines are. This factor can have substantial effects, and variation in some mechanical properties reaches almost 50% even within an individual orb weaving spider (Hesselberg and Vollrath 2012). A variety of spiders, including even the relatively basal araneomorph "), _c('i', [_vm._v("Hypochilus gertschi")]), _vm._v(" (Hypochilidae), do not hold their draglines with any legs while they descend at the end of the line, but can nevertheless descend at different velocities and can even stop without grasping the dragline (Eberhard 1986a). This suggests that their silk lines are already at least partially crystallized while still inside the spider’s body, and that friction of the silk with the walls of the duct itself is used to “brake” production of silk lines (also "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.03.05"
    }
  }, [_vm._v("section 2.3.5")]), _vm._v("). It is possible that this mechanism differs in other species, and that the fluid is converted into semi-crystalline material only at the mouth of the spigot itself, as in the sicariid "), _c('i', [_vm._v("Loxosceles laeta")]), _vm._v(" (Knight and Vollrath 2002).")]), _vm._v(" "), _c('p', [_vm._v("There were also surprising differences in the physical properties of the gumfoot lines of the black widow "), _c('i', [_vm._v("Latrodectus hesperus")]), _vm._v(" and the scaffolding web lines to which gumfoot lines were attached (Argintean et al. 2006), as well as the major ampullate gland silk lines that spiders produced as they fell (Lawrence et al. 2004). Another theridiid, "), _c('i', [_vm._v("Parasteatoda tepidariorum")]), _vm._v(", made thicker lines after encountering larger prey (Boutry and Blackledge 2008). Direct behavioral observations suggested that the gumfoot lines and “scaffolding” lines were continuous with each other (Eberhard et al. 2008b) even though the scaffolding line differed in being more resiliant when under only a slight strain (0–3%) (this difference improved the line’s ability to function as a spring to lift prey up off of the substrate) (Argintean et al. 2006).")]), _vm._v(" "), _c('p', [_vm._v("The mechanical properties of major ampullate silk lines have also been shown to be determined by both the relative amounts of MaSp1 and MaSp2, and how these proteins are assembled (Sponner et al. 2005 in Liao et al. 2009). Spiders themselves may be able to control assembly adaptively. Female "), _c('i', [_vm._v("Cyclosa mulmeinensis")]), _vm._v(" (AR) "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "29",
      "id": "p29",
      "role": "doc-pagebreak"
    }
  }), _vm._v("produced stronger lines without altering their protein composition when they were subjected to wind (Liao et al. 2009). It seems to be generally true that silk lines pulled forcefully from restrained spiders differ in their properties from those in the same spider’s webs (Work 1977, 1978). One possibility (among others) is that spiders altered the physical properties of their silk by using spidroin-specific antibodies to alter MaSp1 and MaSp2 interactions that affect crystalline formation (Liao et al. 2009).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0203"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "464",
      "src": "images/chi-eberhard-fig0203.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p29"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.3.")]), _vm._v(" The non-linear stress–strain curve from the major ampullate silk of the araneid "), _c('i', [_vm._v("Argiope keyserlingi")]), _vm._v(" illustrates several key details related to the biomechanical properties of spider silks. Stress is calculated as force divided by the cross-sectional area of the fiber (“engineering stress”); true stress is calculated by multiplying engineering stress by L/L0 (length of stretched fiber/original length). This approximates the instantaneous cross-sectional area of the fiber, an important variable for elastic materials. Strain measures the change in the length of a fiber relative to its original length (“engineering strain”). It is usually converted, as in the graph, to “true strain” by taking the natural log of L/L0. Tensile strength is the stress at the breaking point of a material under uniaxial loading. Extensibility describes the stretchiness of a fiber, for example the percentage that a fiber’s length is increased when compared with its original length at the moment it breaks. Stiffness is a measure of the ability of a fiber to resist deformation; it is defined by Young’s modulus, calculated from the slope of the initial elastic region of the stress–strain curve. Yield is the point where a fiber transitions from elastic (and reversible) deformation to plastic deformation. Toughness (the energy required to break a thread) is calculated as the area under the stress–strain curve. Hysteresis is the proportion of energy lost as heat during a loading–unloading cycle (the energy required to stretch a silk thread is greater than that required to return it to its natural state). At the molecular level (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0202"
    }
  }, [_vm._v("fig. 2.2")]), _vm._v("), region I corresponds to a stiff initial response with homogeneous stretching, region II to an entropic unfolding of the alpha-folding of semi-amorphous protein domains, and region III to a stiffening as molecules align and the load is transferred to the beta-sheet crystals; a stick-slip deformation of the beta-sheet crystals occurs at failure (after Harmer et al. 2011 and Cranford et al. 2012).")])]), _vm._v(" "), _c('p', [_vm._v("A second factor affecting the orientation of the amorphous regions of spidroins is humidity. When water infiltrates a silk line after it has been drawn, it disrupts hydrogen bonding, allowing the spidroins to move irreversibly to more disordered states (“supercontraction”) (Work 1977). The degree of supercontraction in major ampullate silk varies in different species (Boutry and Blackledge 2010, 2013). It can produce shrinkage of an unrestrained line by up to 50% in high humidity, and can generate substantial forces in web lines. It also softens silk, making it more compliant. The functional implications of the increased tensions and softening of the silk due to supercontraction in natural webs in the field are uncertain. Proposed consequences include the following: reduced sagging when a web is weighted with rain, mist, or dew ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#fig0810"
    }
  }, [_vm._v("fig. 8.10")]), _vm._v(") (Work 1977; Agnarsson et al. 2009b); an improved ability to absorb the kinetic energy of the prey, observed in prey impact with intact orbs of "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" (NE) and "), _c('i', [_vm._v("Argiope trifasciata")]), _vm._v(" (AR), due to the softening effect (Boutry and Blackledge 2013); and facilitation of the alignment of molecules along the fiber axis during the spinning of silk from liquid dope (in this case the water responsiveness of dry threads might be a “non-adaptive by-product” for webs) (Guinea et al. 2005). A distinct process of shortening, “cyclic contraction,” also occurs in the major ampullate gland silk of "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" in response to decreases in humidity (Agnarsson et al. 2009b). Again, the consequences for natural webs are uncertain.")]), _vm._v(" "), _c('p', [_vm._v("A silk line is a “viscoelastic” polymer, meaning that its material properties change as it is stretched ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0203"
    }
  }, [_vm._v("fig. 2.3")]), _vm._v("). A line thus manifests a suite of physical properties, depending on how far it has been stretched. As a line begins to be extended, the changes that occur are generally reversible; later, just before failure, the line suffers permanent plastic deformation. Many silks show high "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "30",
      "id": "p30",
      "role": "doc-pagebreak"
    }
  }), _vm._v("“hysteresis” during the reversible stage, a property that is functionally important in prey capture. Hysteresis is a measure of how much of the kinetic energy that produced the extension is converted to heat, rather than being stored internally (as in a spring). Major ampullate silk converts about 60% of its loading energy to heat. Thus when the load is removed, the line’s return to its original length is slow rather than immediate. In prey capture, high hysteresis means that prey that makes a high-energy impact with the web (higher velocity and/or larger mass) will not simply be bounced forcefully backward, as if the web were a trampoline. Instead much of its impact energy is converted to heat, and the rebound is slower and weaker.")]), _vm._v(" "), _c('p', [_vm._v("Spiders appeared to modify both the composition of the line itself (“material properties”) and the structural properties (e.g., the diameters or numbers) of the lines laid when faced with different problems (e.g., Blackledge and Zevenbergen 2007; Tso et al. 2007; Ortlepp and Gosline 2008). Mechanical properties were also altered (for the worse) when silk was forcibly extracted from "), _c('i', [_vm._v("Nephila")]), _vm._v(" spiders instead of being collected from lines built by the spider (Madsen and Vollrath 2000). The magnitudes of the changes produced by even a single individual spider are sometimes quite substantial (Herberstein and Tso 2011) (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.09"
    }
  }, [_vm._v("section 3.2.9")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("As mentioned above, all types of silk (excepting only the independently evolved “silk” that is produced in the venom glands in the spitting spiders in the family Scytodidae) share the property that the gland contents cannot be ejected forcefully by the spider, but must instead be pulled from the spider’s body. Thus most spiders cannot match the cartoon character Spider-Man’s ability to “shoot” lines. This detail probably had important consequences in the evolution of spinnerets and their spigots, and in building behavior ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.03.02"
    }
  }, [_vm._v("sections 2.3.2")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.01.01"
    }
  }, [_vm._v("7.1.1")]), _vm._v("). Another detail with important consequences for web evolution is that silk lines are apparently coated with a sheath that covers the internal nanobrils and elongate cavities within a core. The sheath may be related to the suggestion from scanning electron microscope (SEM) images that even fibers of non-adhesive silk are apparently slightly “wet” when they first emerge from the spigot. Even non-adhesive fibers from ampullate glands appear to adhere to each other ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0204"
    }
  }, [_vm._v("fig. 2.4a")]), _vm._v("); and the aciniform lines of myglomorphs and araneomorphs often adhered at least weakly to objects that they contacted soon after they were produced (e.g., Barrantes and Eberhard 2007).")]), _vm._v(" "), _c('p', [_vm._v("The following introduction to silk glands and their products is taken largely from the more detailed and authoritative accounts of Blackledge et al. (2011) and Blackledge (2012, 2013). As they emphasize, and is discussed in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.09"
    }
  }, [_vm._v("section 3.2.9")]), _vm._v(", there is much more variation than is indicated here. The diversity of silk types has only begun to be explored, especially in non-orb weavers, and promises to be exciting (Blackledge et al. 2011; Blackledge 2013). Even in some mygalomorphs that build only simple silk structures, spigots and glands differ morphologically (e.g., Glatz 1972 on the trap door spider "), _c('i', [_vm._v("Nemesia caementaria")]), _vm._v("). I will only briefly discuss epiandrous and tubuliform (= cylindrical) silk glands here, because they are involved in making tiny webs to support sperm and egg sacs, rather than in prey capture. I will also omit the controversial possibility of tarsal silk for locomotion (see Gorb et al. 2001; Pérez-Miles et al. 2009; Pérez-Miles and Ortíz-Villatoro 2012; and Foelix et al. 2013a).")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.03"
    }
  }, [_vm._v("2.2.3 Major ampullate glands")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The best-studied glands by far in terms of the chemical composition and physical properties of their products are the large, major ampullate glands, which produce the draglines that most spiders leave behind as they walk (much of the previous section applies to major ampullate silk). The major ampullate gland of "), _c('i', [_vm._v("Nephila")]), _vm._v(" (NE) consists of a sac or ampulla with an apical “tail” that produces some part of the silk feedstock and a funnel that leads to the duct. The long duct is folded back on itself in an elongated “S” that progressively narrows to form a hyperbolic die (a nozzle profile capable of generating constant extensional strain rates) (Mortimer and Vollrath 2015). The flow of droplet inclusions within the silk feedstock confirms that elongational flow at a slow shear rate assists in defining axial molecular orientations before the final draw-down. The combination of wall shear and elongational flow, together with subtle changes in the pH, induce beta-sheet transitions in the proteins as they travel through the duct (Vollrath and Knight 2001). The forms and branching patterns of major ampullate glands vary substantially in different taxonomic groups (P. Michalik pers. comm.). Small lobes develop in juveniles just prior to molts, and produce the draglines when molting occurs (Townley et al. 1993).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0204"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "429",
      "src": "images/chi-eberhard-fig0204.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p31"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.4.")]), _vm._v(" Details of webs and behavior can illuminate silk production. During radius construction, "), _c('i', [_vm._v("Zilla diodia")]), _vm._v(" (AR) broke the provisional radius ("), _c('i', [_vm._v("a")]), _vm._v(") and replaced it with a new dragline as she moved to the hub. As shown in the figure, the spider left the two ampullate fibers of the broken provisional radius loose. They adhered tightly to each other and to the fibers of the definitive radius, and thus were apparently sticky when first produced (from Zschokke 2000; courtesy of Samuel Zschokke). A detail in the image of "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" (AR) engaged in sticky spiral construction from a video recording ("), _c('i', [_vm._v("b")]), _vm._v(") suggests a possible but heretofore unappreciated role for spinneret movements during orb construction. The two flagelliform fibers of the sticky spiral baseline were separated when they emerged from the spider’s posterior lateral spinnerets, and merged farther from her body, forming a single line. There was no separation between these fibers, however, at points where the sticky line was attached to a radius ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0210"
    }
  }, [_vm._v("fig. 2.10e")]), _vm._v("). This suggests that the posterior lateral spinnerets probably moved medially, bringing the flagelliform fibers together at the moment the attachment was made (photo courtesy of Samuel Zschokke).")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "31",
      "id": "p31",
      "role": "doc-pagebreak"
    }
  }), _vm._v("The major ampullate lines do the heavy physical work in the webs of the araneomorphs ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0109"
    }
  }, [_vm._v("figs. 1.9")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0110"
    }
  }, [_vm._v("1.10")]), _vm._v("), forming the scaffolding on which other lines are placed and which absorbs the major part of the stress exerted by both the spider and her prey (I will follow general usage in attributing draglines to the major ampullate glands, even though more than one pair of fibers often occur in a single dragline; see, for instance, Hingston 1922a on the nephilid "), _c('i', [_vm._v("Nephila pilipes")]), _vm._v("). Ampullate gland silk is strong and tough even in basal lineages, but it is especially strong and stiff in Orbicularia (Swanson et al. 2006) (it is especially extensible in "), _c('i', [_vm._v("Deinopis")]), _vm._v(", however); this difference correlates with the presence of the derived spidroin MaSp2, which may form “nanosprings” that increase mobility within the amorphous region of the silk and provide increased toughness. The ratio between MaSp1 and MaSp2 varies among taxa, and possibly even within individual spiders (Blackledge et al. 2011) (for the surprising range of variations in this and other types of silk, see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.09"
    }
  }, [_vm._v("section 3.2.9")]), _vm._v("). Early major ampullate silk is thought to have originated about 375 Mya, its tensile strength improving rapidly with increased repetitiveness and certain amino acid motifs, maximizing in basal entelegyne spiders about 230 Mya (Blackledge "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "32",
      "id": "p32",
      "role": "doc-pagebreak"
    }
  }), _vm._v("et al. 2012b). Toughness improved subsequently in orb weavers, coupled with the origin of MaSp2. This outline is overly simplistic, as the major ampullate silk of even the single araneid genus "), _c('i', [_vm._v("Argiope")]), _vm._v(" showed a wide range of stress-strain relationships (Blackledge et al. 2012b).")]), _vm._v(" "), _c('p', [_vm._v("It might have been expected that the diameters of major ampullate lines were fixed by the diameters of their spigots, but this is not the case. A clear demonstration comes from the diameters of presumed major and minor ampullate fibers in the tangle above the sheet in the web of "), _c('i', [_vm._v("Cyrtophora citricola")]), _vm._v(" in the two webs of two adult females. Of 52 fibers measured under the SEM, 8% were 1 "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("μ")]), _vm._v("m in diameter, 25% were 2 "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("μ")]), _vm._v("m, 10% were 3 "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("μ")]), _vm._v("m, 6% were 4 "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("μ")]), _vm._v("m, 15% were 5 "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("μ")]), _vm._v("m, 8% were 6 "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("μ")]), _vm._v("m, and 29% were 7 "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("μ")]), _vm._v("m (measurements are rounded to the nearest "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("μ")]), _vm._v("m) (Peters 1993a). A mature female "), _c('i', [_vm._v("Nephila")]), _vm._v(" in the lab caused the two dragline-fibers to adhere to each other by medial movements of the anterior lateral spinnerets after they had been experimentally separated while dragline was being pulled from the spider (S. Zschokke pers. comm.). Conversely, flagelliform fibers produced by "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" (AR) were separated during sticky spiral construction ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0204"
    }
  }, [_vm._v("fig. 2.4b")]), _vm._v("). To my knowledge, the possibility that spiders use spinneret movements to alter the properties of lines has never been checked.")]), _vm._v(" "), _c('p', [_vm._v("The numbers and the forms of ampullate glands vary among species; some are double, and others have branches of different forms and sizes (P. Michalik pers. comm.). The agelenid "), _c('i', [_vm._v("Agelena labyrinthica")]), _vm._v(", for instance, has eight similar branches, some with sub-branches of their own, all emptying into a common ampulla, and an additional, smaller ampulla with only one branch; and there is substantial morphological variation within the family Agelenidae (Řezáč et al. 2017). The oecobiid "), _c('i', [_vm._v("Uroctea")]), _vm._v(" has “numerous” glands that, despite having different sizes, apparently produce the same product (judging by their staining properties) (Kovoor 1987). The major ampullate glands of the araneids "), _c('i', [_vm._v("Gasteracantha")]), _vm._v(", "), _c('i', [_vm._v("Cyclosa")]), _vm._v(", and "), _c('i', [_vm._v("Cyrtophora")]), _vm._v(" possess up to at least three histologically distinct secretory regions (Kovoor 1987). A further mystery is the functional significance of the reduction in the number of glands during development in Araneidae. Spiderlings had two pairs of both major and minor ampullate glands on each side, and one of each pair and its corresponding spigot subsequently degenerated (Peters 1993a).")]), _vm._v(" "), _c('p', [_vm._v("Many spider groups that do not build webs use major ampullate glands to produce draglines, which are said to function as safety lines that allow the spider to climb back up if she falls from an elevated perch. While I have indeed seen wandering spiders such as salticids, sparassids, and clubionids do just this, I am less than completely convinced of the importance of this function. How often is it important for a wandering ground spider like a lycosid that falls or jumps from an elevated perch to be able return to that same perch?")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.02.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.04"
    }
  }, [_vm._v("2.2.4 Minor ampullate glands")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("A spider’s minor ampullate glands often resemble its major ampullate glands in morphology, but are smaller. The physical properties of their silk lines are similar to those of major ampullate gland lines, though they are somewhat more extensible, weaker, less tough, and thinner (Blackledge et al. 2011). Minor ampullate lines are included in the sticky cribellum lines, but also play additional, diverse roles in ecribellate spiders ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#tab0201"
    }
  }, [_vm._v("table 2.1")]), _vm._v("; Řezáč et al. 2017). Gland morphology varies with respect to numbers of branches and sub-branches (Řezáč et al. 2017). The functional significance of differences in minor ampullate morphology is not known, although in amaurobioid families a bifurcation of the minor ampullate glands was associated with producing sticky cribellum silk (Řezáč et al. 2017). Another mystery is the fact that "), _c('i', [_vm._v("Araneus cavaticus")]), _vm._v(" (AR) was able to digest (and thus recycle) her major ampullate but not her minor ampullate lines (Townley and Tillinghast 1988).")]), _vm._v(" "), _c('p', [_vm._v("When the minor ampullate gland silk lines of "), _c('i', [_vm._v("Linyphia triangularis")]), _vm._v(" (LIN) emerge they may have an outer adhesive covering that then hardens so that the lines serve to bind other lines together, replacing to some extent piriform gland attachment discs (Peters and Kovoor 1991). The minor ampullate glands of "), _c('i', [_vm._v("L. triangularis")]), _vm._v(" produce at least two different products (both of which stain positively for possibly sticky polysaccharides and acid mucosubstances) (Peters and Kovoor 1991). As with major ampullate glands, there is substantial taxonomic and ontogenetic variation in the forms and branching patterns of minor ampullate glands (Townley et al. 1993; Řezáč et al. 2017; P. Michalik pers. comm.).")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.02.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.05"
    }
  }, [_vm._v("2.2.5 Aciniform glands")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Fossils of spigots suggest that aciniform glands (or something similar to them) were the first to evolve (Shear et al. "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "33",
      "id": "p33",
      "role": "doc-pagebreak"
    }
  }), _vm._v("1989; Vollrath and Selden 2007; Blackledge et al. 2009c). Aciniform lines are relatively thin, and each aciniform gland is small. Typically there are many small aciniform glands and spigots on the posterior median and posterior lateral spinnerets, and multiple aciniform lines are produced simultaneously in broad swaths. In species with long posterior lateral spinnerets, the aciniform spigots are arranged more or less linearly along the spinneret, and the spinneret makes sweeping and tapping movements while the swath is being produced (Rojas 2011; Eberhard and Hazzi 2013). Some species with shorter posterior lateral spinnerets spread them wide while building, and produce swaths of aciniform lines. Spiders typically use aciniform lines to wrap prey, to form the tips of bridge lines floated on the wind (from spigots on the median posterior spinnerets—Peters 1990; Wolff et al. 2014), to produce silk linings for their burrows, and to make dense sheet webs for prey capture ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#tab0201"
    }
  }, [_vm._v("table 2.1")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("The amino acid sequences of aciniform silk are remarkably uniform among the repetitive modules, and they have reduced crystallinity and lower alignment; the lines are thus more extensible than major ampullate lines. A single fibroin gene, aciniform spidroin 1 (AcSp1), was expressed in the aciniform silk gland of "), _c('i', [_vm._v("Argiope trifasciata")]), _vm._v(" (AR). This protein was composed of highly homogenized repeats that were 200 amino acids long and that had low representation of the crystalline regions of ampullate silk; they did not display substantial sequence similarity with other spidroins (Hayashi et al. 2004). Recent study of the sequence of AcSp1 in a black widow suggested a long history of strong purifying selection on its amino acid sequence, as well as selection on silent sites and intragenic recombination (Ayoub et al. 2013).")]), _vm._v(" "), _c('p', [_vm._v("Aciniform glands are sometimes said to be the only type of silk gland in many mygalomorphs ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0109"
    }
  }, [_vm._v("fig. 1.9")]), _vm._v("), but the glands and spigots are much less studied in this group, and homologies are not yet certain. Mygalomorphs are thought to use aciniform silk to line their burrows (Coyle 1986), to construct doors to the burrows (Coyle 1986), to wrap prey (Barrantes and Eberhard 2007), and in one family (Dipluridae) to make prey capture webs with silk tunnels and sheets (Coyle 1986; Eberhard and Hazzi 2013). Phylogenetic analyses of spidroin paralogs indicate that a gene duplication event occurred concomitantly with specialization of the aciniform and tubuliform glands (which produce egg sac silk) (Ayoub et al. 2013). Judging by modern mygalomorphs, the earliest fossil species probably produced aciniform silk in multi-strand swaths; there is a more or less linear array of 19–20 similar spigots along the long axis of a fragment of spinneret of the Middle Devonian fossil "), _c('i', [_vm._v("Attercopus fimbriunguis")]), _vm._v(" (Shear et al. 1989; Selden et al. 1991).")]), _vm._v(" "), _c('p', [_vm._v("SEM images indicate that aciniform fibers are slightly wet and adhesive when they first emerge (Kullmann 1975 on ctenizid and diplurid mygalomorphs; Weng et al. 2006 on an uloborid and an araneid; WE on the araneid "), _c('i', [_vm._v("A. argentata")]), _vm._v("). For instance, the theraphosid "), _c('i', [_vm._v("Psalmopoeus reduncus")]), _vm._v(" initiated wrapping silk production by attaching aciniform lines to the substrate by wiping her posterior lateral spinnerets back and forth across the surface ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0205"
    }
  }, [_vm._v("fig. 2.5")]), _vm._v(") (Barrantes and Eberhard 2007). The diplurid "), _c('i', [_vm._v("Linothele macrothelifera")]), _vm._v(" also wiped her posterior lateral spinnerets across the substrate to attach lines there (Eberhard and Hazzi 2013). The lycosid "), _c('i', [_vm._v("Aglaoctenus castaneus")]), _vm._v(" appeared to attach aciniform lines to each other or to her dragline by clapping her spinnerets together (Eberhard and Hazzi 2017). The aciniform lines of the oecobiid "), _c('i', [_vm._v("Oecobius annulipes")]), _vm._v(", in contrast, appear not to be wet or adhesive when they emerge (Glatz 1967), because the lines were held apart by the long anal setae as they emerged from the spigots during prey wrapping, yet there was no obvious sign (e.g., cleaning movements) that these setae become coated with liquid.")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.02.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.06"
    }
  }, [_vm._v("2.2.6 Flagelliform glands")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Flagelliform glands are known only in araneoid spiders. They produce the axial lines to which adhesive glue from the aggregate glands is added (below). Each flagelliform spigot is part of a “triplet” on the posterior lateral spinneret that is formed with a pair of adjacent aggregate gland spigots that pour glue onto the flagelliform gland line as it emerges. The flagelliform silk in orb webs lacks "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("β")]), _vm._v("-sheets; its rubber-like, highly extensible properties are associated with its relatively disorganized molecular structure (Blackledge et al. 2011). The dominant repeats probably form repeated "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("β")]), _vm._v("-spirals, producing a spring-like helix that may be the basis for the high elasticity of this silk (Hayashi and Lewis 1998). Both introns and exons of flagelliform genes have undergone concerted evolution, and the intron sequences are more homogenized intra-specifically than are the exons. This unusual pattern could be explained by extreme mutation and "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "34",
      "id": "p34",
      "role": "doc-pagebreak"
    }
  }), _vm._v("recombination pressures on internally repetitive exons (Hayashi and Lewis 2000, 2001).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0205"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "357",
      "src": "images/chi-eberhard-fig0205.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p34"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.5.")]), _vm._v(" Prey wrapping behavior, shown here in the mygalomorph theraphosid "), _c('i', [_vm._v("Psalmopoeus reduncus")]), _vm._v(" ("), _c('i', [_vm._v("a–c")]), _vm._v(") and the zoropsid "), _c('i', [_vm._v("Tengella radiata")]), _vm._v(" ("), _c('i', [_vm._v("d")]), _vm._v(", "), _c('i', [_vm._v("e")]), _vm._v("), may have been an important evolutionary source of behavior patterns that enabled spiders to manage swaths of lines during the construction of prey capture webs. Attachments to the substrate by mygalomorphs (which lack piriform silk) were made during both wrapping and web construction by swinging the abdomen laterally, sweeping the leading posterior lateral spinneret and the multiple fine lines it was producing across the substrate (curved arrow in "), _c('i', [_vm._v("a")]), _vm._v("). Typically, both in mygalomorphs ("), _c('i', [_vm._v("a–c")]), _vm._v(") and many araneomorphs ("), _c('i', [_vm._v("d")]), _vm._v(") the trailing spinneret was raised, keeping its swath of fine lines free from the substrate (only a few of the lines in the swath are drawn). By attaching the lines from different spinnerets at different points on the prey and the substrate, the lines in the swaths were spread apart, covering more area on the prey. This same method of spreading swaths of lines was used by the agelenid "), _c('i', [_vm._v("Melpomene")]), _vm._v(" sp. and the lycosid "), _c('i', [_vm._v("Aglaoctenus castaneus")]), _vm._v(" in building sheet webs (Eberhard and Hazzi 2017) (from Barrantes and Eberhard 2007).")])]), _vm._v(" "), _c('p', [_vm._v("Flagelliform lines typically extend several times their resting length before breaking, and the flagelliform silk in orbs is about 1000 times less stiff than major ampullate silk. Pulling on flagelliform silk fibers of the araneid "), _c('i', [_vm._v("Araneus")]), _vm._v(" sp. revealed rupture peaks due to “sacrificial bonds” that are characteristic of other self-healing biomaterials (Becker et al. 2003). Flagelliform silk is approximately 10 times more extensible than major ampullate gland silk, and was also much more extensible than the pseudoflagelliform baselines of cribellate sticky silk ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0206"
    }
  }, [_vm._v("fig. 2.6")]), _vm._v("). Extensibility varied by a factor of three among different orb weaver species (Sensenig et al. 2010a). This stretchiness is increased by contact with water, which is normally provided by the liquid in the coating of glue on the line (Sahni et al. 2014), and the effect may be adjusted in environments with different humidities (Opell et al. 2013, 2015; Amarpuri et al. 2015; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.08.02"
    }
  }, [_vm._v("section 2.2.8.2")]), _vm._v("). This wetting effect also occurs in the major ampullate silk in the gumfoot lines of the theridiid "), _c('i', [_vm._v("Latrodectus hesperus")]), _vm._v(" (Blackledge et al. 2005b,c).")]), _vm._v(" "), _c('p', [_vm._v("The extreme extensibility of flagelliform gland silk has been said to result in part from the sticky spiral baseline being rolled up inside each droplet of sticky silk, and being pulled out when the sticky line was stressed (Vollrath and Edmonds 1989). This “windlass” effect is apparently of little importance in nature, however. The sticky spiral baseline curled on itself when the tension on segments of sticky spiral lines of "), _c('i', [_vm._v("Nephila edulis")]), _vm._v(" was reduced by bringing the ends of the line closer to each other (Elettro et al. 2016), but it only seldom curled appreciably in the unmodified webs of one nephilid and six araneid species (Blackledge et al. 2005c; see also Schneider 1995).")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.02.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.07"
    }
  }, [_vm._v("2.2.7 Pseudoflagelliform glands")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("These relatively unstudied glands produce the axial fibers on which sticky cribellum silk is laid (Joel et al. 2015). They are thought to be homologous to flagelliform glands because their elongate spigots occupy similar positions, on the posterior lateral spinnerets. Pseudoflagelliform fibers are stiffer and stronger than flagelliform fibers, but not nearly as extensible (Opell and Bond 2001; Blackledge and Hayashi 2006b). Their lack of extensibility is compensated to some extent because, after the pseudoflagelliform baselines rupture, the highly "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "35",
      "id": "p35",
      "role": "doc-pagebreak"
    }
  }), _vm._v("folded cribellum fibrils unfold (next section). The evolutionary transition from pseudoflagelliform to flagelliform glands in the araneoid lineage is not well understood (Blackledge et al. 2011; Opell 2013; Sahni et al. 2014; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.08.05"
    }
  }, [_vm._v("section 10.8.5")]), _vm._v(").")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0206"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "430",
      "src": "images/chi-eberhard-fig0206.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p35"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.6.")]), _vm._v(" Comparisons showing the strikingly different biomechanical performance of sticky spiral lines (in black) compared with that of the major ampullate gland dragline silk (in gray) of three cribellates ("), _c('i', [_vm._v("a–c")]), _vm._v(") and an ecribellate araneid ("), _c('i', [_vm._v("d")]), _vm._v(") (in the thumbnail sketches of their prey capture webs the sticky lines are black). Major ampullate silk performed similarly in all four taxa, but the sticky spiral of the ecribellate ("), _c('i', [_vm._v("d")]), _vm._v(") differed from that of the cribellates, where most of the stress was generated in the pair of axial fibers; the cribellate axial fibers failed at high peak stresses and moderate strains, and the sticky spiral line then continued to absorb force through the extension and failure of the hundreds of surrounding cribellum silk fibrils until final failure (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#fig1018"
    }
  }, [_vm._v("fig. 10.18")]), _vm._v(") (the cross-sectional area of these fibrils was not measured, so stress values after failure of the axial fibers can be interpreted only as relative indications of qualitative changes in the forces generated). In the ecribellate, the two axial fibers did not break until the final failure (after Blackledge and Hayashi 2006b).")])])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.02.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.08"
    }
  }, [_vm._v("2.2.8 Sticky silk")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "chaft",
    attrs: {
      "id": "sec02.02.08.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.08.01"
    }
  }, [_vm._v("2.2.8.1 Cribellum glands")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The most ancient of the four different types of gland that produce sticky silk are the cribellum glands, which originated in the Triassic (250–200 Mya). They lie just below a ventral abdominal plate (or pair of plates), called the cribellum, which is the vestige of the anterior median spinnerets. The best summary on cribellum silk is that of Opell (2013). There are still major mysteries associated with cribellum silk, including its molecular structure and the question of how cribellate spiders avoid adhering to it ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.06"
    }
  }, [_vm._v("section 2.6")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("The cribellum is covered with large numbers of small spigots; there are up to >10,000 in the desid "), _c('i', [_vm._v("Badumna insignis")]), _vm._v(", and nearly 5000 even in the small orb weaver "), _c('i', [_vm._v("Uloborus glomosus")]), _vm._v(" (UL) (Opell 1999a, 2002). The spigots are approximately cylindrical, but in most species each spigot has several bulges of unknown functional significance along its length ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0207"
    }
  }, [_vm._v("fig. 2.7")]), _vm._v("). Each spigot produces a single very fine fibril. Fibrils are 25–35 nm in diameter "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "36",
      "id": "p36",
      "role": "doc-pagebreak"
    }
  }), _vm._v("in most species, but range down to 10 nm. In most cribellate species each fibril has small intermittent swellings that are thought to be hydrophylic. The stickiness of cribellum silk is strongly correlated with the number of cribellum spigots in both orb weaving and non-orb weaving cribellates (Opell 1999a). In orb weavers (but not non-orb weavers) the number of cribellum spigots was positively correlated across species with the spider’s weight (Opell 1999a). Spigots with shafts that resemble those of cribellum spigots sometimes occur on the posterior "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "37",
      "id": "p37",
      "role": "doc-pagebreak"
    }
  }), _vm._v("median and posterior lateral spinnerets, producing “paracribellate” fibers; these spigots vary in form, numbers, and locations in different taxa (Griswold et al. 2005).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0207"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "577",
      "src": "images/chi-eberhard-fig0207.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p36"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.7.")]), _vm._v(" The plate-like cribellum ("), _c('i', [_vm._v("a")]), _vm._v(") has hundreds of tiny spigots ("), _c('i', [_vm._v("c")]), _vm._v(") from which the calamistrum, a comb on tibia IV ("), _c('i', [_vm._v("e")]), _vm._v("), pulls a swath of tiny fibrils that are molded into complex mats ("), _c('i', [_vm._v("b")]), _vm._v(", "), _c('i', [_vm._v("f")]), _vm._v(", "), _c('i', [_vm._v("g")]), _vm._v(") that are composed of hundreds of tiny adhesive fibrils ("), _c('i', [_vm._v("d")]), _vm._v("). The calamistrum brushes posteriorly across the cribellum rapidly, over and over; at the end of each rearward stroke, the cribellum fibrils somehow free themselves from the calamistrum, and the leg moves forward to make the next combing movement. It is unclear how the calamistrum avoids adhering to the treacherously adhesive cribellum silk. The forms of the mats of cribellum fibrils differed substantially among different species ("), _c('i', [_vm._v("b")]), _vm._v(", "), _c('i', [_vm._v("f")]), _vm._v(", "), _c('i', [_vm._v("g")]), _vm._v("); neither the means by which the different-shaped mats were produced, nor the functional significance of the differences (if any) are known ("), _c('i', [_vm._v("a")]), _vm._v(", "), _c('i', [_vm._v("c")]), _vm._v(" from Opell 1999a, "), _c('i', [_vm._v("b")]), _vm._v(", "), _c('i', [_vm._v("f")]), _vm._v(", "), _c('i', [_vm._v("g")]), _vm._v(" from Opell 2002, "), _c('i', [_vm._v("d")]), _vm._v(", "), _c('i', [_vm._v("e")]), _vm._v(" courtesy of Brent Opell).")])]), _vm._v(" "), _c('p', [_vm._v("A special comb consisting of one or two rows of stiff bristles on the spider’s hind tibia, the calamistrum, repeatedly brushes rapidly across the cribellum during cribellum fibril production. All species with a cribellum also possess a calamistrum. Recent observations of the basal progradungulid "), _c('i', [_vm._v("Progradungula otwayensis")]), _vm._v(" suggest that the cribellum may have evolved before the calamistrum. This species combs out some cribellum silk with the calamistrum, but also produces other cribellate lines without combing; combed cribellum silk was piled more loosely, and was more adhesive (Michalik et al. 2019). A detailed study in the uloborid "), _c('i', [_vm._v("U. plumipes")]), _vm._v(" (Joel et al. 2015) supported a model of cribellum silk production that involved a complex, highly coordinated set of leg and spinneret movements. Each rapid rearward brushing movement (about 10/s) combined with a small anterior movement of the cribellum to push and fold the mat of fibrils into an expanded section (a “puff”) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0207"
    }
  }, [_vm._v("fig. 2.7")]), _vm._v("), with a greater density of fibrils where the calamistrum had pushed against the mat. The shapes of puffs vary substantially in different species (Griswold et al. 2005). Individuals of "), _c('i', [_vm._v("U. plumipes")]), _vm._v(" in which the clamistra were removed continued to produce mats of cribellum fibrils, but the mats were not formed into puffs. By folding the fibrils into puffs, the spider lengthens the sticky lines and enables them to extend more when stressed by a prey, but the functional significance of different shapes of puffs is unknown.")]), _vm._v(" "), _c('p', [_vm._v("The spinnerets executed complex, coordinated movements during cribellum silk production. The posterior median and the posterior lateral spinnerets opened laterally and closed and the lateral spinnerets extended posteriorly during each combing movement of the calamistrum. The posterior median spinnerets opened just after the calamistrusm’s brushing movement, and paracribellum lines from the long spigots on the posterior median spinnerets became interspersed with the cribellar fibrils; then, when the spinnerets closed medially, the paracribellum lines (and thus, indirectly, the cribellum fibrils) were attached to the pseudoflagelliform axial lines that were emerging from the posterior lateral spinnerets (Joel et al. 2015).")]), _vm._v(" "), _c('p', [_vm._v("In most species, the axial lines were combined with additional, highly folded “reserve warp” (probably paracribellar) lines that varied both within and between groups in number and shape, from straight to slightly coiled to highly coiled (Eberhard and Pereira 1993; Griswold et al. 2005) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0207"
    }
  }, [_vm._v("fig. 2.7")]), _vm._v("); in filistatids, for instance, there were large helical fibers, reserve warp fibers, and crinkled axial fibers (Opell 2013). The axial fibers probably serve to sustain the mats; reserve warp fibers may link cribellum fibrils to the axial fibers as in "), _c('i', [_vm._v("U. plumipes")]), _vm._v(", or reinforce the mat after the axial fibers have broken and its cribellum fibrils are being unfolded and extended by a prey.")]), _vm._v(" "), _c('p', [_vm._v("The unfolding and extension of cribellum fibrils undoubtedly aid in stopping and retaining prey (Opell and Bond 2000; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03"
    }
  }, [_vm._v("section 3.3")]), _vm._v("). In "), _c('i', [_vm._v("Deinopis spinosa")]), _vm._v(" (DEI) up to 90% of the total work performed by capture lines as they were extended could be attributed to these fibrils, rather than to the pseudoflagelliform axial fibers (Blackledge and Hayashi 2006b). The cribellum fibrils were not elastic, and did not return to their initial folded state after being extended (Opell and Bond 2000). Nevertheless, the sticky spiral lines of "), _c('i', [_vm._v("Hyptiotes paradoxus")]), _vm._v(" (UL) have been reported to be highly elastic (Marples and Marples 1937) (in contrast to those of other uloborids such as "), _c('i', [_vm._v("Uloborus")]), _vm._v(", "), _c('i', [_vm._v("Zosis")]), _vm._v(", and "), _c('i', [_vm._v("Philoponella")]), _vm._v(") (WE); the sticky lines in a "), _c('i', [_vm._v("Deinopis")]), _vm._v(" sp. web also returned to their original lengths after being extended when the spider was induced to briefly expand her web by a nearby noise (WE).")]), _vm._v(" "), _c('p', [_vm._v("The adhesiveness of cribellum fibrils is thought to result from the combination of three different mechanisms: mechanical interlocking or snagging on irregularities in the surface (e.g., the setae on an insect); van der Waals forces, which are generated when molecules of the fibrils interact directly with molecules on the surface to which they adhere; and hygroscopic or capillary forces, which are generated when water molecules cohere to both a fibril and to the surface. In addition, the epicuticular waxes on the surfaces of insects infiltrate the mat of cribellum fibrils of "), _c('i', [_vm._v("U. plumipes")]), _vm._v(", probably as a result of capillary forces, and increase the strength of adhesion by a factor of eight over wax-free surfaces (Bott et al. 2017). The relative importance of different types of adhesion probably varies. Snagging may be important with irregular surfaces such as setose insect cuticle, but is not necessary for adhesion: cribellum silk adhered "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "38",
      "id": "p38",
      "role": "doc-pagebreak"
    }
  }), _vm._v("tenaciously even to smooth surfaces such as glass. All cribellum fibers but those of hypochilioids and filistatids have small, regularly spaced nodules, and at typical environmental humidities these apparently contribute substantially to the adhesion of fibers via capillary forces. The total adhesiveness of a line of "), _c('i', [_vm._v("Hyptiotes cavatus")]), _vm._v(" (UL) (with noded fibers) was twice as great at 46% relative humidity than at 1–2 %. Hydroscopic forces basically replaced van der Waals forces as the most important for adhesion at high ambient humidities (Hawthorn and Opell 2003). Although cribellum lines appear to constitute more effective traps in more humid environments, many cribellate species live in quite dry habitats.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec02.02.08.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.08.02"
    }
  }, [_vm._v("2.2.8.2 Aggregate glands")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The second type of sticky silk, the aggregate gland silk of araneoids, is the best studied. Most data on aggregate gland silk are from orb weavers, although the glands also occur in other araneoid families (see reviews of Sahni et al. 2011, 2014; Townley and Tillinghast 2013). There are generally two pairs of these ancient glands (which arose at least 165 Mya), though some have been lost in scattered taxa (Townley and Tillinghast 2013). They produce a complex, watery cocktail of low-molecular-weight, hydrophilic molecules that constitute the sticky droplets that occur like beads on the sticky spiral lines in orb webs, and on major ampullate lines in gumfoot webs and others (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0208"
    }
  }, [_vm._v("figs. 2.8")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#fig1013"
    }
  }, [_vm._v("10.13")]), _vm._v("). These globules constitute the majority of the weight of an orb. Even after the water is removed by evaporation, the water-soluble fraction (largely aggregate gland products) constitutes about one- to two-thirds of an orb’s weight (Townley and Tillinghast 2013).")]), _vm._v(" "), _c('p', [_vm._v("The morphological complexity of the glands, including the densely packed, radially arranged nodules on the ducts (Townley and Tillinghast 2013), suggest a complex secretion process that may include active transport of water and ions (especially phosphate) and possibly organic compounds into the duct lumen (Townley and Tillinghast 2013). Some aggregate gland glycoproteins currently cannot be homologized with other silk proteins.")]), _vm._v(" "), _c('p', [_vm._v("The crescent-shaped tips of the two aggregate spigots adjacent to the tip of the flagelliform spigot apply the morphologically complex aggregate gland products onto the flagelliform baseline. The viscous liquid glue begins as a cylinder, but as it absorbs atmospheric moisture it almost immediately rounds up spontaneously into a series of morphologically complex ellipsoid droplets, with a thin covering remaining on the baseline between droplets (Townley and Tillinghast 2013). Each droplet contains a core of fibrous glycoproteins (an estimated 5–10% of its volume) surrounded by an aqueous coating (Vollrath and Tillinghast 1991), and a thin surface coat (Peters 1995b). It is the inner core or nodule of glycoproteins that constitutes the principal adhesive (Vollrath and Tillinghast 1991; Townley and Tillinghast 2013). There are also granules of glycoprotein within the core that probably act to anchor the more diffuse region of the droplet to the axial line (Opell and Hendricks 2010), although droplets can slide along the axial lines if sufficient force is applied (B. Opell pers. comm.; WE). There are also hygroscopic salts within the glycoprotein (Sahni et al. 2014). Probably a dynamic equilibrium between the hygroscopic liquid in the glue and the surface coat with the water in the air is dominant in droplet formation (Edmonds and Vollrath 1992; Peters 1995b). Droplet size generally correlates positively with spider size (Craig and Freeman 1991).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0208"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "300",
      "src": "images/chi-eberhard-fig0208.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p38"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.8.")]), _vm._v(" The tightly helical form of these lines and the very sparse droplets of glue in the tropical synotaxid, "), _c('i', [_vm._v("Synotaxus")]), _vm._v(" sp., typify the unexplored diversity of properties of silk lines and their functions in different taxonomic groups. The mechanical properties of the silk vary even among closely related species (e.g., Sensenig et al. 2010a), so the previous custom of assuming that lines from a given type of gland have standard properties will have to be abandoned. This will make analyses of the functional significance of different web forms much more challenging (from Barrantes and Triana 2009).")])]), _vm._v(" "), _c('p', [_vm._v("The components of the aqueous cocktail surrounding the core (about 80% water) include low-molecular-weight hydrophylic compounds such as amino acids, "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "39",
      "id": "p39",
      "role": "doc-pagebreak"
    }
  }), _vm._v("five different compounds related or identical to known or suspected neurotransmitters (!), and salts (Tillinghast and Townley 1987; Blackledge et al. 2011). These low-molecular-mass (LMM) compounds occur in very different relative amounts in different congeneric species, and even among webs of a single species. Some variation may be due to compounds that the spider is unable to synthesize itself and acquires from gut bacteria and from reingesting previous webs (Townley and Tillinghast 2013). An additional component, potassium dihydrogen phosphate, may prevent bacterial degradation (Schildknecht et al. 1972), though the short length of time most orbs are exposed before being reingested (often 12 hours or less) may not be long enough for this antibiotic function to be important.")]), _vm._v(" "), _c('p', [_vm._v("The rubbery nature of the baseline and the adhesiveness of the glue are reduced if they are dried out, and one potentially key property of aggregate gland material is the ability to absorb and retain water from the air. The hydrophilic salts and the "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("γ")]), _vm._v("-amino butyramide can increase the adhesive properties of the glue (the volume, contact area, and extensibility of the glycoprotein core) as well as the extensibility and elasticity of the baselines. Droplet volumes increase with greater relative humidity of the air (Sahni et al. 2014; Opell et al. 2015), while viscosity varies with humidity over five orders of magnitude. Adhesion was maximized at very different humidities for five diverse species. Different mixes of proteins and hygroscopic organic salts “tuned” the glue of each species so that it was stickiest in humidity ranges that were typical of their habitats (Amarpuri et al. 2015; see also Opell et al. 2013, 2015). In "), _c('i', [_vm._v("Araneus marmoreus")]), _vm._v(" (AR) these differences resulted in biologically significant variation in retention time of houseflies (Opell et al. in prep.). There are probably tradeoffs in the effects of water in increasing the extensibility of the droplets, which allows the formation of “suspension bridges” that recruit adhesion along the thread’s length, and decreasing its viscosity, which affects the adhesion of a single droplet. Sharp differences between the water-soluble components of the two "), _c('i', [_vm._v("Argiope")]), _vm._v(" species (nine ninhydrin-reactive components were present in the silk of "), _c('i', [_vm._v("A. trifasciata")]), _vm._v(", but only one in that of "), _c('i', [_vm._v("A. aurantia")]), _vm._v(") (Anderson and Tillinghast 1980) hint at further hidden diversity.")]), _vm._v(" "), _c('p', [_vm._v("A second result of aggregate gland material acquiring water from the air may be maintenance of the spider herself: the water acquired by the spider when she reingests an orb may constitute about 10% of her daily water intake (Edmonds and Vollrath 1992).")]), _vm._v(" "), _c('p', [_vm._v("A droplet itself can stretch after contacting an object; this is important in providing a “suspension bridge effect” that aids in overcoming the problem in most sticky materials that adhesion during pull off is generated primarily only at the edges of a surface (Opell and Hendricks 2010). As a sticky spiral line begins to peel off an object, the droplets near the edge of the object stretch and remain in contact with its surface, thus contributing adhesive force while more interior droplets become recruited to resist further pull off (Opell and Hendricks 2010).")]), _vm._v(" "), _c('p', [_vm._v("It has been hypothesized that components of the aggregate gland glue also function as a poison to reduce prey resistence. Such a poison would have to act quite rapidly, however, and in very small amounts, and there are other possible functions for these compounds (Anderson and Tillinghast 1980). Another, perhaps more likely, additional function is for amphiphilic lipids to increase the wettability of insect epicuticles, increasing the glue’s contact area with the prey (Townley and Tillinghast 2013).")]), _vm._v(" "), _c('p', [_vm._v("The watery nature of the droplets of glue might suggest that they are not particularly costly in terms of materials, compared with other types of silk. The aggregate glands are large, however (Townley and Tillinghast 2013), and there are several suggestions that their products are a limiting resource. The amounts of the hygroscopic compound choline in the sticky lines of the araneids "), _c('i', [_vm._v("Argiope trifasciata")]), _vm._v(", "), _c('i', [_vm._v("A. aurantia")]), _vm._v(", and "), _c('i', [_vm._v("Araneus cavaticus")]), _vm._v(" decreased when spiders were starved (Townley et al. 2006), and other low-molecular-mass compounds that are costly for the spider to synthesize were also reduced. Experimental manipulation of the amounts of sticky spiral silk available in the spider’s glands when orb construction began had strong effects on several aspects of orb size and design (Eberhard 1988a; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.03.02"
    }
  }, [_vm._v("section 7.3.3.2")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("Substantial variations in function may be waiting to be discovered. The surface reflectance (brightness) of sticky lines (and thus the visibility of the orb) correlated positively with droplet size, but the correlation was closer in nocturnal than in diurnal orbs and varied "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "40",
      "id": "p40",
      "role": "doc-pagebreak"
    }
  }), _vm._v("within some genera and also between genera (Craig and Freeman 1991). The adhesion forces of glue on sticky spiral lines differed in different species of "), _c('i', [_vm._v("Tetragnatha")]), _vm._v(" endemic to the Hawaiian islands (Alicea-Serrano et al. in prep.).")]), _vm._v(" "), _c('p', [_vm._v("Differences in aggregate gland silk may be especially strong in non-orb weavers (see Sahni et al. 2011 for contrasts between the araneid "), _c('i', [_vm._v("Larinioides cornutus")]), _vm._v(" and the theridiid "), _c('i', [_vm._v("Latrodectus hesperus")]), _vm._v("). The low-molecular-mass compounds in "), _c('i', [_vm._v("Latrodectus")]), _vm._v(" spp. (THD) differed strongly from those in araneoids (in some samples their most abundant component was completely unknown in araneids), and there are also differences among different theridiid genera (Kovoor 1977a,b; Kovoor and Lopez 1983). Sahni et al. (2011) found that with respect to stretching, gumfoot glue behaved like a viscoelastic liquid and was not sensitive to humidity differences, while the sticky spiral glue of "), _c('i', [_vm._v("Larinioides cornutus")]), _vm._v(" (AR) behaved like a viscoelastic solid and experienced reduced elasticity at higher humidity and peak adhesion at intermediate humidities; they proposed that the differences may be due to different tackifiers.")]), _vm._v(" "), _c('p', [_vm._v("The more posterior of the two aggregate glands in theridiids apparently produces the glue used in wrapping attacks on prey and has short ducts that lack the elaborate system of nodules typical of araneids and present in the anterior gland, which produces glue for the web (Townley and Tillinghast 2013). The ducts of the aggregate glands of linyphiids, which are apparently used only for web lines, lacked nodules entirely (Townley and Tillinghast 2013).")]), _vm._v(" "), _c('p', [_vm._v("The glue on gumfoot lines in "), _c('i', [_vm._v("Latrodectus hesperus")]), _vm._v(" lacked the internal nodules that are largely responsible for adhesion in araneids. The entire mass of glue at the tip of a gumfoot line may often collapse onto the prey when the break-away attachment to the substrate fails, so design differences are not unexpected. Other species of "), _c('i', [_vm._v("Latrodectus")]), _vm._v(" also place glue on other, not easily broken lines in other portions of the web (Eberhard et al. 2008b), but the internal structure of these other droplets is unknown.")]), _vm._v(" "), _c('p', [_vm._v("Another mystery concerns the tiny, barely perceptible, droplets in the webs of the theridiids "), _c('i', [_vm._v("Theridion hispidum")]), _vm._v(" and "), _c('i', [_vm._v("T")]), _vm._v(". nr. "), _c('i', [_vm._v("melanostictum")]), _vm._v(" and "), _c('i', [_vm._v("Anelosimus")]), _vm._v(" spp. (Eberhard et al. 2008b), the pholcids "), _c('i', [_vm._v("Modisimus guatuso")]), _vm._v(" (Briceño 1985) and "), _c('i', [_vm._v("Belisana")]), _vm._v(" spp. (Deeleman-Reinhold 1986; Huber 2005) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#fig0919"
    }
  }, [_vm._v("fig. 9.19")]), _vm._v("), and, the synotaxids "), _c('i', [_vm._v("Synotaxus")]), _vm._v(" spp. ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0208"
    }
  }, [_vm._v("fig. 2.8")]), _vm._v(", Eberhard et al. 2008b). These droplets are so small and sparse that they are barely adhesive, and seem likely to be ineffective against all but the smallest, weakest prey. Even tinier droplets that are only visible with magnification occur on tangle lines above the sheet in the webs of species of "), _c('i', [_vm._v("Anelosimus")]), _vm._v(" (Eberhard et al. 2008b) and "), _c('i', [_vm._v("Nihonhimea tesselata")]), _vm._v(" (THD) (Barrantes and Weng 2006b), and on tangle as well as the sheet lines in some linyphiid webs (Nielsen 1932; Peters and Kovoor 1991; Benjamin et al. 2002). Benjamin et al. (2002) speculated that the droplets serve to fasten the lines of the web to each other, as the webs have few piriform attachment discs (Peters and Kovoor 1991); but the droplets are not restricted to junctions and there is as yet no direct evidence of such adhesion (see, however, "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.04"
    }
  }, [_vm._v("section 9.4")]), _vm._v(" on linyphiid sheets). In the synotaxids and "), _c('i', [_vm._v("Belisana")]), _vm._v(" pholcids, the droplets are far from other lines ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0208"
    }
  }, [_vm._v("figs. 2.8")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#fig0919"
    }
  }, [_vm._v("9.19")]), _vm._v(", Eberhard 1977a) and surely do not function in this way.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec02.02.08.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.08.03"
    }
  }, [_vm._v("2.2.8.3 Venom glands that produce contractile sticky “webs” in Scytodidae")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("A third type of sticky material (its classification as “silk” is preliminary) is part of a spectacular predatory innovation in the small “spitting spider” family Scytotidae. One portion of the venom glands associated with the chelicerae is modified to produce both elastic lines and sticky glue that are shot from the spider’s tiny chelicerae onto the prey (Foelix 2011; Stratton and Suter 2009). Raising her basal cheliceral segments and oscillating her fangs rapidly (at about 278–1700 Hz!), the spider "), _c('i', [_vm._v("Scytodes thoracica")]), _vm._v(" “spits” at very high velocity (up to 29 m/s!) an orderly, web-like array of zig-zag gluey lines onto the prey and the surrounding substrate (Stratton and Suter 2009). The line is elastic, and is launched in an elongated state, and then contracts during the 0.2 s after it strikes; this contraction probably serves to “wrap” the prey and fasten it to the substrate (Stratton and Suter 2009). Following a successful spit, the spider approaches cautiously, delivers a delicate bite to any small protruding extremity (her small cheliceral size, probably necessary to permit rapid spitting movements, makes her able to bite only small prey structures), and steps back until the prey becomes immobile.")]), _vm._v(" "), _c('p', [_vm._v("Little is known regarding the composition of these contractile “webs.” They are probably not toxic for prey "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "41",
      "id": "p41",
      "role": "doc-pagebreak"
    }
  }), _vm._v("(Clements and Li 2005), though some prior observers suggested that they contained venom (Nentwig 1985a). Given that the spiders possess genes that code for the silk proteins in their abdominal silk glands and spinnerets, and that there are ultrastructural similarities between the venom gland cells and cells in the abdominal silk glands (Kovoor and Zylberberg 1972), it seems likely that the lines shot from the chelicerae are silk (Suter and Stratton 2009); the glue has not been characterized, however. No sticky material is included in the sparse, non-adhesive tangle webs that some "), _c('i', [_vm._v("Scytodes")]), _vm._v(" species build with silk produced by their spinnerets (Nentwig 1985a; Gilbert and Rayor 1985; Eberhard 1973a, 1986a).")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec02.02.08.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.08.04"
    }
  }, [_vm._v("2.2.8.4 Ampullate glands in "), _c('i', [_vm._v("Loxosceles")])])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Still another type of sticky line is known only from a small group of poisonous, “brown recluse” spiders in the genus "), _c('i', [_vm._v("Loxosceles")]), _vm._v(", and has scarcely been studied. The highly adhesive sticky silk is not associated with any liquid; it consists of wide, very thin ribbons about 2–4 µm wide that have been estimated in different species to be only 12–40 nm thick (Lehmensick and Kullmann 1956; Coddington et al. 2002; Knight and Vollrath 2002). The ribbons are laid loosely on the substrate near the spider’s sheltered retreat under a rock or a trunk (Vetter 2015). The mechanism responsible for their adhesiveness is unknown; speculations include van der Waals and electrostatic forces (Knight and Vollrath 2002) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0209"
    }
  }, [_vm._v("fig. 2.9")]), _vm._v("). Clumps of loose adhesive silk of "), _c('i', [_vm._v("L. arizonica")]), _vm._v(" moved toward objects like fingers, forceps, and a glass slide that were brought near, so electrostatic interactions may be involved (Coddington et al. 2002). The ribbons are unusual in that the liquid gland product is apparently converted to a semi-cristalline state abruptly, at the distal tip of the spigot; the valve that usually occurs within the duct of the ampullate gland of araneids is lacking (Knight and Vollrath 2002). Unique, highly modified toothed setae near the spigots may be involved in silk production ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0209"
    }
  }, [_vm._v("fig. 2.9")]), _vm._v("). The sticky silk of "), _c('i', [_vm._v("Loxosceles laeta")]), _vm._v(" is not known to be associated with baselines corresponding to the flagelliform or pseudoflagelliform lines of the other groups (Lehmensick and Kullmann 1957; Knight and Vollrath 2002; Margalhaes in press). The homology with the ampullate gland silk of other spiders is uncertain.")])])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.02.09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.09"
    }
  }, [_vm._v("2.2.9 Piriform glands")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Both ampullate and piriform silk appeared abruptly with the araneomorph spiders, and are present throughout the modern species in this group (Griswold et al. 2005). The evolutionary sequence may have been complex, however, as some piriform protein products probably had a separate evolutionary origin (below). The association between ampullate and piriform lines makes sense functionally, as fastening a few thicker lines to each other with a mass of fine lines and glue seems more effective than the more ancient technique using swaths of thin aciniform lines using only their weak stickiness when first produced. Piriform silk may have originally evolved to attach lines to the substrate (e.g., in silk linings of tunnels), and only later to attach single lines to each other. Attachments to the substrate are less demanding in terms of precise positioning of the piriform lines. Many wandering spiders, like salticids, repeatedly attach their trail lines to the substrate, and also make attachment discs that attach lines to the substrate but not to other single lines (Li et al. 2002).")]), _vm._v(" "), _c('p', [_vm._v("The piriform glands probably had especially important consequences for the evolution of webs. Their products fasten silk lines firmly to each other ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0210"
    }
  }, [_vm._v("fig. 2.10")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0211"
    }
  }, [_vm._v("2.11")]), _vm._v(") and to the substrate ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0210"
    }
  }, [_vm._v("fig. 2.10b,c,e")]), _vm._v("), and also (in uloborids) help wrapping lines from the aciniform glands adhere to prey (Peters 1982). Before these glands evolved, spiders could probably only fasten their lines more weakly to other objects and lines, dabbing or wiping their spinnerets on the substrate to which they wished to attach ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.03.08"
    }
  }, [_vm._v("section 5.3.8")]), _vm._v(", box 5.2). Adhesion probably resulted from the silk lines being slightly wet when they first emerged ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0211"
    }
  }, [_vm._v("fig. 2.11")]), _vm._v("), or to occasionally snagging lines of silk on the substrate. As with many types of silk glands, piriform glands appeared abruptly with the origin of araneomorph spiders (Blackledge et al. 2009c). The evolution of a combination of strong ampullate lines and piriform attachments that fasten them firmly opened up a new world of possible web forms for spiders ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.04"
    }
  }, [_vm._v("section 10.4")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("There are at least two piriform gland products: fibers; and an amorphous, hydrocarbon-rich cement-like substance that includes aligned nanofibrils, lipid enclosures, and a dense, isotropic boundary layer (Kovoor and Zylberberg 1980; Peters 1992; Grawe et al. 2014; Wolff et al. 2015) (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0210"
    }
  }, [_vm._v("fig. 2.10")]), _vm._v("). The gland products are complex chemically, and the fibers may include at least two "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "42",
      "id": "p42",
      "role": "doc-pagebreak"
    }
  }), _vm._v("unique proteins (Blackledge 2013). Some proteins may be exceptional in not belonging to the spidroin gene family (Hu et al. 2007). The piriform silk in sticky spiral-radius attachments in orb webs of the araneids "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" and "), _c('i', [_vm._v("Argiope aurantia")]), _vm._v(" differed from silk in radius-frame attachments with respect to its affinity for histological stains, and birefringences (Tillinghast and Townley 1987; Townley and Tillinghast 2013), as well as the mechanical properties of the “pulley-like” attachments (below). There may be a great deal of as yet unexplored diversity in piriform gland products.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0209"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-eberhard-fig0209.jpeg",
      "width": "477"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p42"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.9.")]), _vm._v(" These greatly broadened comb-like setae (some are labeled “"), _c('i', [_vm._v("c")]), _vm._v("”) constitute a morphological reminder of the many remaining mysteries that surround variations in silk constitution and production. Setae of this sort are known only from the posterior lateral spinnerets of the haplogyne fiddle back spider, "), _c('i', [_vm._v("Loxosceles laeta")]), _vm._v(" (Sicariidae); presumably they function in conjunction with the very rapid spinneret movements that occur during sticky silk production (Margalhaes in press). Possible functions that have been proposed include such diverse uses as pressing the thin ribbons of silk that are produced by the anterior lateral spinnerets, directing this silk onto the web, pulling it from the anterior lateral spinnerets, or charging it electrostatically as it emerges (scale bar is 20 "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("μ")]), _vm._v("m) (from Knight and Vollrath 2002).")])]), _vm._v(" "), _c('p', [_vm._v("The adhesion produced by piriform attachment discs, especially those cementing lines to each other, is often strong: when orb webs break under the stress of prey impact, failure is usually due to rupture of the lines themselves rather the junctions between them ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.09"
    }
  }, [_vm._v("section 3.3.2.9")]), _vm._v("). Even attachments to smooth substrates such as Teflon and smooth, waxy leaves are often strong enough to hold the spider’s weight (Grawe et al. 2014). The most common type of failure of attachments to a leaf or Teflon film was for the entire disc to peel off. In contrast, when the surface was a glass microscope slide, peeling off never occurred, and the most common type of failure was breakage of the lines that joined the dragline to the area in contact with the leaf (Grawe et al. 2014). The attachments of sticky spiral lines to radii in the orbs of "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "44",
      "id": "p44",
      "role": "doc-pagebreak"
    }
  }), _vm._v("some araneids and nephilids are unusual in allowing the sticky spiral lines to slide through the attachments (“pulley attachments”), increasing the web’s ability to stop and retain prey ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.01.06"
    }
  }, [_vm._v("section 3.3.3.1.6")]), _vm._v(").")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0210"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "43",
      "id": "p43",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "547",
      "src": "images/chi-eberhard-fig0210.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.10.")]), _vm._v(" A crucial development in the evolution of spider webs was the piriform disc. Composed of both fine fibrils and liquid glue, piriform discs fasten silk lines to the substrate ("), _c('i', [_vm._v("b")]), _vm._v(", "), _c('i', [_vm._v("c")]), _vm._v(") and to other silk lines ("), _c('i', [_vm._v("a")]), _vm._v(", "), _c('i', [_vm._v("d")]), _vm._v(", "), _c('i', [_vm._v("e")]), _vm._v("). As shown in this sampler, the discs vary in their morphology. "), _c('i', [_vm._v("a")]), _vm._v(") This SEM image shows part of a typical attachment between two non-sticky lines, a radius to a frame line of "), _c('i', [_vm._v("Cyrtophora citricola")]), _vm._v(" (AR). Attachments of this sort are typically stronger than either of the lines that they join. "), _c('i', [_vm._v("b")]), _vm._v(") This typical piriform disc attaches a non-sticky dragline of "), _c('i', [_vm._v("Latrodectus geometricus")]), _vm._v(" (THD) to a glass slide; the zig-zag pattern of fine lines increases the area of contact with the substrate and thus probably also the strength of the adhesion. "), _c('i', [_vm._v("c")]), _vm._v(") This specialized, reduced piriform disc was built by the same instar of "), _c('i', [_vm._v("L")]), _vm._v(". "), _c('i', [_vm._v("geometricus")]), _vm._v(" as "), _c('i', [_vm._v("b")]), _vm._v(" to attach a gumfoot line to a slide. It is designed to be easily broken by tugs by prey that adhere to the glue droplets near the tip of the gumfoot line; when the attachment disc breaks, the tension on the line lifts the prey away from the substrate, where it dangles helplessly. "), _c('i', [_vm._v("d")]), _vm._v(") This piriform disc attaches a line with cribellum silk to the sheet of the zoropsid "), _c('i', [_vm._v("Tengella radiata")]), _vm._v(". Some of the piriform lines are wrapped around strong, straight lines as in "), _c('i', [_vm._v("a")]), _vm._v(", but many are splayed apart on the very fine lines of the sheet (which are not visible at this magnification). "), _c('i', [_vm._v("e")]), _vm._v(") This SEM image shows a coat of glue covering the piriform attachment of the sticky spiral to a radius in the orb of "), _c('i', [_vm._v("Nephila madagascarensis")]), _vm._v(" (NE). This special “pulley” attachment breaks partially when force is applied to the sticky spiral line, allowing the sticky spiral baseline to slide past the radius, but maintaining its adhesion to the radius ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.01.06"
    }
  }, [_vm._v("section 3.3.3.1.6")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#fig0333"
    }
  }, [_vm._v("fig. 3.33")]), _vm._v(") ("), _c('i', [_vm._v("a")]), _vm._v(" and "), _c('i', [_vm._v("e")]), _vm._v(" from Kullmann 1975, "), _c('i', [_vm._v("d")]), _vm._v(" from Eberhard and Hazzi 2017, "), _c('i', [_vm._v("b")]), _vm._v(" and "), _c('i', [_vm._v("c")]), _vm._v(" courtesy of Gilbert Barrantes).")])]), _vm._v(" "), _c('p', [_vm._v("Piriform glue is also quite unusual in how rapidly it hardens (S. Zschokke pers. comm.; Wolff et al. 2015). Most man-made adhesives take seconds or minutes to harden, but piriform attachments made during web construction resist tension almost immediately after they are made; Samuel Zschokke (per. comm.) measured hardening times of around 0.2 s in "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" (AR). The piriform attachments made during the construction of orbs and other webs when the spider “cinches up” a frame line ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.02"
    }
  }, [_vm._v("sections 6.3.2")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.03"
    }
  }, [_vm._v("6.3.3")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#fig0604"
    }
  }, [_vm._v("figs. 6.4g")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#fig0605"
    }
  }, [_vm._v("6.5c")]), _vm._v(") or tightens a line by adding attachments to the substrate or other web lines ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0210"
    }
  }, [_vm._v("fig. 2.10")]), _vm._v(") involve particularly substantial tensions that are applied almost instantaneously.")]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec02.02.09.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.09.01"
    }
  }, [_vm._v("2.2.9.1 Spinneret morphology")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The piriform spigots are on the anterior lateral spinnerets, with their tips often in approximately the same plane on the spinneret’s flattened medial-distal surface (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0211"
    }
  }, [_vm._v("fig. 2.11")]), _vm._v(", Griswold et al. 2005). This flat surface probably permits multiple spigots to touch a flat substrate simultaneously when the spider spreads her anterior lateral spinnerets. In some species, such as "), _c('i', [_vm._v("Nephila pilipes")]), _vm._v(" (= "), _c('i', [_vm._v("maculata")]), _vm._v(") (NE) (Hingston 1922a) and "), _c('i', [_vm._v("Micrathena duodecimspinosa")]), _vm._v(" (AR) (WE) the spider may facilitate contact of these spigots with the substrate by rocking her abdomen from side to side while she makes an attachment. The positions of the piriform spigots on the anterior spinnerets are appropriate for fastening the ampullate gland lines, which are also produced by the anterior lateral spinnerets, to the substrate or other lines; but they are not appropriate for fastening the aciniform lines, which emerge farther posteriorly, to other objects or lines.")]), _vm._v(" "), _c('p', [_vm._v("Diverse morphologies, positions, and numbers of piriform spigots are illustrated in the taxonomic literature (e.g., Griswold et al. 2005). The functional significance of the differences is largely unknown, though there are exceptions. The more than two-fold difference in the numbers of piriform spigots in "), _c('i', [_vm._v("Poltys illepidus")]), _vm._v(" and "), _c('i', [_vm._v("P. laciniosus")]), _vm._v(" (AR) may be associated with the need for a stronger dragline attachment in the heavier "), _c('i', [_vm._v("P. illepidus")]), _vm._v(", which seemed more disposed to jump and dangle on its dragline when disturbed (Smith 2006). Gnaphosid spiders that did not build webs attacked prey by running past and around them, producing a band of sticky silk that immobilized the prey’s legs (Bristowe 1958), and they used their enlarged anterior lateral spinnerets with derived piriform spigot morphology to produce the band (Wolff et al. 2017b).")]), _vm._v(" "), _c('p', [_vm._v("On the other hand, the significance of the loss of piriform spigots in the diguetid "), _c('i', [_vm._v("Diguetia")]), _vm._v(" sp. (Platnick et al. 1991), a genus in which spiders make aerial webs with many firm attachments of lines to the substrate and to each other, is a mystery. Web design probably correlates with the relative sizes of piriform glands themselves in some groups. For instance, a typical linyphiid web may have more attachment discs, especially in the tangle above the sheet, than does an orb; correlated with this, a mature female "), _c('i', [_vm._v("Linyphia triangularis")]), _vm._v(" has numerous, fairly large piriform glands (Peters and Kovoor 1991). One exceptional species is the sand dune eresid "), _c('i', [_vm._v("Seothyra henscheli")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#box0903"
    }
  }, [_vm._v("box 9.3")]), _vm._v("). The piriform spigots bristled in different directions at the tip of the anterior lateral spinneret like the spikes of a mace ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#fig0931"
    }
  }, [_vm._v("fig. 9.31d")]), _vm._v("). The spider forms mats of grains by stabbing her anterior lateral spinnerets repeatedly into the sand; the lines from the bristling piriform spigots bind the grains together into a mat to which the spider then attaches her web lines (Peters 1992; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#fig0930"
    }
  }, [_vm._v("fig. 9.30")]), _vm._v(").")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec02.02.09.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.09.02"
    }
  }, [_vm._v("2.2.9.2 Morphology of attachment discs")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Piriform attachments (“attachment discs”) are complex morphologically ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0210"
    }
  }, [_vm._v("fig. 2.10")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0211"
    }
  }, [_vm._v("2.11")]), _vm._v(") (Schütt 1996; Wolff et al. 2017a). Attachment discs fastening the dragline to a planar substrate had piriform fibers enclosing the dragline that also spread approximately radially on the substrate ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0210"
    }
  }, [_vm._v("fig. 2.10b")]), _vm._v("). This architecture results in a large contact area generated at low material cost, and probably distributes forces over a high number of branches, lowering the stress generated in each single structure. In addition, propagating cracks may be arrested because there are fibers embedded in the cement-like substance. In addition, peeling angles are kept low, making the attachment resist higher forces before detaching (Grawe et al. 2014; Wolff et al. 2015). In "), _c('i', [_vm._v("Nephila plumipes")]), _vm._v(" the insertion point of the dragline was shifted toward the center of the attachment disc, forming a flexible tree root-like network of branching fibers around the loading point (Wolff and Herberstein 2017).")]), _vm._v(" "), _c('p', [_vm._v("Discs attaching draglines to the substrate were morphologically "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "45",
      "id": "p45",
      "role": "doc-pagebreak"
    }
  }), _vm._v("diverse ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0210"
    }
  }, [_vm._v("fig. 2.10")]), _vm._v(", Schütt 1996). One specialized type is theridiid gumfoot line attachments to the substrate, which break easily, allowing the line to lift the prey up, out of contact with the substrate (e.g., Bristowe 1958; see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#ch09"
    }
  }, [_vm._v("chapter 9")]), _vm._v("). These discs had fewer fine lines contacting the substrate than did other substrate attachments of non-sticky lines of the same spiders (Eberhard et al. 2008b; Sahni et al. 2012, "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0210"
    }
  }, [_vm._v("fig. 2.10a,b")]), _vm._v("). The attachments of lines to the surface of tropical streams and lakes by the theridiosomatid "), _c('i', [_vm._v("Wendilgarda")]), _vm._v(" spp. had a similar sparse appearance (Coddington and Valerio 1980; Eberhard 2000a, 2001a). In contrast, the substrate attachments of strong radial lines by the filistatid "), _c('i', [_vm._v("Kukulcania hibernalis")]), _vm._v(" were compound, including both broad swaths of many fine (presumably aciniform) lines that were applied with rapid waggling movements of the PL spinnerets, and also had smaller masses of possible piriform material (WE) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#fig1011"
    }
  }, [_vm._v("fig. 10.11")]), _vm._v("). The attachment discs of the pholcid "), _c('i', [_vm._v("Pholcus phalangioides")]), _vm._v(" were extreme in being puddles of a liquid silk that lacked fibers (Schütt 1996); the liquid was probably produced by a single pair of very wide spigots that may be derived from piriform spigots (Platnick et al. 1991). The egg sacs of "), _c('i', [_vm._v("Zygiella x-notata")]), _vm._v(" (AR) had two types of substrate attachments—typical piriform discs, and more liquid “glue droplets” (Gheysens et al. 2005).")]), _vm._v(" "), _c('p', [_vm._v("The morphology of piriform discs that attached one line to another involved, in contrast, many fine lines that were wrapped around the two lines being joined, as well as glue ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0210"
    }
  }, [_vm._v("fig. 2.10a,e")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0211"
    }
  }, [_vm._v("2.11c,d")]), _vm._v("; see also Kavanagh and Tillinghast 1979; Grawe et al. 2014). In "), _c('i', [_vm._v("Cyrtophora citricola")]), _vm._v(" (AR) the liquid itself had at least two components, one electron dense and the other electron lucent (Peters 1993a). Details of how these different components emerge from the spigots are not known. Images of at least some piriform lines of the eresid "), _c('i', [_vm._v("Seothyra henscheli")]), _vm._v(" suggested they were “wet” when they were produced (Peters 1992). Attachments between lines can differ within a single web ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0210"
    }
  }, [_vm._v("fig. 2.10c–f")]), _vm._v("). In "), _c('i', [_vm._v("Cyrtophora citricola")]), _vm._v(" (AR), the attachments of the non-sticky spiral to the radii in the sheet ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0107"
    }
  }, [_vm._v("fig. 1.7")]), _vm._v(") were substantially shorter than the attachments between other non-sticky lines in the upper tangle (Peters 1993a). In the sheet web of the lycosid "), _c('i', [_vm._v("Aglaoctenus castaneus")]), _vm._v(" some piriform attachments were much wider and longer than others ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0210"
    }
  }, [_vm._v("fig. 2.10e,f")]), _vm._v("), and appeared to attach the dragline simultaneously to multiple lines in the sheet (Eberhard and Hazzi 2017). The attachments of sticky spiral lines to radii in "), _c('i', [_vm._v("Nephila madagascarensis")]), _vm._v(" (NE) (Kullmann 1975) and in several other species of araneids and tetragnathids (WE) differed from the attachments between non-sticky lines in having a relatively greater mass of “glue” and a smaller quantity of fibers (Kullmann 1975, "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0210"
    }
  }, [_vm._v("fig. 2.10c")]), _vm._v("). The lines in the dense sheets of "), _c('i', [_vm._v("Linyphia triangularis")]), _vm._v(" and "), _c('i', [_vm._v("Microlinyphia pusilla")]), _vm._v(" (LIN) were joined by a variety of mechanisms (Benjamin et al. 2002). In sum, the morphology of attachment structures produced by piriform glands is diverse.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec02.02.09.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.09.03"
    }
  }, [_vm._v("2.2.9.3 Different attachment disc morphologies result from spinneret behavior and morphology")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Differences in the forms of attachment discs that were made to smooth surfaces by the nephilid orb-weaver "), _c('i', [_vm._v("Nephila plumipes")]), _vm._v(" and the webless, trunk-living sparassid hunting spider "), _c('i', [_vm._v("Isopeda villosa")]), _vm._v(" (which was 2–3 times heavier) were associated with differences in both spinneret behavior and morphology (Wolff et al. 2017a). The mechanical properties of the dragline attachments of "), _c('i', [_vm._v("I. villosa")]), _vm._v(" were strongly “directional”; their highest pull-off resistance was when they were loaded parallel to the substrate and in the direction along which the spider had moved (that is, the direction in which loading often occurred in nature). The substrate attachments of "), _c('i', [_vm._v("N. plumipes")]), _vm._v(" were more robust in different loading directions (again, as occurs when webs are anchored to substrates in nature); they resisted pull-off at 90° about twice as well as those of "), _c('i', [_vm._v("I. villosa")]), _vm._v(", despite being produced more rapidly. A larger field of piriform spigots in "), _c('i', [_vm._v("N. pilipes")]), _vm._v(", and rubbing movements of the spinnerets applying piriform material to the dragline, were correlated with these differences (Wolff et al. 2017a).")]), _vm._v(" "), _c('p', [_vm._v("Peters (1993a) thought that the spinnerets of "), _c('i', [_vm._v("C. citricola")]), _vm._v(" “glide along the threads to be connected” (p. 159) as the spider moves. The parallel orientation (on the right in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0210"
    }
  }, [_vm._v("fig. 2.10a")]), _vm._v(") of the piriform fibers and new line that was being laid as the spider moved in the tail end of an attachment, as well as video recordings of the slender posterior section of the piriform field in "), _c('i', [_vm._v("Nephila plumipes")]), _vm._v(" (Wolff et al. 2017a), were in accord with this idea. The jumble of piriform lines in the central area of the attachment disc, in contrast, came from the broad anterior section of the piriform field (Wolff et al. 2017a). In general, understanding the spatial relations between "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "46",
      "id": "p46",
      "role": "doc-pagebreak"
    }
  }), _vm._v("the morphology and behavior of the spinnerets, spigots, and lines of different species is complicated by the fact that the area around the spinnerets was inflated in many published photographs (for better visibility); they may thus be in unnatural positions. Probably many details remain to be understood of the processes by which piriform lines emerge from their spigots and are applied to the ampullate or sticky spiral lines that are produced at the same time as well as to other lines already in place (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0210"
    }
  }, [_vm._v("fig. 2.10a")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("The multiple orientations of piriform fibers may be produced by rubbing movements of the spinnerets against each other, such as the brief, rapid anterior-posterior brushing movements by the anterior lateral spinnerets of "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" (NE) that were observed each time the sticky spiral was attached to a radius (appendix O6.3.6.3). Moving the anterior lateral spinneret anteriorly could bring the new major ampullate gland line into contact with piriform lines that had just been attached to the old line. In a species like "), _c('i', [_vm._v("N. clavipes")]), _vm._v(", the spider’s abdomen is more or less parallel to the radius throughout both temporary and sticky spiral construction (fig. O6.4), so new spiral lines will be more nearly perpendicular than parallel to the long axis of the spider’s abdomen as they are being attached to a radius; this could bring the major area of piriform spigots on the anterior lateral spinneret closer to the spiral lines.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec02.02.09.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.09.04"
    }
  }, [_vm._v("2.2.9.4 The “piriform queen”—"), _c('i', [_vm._v("Cyrtophora citricola")])])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The piriform attachments of "), _c('i', [_vm._v("Cyrtophora citricola")]), _vm._v(" were not morphologically unusual ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0211"
    }
  }, [_vm._v("fig. 2.11")]), _vm._v("), but the speed and agility with which they were produced during web construction was extraordinary: about 4 attachments were made each second, for periods lasting up to many minutes while the non-sticky spiral was being constructed ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0107"
    }
  }, [_vm._v("fig. 1.7")]), _vm._v(") (Kullmann 1958; WE). This speed is spectacular, because each attachment involved complex behavior: finding the next radius; positioning it precisely between the anterior lateral spinnerets and at a precise distance from the previous attachment to this radius; initiating piriform silk production; and then cleanly terminating piriform production. The precisely coordinated processes of initiation and termination probably lasted on the order of only hundredths of a second. The piriform spigots of this species were also unusual (Peters 1993a). There were two distinct sizes, and the smaller spigots were particularly numerous ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0211"
    }
  }, [_vm._v("fig. 2.11a")]), _vm._v(") compared with those of other “typical” araneoid orb weavers such as "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" and "), _c('i', [_vm._v("Argiope bruennichi")]), _vm._v(". There was also an unusually large U-shaped bald patch on the side of the spinneret distal to the major ampullate spigot; the outer margin of this patch was lined with especially small piriform spigots. The functional significance of these traits is unclear (Peters 1993a).")])])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.02.10"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.10"
    }
  }, [_vm._v("2.2.10 Epiandrous glands")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The small, somewhat mysterious epiandrous (or epigastric) glands that occur only on the ventral surface of the abdomen of mature males constitute one final set of silk glands. They are superficially similar to piriform glands (Peters and Kovoor 1991), but they empty externally through a few fine spigots located just anterior to the external male gonopore, far anterior to the spinnerets. Epiandrous glands seem to be present throughout the order (Foelix 2011), though they are absent in scattered species (Agnarsson 2004). The glands and their spigots are so inconspicuous that their absence in other groups could easily go unnoticed.")]), _vm._v(" "), _c('p', [_vm._v("The mystery of the epiandrous glands is not the function of their silk, but why it is needed. They produce a small mat of fine lines in the “sperm web,” onto which the male deposits a droplet of the semen directly from his gonopore; he then takes up the semen into his pedipalps. But why is this tiny mat necessary? For instance, the male of the theraphosid "), _c('i', [_vm._v("Grammostola monticola")]), _vm._v(" first makes a larger, dense sheet of fine “aciniform” lines, then adds a small, seemingly superfluous mat of epiandrous silk onto which he deposits a droplet of semen (Costa and Pérez-Miles 2002). The filistatid "), _c('i', [_vm._v("Kukulcania hibernalis")]), _vm._v(" also adds epiandrous gland lines to an already dense sheet of lines (Barrantes and Ramírez 2013).")]), _vm._v(" "), _c('p', [_vm._v("Could it be that the epiandrous silk has some special property that somehow facilitates coherence of the droplet or its uptake by the palps? Perhaps, for instance, it is especially hydrophobic (I. Agnarsson pers. comm.). The fact that the epiandrous glands of "), _c('i', [_vm._v("Linyphia triangularis")]), _vm._v(" produce two types of secretion with different staining affinities (Peters and Kovoor 1991) hints at the possible importance of special chemical properties.")]), _vm._v(" "), _c('p', [_vm._v("Alternatively, it might be that the epiandrous mat is an ancient fail-safe device to assure sperm are not lost. The spider’s orientation just prior to sperm deposition "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "47",
      "id": "p47",
      "role": "doc-pagebreak"
    }
  }), _vm._v("may be only approximate, and the male cannot afford to lose track of the site where he will deposit his small but crucial droplet. To my knowledge, sperm deposition always follows immediately after deposition of epiandrous lines; the male moves his abdomen slightly anteriorly and deposits the droplet.")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.02.11"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.11"
    }
  }, [_vm._v("2.2.11 Other products associated with silk")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("There are other chemical products that are associated with silk lines but whose provenance remains to be clarified. One common type are the sex pheromones produced by mature females, which may be lipids or lipid-soluble substances (Gaskett 2007). Another recently discovered and presumably rare product, is an ant repellent pyrrolidine alkaloid that may function to keep ants from invading the webs on the thick non-sticky lines of larger juveniles and adults of the giant nephilid "), _c('i', [_vm._v("Trichonephila antipodiana")]), _vm._v(" (Zhang et al. 2011). The possibility of similar effects has very seldom been checked, and there are many species of very small ants which could possibly use thinner lines (ants do occur on some densely meshed sheet webs with accumulated detritus—WE); ants are important predators of "), _c('i', [_vm._v("Stegodyphus")]), _vm._v(" spiders (Henschel 1998; Wright et al. 2016). A third recently discovered property is the antibiotic effect of silk from both the retreat and the prey capture web of the eresid "), _c('i', [_vm._v("Stegodyphus dumicola")]), _vm._v(" (Keiser et al. 2015) and the agelenid "), _c('i', [_vm._v("Tegeneria domestica")]), _vm._v(" (Wright and Goodacre 2012). The functional significance (if any) of this effect for these spiders has not been determined.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0211"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-eberhard-fig0211.jpeg",
      "width": "470"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p47"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.11.")]), _vm._v(" The tip of the right anterior lateral spinneret ("), _c('i', [_vm._v("a")]), _vm._v(") of a mature female of the “piriform queen” of spiders, "), _c('i', [_vm._v("Cyrtophora citricola")]), _vm._v(" (AR) is largely covered with small piriform spigots (all of the many spigots are piriform except the single large major ampullate spigot [Ma], which has a line emerging from it). This species makes extraordinary numbers of piriform attachments (>22,000/web) with extreme precision and speed (>4/s) while building its sheet ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0107"
    }
  }, [_vm._v("fig. 1.7")]), _vm._v(", appendix O6.3.5.1) (these spigots took only approximately 0.03 s to produce each attachment). The surface that bears the piriform spigots is approximately planar (as in many other species), probably to facilitate simultaneous contact of many spigots with a surface to which an attachment is being made. There were two size classes of piriform spigots in this species (Peters 1993a), and lines with various diameters were included in each attachment ("), _c('i', [_vm._v("b–d")]), _vm._v("). The smaller spigots are particularly numerous in this species compared with other “typical” araneoid orb weavers such as "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" and "), _c('i', [_vm._v("Argiope bruennichi")]), _vm._v(". There is also an unusually large U-shaped bald patch near the major ampullate spigot; the outer margin of this patch is lined with small piriform spigots. Judging by the piriform lines in "), _c('i', [_vm._v("b")]), _vm._v(", initiation of an attachment (right side in "), _c('i', [_vm._v("b")]), _vm._v(") was more precise than termination (the left side of the attachment in "), _c('i', [_vm._v("b")]), _vm._v(" has a short tail of apparently wasted piriform lines). At greater magnification ("), _c('i', [_vm._v("d")]), _vm._v("), the piriform lines seem to have been covered by a thin layer of liquid. The relationship (if any) between the especially numerous small piriform spigots (which were not specialized for producing glue rather than lines, because some had fibers emerging from them), the large bald patch, and the extraordinarily precise and rapid initiation and termination of piriform silk deposition is not clear (photos and data are from Peters 1993a).")])])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.02.12"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.12"
    }
  }, [_vm._v("2.2.12 Control of rates of silk secretion in glands")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Spiders make substantial adjustments in the rate of silk synthesis. Emptying the accumulated contents of the lumen of the major ampullate gland of "), _c('i', [_vm._v("Araneus")]), _vm._v(" (AR) stimulated transport of silk already present in secretory vesicles in the cytoplasm of cells lining the gland’s lumen (partially refilling the gland in 30 min), and stimulated synthesis of new silk (Witt et al. 1968; Moon and Tillinghast 2004). Vescicle numbers and lumen contents were replenished in several hours: discharge into the lumen was still heavy at 4 hr, and was nearly complete at 8 hr. Both cholinergic stimulation of the glands (as in stimulation from nerves) and depletion via mechanical pulling induced synthesis (Peakall 1964, 1965). The "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "48",
      "id": "p48",
      "role": "doc-pagebreak"
    }
  }), _vm._v("overall rate of production was positively correlated with demand for silk (e.g., web production) (Witt et al. 1968; Reed et al. 1970). As would be expected for an animal that depends on silk to obtain food, the glands persisted in synthesizing silk even in the face of sustained starvation (Witt et al. 1968; Reed et al. 1970). Starved "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" lost up to 50% of their body weight and still continued to produce silk (Witt 1963).")]), _vm._v(" "), _c('p', [_vm._v("The ampullate glands are not normally emptied completely when an orb is built, because spiders could be induced to add extra radii if newly built radii were destroyed during radius construction. "), _c('i', [_vm._v("Neoscona nautica")]), _vm._v(" (AR), "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" (AR), and "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(" (TET) added up to at least a complete extra set of radii before the spider abandoned radius construction and began to build the temporary spiral (Hingston 1920; König 1951; Reed 1969; Eberhard 1988c). Thus an orb weaver normally has a small reserve of ampullate gland silk when she finishes her orb. Maintaining a reserve of dragline silk makes adaptive sense, because the spider needs to be able to continue to produce draglines as she moves around on her finished orb (to attack prey, to flee from danger, etc.).")]), _vm._v(" "), _c('p', [_vm._v("The data on filling and emptying refer only to non-sticky dragline silk. Almost nothing is known regarding the time course and control of filling and emptying the aggregate and flagelliform glands that produce the sticky spiral glue and baseline, other than that the aggregate gland is relatively full at the beginning of orb construction and empty at the end (Witt et al. 1968). This is an important gap, because in at least some species orb designs are more directly affected by the spider’s reserves of sticky spiral silk ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.02.02"
    }
  }, [_vm._v("section 7.3.2.2")]), _vm._v(").")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.02.13"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.02.13"
    }
  }, [_vm._v("2.2.13 Forming bridge lines")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Bridge lines are floated on the breeze to establish connections to distant objects. Bridge line construction occurs during exploration and the early stages of web construction, and also when web spiders move long distances. The strength with which the distal portion of a bridge line adheres to objects in the spider’s environment varies, and some fail; thus the bridge lines produced by "), _c('i', [_vm._v("Micrathena duodecimspinosa")]), _vm._v(" (AR) that contacted large leaves in nature often failed to adhere strongly enough to support the weight of the spider when she walked toward the leaf (WE). The frequency with which bridge lines of "), _c('i', [_vm._v("Larinioides sclopetarius")]), _vm._v(" in captivity adhered strongly enough to support the spider’s weight varied with the presumed amount of surface area contacted; 17 of 28 contacts with a sheet of cardboard sustained the spider’s weight when the sheet was parallel with the air current, but only 3 of 38 when it was perpendicular (Wolff et al. 2014). Adhesion involved both mechanical tangling of the fibers with surface irregularities in the substrate, and adhesive properties of the fibers themselves, and the surface properties of the substrate itself affected adhesion: successful bridges were established to cardboard and glass, but not to aluminum foil, or plexiglass (Wolff et al. 2014).")]), _vm._v(" "), _c('p', [_vm._v("The bridge lines of subadult female "), _c('i', [_vm._v("L. sclopetarius")]), _vm._v(" (AR) were composed of multiple fine aciniform fibers (50–80 nm in diameter) from spigots on the median posterior spinnerets, combined with a pair of minor ampullate fibers (Wolff et al. 2014). The minor ampullate fibers were present in greater numbers in the distal portion of the line (at least 15 are visible in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#fig0906"
    }
  }, [_vm._v("fig. 9.6")]), _vm._v(" of Wolff et al. 2014). Some of the aciniform fibers splayed apart in the wind, in some cases forming loops. They thus presumably increased both the chances of contacting an object, and increased the surface area of the line that contacted the object and its irregularities.")])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "sec02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.03"
    }
  }, [_vm._v("2.3 Spinnerets as high-precision instruments")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The spinnerets of most spiders are stubby, relatively simple cylindrical structures, and have not inspired studies of their behavioral finesse. Nevertheless, they are probably capable of subtle movements, as indicated by their extensive musculature ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0201"
    }
  }, [_vm._v("fig. 2.1")]), _vm._v("). Even the web-less ctenid "), _c('i', [_vm._v("Cupiennius salei")]), _vm._v(" has special mecanoreceptors that probably provide information on the forces pulling on the dragline and its orientation in space (Gorb and Barth 1996). Additional, more “internal” behavior that facilitates the very precise timing in both initiating and terminating lines also occurs in some groups. For instance, the effective and efficient use of piriform attachment discs requires that the piriform lines and glue be initiated and terminated very abruptly and precisely. Similarly, effective use of aciniform lines to wrap prey during attacks requires rapid and simultaneous initiation "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "49",
      "id": "p49",
      "role": "doc-pagebreak"
    }
  }), _vm._v("of many lines, and also spreading these lines apart in a swath to increase contact with the prey. Because spiders cannot “shoot” their lines, initiation of lines from particular glands presumably involves exuding liquid silk at the tips of their spigots, touching these tips against particular substrates (other lines or objects), and then pulling away (see below). Because the spigots themselves are apparently not mobile, these processes call for finely controlled spinneret mobility, and strategic placements of the spigots on the surfaces of the spinnerets.")]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.03.01"
    }
  }, [_vm._v("2.3.1 Ancestral morphology and behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The ancestral morphology and behavior of the spinnerets are relatively clear in some respects. As noted above, the Devonian fossil "), _c('i', [_vm._v("Attercopus fimbriunguis")]), _vm._v(" apparently had at least some relatively long spinnerets (Vollrath and Selden 2007). Present-day mygalomorphs serve to suggest several details. Each spigot on the spinnerets of a theraphosid consisted of a hollow proximal bulb and a distal shaft from which a silk line was emitted ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0201"
    }
  }, [_vm._v("fig. 2.1")]), _vm._v("), and there were probably spigots on several segments rather than only on the terminal segment, as in araneomorphs (Foelix et al. 2013b). Modern spigots are modified setae or at least derived from similar precursors, but they lack the multiple innervations that are typical of setae, so ancient spigots probably did not serve as tactile organs. The long ancestral spinnerets were probably also quite mobile, and while attaching lines to the substrate the spider probably made crouching movements with her body, dabbing movements with her abdomen, and waving or tapping movements with her posterior lateral spinnerets, as occur, for instance, during web construction by the diplurid "), _c('i', [_vm._v("Linothele macrothelifera")]), _vm._v(" (Eberhard and Hazzi 2013), tube construction by the atypid "), _c('i', [_vm._v("Sphodros rufipes")]), _vm._v(" (WE), and prey wrapping by the theraphosid "), _c('i', [_vm._v("Psalmopoeus reduncus")]), _vm._v(" (Barrantes and Eberhard 2007). Dabbing and side-to-side movements of the abdomen to produce and attach draglines are presumably ancient, and occur in various families, including Salticidae, Anyphaenidae, and Pisauridae, and Sparassidae (Li et al. 2002; Eberhard 2007a; Wolff et al. 2017a).")]), _vm._v(" "), _c('p', [_vm._v("These probable ancestral movements are conserved in egg sac construction. The abdomen swings and bobs while a swath of lines is produced without any legs being involved, even in groups such as araneoids and uloborids in which the spiders grasp lines and bring them to the spinnerets with their legs in other contexts. Typically the spider dabbed her abdomen repeatedly against the egg sac, touching her spinnerets to the sac with each dip, then pulling out additional silk as she pulled her abdomen away. Dabbing behavior occurred in "), _c('i', [_vm._v("Miagrammopes")]), _vm._v(" (UL) (Akerman 1932), "), _c('i', [_vm._v("Hyptiotes paradoxus")]), _vm._v(" (UL) (Marples and Marples 1937), "), _c('i', [_vm._v("Zosis geniculata")]), _vm._v(" and "), _c('i', [_vm._v("Uloborus")]), _vm._v(" sp. (UL) (WE), and the araneids "), _c('i', [_vm._v("Cyrtophora citricola")]), _vm._v(" (Kullmann 1958), "), _c('i', [_vm._v("Mastophora dizzydeani")]), _vm._v(" (Eberhard 1980a), "), _c('i', [_vm._v("Pozonia nigroventris")]), _vm._v(", "), _c('i', [_vm._v("Micrathena")]), _vm._v(" sp. (Moya et al. 2010), and "), _c('i', [_vm._v("Argiope argentata")]), _vm._v(" (WE), the austrochilid "), _c('i', [_vm._v("Hickmania troglodytes")]), _vm._v(" (Doran et al. 2001), and the diguetid "), _c('i', [_vm._v("Diguetia albolineata")]), _vm._v(" (WE) (in the diguetid, dabbing movements of the abdomen also occurred during construction of the long tubular retreat). In "), _c('i', [_vm._v("A. argentata")]), _vm._v(" (AR), "), _c('i', [_vm._v("Metazygia wittfeldae")]), _vm._v(" (AR), and "), _c('i', [_vm._v("Latrodectus geometricus")]), _vm._v(" (THD) the spider used her legs IV to pull out silk lines and push them onto the sac (WE, G. Barrantes pers. comm.), but did not grasp the egg sac lines to which she was attaching these new lines. The newly emerged lines were at least briefly sticky, and adhered to the substrate and to other lines without any piriform attachment discs.")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.03.02"
    }
  }, [_vm._v("2.3.2 Strategic placements of spigots on the spinnerets of araneomorphs")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Spinneret morphology provides many useful higher-level taxonomic characters in spiders, and the distributions and forms of the spigots of different silk glands are known for many species (summaries in Coddington 1987; Platnick et al. 1991; Agnarsson 2004; Griswold et al. 2005). Surprisingly, however, there has been little discussion of the possible functional significance of the locations of spigots on spinnerets, despite the fact that the sites of different types of spigots relative to each other are likely to influence the abilities of spiders to initiate and coordinate the production of different types of lines.")]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec02.03.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.03.02.01"
    }
  }, [_vm._v("2.3.2.1 General considerations")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Apparently the only general discussion of the possible functional significance of spigot placement is relatively recent (Eberhard 2010a). The basic argument is that the anterior-posterior order of the spinnerets on the spider’s body and of the sites of the spigots on the spinnerets is "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "50",
      "id": "p50",
      "role": "doc-pagebreak"
    }
  }), _vm._v("likely to have important consequences for how the spider will be able to initiate and attach different types of lines to each other and to the substrate. The logic is based on the fact that silk lines can only be produced by pulling them from the spider’s body (the spider cannot “shoot” them) (Witt et al. 1968; Foelix 2011). Thus new lines must be initiated by pressing the tips of spigots against some other object and then pulling them away. Two different basic mechanisms have been proposed for line initiation. The best known, “direct contact initiation,” occurs when the spider presses her spinnerets against an object (e.g., a branch, or a silk line) and then pulls away (e.g., Kullmann 1975). If the spinnerets are held in appropriate positions, and if the spigots are at appropriate sites on the spinnerets to bring their tips into contact with an object or another silk line, then liquid silk at the tips of the spigots will adhere to the object and the spider can initiate a new line when she pulls her spinnerets (or the silk line) away. Similarly, lines could be initiated by direct contact between spigots on different spinnerets, or of spigots with lines being drawn from other spigots (see below).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0212"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "512",
      "src": "images/chi-eberhard-fig0212.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p50"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.12.")]), _vm._v(" The spigots of different silk glands are located at strategic sites in this generalized diagram of the three pairs of spinnerets of an araneoid spider; posterior, or “downstream,” is down (a few of the multiple piriform and aciniform spigots are indicated by arrows). The spigots for the aciniform fibers, whose initiation often depends on their making contact with other lines, are downstream from other spigots such as those of the piriform and major ampullate glands whose fibers are often initiated without contact with other lines (Eberhard 2010a) (after Coddington 1989).")])]), _vm._v(" "), _c('p', [_vm._v("One example of this “dragline initiation” technique occurs when "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" and "), _c('i', [_vm._v("Argiope argentata")]), _vm._v(" wrap their prey (Eberhard 1987c). When a large female "), _c('i', [_vm._v("N. clavipes")]), _vm._v(" begins to wrap a prey, the lines in the swath of wrapping lines from the aciniform spigots begin where they are attached to her dragline. Initiation of these wrapping lines presumably occurred when the spider applied the wet tips of the acinoform spigots to the dragline she was producing as she moved toward the prey. Dragline initiation is also presumably used in many species (Eberhard 1987c) to produce airborne lines; the glandular origins of the airborne lines are generally not known for certain; Hingston (1922a) believed they emerged from the posterior lateral spinnerets in "), _c('i', [_vm._v("Nephila pilipes")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Dragline initiation is feasible only if the tips of the spigots of the lines to be initiated can touch the dragline after it has emerged from the major ampullate spigots on the anterior lateral spinnerets. The possibility of such contact will depend on the movements and positions of the spinnerets, and the sites of the spigots on the spinnerets. So long as the spider moves forward rather than backward while spinning draglines (which is generally the case, except during sticky spiral construction in araneoids; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.03.02"
    }
  }, [_vm._v("section 2.3.2")]), _vm._v("), the general rule would be that spigots that are located farther posterior (“downstream”) on the spider’s body ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0212"
    }
  }, [_vm._v("fig. 2.12")]), _vm._v(") can initiate lines by touching their tips to lines that are produced by more anterior (“upstream”) spigots, but not vice versa (except in unusual cases in which the spinnerets themselves are long and are flexed forward).")]), _vm._v(" "), _c('p', [_vm._v("A second possible mechanism for initiating lines, “clapping initiation,” involves touching spinnerets together and then spreading them apart (Blackwall cited in McCook 1889; Nielsen 1932; Eberhard 1987c). For example, the spider could clap or rub a pair of spinnerets together and then spread them laterally. The spider could then elongate the short lines between the spinnerets by pulling out additional silk with her legs or by using friction with the air. There are reports that spinnerets are spread widely during the initiation of some airborne lines (Blackwall in McCook 1889; Eberhard 1987c), but I know of no confirmed demonstration of clapping initiation. The giant nephilid "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" rubbed her spinnerets briefly together when she made each attachment of the sticky spiral, presumably initiating piriform lines (WE). Hesselberg and Vollrath 2012 speculated that "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "51",
      "id": "p51",
      "role": "doc-pagebreak"
    }
  }), _vm._v("the rubbing movements of the spinnerets that they observed during temporary spiral construction by "), _c('i', [_vm._v("N. edulis")]), _vm._v(" served to twist lines around each other, but this does not seem topologically possible; the rubbing motions more likely also functioned to initiate and apply piriform silk lines.")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "tab0202"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th",
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticClass: "thn"
  }, [_vm._v("Table 2.2.")]), _vm._v(" Morphological details of spinnerets that may have possible functional consequences (Eberhard 2010a) (see the text for more complete explanations): the sites of spigots of different glands on different spinnerets in different groups of spiders (data for araneoids from Coddington 1987, for araneomorphs from Griswold et al. 2005) (ALS = anterior lateral spinneret; PLS = posterior lateral spinneret; “—” = gland not present).")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Detail")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Araneoids")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Other araneomorphs")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Possible consequences")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Aciniform spigots downstream of ampullate spigots")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Initiate aciniform lines on the dragline")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Piriform spigots limited to the tip of the ALS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Spinneret movement determines site of attachment disc")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Tip of ALS where piriform spigots occur is flat or nearly so")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Many spigots contact surface")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Piriform spigots upstream of flagelliform and aggregate spigots")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Lateral orientation of sticky line with respect to abdomen needed to make attachments to radii")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Flagelliform spigots downstream in theridiids with respect to ampullate spigots")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Initiate sticky wrapping silk on dragline (if this occurs—see text)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Aciniform downstream from ampullate or flagelliform")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Initiate aciniform lines on sticky silk lines during wrapping in theridiids (Barrantes and Eberhard 2007)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Spigots for cribellum silk are upstream of other lines")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Fibrils are initiated with legs IV rather than on other lines, so do not need to be downstream of others")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Aciniform in pholcids downstream from sticky (possibly piriform?) spigots")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Initiate “dry” wrapping on sticky wrapping lines")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Cylindrical gland spigots downstream of piriform spigots")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Attachments nevertheless possible (though possibly not as strong) because cylindrical lines are adhesive so few piriform discs needed")])])])])]), _vm._v(" "), _c('p', [_vm._v("A second type of deduction derived from “upstream-downstream” locations concerns how lines are fastened to other lines or to the substrate. Generally speaking, the spigots that produce the fastening silk need to be downstream to or at most level with the spigots that produce the lines that are being fastened.")]), _vm._v(" "), _c('p', [_vm._v("These types of argument show that the locations of the spigots of several glands in spiders can be explained in terms of their functions (Eberhard 2010a) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#tab0202"
    }
  }, [_vm._v("table 2.2")]), _vm._v("). For instance, the location of the piriform spigots on the flattened, distal-medial surface on the anterior lateral spinnerets is appropriate for producing attachment discs to fasten the spider’s dragline both to more or less planar objects and to other silk lines.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec02.03.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.03.02.02"
    }
  }, [_vm._v("2.3.2.2 Special cases involving web designs")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Perhaps the most striking example of a functional relation between spinneret morphology and web design comes from the ochyroceratid "), _c('i', [_vm._v("Ochyrocera cachote")]), _vm._v(", which builds small domed aerial sheet webs with sectors in which large numbers of lines are nearly perfectly parallel ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0213"
    }
  }, [_vm._v("fig. 2.13")]), _vm._v("; Hormiga et al. 2007). Each posterior lateral spinneret of "), _c('i', [_vm._v("O. cachote")]), _vm._v(" has an unusual row of tightly spaced aciniform spigots (similar rows of spigots also occur in "), _c('i', [_vm._v("O")]), _vm._v(". sp. and Telemidae and Leptonetidae [Platnick et al. 1991]; "), _c('i', [_vm._v("Leptoneta nippora")]), _vm._v(" builds a thin, more or less horizontal sheet web [Shinkai and Takano 1984], but the pattern of lines has not been observed). The similarity between the number of spigots and the numbers of parallel lines in the swaths in "), _c('i', [_vm._v("O. cachote")]), _vm._v(" "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "52",
      "id": "p52",
      "role": "doc-pagebreak"
    }
  }), _vm._v("(about 20), and the highly parallel orientations of these lines, leave little doubt that each swath was produced during a single pass of spider’s spinnerets ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0213"
    }
  }, [_vm._v("fig. 2.13")]), _vm._v("), though it appears that the lines in webs are farther apart than are the spigots on the spinnerets (M. Ramírez pers. comm.). It may be that the highly folded membranous areas where the spigots occur are inflated and cause the spigots to fan apart during web construction; such spreading occurred in wrapping attacks on prey in the piriform spigots on the anterior lateral spinnerets of several gnaphosid species attacking prey by wrapping (Lissner et al. 2016; Wolff et al. 2017b), and in the aciniform spigots on the posterior lateral spinnerets of "), _c('i', [_vm._v("Oecobius annulipes")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0214"
    }
  }, [_vm._v("fig. 2.14")]), _vm._v(").")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0213"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "451",
      "src": "images/chi-eberhard-fig0213.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p52"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.13.")]), _vm._v(" The unusual morphology of the posterior lateral spinnerets of the ochyroceratid "), _c('i', [_vm._v("Ochyrocera cachote")]), _vm._v(" (lateral view in "), _c('i', [_vm._v("a")]), _vm._v(", postero-lateral view in "), _c('i', [_vm._v("b")]), _vm._v("), each of which had a tightly packed row of small aciniform spigots mounted on an accordion-like folded membrane, is probably linked to the unusual arrays of nearly parallel lines in the sheets of its web (arrows in "), _c('i', [_vm._v("c")]), _vm._v("). Web construction has never been observed directly, but the correspondence between the number of parallel lines in a swath and the approximate number of these spigots suggests that each swath of parallel lines is produced with a single pass of the spider’s abdomen. Recent observations of an unidentified Colombian ochyroceratid showed that the distances between parallel lines in swaths were substantially greater than the distances between spigots (M. Ramírez pers. comm.); perhaps the highly folded tissue associated with the spigots ("), _c('i', [_vm._v("b")]), _vm._v(") is inflated, spreading them apart as the spider is producing the lines (from Hormiga et al. 2007).")])]), _vm._v(" "), _c('p', [_vm._v("A second clearly functional morphological detail involves the position of the tips of the two aggregate gland spigots immediately adjacent to the tip of the flagelliform gland spigot in orb-weaving araneoids; the aggregate spigots pour their liquid contents directly onto the sticky spiral flagelliform line as it emerges (Coddington 1989). The less consistent positions of this triad of spigots in “derived orbweavers” such as theridiids (i.e., aranoids "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "53",
      "id": "p53",
      "role": "doc-pagebreak"
    }
  }), _vm._v("that no longer build orbs) (I. Agnarsson pers. comm.), suggest that perhaps this association is less important (perhaps sticky aggregate silk is applied to ampullate rather than to flagelliform lines?).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0214"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "336",
      "src": "images/chi-eberhard-fig0214.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p53"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.14.")]), _vm._v(" The oecobiid "), _c('i', [_vm._v("Oecobius annulipes")]), _vm._v(" uses specialized morphology and behavior to spread aciniform fibers into a wide swath of wrapping silk. Each elongate posterior lateral spinnet has a row of spigots; the long setae on the nearby anal tubercle hold the fibers apart while the spider runs rapidly over and around the prey (after Glatz 1967).")])]), _vm._v(" "), _c('p', [_vm._v("One other unstudied consequence of possible general importance occurs in the funnel webs of agelenids and lycosids, in which swaths of lines from the posterior spinnerets (especially the posterior lateral spinnerets) form a dense sheet (Rojas 2011; González et al. 2015; Eberhard and Hazzi 2017). These lines have been said to be “brushed” onto other lines in the sheet without piriform attachments (Blackledge et al. 2009c). This lack of strong piriform attachments is seemingly an inevitable “upstream-downstream” consequence of the location of the piriform spigots on the anterior spinnerets. Similar “brushing” attachments occur in the diplurid "), _c('i', [_vm._v("Linothele macrothelifera")]), _vm._v(" (Eberhard and Hazzi 2013). In fact, however, the situation is more complex (at least in the sheet web lycosid "), _c('i', [_vm._v("Aglaoctenus castaneus")]), _vm._v("), because the abdomen is inclined laterally when attachments are made and the lines from the posterior spinnerets on the lower side are apparently sometimes attached with what appear (under the microscope) to be piriform attachments (Eberhard and Hazzi 2017).")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec02.03.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.03.02.03"
    }
  }, [_vm._v("2.3.2.3 Additional complications")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The upstream-downstream logic just applied to questions regarding attachments to other lines (Eberhard 2010a) depends on whether the dragline or the sticky spiral line that is being attached runs more or less parallel to the spider’s own longitudinal axis. There are two clear exceptions. One is when the sticky spiral is being attached to a radius during araneoid sticky spiral construction (see, for different families, figs. O6.2–O6.4). The longitudinal axis of the spider’s abdomen is more or less parallel to the radius, and nearly perpendicular to the sticky line. The sticky spiral baseline from the flagelliform gland spigot on the posterior median spinneret passes close enough to the anterior lateral spinneret that the piriform spigots contact the baseline when they make their quick anterior-posterior rubbing movements at the moment of attachment (see description above of "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("A similar exception occurs during hub spiral and temporary spiral construction when the long axis of the abdomen is more or less aligned with the radius but is more nearly perpendicular to the spiral line. This could bring the minor ampullate line emerging from the median posterior spinneret of "), _c('i', [_vm._v("Cyrtophora citricola")]), _vm._v(" (AR) (Peters 1993a) close to the field of piriform spigots on the anterior lateral spinneret.")]), _vm._v(" "), _c('p', [_vm._v("The sensory structures at the cephalothorax-abdomen articulation constitute a further possibly important morphological trait that gives the spider information on the position of her abdomen. As noted by Agnarsson et al. (2008), aerial web spiders probably flex their abdomens at this articulation more, and more precisely, than other spiders. Lifestyle correlations with specialized setae at this articulation appear to be weak, however (Agnarsson et al. 2008).")])])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.03.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.03.03"
    }
  }, [_vm._v("2.3.3 Phylogenetic inertia?")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("An alternative, “historical constraint” hypothesis for spigot placements needs to be considered. Perhaps the spigots originated by chance at their present locations, and then remained there because no alternative forms arose. The major ampullate spigots apparently evolved only once (Griswold et al. 2005), and the only small variations in major ampullate spigot placement across spiders indicates that their placements in different species represent (at least in some senses) only a single evolutionary event. This skepticism regarding functional interpretations does not explain why, by chance, the present favorable locations originated; clearly the spigots "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "54",
      "id": "p54",
      "role": "doc-pagebreak"
    }
  }), _vm._v("are not randomly scattered over the spinnerets. Nor can it explain why their locations did not subsequently change more substantially. Clearly, the constraint imposed by phylogeny is not severe, as the numbers and locations on a given spinneret do vary to some extent.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0215"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "503",
      "src": "images/chi-eberhard-fig0215.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p54"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.15.")]), _vm._v(" The number of spigots on the spinnerets of the pholcid "), _c('i', [_vm._v("Leptopholcus guineensis")]), _vm._v(" has been reduced to only 8 (dotted arrows) (ALS = anterior lateral spinneret; PMS = posterior median spinneret; PLS = posterior lateral spinneret). Reductions in spigot numbers have evolved repeatedly in this family; their selective significance is unknown (from Huber and Kwapong 2013, courtesy of Bernhard Huber).")])]), _vm._v(" "), _c('p', [_vm._v("In one group, the Pholcidae, there has been some evolutionary flexibility in spigot numbers (though not their locations). The numbers of spigots have been reduced repeatedly from 18–20 to only 8, as in "), _c('i', [_vm._v("Leptopholcus guineensis")]), _vm._v(" (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0215"
    }
  }, [_vm._v("fig. 2.15")]), _vm._v("). The same 12 spigots on the anterior lateral spinnerets have always been lost. The reason for this consistency is not clear; the webs of species with fewer spigots looked much the same, at least superficially (B. Huber pers. comm.).")]), _vm._v(" "), _c('p', [_vm._v("Further tests of the historical constraint versus the functional design hypothesis could be performed with additional studies of spinneret behavior. For instance, there should be a correlation between how the anterior lateral spinnerets are moved when attachments are made and the site and slant of the planar field on this spinneret where the piriform spigots are located. There are also some spigot placements in cribellate spiders that are not yet intelligible (Eberhard 2010a), also offering scope for future research.")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.03.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.03.04"
    }
  }, [_vm._v("2.3.4 Behavior of the spinnerets")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Recent studies have begun to describe heretofore neglected spinneret behavior. I will describe a few preliminary glimpses. High-speed video recordings of the giant females of "), _c('i', [_vm._v("Nephila plumipes")]), _vm._v(" (NE) making attachment discs to attach the dragline to a glass slide revealed a complex two-step process (Wolff and Herberstein 2017). First the distal tips of the anterior lateral spinnerets (where the piriform spigots are located) were rubbed repeatedly against each other, rolling the dragline over the spigot fields and wrapping it in piriform silk. The second step (often immediately following the first, but sometimes after a minute or more), began when these spinnerets were spread, pulling piriform strands from the spigots, and pressing them to the glass to form the attachment disc. The spinnerets swept simultaneously both anteriorly and posteriorly (in opposite directions); each movement produced an approximately 3 mm long track. In between sweeps, the spinnerets rubbed along each other in a tilted position, presumably strengthening the bridge between the dragline and the disc. The spider made several sets of sweeps while moving her abdomen slightly anteriorly, and a few more while moving posteriorly, producing an approximately circular disc. Tracing the lengths of the paths of the spinnerets and counting the piriform spigots, Wolff and Herberstein (2017) calculated "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "55",
      "id": "p55",
      "role": "doc-pagebreak"
    }
  }), _vm._v("that the spider laid a total of 3.5–8 m of nanofibers in each attachment disc (!).")]), _vm._v(" "), _c('p', [_vm._v("Video recordings of sticky spiral construction by female "), _c('i', [_vm._v("N. clavipes")]), _vm._v(" (WE) gave a more fragmentary glimpse of spinneret behavior during orb construction. At the moment when the sticky spiral line was attached to a radius, the spider’s abdomen was aligned very precisely, so that the radius was in the cleft between the right and left spinnerets and its long axis was approximately parallel to the radius (last drawing in fig. O6.4). The tips of the two anterior lateral spinnerets rubbed against each other briefly about twice with a brief anterior-posterior motion that lasted about 0.07 s. During this brief period, the piriform spigots initiated and then terminated production of the lines and glue that fastened the sticky spiral to the radius. Similar rubbing movements with the anterior lateral spinnerets occurred in one bout of prey wrapping, just as wrapping began; later, during wrapping, the anterior and posterior lateral spinnerets clapped together.")]), _vm._v(" "), _c('p', [_vm._v("Video recordings of construction behavior by the funnel web wolf spider "), _c('i', [_vm._v("Aglaoctenus castaneus")]), _vm._v(" (Eberhard and Hazzi 2017) revealed a previously unappreciated variety of spinneret movements (visible in this species because of its large body and spinnerets and its unhurried movements). The posterior lateral spinnerets were frequently spread wide laterally while the spider walked, with each emitting a swath of fine lines. Sometimes the anterior lateral spinnerets clapped or rubbed against each other before making an attachment; the posterior lateral spinnerets also sometimes clapped together before or after attachments. One posterior lateral spinneret was consistently lifted while the other was extended posteriorly when the spider attached lines to other silk lines ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#fig0517"
    }
  }, [_vm._v("fig. 5.17")]), _vm._v("). Spiders also produced long aerial bridge lines that were carried on the weak wind while the spider walked along under another line early in construction, but the spinneret movements involved in initiating these lines (claps?) were not observed. Similar asymmetric raising of only one posterior lateral spinneret while making an attachment also occurred during sheet construction by the diplurid "), _c('i', [_vm._v("Linothele macrothelifera")]), _vm._v(" (Eberhard and Hazzi 2013), and was common during prey wrapping in various mygalomorph and araneomorph families ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0205"
    }
  }, [_vm._v("fig. 2.5")]), _vm._v(", Barrantes and Eberhard 2007; Hazzi 2014). Clearly there is a great deal yet to be learned about spinneret behavior in sheet building spiders.")]), _vm._v(" "), _c('p', [_vm._v("Small rhythmic medial movements of the posterior lateral spinnerets during sticky spiral construction probably had a different function in the uloborids "), _c('i', [_vm._v("Uloborus walckenaerius")]), _vm._v(" (Peters 1984) and "), _c('i', [_vm._v("Zosis geniculata")]), _vm._v(" (WE). The spinnerets moved medially following each brushing movement of leg IV that pulled fibers of cribellum silk from the cribellum; the movements may function in molding the mat of cribellum fibers around the sticky spiral baseline ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0207"
    }
  }, [_vm._v("fig. 2.7")]), _vm._v(", Peters 1984).")]), _vm._v(" "), _c('p', [_vm._v("One recent discovery, with no known parallel in other groups, is that the elongate anterior lateral spinnerets of the sicariid "), _c('i', [_vm._v("Loxosceles laeta")]), _vm._v(" made rhythmical and very rapid movements (8.5–13/s) while spinning the very thin, ribbon-like, and highly adhesive major ampullate lines ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.08.04"
    }
  }, [_vm._v("section 2.2.8.4")]), _vm._v("). Highly modified toothed setae ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0209"
    }
  }, [_vm._v("fig. 2.9")]), _vm._v(") on the posterior sides of the posterior lateral spinnerets may hold the ribbon lines while the anterior spinnerets are moving forward, pulling lines from the major ampullate spigots, and then the posterior median spinnerets (which are also moved rapidly after each anterior lateral movement) may free the lines from the setae for the next pull (Margalhaes in press).")]), _vm._v(" "), _c('p', [_vm._v("These accounts omit at least one further behavior that occurs within the spider’s abdomen—the opening and closing of a valve in the duct of the major ampullate gland (Wilson 1962) (I am not aware of valves having been found in the ducts of any other araneomorph silk glands, or in any mygalomorph ducts). Closing this major ampullate gland valve (or perhaps some other structure in the gland duct?) increases the force necessary to draw silk (Work 1978). In a female "), _c('i', [_vm._v("A. diadematus")]), _vm._v(" (AR) a pull of only about 5 mg was usually needed to pull dragline silk from her body; but the spider could hang motionless at the end of her dragline even when her legs were not touching it, thus supporting her own weight (about 60 mg) (Work 1978). The force of this “holding brake” is sometimes even substantially greater (Work 1978). Work (1978) hypothesized that braking resulted when the spinnerets were closed medially on each other, and other (piriform) spigots and perhaps setae on the anterior lateral spinnerets produced friction with the line, much like the friction produced by the interdigitating “tension gates” used in textile machines that produce artificial lines, but he did not specify specific structures. Another indication of an internal brake is that even when the strain energy capacity of the dragline is insufficient to "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "56",
      "id": "p56",
      "role": "doc-pagebreak"
    }
  }), _vm._v("absorb the potential energy lost by a spider as she falls, failure of the dragline is avoided by dissipating energy by friction in the duct as dragline silk is drawn (Brandwood 1985). In some species the spider also manipulates the dragline with leg IV as she falls, allowing the line to slip through her tarsal claw (Eberhard 1986a).")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.03.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.03.05"
    }
  }, [_vm._v("2.3.5 How are lines terminated?")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Very little is known concerning the mechanisms that spiders use to terminate lines, and most concerns only major ampullate lines. When a dragline is being forcibly pulled from an immobilized spider, the anterior lateral spinnerets sometimes move medially from a more spread position, and break the line by rubbing quickly forward and rearward against each other (Work 1978). The tension gate mechanism proposed by Work (1978) could theoretically be responsible. Similar morphological arrangements that would allow termination by rubbing against other homologous spigots do not occur, however, for piriform or aciniform spigots.")]), _vm._v(" "), _c('p', [_vm._v("Breakage apparently occurs in some other contexts when there is a lack of liquid silk in the duct to the spigot, or the duct itself closes valve-like; the line breaks there while it is being pulled (Work 1978). Presumably subsequent initiation of another line occurs when liquid silk is pushed out the duct (past the broken end?) to the tip of the spigot.")]), _vm._v(" "), _c('p', [_vm._v("Several types of silk are mostly produced during long uninterrupted periods, and rapid, precise termination may not be especially important, but piriform lines are exceptions. Piriform lines terminate and then rapidly reinitiate production hundreds or thousands of times during the construction of a single orb, with truly amazing, split-second coordination. In building the orb illustrated in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0104"
    }
  }, [_vm._v("fig. 1.4")]), _vm._v(", for example, the female "), _c('i', [_vm._v("Micrathena duodecimspinosa")]), _vm._v(" made 832 attachments of her hub and temporary spiral to radii in the space of only 428 s (a new attachment every 0.52 s) (WE). For each attachment, the radius was contacted by the spinnerets for only about 0.07–0.09 s, so the piriform silk must have been initiated and then terminated in even less time. In addition, the sticky spiral was attached to the radii on the order of 3000 additional times, and each of these attachments also lasted only approximately 0.07 s. Some other species have even more spectacular numbers: "), _c('i', [_vm._v("Cyrtophora citricola")]), _vm._v(" (AR) makes about four piriform attachments/s, and a total of >22,000 in a single web (Kullmann 1958; Peters 1993a; WE).")]), _vm._v(" "), _c('p', [_vm._v("How terminations and initiations are accomplished so rapidly and precisely in the short ducts and spigots of the numerous small piriform glands is unclear. Microscopic examination of the piriform silk at major and minor ampullate line attachments in "), _c('i', [_vm._v("C. citricola")]), _vm._v(" (AR) webs ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0211"
    }
  }, [_vm._v("fig. 2.11")]), _vm._v(") indicated that initiation was typically more abrupt than termination (Kullmann 1975), as termination involved the production of a short “trail” of fine lines as the spider moved away from the attachment ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0210"
    }
  }, [_vm._v("fig. 2.10a")]), _vm._v("; Peters 1993a). These trails of lines (which also occurred in radius-frame attachments in other araneids—WE) appeared to have less glue on them ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0210"
    }
  }, [_vm._v("fig. 2.10a")]), _vm._v("), and appeared to represent wasted silk. It is possible that selection for ease of termination may also affect spigot placement. For instance, when female "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" finished wrapping a prey, they often seemed to “scrub” the spinnerets together and to scrape their surfaces with tarsus IV (WE). If such scrubbing is needed to terminate wrapping lines, positioning the spigots so they can be scrubbed could facilitate termination. The apparent need for this cleaning behavior in "), _c('i', [_vm._v("N. clavipes")]), _vm._v(" makes the precise, rapid terminations of piriform silk during orb construction seem even more extraordinary.")])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "sec02.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.04"
    }
  }, [_vm._v("2.4 Leg morphology and behavior: grasping lines precisely and securely")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bhaft",
    attrs: {
      "id": "sec02.04.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.04.01"
    }
  }, [_vm._v("2.4.1 Grasping lines in a web; tarsal morphology and leg movements")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("As long as spiders built webs very near to the substrate (e.g., the linings of burrows; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.03.01"
    }
  }, [_vm._v("section 10.3.1")]), _vm._v("), walking on the web probably did not require radical new abilities. For instance, the tarsi of the filistatid "), _c('i', [_vm._v("Kukulcania hibernalis")]), _vm._v(" consistently walked on the substrate rather than on the lines of the web itself, at least in the less dense parts of the web (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#fig0510"
    }
  }, [_vm._v("fig. 5.10")]), _vm._v(") (WE). When spiders began constructing aerial lines above the substrate, however, new morphological structures and behavioral abilities became advantageous. Walking along an aerial line poses several problems: the spider needs to find lines to grasp; she needs to grasp them securely; she needs to release them quickly and cleanly; and she needs to hang under the line rather than walking on top of it.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0216"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "453",
      "src": "images/chi-eberhard-fig0216.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p57"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.16.")]), _vm._v(" Drawings of "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" (AR) ("), _c('i', [_vm._v("a")]), _vm._v(" and "), _c('i', [_vm._v("b")]), _vm._v(") illustrate how the middle claw and the serrated accessory setae just ventral to it represent crucial evolutionary developments in managing silk lines. By flexing the claw ventrally ("), _c('i', [_vm._v("a")]), _vm._v("), the spider seizes a silk line tightly by trapping it against the teeth on the serrated setae. The tarsus I of the araneid "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(", seen in anterior view ("), _c('i', [_vm._v("b")]), _vm._v("), illustrates another subtle but important detail: the accessory setae and the median claw are located asymmetrically, on the antero-lateral sides of tarsi I and II and on the postero-lateral sides of tarsi III and IV. The anteriorly directed median claw and the accessory setae on the anterior side of the tarsi I and II facilitate grasping new lines when legs I and II swing medially ahead of the spider. A SEM image ("), _c('i', [_vm._v("c")]), _vm._v(") of the left tarsus IV of a mature female "), _c('i', [_vm._v("Gasteracantha cancriformis")]), _vm._v(" (AR) illustrates a veritable tool kit: the asymmetrically placed serrate accessory setae; the median claw (directed to the same retrolateral side where the accessary setae are located); a row of stout setae that are presumably used to wrap prey; presumed chemosensory setae; and a forest of toothed setae that aid in minimizing the spider’s adhesion to her own sticky silk ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.06"
    }
  }, [_vm._v("section 2.6")]), _vm._v(") ("), _c('i', [_vm._v("a")]), _vm._v(" from Foelix 2011, "), _c('i', [_vm._v("b")]), _vm._v(" from Nielsen 1932).")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "57",
      "id": "p57",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Modifications of the tarsal claws and the associated serrate accessory setae at the tip of the tarsus have long been known to enable spiders with three tarsal claws to firmly grasp and then release single silk lines. The middle claw moves as a unit with the lateral claws (to which it is fused) when trapping the line against the teeth on one (or perhaps more) of the stiff but nevertheless somewhat flexible serrate setae nearby ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0216"
    }
  }, [_vm._v("fig. 2.16")]), _vm._v(") (Nielsen 1932; Wilson 1962; Foelix 1970, 2011). The three claws are supplied with only two tendons, one that can produce a dorsal movement of the unit and the other that can produce a ventral movement; there are no tendons that could produce lateral movements (Labarque et al. 2017). When the claws are flexed ventrally, the middle claw bends the line sharply against the serrated accessory setae and achieves a firm grip; when the middle claw is lifted slightly, the grip is loosened (Wilson 1962) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0216"
    }
  }, [_vm._v("fig. 2.16a")]), _vm._v("); and when it is lifted completely, the grip on the line is released. At the moment of release, the tension on the line itself as well as the straightening movements of the setae may propel the line away from the claw (Nielsen 1932).")]), _vm._v(" "), _c('p', [_vm._v("A functional association between the middle claw and the serrate accessory setae is supported by their similar asymmetrical positions on the tarsus: on legs I and II the middle claw is directed prolaterally, and most of the setae are on the prolateral side of the tarsus; on legs III and IV, the middle claw is directed retrolaterally, and most of the setae are on the retrolateral side of the tarsus ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0216"
    }
  }, [_vm._v("fig. 2.16a,b")]), _vm._v(", Nielsen 1932). These asymmetrical positions of the median claw and the serrated accessory setae are correlated with the positions in which the spider often holds her legs (Nielsen 1932); legs I and II are often directed anteriorly and legs III and IV are directed posteriorly. The asymmetric positions of the median "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "58",
      "id": "p58",
      "role": "doc-pagebreak"
    }
  }), _vm._v("claws enable the spider to snag lines by executing medially directed searching leg movements ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.04.02"
    }
  }, [_vm._v("section 2.4.2")]), _vm._v("). Experimental evidence of a grasping function for the serrate accessory setae was obtained by removing them from all of the legs of "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v("; the spider experienced difficulties in both web construction and in climbing vertical lines ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0217"
    }
  }, [_vm._v("fig. 2.17")]), _vm._v(") (Foelix 1970). Comparative morphological data from other species also support this interpretation. The amaurobiid "), _c('i', [_vm._v("Amaurobius ferox")]), _vm._v(", which lacks the setal teeth, slipped while attempting to climb vertical lines (Nielsen 1932). In the triangle web uloborid, "), _c('i', [_vm._v("Hyptiotes paradoxus")]), _vm._v(", which holds a line to her web under substantial tension with her legs I for long periods while she waits for prey, both the middle claws and their serrated accessory setae are especially stout and have numerous teeth (Nielsen 1932). The most dramatic modification in "), _c('i', [_vm._v("H. paradoxus")]), _vm._v(" is on legs III, where there are three serrated accessory setae on each side of the median claw (Nielsen 1932), suggesting an important role in silk manipulation. These legs do not hold the tight line, but instead hold the mass of lax line that the spider releases the moment a prey strikes her web, after which these legs grasp the line (it is not clear whether having extra serrated accessory setae could aid in managing this silk). The serrated setae were stronger and more prominent in the juveniles of "), _c('i', [_vm._v("Pachygnatha")]), _vm._v(" spp. that build orbs than in conspecific adults that do not build prey capture webs (Martin 1978). The agelenid "), _c('i', [_vm._v("Eratigena atrica")]), _vm._v(" and the amaurobiid "), _c('i', [_vm._v("Amaurobius ferox")]), _vm._v(" lack serrated accessory setae, but have tufts of smooth setae associated with both the medial claw and the two lateral claws that may be bent when the tarsus contacts silk lines, and that may thus aid in pushing the line clear of the claws when the spider is releasing it (Nielsen 1932). The eresid "), _c('i', [_vm._v("Eresus niger")]), _vm._v(" has a pair of smooth accessory setae associated with the median claw that are presumably bent when it grasps a line.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0217"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "337",
      "src": "images/chi-eberhard-fig0217.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p58"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.17.")]), _vm._v(" Webs that were built by "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" before ("), _c('i', [_vm._v("a")]), _vm._v(") and after ("), _c('i', [_vm._v("b")]), _vm._v(") the serrated accessory tarsal setae were removed suggest that reducing the spider’s ability to grasp lines firmly affects orb construction. Surprisingly, the effects seem to be concentrated on sticky spiral construction, rather than on earlier stages. The regularity of the hub spiral spacing was hardly affected, even though precise grasping of lines and highly coordinated leg movements also occur during hub construction ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.03.04"
    }
  }, [_vm._v("section 6.3.3.4")]), _vm._v(", appendix O6.3.4). The lower numbers of radii and hub loops in "), _c('i', [_vm._v("b")]), _vm._v(" are associated with a lower number of sticky spiral loops, and may have resulted not from problems grasping lines but rather from an earlier decision during construction to lay a smaller length of sticky line (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.03"
    }
  }, [_vm._v("sections 7.3.3")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03.04"
    }
  }, [_vm._v("7.3.4")]), _vm._v("). Further experiments will be needed to document differences quantitatively (from Foelix 1970).")])]), _vm._v(" "), _c('p', [_vm._v("Even spiders lacking these refined grasping structures are able to walk in webs. Small spiderlings in the mygalomorph families Ctenizidae and Atypidae walked under aerial lines to elevated dispersal sites several m from their mother’s burrows (Eberhard 2006; Cox 2015), even though they are normally substrate-bound, burrow-dwellers and lack middle claws (Main 1976; Coyle 1986). Video recordings of other mygalomorph spiderlings, including the atypids "), _c('i', [_vm._v("Atypus affinis")]), _vm._v(" (unpublished video by Janni Louise Cox) and "), _c('i', [_vm._v("Sphodros rufipes")]), _vm._v(" (WE) and a ctenizid (perhaps "), _c('i', [_vm._v("Ummidia")]), _vm._v(" sp.), showed that spiderlings "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "59",
      "id": "p59",
      "role": "doc-pagebreak"
    }
  }), _vm._v("gave no indication of having trouble grasping or releasing lines, though their progress was slow and jerky (WE). Many of the lines that they walked along were made up of multiple fine strands. Other groups such as jumping spiders, whose tarsi are also designed for walking on the substrate and not on silk lines (Hill 2006), can also walk in spider webs and even hunt their owners there (Jackson 1990a,b; Li et al. 1997).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0218"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "450",
      "src": "images/chi-eberhard-fig0218.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p59"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.18.")]), _vm._v(" This array of images illustrates the lack of consistency with which a mature female of the filistatid "), _c('i', [_vm._v("Kukulcania hibernalis")]), _vm._v(" grasped lines with different portions of her tarsal claws while the spider rested in her retreat (each arrow indicates the portion or portions of the claw that exerted force on the line) (in "), _c('i', [_vm._v("b")]), _vm._v(" the claws have snagged some but not all of the fibers in a multistrand cable of lines near an attachment to the substrate). The variety in the orientations of the lines, ranging from more or less perpendicular ("), _c('i', [_vm._v("a")]), _vm._v(", "), _c('i', [_vm._v("c")]), _vm._v(", "), _c('i', [_vm._v("d")]), _vm._v(", "), _c('i', [_vm._v("f")]), _vm._v(") to more nearly parallel ("), _c('i', [_vm._v("i")]), _vm._v(") to the long axis of the tarsus, and in the portions of the claw that snagged the lines, contrasts with the more nearly perpendicular orientations and the contacts with the median claw that were typical of orb weavers ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0216"
    }
  }, [_vm._v("figs. 2.16")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0220"
    }
  }, [_vm._v("2.20")]), _vm._v(").")])]), _vm._v(" "), _c('p', [_vm._v("Preliminary observations of a mature female of the basal haplogyne filistatid, "), _c('i', [_vm._v("K. hibernalis")]), _vm._v(", which lacks serrate accessory setae, revealed that the details of how a mature female in her retreat grasped lines with her tarsal claws were variable and inconsistent ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0218"
    }
  }, [_vm._v("fig. 2.18")]), _vm._v(") (Eberhard 2017). This spider was only resting quietly in a sparse retreat, and was not exerting special force on any lines; it is possible that spiders show more consistently strong, less variable grips on lines in other contexts. Of course, walking slowly along a line like the "), _c('i', [_vm._v("Ummidia")]), _vm._v(" spiderlings, or hanging in a sheltered retreat, is not as difficult as running rapidly across a web to attack a prey.")]), _vm._v(" "), _c('p', [_vm._v("There are many additional details and variations in this basic morphological scheme whose functional significance is unclear. The position of the middle tarsal claw is also strongly asymmetrical in the basal cribellate non-orb weaving web spider "), _c('i', [_vm._v("Thaida")]), _vm._v(", as well as the non-web builder "), _c('i', [_vm._v("Senoculus")]), _vm._v(" (here the middle claws on all four legs are directed prolaterally). In contrast, the middle claws are not oriented asymetrically in the orb weaver "), _c('i', [_vm._v("Uloborus")]), _vm._v(", or in the dictynid "), _c('i', [_vm._v("Dictyna")]), _vm._v(". The possession of a third claw is not always associated with webs, as third claws occur in some non-web spiders such as ground living lycosids (Nielsen 1932; Ramírez 2014). Here they presumably function such as spurs that brace or hook against the substrate as the spider moves.")]), _vm._v(" "), _c('p', [_vm._v("Serrate accessory setae are also an apparently old trait that is widely distributed in araneomorphs. They occur in spiders both with and without webs (for example "), _c('i', [_vm._v("Megadictyna")]), _vm._v("), from austrochilids to orbicularia (Griswold et al. 2005). There is no clear difference in the serrate accessory setae of austrochilids compared with those of other araneomorphs. Perhaps the most puzzling combination of traits occurs in Psechridae, which have 3 claws, but claw tufts rather than accessory setae (Griswold et al. 2005), and walk under lines in their webs (Bristowe 1930; Eberhard 1987a); perhaps here the median claws serve to allow spiders to climb vertical lines. There are also further subtleties in the median claws of other web builders (concave surfaces on the retrolateral sides of the teeth of the median claw (M. J. Ramírez pers. comm.) whose functional significance is not clear.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "60",
      "id": "p60",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Finally, many spiders sometimes allow a line to slide smoothly under the middle claw. Presumably they accomplish this by raising the tarsal claw slightly so that the line remains snagged under the tarsal claw and on the serrated accessory setae, but is not bent sharply. In an orbweaver like "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" (NE), both tarsi III and IV slid along lines during radius construction (WE, sections O6.3.2.2, O6.3.3.2). I do not know the taxonomic distribution of this ability, and suspect that it could harbor interesting taxonomic information ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.03.03"
    }
  }, [_vm._v("section 5.3.3")]), _vm._v("). It appears that sliding one tarsus IV along the dragline as it is produced is widespread among orbicularians (WE), while some mygalomorphs and other basal groups such as filistatids (Eberhard 1986a; WE) and the web-building wolf spider "), _c('i', [_vm._v("Aglaoctenus castaneus")]), _vm._v(" (Eberhard and Hazzi 2017) apparently never slide the dragline through any claws (proving the absence of a capability is difficult, however).")]), _vm._v(" "), _c('p', [_vm._v("The ability to clamp lines firmly with leg IV probably enables the spider to lay lines under substantial tension. When the orb weaver "), _c('i', [_vm._v("Micrathena duodecimspinosa")]), _vm._v(" attached anchor lines under substantial tension to the substrate, she held the new line she was producing with one leg IV while she pulled herself forward on the substrate with her more anterior legs. This movement on the substrate was accompanied by increased tension on the dragline, as indicated by the angles formed with the web lines to which it was attached and, in some cases, by the bending or twisting of a flexible substrate such as a leaf. The spider’s ability to clamp her dragline firmly with leg IV allowed her to raise the tension on the line substantially above the tension that was needed to pull silk from her spinnerets.")]), _vm._v(" "), _c('p', [_vm._v("One final puzzle regarding tarsal claw morphology, recognized long ago by Hingston (1920), is that sheet weavers are able to run rapidly across sheets that consist of dense arrays of fine lines laid at widely varying angles without snagging their strongly curved claws (e.g., Rojas 2011; Eberhard and Hazzi 2013, 2017). Lifting the tarsal claws as the spider begins to execute a stepping motion is probably a very ancient trait, as it occurs in a variety of groups with and without webs, including liphistiids, and occurs across the entire diversity of foot configurations in spiders (Labarque et al. 2017). Perhaps the tarsal claws of funnel web spiders remain flexed dorsally as they move on their webs? Strangely, Hingston (1920) found that the lycosid "), _c('i', [_vm._v("Hippasa olivacea")]), _vm._v(" lost her ability to avoid being snagged when her pedipalps were removed.")]), _vm._v(" "), _c('p', [_vm._v("An additional derived feature of the tarsi of web builders is subdivision of the podotarsite that confers additional mobility and mechanical flexibility (Labarque et al. 2017). Similar subdivisions also evolved independently in other webless lineages. Both may have been derived from weak areas of the cuticle associated with the sensory organ (the foot slit sensilla) (Labarque et al. 2017).")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.04.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.04.02"
    }
  }, [_vm._v("2.4.2 Complementary searching and grasping behavior")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "chaft",
    attrs: {
      "id": "sec02.04.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.04.02.01"
    }
  }, [_vm._v("2.4.2.1 The blind man’s cane and the art of following")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("An appropriate image for a spider finding her way around her web is that of a blind man using his cane to explore his surroundings (Vollrath 1992; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.06.01"
    }
  }, [_vm._v("sections 6.6.1")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.01.01"
    }
  }, [_vm._v("7.1.1")]), _vm._v("). A web spider seldom if ever sees her lines during web construction: her eyes are not capable of resolving such fine objects (Foelix 2011); they are directed dorsally while the lines are usually ventral to her body while she builds; and most spiders build in darkness. The spider relies instead on tapping movements of her legs (usually legs I and II) to find new lines. Use of tactile cues was confirmed by the spider’s extensive use of apparently exploratory tapping behavior with the legs and small imprecisions in how lines were contacted ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.04.02.02"
    }
  }, [_vm._v("sections 2.4.2.2")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.03"
    }
  }, [_vm._v("6.3.3")]), _vm._v(", appendix O6.2.1). A major, but heretofore generally unremarked, trend is for the spider’s more posterior legs to follow “in the footsteps” of her more anterior legs. An anterior leg like leg I explores an area by waving, contacts a line and grasps it; then the next leg on the same side (e.g., ipsilateral leg II) reaches forward directly and seizes this line with little or no exploratory waving near the point held by leg I. Leg I then releases its hold on the line, and searches farther ahead for another line to grasp. Often a line is then passed to more posterior legs in the same way (III follows II; IV follows III). Occasionally a leg I on one side follows the leg I on the other (Briceño and Eberhard 2011 on "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(" [TET]).")]), _vm._v(" "), _c('p', [_vm._v("Following behavior occurred in many contexts, including exploration and construction of the radii, the hub, the temporary spiral, and the sticky spiral construction ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.04.02"
    }
  }, [_vm._v("section 2.4.2")]), _vm._v(", table O2.3). The functional significance "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "61",
      "id": "p61",
      "role": "doc-pagebreak"
    }
  }), _vm._v("of following behavior seems clear: it economizes on time and on the leg movements needed while moving on the web. By reducing the need for her more posterior legs to wave and explore like a blind man’s cane, the spider can move more quickly, and expend less energy.")]), _vm._v(" "), _c('p', [_vm._v("Following behavior was first described in sticky spiral construction behavior by "), _c('i', [_vm._v("Nephila pilipes")]), _vm._v(" (= "), _c('i', [_vm._v("maculata")]), _vm._v(") (NE) by Hingston (1922b), then later in hub construction behavior in "), _c('i', [_vm._v("Uloborus diversus")]), _vm._v(" (UL) (Eberhard 1972a), and sticky spiral construction in at least eight araneid and three tetragnathid genera (Eberhard 1981a), and recently at several other stages and in other genera (Eberhard 2017). I anticipate that further studies will show that the tendency for more posterior legs to follow more anterior legs is taxonomically widespread beyond the orbicularians ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.03.07"
    }
  }, [_vm._v("section 5.3.7")]), _vm._v("), and represents an ancient adaptation that has been used in many different groups to accomplish many different tasks in web construction. Following behavior appeared not to occur in the "), _c('i', [_vm._v("Ummidia")]), _vm._v(" mygalomorph spiderlings mentioned above when they walked under lines (WE), but legs IV of the diplurid "), _c('i', [_vm._v("Linothele macrothelifera")]), _vm._v(" tended to follow legs III while the spider walked on the substrate or the sheet of silk already present during sheet construction (Eberhard and Hazzi 2013). Following is thus probably an ancient trait, and was probably already present when early spiders evolved to walk under aerial lines. Similar following behavior has evolved convergently in the emesine bug "), _c('i', [_vm._v("Stenolemus giraffa")]), _vm._v(", whose posterior legs follow the anterior legs, solving the same problem of finding lines to grasp when the bug stalks its spider prey in its web (F. Soley pers. comm.).")]), _vm._v(" "), _c('p', [_vm._v("One further detail is that following behavior is sometimes facultatively omitted. Sometimes a spider alters her usual “explore and then follow” behavior when she finds herself in an area where the lines are so dense that her leg is likely encounter a line nearby wherever she places it. The large psechrid "), _c('i', [_vm._v("Psechrus")]), _vm._v(" sp. used her leg III to tap to find the next line in her sheet to which she was going to attach her sticky line, rather than following her more anterior legs, which held lines far from the attachment site and were moved less frequently (Eberhard 1987a). Some spiders may facultatively abandon following behavior when the lines in the web are dense. For instance, "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(" used following behavior in most parts of her web, where lines were sparse (e.g., Eberhard 1987d hub construction), but when she was turning rapidly at the hub of her orb during prey attack behavior, she seized new lines more or less directly without following other legs (Briceño and Eberhard 2011). An interesting implication of these behavioral adjustments is that the spider seems to “know” the likely density of lines in her immediate vicinity.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec02.04.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.04.02.02"
    }
  }, [_vm._v("2.4.2.2 Asymmetric searching movements that match asymmetric tarsal morphology")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Video recordings make it possible to add a behavioral dimension to the old morphological story just described. There are behavioral asymmetries that fit beautifully with the tarsal asymmetries and that facilitate grasping and holding individual silk lines ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#tab0203"
    }
  }, [_vm._v("table 2.3")]), _vm._v("). The small searching movements made by following legs to find and grasp the line held by a leading leg had consistent orientations: legs I and II moved prolaterally; and legs III and IV moved retrolaterally ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#tab0203"
    }
  }, [_vm._v("table 2.3")]), _vm._v("). These movements, which were necessary because the following leg never grasped the line at exactly the same site as the anterior leg, thus brought the asymmetrically placed middle claws and their associated serrate accessory setae into contact with the lines (Eberhard 2017). They may also occur in non-orb weavers, as leg I of "), _c('i', [_vm._v("Chrosiothes")]), _vm._v(" sp. nr. "), _c('i', [_vm._v("portalensis")]), _vm._v(" (THD) also searched in a prolateral direction during sheet construction (WE). It is not known whether asymmetry in searching movements occurs in other spider taxa, or whether (as predicted by the interpretation here) behavioral asymmetries in the searching behavior of legs are reduced or lacking in those groups in which tarsal tips are morphologically symmetrical (Ramírez 2014).")]), _vm._v(" "), _c('p', [_vm._v("An exception seen in these same video recordings lent further support to the association between asymmetric behavior and asymmetric morphology. During sticky spiral construction, the spider used one leg to tap to encounter lines, but not to grasp them (“inner loop localization behavior”) (figs. O6.2, O6.3, "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.05"
    }
  }, [_vm._v("section 6.3.5")]), _vm._v(", appendix O6.2.5). Tapping movements in this context tended to be directed dorso-ventrally rather than laterally in the araneids "), _c('i', [_vm._v("Araneus expletus")]), _vm._v(", "), _c('i', [_vm._v("Cyclosa monteverde")]), _vm._v(", "), _c('i', [_vm._v("Gasteracantha cancriformis")]), _vm._v(", and the uloborid "), _c('i', [_vm._v("Zosis geniculata")]), _vm._v(" (leg oI) (WE). In the nephilid "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" the inner loop localization movements were exploratory "), _c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p63"
    }
  }), _vm._v("extensions with leg oIV, and were oriented to produce dorsal rather than lateral contact (Eberhard 1982; WE). These legs generally touched the inner loop only briefly (usually in only a single frame in the 30 fps video recordings), and did not seize it.")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "tab0203"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th",
    attrs: {
      "colspan": "5"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "62",
      "id": "p62",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "thn"
  }, [_vm._v("Table 2.3.")]), _vm._v(" A tentative list of possible uniformities in two details of leg movements performed during orb construction: following; and prolateral vs. retrolateral short-distance searching movements. The species are those whose construction behavior I happen to have filmed (not all stages are represented for all species). All recordings were made in the field except those of "), _c('i', [_vm._v("Cyclosa monteverde")]), _vm._v(", "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(", and "), _c('i', [_vm._v("Zosis geniculata")]), _vm._v(". In most species only a single individual was filmed, but in all cases the activity was repeated many times. Sticky spiral construction was characterized in the outer rather than the inner half of the web, and in vertical webs usually included behavior above as well as below the hub. One leg was characterized as “following” another if it consistently moved to and grasped a line near to the point where that same line was being held by the other, leading leg, and in which the leading leg then quickly released its hold on the line (typically moving forward to find and grasp another line). “Short-distance searching” movements were the generally small amplitude movements executed by the tip of the leg approximately 0.1 s before it grasped a line; they were especially clear when one leg was following another (probably because the approximate location of the line was already known by the spider). They differed from the repetitive, larger-amplitude “long distance searching” leg movements made when a spider explored an empty space by waving or tapping with her legs (see text). Legs are indicated by “o” and “i” to indicate their positions during construction: “outer” legs were those directed away from the hub while the spider was spiraling around the web building hub, temporary, and sticky spiral lines; “inner” legs were directed toward the hub (e.g., fig. O6.1). Many of the behavior patterns (both following and short-distance searching) were not absolutely constant, and the characterizations represent the most common types of movements rather than exhaustive lists of all movements. Inconsistent behavior and behavior of species that were too small or moved too rapidly for me to interpret the leg movements are indicated with “—”. In sum, this table does not provide final characterizations of all leg movements, but rather illustrates two apparently general trends in the more consistent and easily observed types of leg movements: legs often followed the immediately anterior ipsilateral leg; and short distance searching movements by legs I and II tended to be prolateral in direction, while those by legs III and IV tended to be oriented retrolaterally.")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Behavioral operation and spider species")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Legs that followed other legs (leading leg–following leg)")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Legs NOT follow any other leg")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Direction of short-distance searching: Prolateral")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Retrolateral")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Secondary radius construction")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Leucauge mariana")]), _vm._v(" TET")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("I-II; II-I; I-I (contralat.)"), _c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("I; II"), _c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("I; II")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Micrathena duodecimspinosa")]), _vm._v(" AR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("I-I"), _c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Zosis geniculata")]), _vm._v(" UL")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI-iI"), _c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Hub construction")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("L. mariana")]), _vm._v(" TET")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI-oII; oII-oIII; oIII-oIV")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI; iIII"), _c('sup', [_vm._v("3")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oIII"), _c('sup', [_vm._v("4")]), _vm._v("; oIV")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("M. duodecimspinosa")]), _vm._v(" AR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI-oII; oII-oIII; oIII-oIV")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI; iIII"), _c('sup', [_vm._v("3")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI; oII; iI; iII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oIII; oIV")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Z. geniculata")]), _vm._v(" UL")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oII-oIV; oIV-oIII"), _c('sup', [_vm._v("5")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oIII; oII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Temporary spiral Construction")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("L. mariana")]), _vm._v(" TET")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oII-oI; oIII-oII; oIV-oII"), _c('sup', [_vm._v("6")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Cyrtophora citricola")]), _vm._v(" AR"), _c('sup', [_vm._v("7")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI-oII; oII-oIII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Nephila clavipes")]), _vm._v(" NE")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oII-oIII; oIII-oIV; oI-oII"), _c('sup', [_vm._v("8")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI; oII; iI; iII; iIII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI; oII; iI; iII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oIII; oIV")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Z. geniculata")]), _vm._v(" UL")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI-oII; oII-oIII"), _c('sup', [_vm._v("9")]), _vm._v("; oIV-oII/oIII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("iII, iIII"), _c('sup', [_vm._v("10")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI?; oII?")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oIV")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Sticky spiral construction")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("L. mariana")]), _vm._v(" TET")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI-oII; oII-oIII; oIII-oIV?"), _c('sup', [_vm._v("6")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oIV (?)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("M. duodecimspinosa")]), _vm._v(" AR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oII-oIII; oIII-oIV")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI; oII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oIII?; oIV"), _c('sup', [_vm._v("11")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Gasteracantha cancriformis")]), _vm._v(" AR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI-oII"), _c('sup', [_vm._v("12")]), _vm._v("; oII-oIII"), _c('sup', [_vm._v("13")]), _vm._v("; oII/oIII-oIV"), _c('sup', [_vm._v("6")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oII"), _c('sup', [_vm._v("11")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI"), _c('sup', [_vm._v("14")]), _vm._v("; oII"), _c('sup', [_vm._v("15")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oIII"), _c('sup', [_vm._v("14")]), _vm._v("; oIV")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Araneus expletus")]), _vm._v(" AR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oII-oIII; oIII-oIV; iI-iII; oI-iI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oII; iI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI (?); oII (?); iI; iII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oIII; oIV")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Cyclosa monteverde")]), _vm._v(" AR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oII-oIII; oIII-oIV")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("iII; iIII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oIII; oIV; iIII; iIV")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("N. clavipes")]), _vm._v(" NE")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oIII-oIV"), _c('sup', [_vm._v("11")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oIII; oII; oI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oIII; oIV")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Z. geniculata")]), _vm._v(" UL")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI-oII"), _c('sup', [_vm._v("16")]), _vm._v("; oII-oIII"), _c('sup', [_vm._v("13")]), _vm._v("; oIII-oII"), _c('sup', [_vm._v("13")]), _vm._v("; oI-iI"), _c('sup', [_vm._v("17")]), _vm._v("; iI-oI"), _c('sup', [_vm._v("17")]), _vm._v("; iIII-oIII"), _c('sup', [_vm._v("18")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oI; oII"), _c('sup', [_vm._v("15")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("oIII"), _c('sup', [_vm._v("15")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "tn"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "63",
      "id": "p63",
      "role": "doc-pagebreak"
    }
  }), _c('sup', [_vm._v("1")]), _vm._v(" All three following sequences were common; some other times these legs did not follow each other.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("2")]), _vm._v(" As grasped successive possible exit radii.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("3")]), _vm._v(" Did not move at all during construction of the first loop.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("4")]), _vm._v(" The movements were very rapid, so this characterization is tentative.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("5")]), _vm._v(" oIV grasped r"), _c('sub', [_vm._v("n")]), _vm._v(" first, then oIII grasped it nearby. But oIV did not then immediately release its grip and move on; instead both legs held the radius as the sticky line was attached between them.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("6")]), _vm._v(" Leg oII often left the radius one or two frames of the video recording before oIV arrived; during this time oIII (which had followed oII) remained holding the same radius. The site grasped by oIV was closer to that grasped by oII than to that grasped by oIII. It is thus not entirely clear whether it should be said that oIV followed either oII or oIII.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("7")]), _vm._v(" Construction of non-sticky spiral that may be homologous with hub spiral in dense horizontal sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("8")]), _vm._v(" Behavior occurred while turning from temporary spiral construction to lay a tertiary radius.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("9")]), _vm._v(" Both oII and oIII were on r"), _c('sub', [_vm._v("n")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("10")]), _vm._v(" If following occurred, it was at best inconsistent.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("11")]), _vm._v(" The tarsus often appeared to slide (probably making contact on its retrolateral side) along r"), _c('sub', [_vm._v("n")]), _vm._v(" before gripping it.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("12")]), _vm._v(" oII followed oI to first seize r"), _c('sub', [_vm._v("n")]), _vm._v(", but later did not follow oI during inner loop localization behavior when it occasionally grasped r"), _c('sub', [_vm._v("n")]), _vm._v(" briefly during its tapping movements to locate the inner loop of sticky spiral.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("13")]), _vm._v(" Hand-over-hand movements reeling in or walking out r"), _c('sub', [_vm._v("n")]), _vm._v(", with each leg grasping the radius outside the other; often only 1–2 steps.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("14")]), _vm._v(" When reached to grasp r"), _c('sub', [_vm._v("n+1")]), _vm._v(", but not while it tapped to locate the inner loop.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("15")]), _vm._v(" Especially clear as oII and oIII pulled in or walked out r"), _c('sub', [_vm._v("n")]), _vm._v(" hand-over-hand.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("16")]), _vm._v(" Except on the first sticky spiral on r"), _c('sub', [_vm._v("n")]), _vm._v(", when oI held the temporary spiral and oII grasped r"), _c('sub', [_vm._v("n")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("17")]), _vm._v(" Infrequent.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("18")]), _vm._v(" Only during the first step of leg oIII following an attachment.")])])])])]), _vm._v(" "), _c('p', [_vm._v("One further possible dimension is as yet unexplored: the dorso-ventral movements of the tarsal claws themselves ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.04.03"
    }
  }, [_vm._v("section 2.4.3")]), _vm._v("). Perhaps ancestral spiders lowered the claws when the tarsus was about to contact the substrate, and raised the claws when lifting the leg from the substrate. Such movements would resemble those needed when walking under a line, and may have preceded them evolutionarily. Some other tasks while walking on the substrate may also resemble those while walking under a line, such as coordinating leg movements so that several legs are always in contact with the substrate at any given moment and are thus able to support the spider’s weight (e.g., Foelix 2011).")]), _vm._v(" "), _c('p', [_vm._v("In sum, the tarsi of web-building spiders tell a beautiful story of functional morphology. The forms of the median claws and the serrated accessory setae, their orientations and positions on the tarsi, the movements of the spider’s legs, and the results of experimental removal of the setae all argue strongly for their importance in grasping and clamping lines. I have to admit, however, that I was left thinking one sunny morning that there may still be much to be discovered about how spiders grasp and walk on lines after watching a young sparassid, which has only two claws and a dense claw tuft rather than serrated accessory setae, literally sprint up its dragline to hide under the leaf from which I had dislodged it (WE).")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec02.04.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.04.02.03"
    }
  }, [_vm._v("2.4.2.3 An additional detail: rotating legs to grasp lines")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("One further aspect of grasping lines has only recently been studied. While the median claw can clamp a line against the serrated accessory setae when the line runs perpendicular to the direction in which the claw is flexed ventrally ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0216"
    }
  }, [_vm._v("fig. 2.16a")]), _vm._v("), this is not possible when the median tarsal claw grasps a line that is more or less parallel to the leg’s longitudinal axis. This orientation is very common in natural contexts, however, as illustrated by "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#fig0328"
    }
  }, [_vm._v("fig. 3.28")]), _vm._v(" of legs I and II of a "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(" (TET) and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0219"
    }
  }, [_vm._v("fig. 2.19")]), _vm._v(" of legs I and II of a "), _c('i', [_vm._v("Metabus ocellatus")]), _vm._v(" (TET) at the hubs of their webs. Nielsen (1932) noted this problem in "), _c('i', [_vm._v("Hyptiotes paradoxus")]), _vm._v(", in which legs I and II normally hold the line to the orb that is oriented with the spider’s longitudinal axis while the spider waits for prey; he believed that the spiders solved this problem with the stronger prolateral displacement of the median claws and the serrated accessory setae on legs I and II of this species, and by bending the line at the point where the claw grasped "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "64",
      "id": "p64",
      "role": "doc-pagebreak"
    }
  }), _vm._v("it ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0221"
    }
  }, [_vm._v("fig. 2.21")]), _vm._v("). Such bending was not seen, however, in several species in three families of orb weavers that were checked (Eberhard 2017). Instead, the spiders appear to have solved this problem in two different ways. Orb weavers and their allies used a previously unrecognized movement, rotating the distal portion of the leg on its longitudinal axis, thus orienting the middle claw so that it was more or less perpendicular to the line ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0220"
    }
  }, [_vm._v("figs. 2.20")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0221"
    }
  }, [_vm._v("2.21")]), _vm._v("). The precise site (or sites) where rotation occurs remain to be determined, though the limited dorso-ventral mobility of the claws themselves (see Ramírez 2014) indicates that the it occurred at more basal articulations. A second, clumsier solution, is illustrated in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#fig0517"
    }
  }, [_vm._v("fig. 5.17b")]), _vm._v(" of the lycosid "), _c('i', [_vm._v("Aglaoctenus castaneus")]), _vm._v(": the spider’s legs on one side were aligned approximately perpendicular to the line, and she used only these legs to walk along it, letting the others dangle in air below. Similar behavior also occurred in spiderlings in the mygalomorph families Atypidae, including "), _c('i', [_vm._v("Atypus affinis")]), _vm._v(" (unpublished video recording of Jenni Louise Cox) and "), _c('i', [_vm._v("Sphodros rufipes")]), _vm._v(" (WE), and Ctenizidae (possibly "), _c('i', [_vm._v("Ummidia")]), _vm._v(") (WE). Further observations will be needed to determine the taxonomic extent of these types of behavior.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0219"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "332",
      "src": "images/chi-eberhard-fig0219.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p64"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.19.")]), _vm._v(" Two species illustrate contrasting extremes in hub designs. The “minimalist” open hub of the horizontal orb of "), _c('i', [_vm._v("Metabus ocellatus")]), _vm._v(" (TET) just above the surface of a tropical stream ("), _c('i', [_vm._v("a")]), _vm._v(") is just large enough to be grasped by the spider’s legs III and IV (one leg III and one leg IV hold the outermost hub loop). They grip the hub directly above the spider’s heavy abdomen, while her long legs II and I hold radii in the free zone (they occasionally even extended into the capture zone). The anterior legs probably support little of the spider’s weight, and provide little motive force when the spider turns at the hub to attack prey. The hub of "), _c('i', [_vm._v("Allocyclosa bifurca")]), _vm._v(" (AR) ("), _c('i', [_vm._v("b")]), _vm._v(") represents the opposite extreme. The numerous, tightly spaced loops extend far beyond all of the spider’s legs, even when she abandons her daytime cryptic crouch and spreads her legs at night (see also "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#fig0327"
    }
  }, [_vm._v("fig. 3.27")]), _vm._v("; the object just above the spider is part of an egg sac—see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04.01"
    }
  }, [_vm._v("section 3.3.4.1")]), _vm._v(").")])]), _vm._v(" "), _c('p', [_vm._v("This implies that an orb weaver moving across her web probably constantly adjusts the rotation of each of her legs to align its middle claw perpendicular to the lines that it grasps. It may be that the information acquired during following behavior (preceding section) includes the orientation as well as the location of the line that is being held by the leading leg. This could allow the spider to adjust the degree of rotation of her following leg before it contacts the line, making it easier to grasp the line when the leg encounters it. When "), _c('i', [_vm._v("Z. geniculata")]), _vm._v(" moved one leg II moved to grasp a line that was already being held by the other leg II, the moving leg II was already rotated so that its median claw was approximately perpendicular to the line (WE).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0220"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "65",
      "id": "p65",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "436",
      "src": "images/chi-eberhard-fig0220.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.20.")]), _vm._v(" A subtle (and previously unnoticed) behavioral detail allowed this mature female "), _c('i', [_vm._v("Argiope argentata")]), _vm._v(" (AR) ("), _c('i', [_vm._v("a")]), _vm._v(", "), _c('i', [_vm._v("b")]), _vm._v(") to grasp a radius with one leg IV at the hub of her orb even though the line was nearly parallel to this leg’s longitudinal axis. By rotating a distal portion of her leg on its longitudinal axis (compare the orientations of her lateral tarsal claws with those of the tibia-metatarsus intersegmental membrane in "), _c('i', [_vm._v("b")]), _vm._v(") she positioned the median claw (not visible) approximately perpendicular to the line, allowing it to clamp the line firmly against her serrated accessory tarsal setae (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0216"
    }
  }, [_vm._v("fig. 2.16")]), _vm._v("). A mature female "), _c('i', [_vm._v("Uloborus trilineatus")]), _vm._v(" UL ("), _c('i', [_vm._v("c–e")]), _vm._v(") used similar behavior to grasp a frame line that was nearly parallel to the spider’s long axis with both of her legs I, as demonstrated by the orientations of her femur, patella, and tibia ("), _c('i', [_vm._v("c")]), _vm._v(", "), _c('i', [_vm._v("d")]), _vm._v(") compared with that of her tarsus ("), _c('i', [_vm._v("e")]), _vm._v(") (after Eberhard 2017).")])]), _vm._v(" "), _c('p', [_vm._v("It is not known how a spider determines how much she needs to rotate her leg in order to seize a newly encountered line (one not already being held by another leg). Perhaps the direction in which the setae at other sites on her tarsus are deflected by the line just before she grasps it provide this sort of information. But this is only speculation; high-speed recordings of the process of grasping a new line, and lines already held by other legs, could test these ideas. It is theoretically possible for "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "66",
      "id": "p66",
      "role": "doc-pagebreak"
    }
  }), _vm._v("a spider to sense the orientation of a line that she has grasped, via either the rotation of her legs or the stresses exerted on her leg by the line.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0221"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "268",
      "src": "images/chi-eberhard-fig0221.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p65"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.21.")]), _vm._v(" Three theoretically possible ways in which a spider could orient her leg to use her middle tarsal claw to grasp a line that was more or less parallel to the long axis of her leg: "), _c('i', [_vm._v("a")]), _vm._v(") bend the line so that it is perpendicular to the long axis of her leg at the point where the middle claw grasps it (proposed by Nielsen 1932); "), _c('i', [_vm._v("b")]), _vm._v(") bend her leg so that the long axis of her tarsus is perpendicular to the line; and "), _c('i', [_vm._v("c")]), _vm._v(") twist the leg on its long axis so that the middle claw is perpendicular to the line. Orb-weaving spiders apparently use technique "), _c('i', [_vm._v("c")]), _vm._v(".")])])])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.04.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.04.03"
    }
  }, [_vm._v("2.4.3 Grasping a line prior to attaching the dragline")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Additional motor abilities are needed to attach lines to each other. The spider must grasp lines and hold them in precise alignment against her spinnerets in order to attach lines to them at precisely determined points, and then to release these lines. Mygalomorphs have never, to my knowledge, been observed to use any of their legs in making attachments. The few detailed studies of their spinning behavior suggest that these spiders apply lines to the substrate and other lines only imprecisely, by lowering the abdomen and tapping or sweeping their spinnerets on the substrate without contacting the lines with their legs (e.g., Barrantes and Eberhard 2007; Eberhard and Hazzi 2013; in prep.). It is still possible, however, that more elaborate mygalomorph attachment behavior may yet be discovered in the tangles of strong lines high above the sheets of some diplurids (e.g., Paz 1988).")]), _vm._v(" "), _c('p', [_vm._v("Grasping lines before attaching to them may have evolved before aerial webs, judging by how the substrate web filistatid "), _c('i', [_vm._v("Kukulcania hibernalis")]), _vm._v(" consistently used one leg III to grasp the lines to which she attached cribellum silk (Eberhard 1987a). The legs used and the sites that they grasped varied in different groups: one leg III anterior to the spinnerets in "), _c('i', [_vm._v("K. hibernalis")]), _vm._v(", the pholcid "), _c('i', [_vm._v("Physocyclus globosus")]), _vm._v(" (WE), and (probably) the lycosid "), _c('i', [_vm._v("Aglaoctenus castaneus")]), _vm._v(" (Eberhard and Hazzi 2017); one leg IV (or sometimes none) behind the spinnerets in the scytodid "), _c('i', [_vm._v("Scytodes")]), _vm._v(" sp. (Gilbert and Rayor 1985); and one leg III in front and the ipsilateral IV behind in orb weavers and perhaps all orbicularians (Eberhard 1982; WE).")]), _vm._v(" "), _c('p', [_vm._v("The precision needed to make such attachments has seldom been appreciated. In typical orbicularians, for instance, the line is grasped with ipsilateral III and IV as just described, and these legs then bring it to the spinnerets, aligning it very precisely in the tiny cleft between her two anterior lateral spinnerets. Only in this position can it be contacted on either side by her piriform spigots ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0212"
    }
  }, [_vm._v("fig. 2.12")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.03.02"
    }
  }, [_vm._v("section 2.3.2")]), _vm._v("). The spider achieves this precision despite the fact that her abdomen has only limited mobility, few tactile sensory structures, and the spinnerets themselves are short and ill-equipped to sense other lines.")]), _vm._v(" "), _c('p', [_vm._v("Some spiders achieve the necessary precision in other ways, as illustrated in the building behavior of the pisaurid "), _c('i', [_vm._v("Thaumasia")]), _vm._v(" sp. This spider made relatively precise attachments between lines ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#fig0511"
    }
  }, [_vm._v("fig. 5.11")]), _vm._v(") despite never using her legs to explore or hold them (her tarsi consistently rested on the surface of the leaf just below, rather than on the web) (Eberhard 2007a). Perhaps the relatively small distances between the lines, the radial design of the web, or the spider’s frequent returns to the center of the web during construction allowed her to make attachments without seizing any lines with her legs.")])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "sec02.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.05"
    }
  }, [_vm._v("2.5 Cutting lines and recycling silk")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bhaft",
    attrs: {
      "id": "sec02.05.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.05.01"
    }
  }, [_vm._v("2.5.1 Cutting lines")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Cutting lines that are already in place is an important aspect of the construction of an orb. Provisional lines that were laid during preliminary exploration are often shifted or removed, allowing much more consistency in the design of the final product. Exploration usually involves placement of lines that are not organized around the future hub of the web (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#fig0601"
    }
  }, [_vm._v("fig. 6.1")]), _vm._v(") and are later removed. Cutting lines is also an integral part of the “cut and reel” behavior ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#sec05.03.06"
    }
  }, [_vm._v("sections 5.3.6")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.03"
    }
  }, [_vm._v("6.3.3")]), _vm._v(") used to adjust tensions on lines, to shift points of attachment ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.02"
    }
  }, [_vm._v("section 6.3.2")]), _vm._v("), and to remove the temporary spiral. The mechanisms used to cut lines have not received much attention. Many authors (myself included) have limited themselves to simply noting that spiders cut lines by bringing them to the vicinity of their mouths. But many spiders’ mouthparts are not properly designed to cut lines mechanically: the chelicerae cannot act effectively either as a scissors, or as a knife working against a chopping block (below). The mechanism used to cut lines remains somewhat mysterious; I suspect that it often involves special digestive enzymes (Tillinghast and Kavanagh 1977; Tillinghast and Townley 1987).")]), _vm._v(" "), _c('p', [_vm._v("The ability to digest dragline silk is probably a derived trait in spiders, because special enzymes in addition to those for digesting food are required; the molecular structure of dragline silk makes it largely immune to the action of many general proteases, which attack alpha "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "67",
      "id": "p67",
      "role": "doc-pagebreak"
    }
  }), _vm._v("helices rather than pleated sheets (Tillinghast and Kavanagh 1977). An enzyme that can digest silk molecules occurs in the digestive fluid of the araneid "), _c('i', [_vm._v("Argiope aurantia")]), _vm._v(" (Tillinghast and Kavanagh 1977). The fact that fluffy, cotton-like masses of loose silk at the center of the hub (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.06"
    }
  }, [_vm._v("section 6.3.6")]), _vm._v(") and entire collapsed webs ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.09"
    }
  }, [_vm._v("section 6.3.9")]), _vm._v(") are often ingested by several araneids in a matter of seconds (or less) (Peakall 1971; Carico 1986; WE), with no sign of masticating movements of the mouthparts (WE) is in accord with rapid extra-oral chemical breakdown of the silk. The fine filtration of food that occurs in the spider’s pharynx argues against the possibility that the silk lines are ingested intact and degraded deeper in the spider’s digestive tract.")]), _vm._v(" "), _c('p', [_vm._v("Perhaps the context in which the ability to break lines originated was in freeing prey that had been immobilized from the web in order to carry them to a safer site to feed on them with a minimum of damage to the web (other early uses may have included cutting debris or unwanted prey free). The taxonomic distribution of the ability to cut immobilized prey free is not known. Some spiders such as the theraphosid "), _c('i', [_vm._v("Psalmopoeus reduncus")]), _vm._v(" and the diplurid "), _c('i', [_vm._v("Linothele macrothelifera")]), _vm._v(" ripped prey free of entangling lines by brute force (Barrantes and Eberhard 2007; Eberhard and Hazzi 2013), and the filistatid "), _c('i', [_vm._v("Kukulcania hibernalis")]), _vm._v(" also pulled subdued prey through her web by force as she backed toward her retreat (WE). In a variety of other haplogyne families, including Hypochilidae (Shear 1969), Diguetidae (Eberhard 1967; Bentzien 1973), Scytodidae (Gilbert and Rayor 1985), and Pholcidae (Eberhard and Briceño 1983; Barrantes and Eberhard 2007; I. Escalante in prep.), spiders cut prey free with little or no tugging. The diguetid "), _c('i', [_vm._v("Diguetia canities")]), _vm._v(" also sometimes broke lines forcefully while freeing prey (and also during web construction): holding the line near her mouth with a leg II or III, the spider pumped her body up and down several times; the moment the line broke, her body sprang back (Eberhard 1967; WE). Cutting lines is a standard part of attack behavior in orbicularians (e.g., Robinson and Mirick 1971; Robinson and Olazarri 1971; Robinson et al. 1971; Barrantes and Eberhard 2007), as well as in non-orb web-building entelegynes such as psechrids (Robinson and Lubin 1979b).")]), _vm._v(" "), _c('p', [_vm._v("A second context in which cutting could have arisen is sperm web construction. The clumsy way in which mature theraphosid males used their mouthparts and/or oral secretions to slowly produce a notch in the edge of the sheet of the sperm web by “masticating” it (the process lasted up to several min) (Costa and Pérez-Miles 2002) contrasts sharply, however, with the nearly instantaneous and precise breaking of lines by orb weavers like "), _c('i', [_vm._v("Nephila")]), _vm._v(" and "), _c('i', [_vm._v("Argiope")]), _vm._v(" spp. during attacks on prey (e.g., Robinson and Mirick 1971; Robinson and Olazarri 1971; Robinson et al. 1971) and during orb construction ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#ch06"
    }
  }, [_vm._v("chapter 6")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("Closeup video recordings of the large, slow moving orbicularian "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" (NE) showed that cutting did not involve tugging or any other obvious exertion of force; the line was brought to the mouth region by the tarsus of a leg or palp, and often though apparently not always grasped and pulled briefly closer to the mouth with a cheliceral fang; it then “fell apart” without visible indications of strong mechanical force having been applied (WE). Morphological details of the chelicerae of "), _c('i', [_vm._v("N. clavipes")]), _vm._v(" are also not appropriate for cutting lines mechanically (WE). The basal segment has no sharp, flat edge that could mesh like a scissors with the fang; its scattered, conical teeth are not appropriately designed for a scissor-like function. An alternative, chopping block hypothesis was also not supported. The internal surface of the fang is not sharp, but is rather slightly rounded and has no sharp edge or ridges. The floor of the fang furrow, against which the fang closes, is flat; it also lacks any structure that would be appropriate for mechanically cutting lines.")]), _vm._v(" "), _c('p', [_vm._v("Behavioral details also argued against the chopping block hypothesis, because lines making a wide variety of angles with the chelicerae were all cut immediately; the spider made no attempts to align them in any particular way with the chelicerae beforehand. The chelicerae also did not move in ways, such as “sawing” or “snipping” at the line, that might be expected to accompany mechanical cutting. Rather the line seemed to simply fall apart when it reached the spider’s mouth area; sometimes the ends fell apart with a gentle “snap,” with no perceptible previous tightening (WE).")]), _vm._v(" "), _c('p', [_vm._v("I hypothesize that selection to reduce damage inflicted on the web by prey removal, possibly combined with selection to economize on the effort needed, probably favored the ability to cut lines chemically. A further, "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "68",
      "id": "p68",
      "role": "doc-pagebreak"
    }
  }), _vm._v("probably originally incidental advantage was the ability to recycle their webs, reducing the costs of moving to new websites ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.05.02"
    }
  }, [_vm._v("sections 2.5.2")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.02"
    }
  }, [_vm._v("8.2")]), _vm._v(").")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec02.05.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.05.02"
    }
  }, [_vm._v("2.5.2 Recycling silk")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Orb weavers routinely gather the previous web together and ingest it before they build a new one. Labeled material from a radioactively labeled web began to appear in the ampullate glands of "), _c('i', [_vm._v("A. diadematus")]), _vm._v(" as soon as 30 min following ingestion (Peakall 1971; Witt et al. 1968). A large fraction (about 80–90%) of the ingested labeled material ended up in the ampullate glands as opposed to the rest of the spider’s body (Peakall 1971). This study suggested an extremely high efficiency of recovery of ingested silk protein in new silk (about 80–95%), but later studies (using another species of "), _c('i', [_vm._v("Araneus")]), _vm._v(", and with some methodological differences) gave recovery rates of around 30%, which is more typical for proteins ingested by other animals (Townley and Tillinghast 1988). In any case, recycling of web protein surely occurs.")]), _vm._v(" "), _c('p', [_vm._v("Blackledge et al. (2011) stated that web recycling in orb weavers occurs primarily in araneoids that produce viscid silk, rather than cribellate orb weavers or more derived orbicularians that have lost orbs. If this is true (they did not cite supporting data), it could suggest that the primary target of recovery is the viscid glue droplets (Blackledge et al. 2011), perhaps the essential amino acids that constitute 39% of the proteins in aggregate gland secretions (Townley and Tillinghast 2013). Some other otherwise-puzzling observations suggest that this may be an oversimplification. The linyphiid sheet weaver "), _c('i', [_vm._v("Diplothyron")]), _vm._v(" sp. produces abundant lines with sticky droplets, but abandons rather than removing old webs (WE). Perhaps it is recovery of particular components of aggregate gland secretions, not the recovery of the protein per se, that has most selective importance in silk recycling. Uloborids, which do not add accessory gland products to their orbs, may be less likely to reingest their old webs. For instance, "), _c('i', [_vm._v("Zosis geniculata")]), _vm._v(" (UL) discarded large masses of loose silk when replacing and repairing major sectors of their orbs (I have seen up to 33 substantial masses of fluff accumulated under a single orb), and also discarded egg sacs from which spiderlings had emerged (WE), even though they reingested silk while removing the small mass of loose dragline silk that accumulated from cut and reel behavior during exploration and early radius construction during proto-hub construction (appendix O6.3.2.3), as also occurred in "), _c('i', [_vm._v("Lubinella morobensis")]), _vm._v(" (UL) (Lubin 1986). Other species of deinopids and uloborids are known to cut lines easily during web construction, but nevertheless to sometimes discard balls of loose silk from previous webs or abandoned webs without reingesting them (Akerman 1926; Marples and Marples 1937; Eberhard 1972a; Nentwig and Spiegel 1986). Another uloborid, "), _c('i', [_vm._v("Hyptiotes paradoxus")]), _vm._v(", however, consistently reingested silk (Opell 1982). Some tetragnathids and nephilids also sometimes abandoned webs without reingesting them (Buskirk 1975; WE). In sum, the ability to sever and digest lines enzymatically is widespread in araneoids ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.05"
    }
  }, [_vm._v("section 2.5")]), _vm._v("; Carico 1986; Higgins 1987, 1992b), but the present incomplete knowledge of taxonomic distribution of web recycling in other groups does not follow clear patterns.")]), _vm._v(" "), _c('p', [_vm._v("Another puzzling observation is that, at least in "), _c('i', [_vm._v("Nephila pilipes")]), _vm._v(" (= "), _c('i', [_vm._v("maculata")]), _vm._v("), ingestion of the old web sometimes took many hours. Hingston (1922c) saw that an individual that rolled up her web (after he had broken all the anchors except one at the top) fed for approximately 12 hours (from 10 AM to “late at night”). Because of the spider’s large size, he was able to observe “the yellow ball” of silk on her mouthparts. Why did this spider take so long to ingest silk, while recordings of "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" (AR) (Peakall 1971) and "), _c('i', [_vm._v("Micrathena duodecimspinosa")]), _vm._v(" (AR) (WE) showed that ingestion of an old web or a mass of fluff took on the order of one second?")]), _vm._v(" "), _c('p', [_vm._v("One previously unremarked problem in reingesting webs is that the presence of water droplets on lines from rain, fog, or dew could dilute and probably reduces the effectiveness of her proteolytic enzymes ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.05"
    }
  }, [_vm._v("section 2.5")]), _vm._v("). Thus, an araneoid orb weaver may be obliged to discard a web that has accumulated drops of water rather than recycle it ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#fig0810"
    }
  }, [_vm._v("fig. 8.10")]), _vm._v("). Perhaps breaking the lines in an old, water-laden web but not cutting them entirely free (as in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#fig0810"
    }
  }, [_vm._v("fig. 8.10")]), _vm._v(") allows spiders to later rescue at least part of a web by waiting until it dries off, but this is only speculation.")]), _vm._v(" "), _c('p', [_vm._v("The protein in silk lines may sometimes be discarded because it is not valuable nutritionally to the spider. After all, silk may have evolved from the nitrogenous waste products of these predators, whose food is rich in protein ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02.01"
    }
  }, [_vm._v("section 2.2.1")]), _vm._v("). Glatz (1967) used this reasoning to explain the frequent abandonment of apparently intact "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "69",
      "id": "p69",
      "role": "doc-pagebreak"
    }
  }), _vm._v("and functional webs by the oecobiid "), _c('i', [_vm._v("Oecobius annulipes")]), _vm._v(" only two to four days after building them; the pholcid "), _c('i', [_vm._v("Physocyclus globosus")]), _vm._v(" also frequently abandoned intact webs (Eberhard 1992a). Nevertheless, at least for some spiders in some situations, ingesting silk is apparently a significant source of nutrition. Many orb weavers routinely ingest their previous webs (Shelly 1984; Carico 1986), and some spiders, including the theridiid "), _c('i', [_vm._v("Argyrodes lanyuensis")]), _vm._v(" (Tso and Severinghaus 1998) and mature males of the tetragnathid "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(" (WE), steal and ingest the silk from the webs of other spiders.")]), _vm._v(" "), _c('p', [_vm._v("One ecological consequence of the ability to digest silk, whether or not the major payoff is from the silk lines themselves or from aggregate gland products, is that it probably enables web builders to search for prey more efficiently. Most orb weavers, for instance, can ingest the old web before abandoning a site which has proven to be unsatisfactory, thus reducing the cost of moving away. Section 8.6 discusses possible ecological consequences of recycling silk.")])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "sec02.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.06"
    }
  }, [_vm._v("2.6 How spiders avoid adhering to their own webs: a mystery partly solved")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Finally, an important ability that has received puzzlingly little attention is how spiders that make sticky webs avoid becoming stuck to their own webs. Perhaps the most obvious problem is that when a spider attacks a prey, she needs to move rapidly across sticky portions of her web without becoming entangled; she could also benefit from minimizing the damage she produces in her web as she moves. One possible solution was first outlined by the pioneering naturalists Fabre (1912) and Hingston (1920). Working with adult females of "), _c('i', [_vm._v("Argiope bruennichi")]), _vm._v(" (AR) and "), _c('i', [_vm._v("Nephila pilipes")]), _vm._v(" (NE), they found that when the tips of the spider’s legs were washed in a non-polar organic solvent, the spider apparently adhered more tenaciously than usual when she subsequently contacted sticky spiral lines. Hingston (1920) also found that "), _c('i', [_vm._v("N. pilipes")]), _vm._v(" also appeared to “recoat” her legs by moistening her tarsi in her mouth, and rubbing them on other parts of her body such as her legs, her abdomen on and near her spinnerets, and the sides of her abdomen, which Hingston thought were especially likely to come into contact with sticky lines. In contrast, she neglected other large expanses of her body such as the ventral surfaces of her abdomen and cephalothorax that do not contact lines. Hingston gave anecdotal evidence that these areas adhered more to sticky lines when he experimentally brought lines into contact with them. Both Fabre and Hingston concluded that orb weavers probably use some substance, perhaps some sort of oil, to avoid adhering to their sticky spiral lines.")]), _vm._v(" "), _c('p', [_vm._v("Most subsequent discussions simply repeated these accounts, though Vollrath and Tillinghast (1991) argued that the anti-adhesive story is a myth, and that orb weavers do not need a defense against adhesion because they tend to avoid walking on the sticky lines in their webs (as also noted by Fabre and Hingston), moving instead along the non-sticky radial lines. The preference for walking on non-sticky radial lines could also, however, be due to selection to avoid disturbing the uniform spacing between sticky lines by not walking on them ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0419"
    }
  }, [_vm._v("fig. 4.19")]), _vm._v("), or to the fact that radii are much less extensible than the sticky spiral lines, and thus offer more rigid support for the spider’s weight ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.02"
    }
  }, [_vm._v("section 2.2")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("More importantly, the avoidance hypothesis fails to take into account that at other moments during sticky spiral construction araneoid orb weavers do not avoid contact with sticky lines, but rather repeatedly touch and pull forcefully on them. Just before attaching the sticky spiral to each radius, the spider pulls out additional sticky line from her spinnerets with her legs IV ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.05"
    }
  }, [_vm._v("section 6.3.5")]), _vm._v("; Eberhard 1982; Briceño and Eberhard 2012). In "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" (NE) and "), _c('i', [_vm._v("Gasteracantha cancriformis")]), _vm._v(" (AR), for instance, the spider pulls on the sticky spiral line approximately 1000 to 1500 times with each hind leg during the construction of a single orb (Briceño and Eberhard 2012). The pulls lengthen the sticky line, reducing the tension on it and probably improving its ability to stop and retain prey. Pulls of this sort apparently occur in all species of araneoid orb weavers (Eberhard 1982). Spiders also repeatedly contact sticky lines during inner loop localization behavior just before each attachment to a radius ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.05"
    }
  }, [_vm._v("section 6.3.5")]), _vm._v("). Still further contact often occurs during prey attack in "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" (AR) (Peters 1933a) and "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" (WE) when the spider pushes against the orb with the distal portions of her legs I and II to position her body while wrapping the prey at the attack site. In short, orb weavers repeatedly contact sticky lines; in no contexts, however, does the spider "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "70",
      "id": "p70",
      "role": "doc-pagebreak"
    }
  }), _vm._v("adhere more than very weakly to the sticky lines (Briceño and Eberhard 2012).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0222"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "393",
      "src": "images/chi-eberhard-fig0222.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p70"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.22.")]), _vm._v(" The tarsal setae of a mature female "), _c('i', [_vm._v("N")]), _vm._v(". "), _c('i', [_vm._v("clavipes")]), _vm._v(" (NE) illustrate a morphological mechanism used by some spiders to reduce their adhesion to their own webs. In dorsal view ("), _c('i', [_vm._v("a")]), _vm._v("), the tarsus is densely clothed with setae, a few of which were blunt-tipped and oriented more nearly perpendicularly to the surface of the tarsus, and which probably function as chemo-sensors (dotted arrows). At greater magnification ("), _c('i', [_vm._v("b")]), _vm._v("), small barbs (solid arrows) are visible near the bases of the other, more common setae, always on the surface of the seta farthest from the surface of the tarsus (most setae in "), _c('i', [_vm._v("b")]), _vm._v(" are projecting approximately toward the viewer). When the tarsus was pressed experimentally against a sticky spiral line, mimicking a common behavior during sticky spiral construction, the line slid along individual setae until it was arrested by the barbs near their bases; this minimized the area of contact by preventing extensive contact with the tarsal surface below. In "), _c('i', [_vm._v("c")]), _vm._v(", a tarsus IV of a mature female "), _c('i', [_vm._v("N")]), _vm._v(". "), _c('i', [_vm._v("clavipes")]), _vm._v(" that was pressed 400 times against a sticky spiral line illustrates how liquid (solid arrows; presumably glue from the orb) accumulated on the setae. Dotted arrow indicates a blunt-tipped seta. Additional defenses of the spider against adhesion to her own web included details of how she moved her legs, and an oily, anti-adhesion coating.")])])])])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('section', [_c('p', [_vm._v("Two recent studies gave further support to the Fabre and Hingston anti-adhesive idea with "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" (NE) and "), _c('i', [_vm._v("Gasteracantha cancriformis")]), _vm._v(" (AR) (Briceño and Eberhard 2012), and with the araneids "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" and "), _c('i', [_vm._v("Larinioides sclopetarius")]), _vm._v(" (Kropf et al. 2012). Washing isolated legs with either hexane or carbon disulfide increased the force of adhesion by sticky spiral lines in standardized tests (washing with water gave inconsistent results). Two additional anti-adhesion traits that were revealed included cleverly oriented leg movements, and barbed, drip-tip setae. Spiders pulled sticky lines from their spinnerets with thrusting movements of leg IV that brought the exterior surfaces of the setae on the tarsus into contact with sticky lines. The direction of the leg’s thrust caused the droplets of adhesive on the sticky line to slide basally on these setae until the baseline snagged on other setae or on the basal branches or “barbs” on the exterior surfaces of these setae ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0222"
    }
  }, [_vm._v("fig. 2.22")]), _vm._v("); snagging on the barbs prevented the sticky droplets from reaching the surface of the tarsus where they would have made more extensive contact and thus adhered much more strongly. When the leg then pulled away from the sticky line, it moved more or less parallel to the long axis of its tarsus (Briceño and Eberhard 2012), thus causing the sticky droplets on the line to retrace their paths, sliding distally along the setae ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0222"
    }
  }, [_vm._v("fig. 2.22")]), _vm._v("); at the moment the leg finally pulled the setae free, the area of contact between each sticky droplet and a seta had become reduced to just the tip of the seta, minimizing the force of adhesion. Because the setae are scattered along the length of the tarsus rather than being arranged in rows (Briceño and Eberhard 2012), different droplets pulled free from different setae one after the other rather than simultaneously, reducing still further the strength of adhesion.")]), _vm._v(" "), _c('p', [_vm._v("The possibility that the anti-adhesion traits documented "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "71",
      "id": "p71",
      "role": "doc-pagebreak"
    }
  }), _vm._v("in these studies occur in spiders in general is raised by a recent observation of the salticid "), _c('i', [_vm._v("Thyene imperialis")]), _vm._v(" walking on sticky lines of "), _c('i', [_vm._v("Cyclosa deserticola")]), _vm._v(" (AR) “without any problems” (Jäger 2012).")]), _vm._v(" "), _c('p', [_vm._v("The tests of adhesion to isolated legs also revealed an additional, previously unappreciated problem that orb weavers confront. When an isolated hexane-washed leg was touched over and over to a sticky line, the force with which it adhered gradually increased. The likely reason for this increase was that sometimes when the leg pulled away, a small amount of adhesive substance remained on the leg; this glue gradually built up on the leg. When washed legs that had touched a sticky line 400 times were checked under the SEM, their setae had substantial accumulations of viscous material ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0222"
    }
  }, [_vm._v("fig. 2.22c")]), _vm._v("). This number of contacts is biologically realistic (or even an underestimate) for the construction of a single orb. For instance, the "), _c('i', [_vm._v("Micrathena undecimspinosa")]), _vm._v(" web in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0104"
    }
  }, [_vm._v("fig. 1.4")]), _vm._v(" had over 3500 attachments (57 loops of sticky spiral and 63 radii), and the spider pulled sticky line with her IV one or more times prior to each attachment to a radius ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.05"
    }
  }, [_vm._v("section 6.3.5")]), _vm._v("). Orbs like those of "), _c('i', [_vm._v("Acacesia")]), _vm._v(" and "), _c('i', [_vm._v("Deliochus")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0305"
    }
  }, [_vm._v("fig. 3.5")]), _vm._v(") and "), _c('i', [_vm._v("Pozonia")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#fig0335"
    }
  }, [_vm._v("fig. 3.35")]), _vm._v(") have even higher numbers of sticky spiral attachments. The anti-adhesive coating (washed off in these experiments) presumably helps protect against such accumulations of glue.")]), _vm._v(" "), _c('p', [_vm._v("Several mysteries still remain. The largest puzzle is that cribellate spiders also avoid adhering to the treacherously adhesive cribellum silk in their webs, but none of the defensive mechanisms just described will work in their webs. In the first place, the webs of many cribellates, such as those of filistatids, "), _c('i', [_vm._v("Stegodyphus")]), _vm._v(", and dictynoids (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#ch09"
    }
  }, [_vm._v("chapter 9")]), _vm._v("; Griswold et al. 2005), have dense, disorganized arrays of cribellum silk that often extend into and around the spider’s own retreat, so neither the “tip toe” tactic nor the carefully oriented withdrawal movements of the legs of orb weavers that were just described is a feasible defense. The non-orb weavers routinely contact sticky lines with many parts of their bodies as they move in their webs, but show no sign of adhering. Secondly, an oily substance is not likely to provide a defense against the hygroscopic and van der Waals forces responsible for the stickiness of cribellum silk (see Opell 2013; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.06"
    }
  }, [_vm._v("section 2.6")]), _vm._v(".). If anything, oil might be expected to increase adhesion: the cribellum silk of the filistatid "), _c('i', [_vm._v("Kukulcania hibernalis")]), _vm._v(" adhered tenaciously to the tarsi of "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" (D. Briceño pers. comm.). A possible clue comes from the unusually “hairy” setae on the tarsi ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0011#fig0223"
    }
  }, [_vm._v("fig. 2.23")]), _vm._v(") of mature male "), _c('i', [_vm._v("Kukulcania hibernalis")]), _vm._v(" (Filistatidae), which may have an especially demanding challenge to avoid adhesion, because they grasp and tug strongly on sticky lines in female webs as part of courtship. Just how cribellate spiders avoid adhering to their own sticky silk is not known.")]), _vm._v(" "), _c('p', [_vm._v("An even greater mystery occurs in all cribellate spiders—the lack of adhesion when the calamistrum pulls sticky lines from the cribellum. The comb-like row of thick setae on leg IV (the calamistrum) snags and pulls swaths of lines from the cribellum during huge numbers of rapidly repeated brushing movements across the cribellum ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0207"
    }
  }, [_vm._v("fig. 2.7")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.03.02.01.02"
    }
  }, [_vm._v("section 3.3.3.3.2.1.2")]), _vm._v("); for instance, a mature female "), _c('i', [_vm._v("Zosis geniculata")]), _vm._v(" [UL] brushed posteriorly over her calamistrum on the order of 69,000 times in the course of building a single orb (WE). With each posterior brushing movement an additional length of cribellum silk is snagged by the calamistrum, pulled from the cribellum spigots, and then somehow released. Following each brushing movement, the leg reverses direction moves anteriorly to prepare for the next brushing movement. At this critical moment, the bristles of the calamistrum must somehow free themselves from the highly sticky lines that they have just pulled from the cribellum. The only force that would seem likely to pull the cribellum fibers from the calamistrum bristles is their air resistence.")]), _vm._v(" "), _c('p', [_vm._v("How do the calamistrum setae free themselves immediately and smoothly from the cribellum lines? I have not found any study addressing this question. A calamistrum is apparently present in all spider species with a cribellum, and the combing movements are very ancient (above; Griswold et al. 2005). Perhaps the complex microsculpture of tiny ridges and teeth on the calamistrum setae of some groups (Ramírez 2014), which do not seem to have any known function, is involved. But the calamistrum setae of some other groups, like "), _c('i', [_vm._v("Uloborus")]), _vm._v(" spp., are relatively smooth (R. Foelix pers. comm.). Brent Opell has suggested (pers. comm.) that perhaps the fine cribellum lines are not sticky the instant that they are pulled from the cribellum, and only become adhesive a little later, perhaps after the tiny nodules on the fibrils are formed (Opell 2013).")]), _vm._v(" "), _c('p', [_vm._v("There are also some puzzling reports of "), _c('i', [_vm._v("lack")]), _vm._v(" of adhesion "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "72",
      "id": "p72",
      "role": "doc-pagebreak"
    }
  }), _vm._v("by cribellum silk. The eresid "), _c('i', [_vm._v("Seothyra henscheli")]), _vm._v(" shook sand grains off the cribellate lines in their webs after wind blew sand onto them (Henschel and Lubin 1992)! Pentatomid bugs and earwigs living in the abandoned web of the eresid "), _c('i', [_vm._v("Adonea")]), _vm._v(" moved in the web without adhering to it (Nentwig 1983c), and the salticid "), _c('i', [_vm._v("Portia fimbriata")]), _vm._v(" moved through the webs of the social cribellate eresid "), _c('i', [_vm._v("Stegodyphus")]), _vm._v(" sp. without perceptibly adhering to them (Jackson 1986). The scytodid "), _c('i', [_vm._v("Scytodes globosus")]), _vm._v(" also moved freely in the web of its prey, the amphinectid "), _c('i', [_vm._v("Metaltella simoni")]), _vm._v(", without any signs of adhesion to the abundant cribellum lines there (Escalante et al. 2015; I. Escalante pers. comm.).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0223"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "417",
      "src": "images/chi-eberhard-fig0223.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p72"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 2.23.")]), _vm._v(" Ventral views of the tip of the tarsus I of a mature male "), _c('i', [_vm._v("Kukulcania hibernalis")]), _vm._v(" (Filistatidae) at different magnifications highlight a small cluster of thick setae resembling hairy caterpillars that may reduce the adhesion of the male to the female’s highly adhesive cribellum silk (most of the other setae on the right side of photos "), _c('i', [_vm._v("a")]), _vm._v(" and "), _c('i', [_vm._v("c")]), _vm._v(" were removed). The tips of the male’s tarsi made strong contact with the adhesive cribellum lines on the webs of females during courtship, when he jerked and pulled on her web, but they nevertheless adhered weakly if at all. Female tarsi have more reduced versions of these setae (G. Barrantes pers. comm.). This strange male setal morphology supports the idea that processes on setae are somehow important in avoiding adhesion to cribellum lines, and argues against the importance of mechanical entanglement in the adhesiveness of cribellum lines (photos courtesy of Gilbert Barrantes).")])]), _vm._v(" "), _c('p', [_vm._v("The highly adhesive web of "), _c('i', [_vm._v("Deinopis longipes")]), _vm._v(" was thrust rapidly toward the flat substrate by the spider’s legs I and II, where it captured walking prey but never adhered to the substrate (Robinson and Robinson 1971); the authors say that “the net is held in such a way that the tarsi may touch the substrate in advance of the net,” but the published photos do not show the tarsi projecting beyond the lines; indeed the morphology of the spiders, with the tarsal claws that presumably grasp the lines located at the tips of their legs, would seem to preclude this possibility.")]), _vm._v(" "), _c('p', [_vm._v("Similar mystery surrounds the long, thin ribbons of major ampullate silk that sicariid spiders "), _c('i', [_vm._v("Loxosceles")]), _vm._v(" spp. lay in apparently disorganized clumps around their retreats (Lehmensick and Kullmann 1956; Vetter 2015). The "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "73",
      "id": "p73",
      "role": "doc-pagebreak"
    }
  }), _vm._v("disorganized arrangement of the sticky silk precludes defending against adhesion by using careful orientation of the spider’s legs or body. The adhesion of this silk may come from electrostatic properties (Coddington et al. 2002). If so, this poses the question of whether these spiders use electrostatic charges as defenses.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "sec02.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.07"
    }
  }, [_vm._v("2.7 Central nervous system basis for web construction")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Some volumetric measurements suggested that the “central body,” an arc of specialized neuropil in the supraesophageal ganglion, is of particular importance in the nervous control of web-building behavior. But comparisons among four species with different lifestyles (only one of which was an orb weaver) showed little difference in the relative fraction of the volume of this ganglion that was occupied by the central body (approximately 3.1 to 5.1 %). Much remains to be learned about which portions of the central nervous system are involved in which aspects of web construction.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "sec02.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec02.08"
    }
  }, [_vm._v("2.8. Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Silk production is a defining feature of spiders, and this chapter describes the multiple morphological, secretory, and behavioral traits that permit spiders to produce silk and build their webs. Spider silks are proteins that were probably originally derived from nitrogenous waste products. Nearly all have evolved from a single ancestral “spidroin” gene that subsequently duplicated and diverged repeatedly, flowering into an assortment of different types of silk products that are synthesized in at least ten different types of glands. These silks have a variety of properties that adapt them to perform many different functions. Silk is used in forming the linings for burrows, protective enclosures for eggs, protective walls of retreats, safety lines, attachments of lines to the substrate and to other lines, platforms onto which males deposit droplets of semen, thin lines that float free in gentle breezes to establish bridges to distant objects (and also lift spiders to fly), sticky lines that adhere tenaciously to prey, and strong lines to resist stress from the impacts of prey that hit the web and that prevent them from pulling away.")]), _vm._v(" "), _c('p', [_vm._v("The strongest spider silks are justly famous for their extraordinary combination of extensibility and toughness. Their potential for medical, military, and industrial applications has stimulated much current research on their molecular and mechanical properties. The viscoelastic nature of dragline silk allows an orb web to absorb sudden stresses from prey without breaking; the lines cede with the impact and do not immediately spring back, thus absorbing momentum and avoiding a trampoline effect of launching the prey in the opposite direction. The conversion of silk from an aqueous liquid (in the lumen of the gland) occurs at the tips of the spigots or within the gland ducts, and happens only when the line is pulled. This dependence on pulling has had important consequences for the morphology of the spinnerets and their spigots, and for web-building behavior in general; the spider cannot shoot lines to distant objects, and thus must depend on her own movements, movements of her spinnerets, or air movements to initiate and extend bridge lines.")]), _vm._v(" "), _c('p', [_vm._v("Recent work has revealed a previously unsuspected diversity in the chemical and mechanical properties of lines in different species, even in the lines from a given gland in an individual spider. Spiders apparently facultatively manipulate the abilities of lines to resist stress and their stickiness (e.g., Gosline et al. 1999; Madsen et al. 1999; Vollrath et al. 2001). A new generation of studies is now beginning to document the extent of this inter- and intra-specific diversity and its relations to other factors such as web designs, prey types, humidity, and environmental stresses (see for example Blackledge et al. 2011; Sensenig et al. 2011; Blackledge 2013; Opell 2013; Boutry and Blackledge 2013; Amarpuri et al. 2015; Opell et al. 2015). It is already clear that uptake of water from the atmosphere (promoted by inclusion of proteins and organic salts in glue droplets) is important in maintaining the stickiness and high extensibility of sticky spiral lines. It appears that the hygrosopic properties of different species’ sticky lines are “tuned” to the humidity of their natural habitats to produce maximum adhesion. Silk from different species differs in the degree to which it “supercontracts,” and high humidities that cause non-sticky lines to supercontract can alter an orb’s ability to stop prey. The degree of supercontraction is correlated with the proline composition of the silk molecules, and "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "74",
      "id": "p74",
      "role": "doc-pagebreak"
    }
  }), _vm._v("the silks of different species contain different proportions of proline (Liu et al. 2008). Study of evolutionary adjustments of silk properties to different environmental conditions is only in its infancy, and exciting developments seem sure to emerge in the future.")]), _vm._v(" "), _c('p', [_vm._v("Another newly appreciated complication is the structural complexity of the small droplets of adhesive on the sticky spiral lines of araneoid orb weavers and the functional significance of the different components. It is also likely that some types of silk lines (e.g., aciniform, major ampullate, and cylindriform gland lines) are at least somewhat adhesive when first laid, but later become non-adhesive.")]), _vm._v(" "), _c('p', [_vm._v("Morphological structures that allow a spider to control how and where her silk lines are deposited also affect web construction. These abilities were probably especially important as spiders evolved from solving the mechanical problems associated with webs by “brute force” (for instance, by simply adding more and more lines) to using more precise positioning of fewer, stronger lines to capture prey (see also "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#sec10.03"
    }
  }, [_vm._v("section 10.3")]), _vm._v("). One key set of structures is the spinnerets. Early in evolution they were long and highly mobile, but they are much shorter in most modern groups. The complex musculature of spinnerets suggests that even short spinnerets are capable of various types of movements, and limited direct observations of their behavior have confirmed that they perform rapid, precise movements that are of crucial importance in processes such as initiating and terminating lines rapidly, and fastening lines solidly to each other and to the substrate. Spinneret movements may be more elaborate and important during web construction than is currently appreciated. The positions of the spigots on the spinnerets probably represent adaptations for initiating lines and fastening them to each other and to the substrate.")]), _vm._v(" "), _c('p', [_vm._v("Structures on the tarsi and subtle details of leg movements enable spiders to grasp, manipulate, and release silk lines precisely. Early web-building spiders probably never grasped individual lines with their legs, and relied instead on movements of the entire abdomen and their long, mobile spinnerets to place lines. Evolutionary innovations that were important in building prey capture webs include the following: acquisition of a middle tarsal claw and strong accessory tarsal setae that have notches enabling the spider to seize lines firmly when the middle claw flexes ventrally; following behavior by more posterior legs that economizes on searching behavior, by utilizing information on the locations of lines from more anterior legs; asymmetric lateral searching behavior by the legs (which, in conjunction with the asymmetric placement of the middle claw and its accessory setae, facilitates grasping newly encountered lines); rotating the leg on its longitudinal axis so that the middle tarsal claw is perpendicular to the line that is being grasped; grasping a line with tarsi III and/or IVand holding it precisely aligned against the spinnerets to facilitate making attachments by using piriform silk (facilitated in turn by the flat field of spigots on the medial side of the tip of the anterior lateral spinneret); and the combination of branched setae, careful tarsal movements, and a protective chemical coating that allows some spiders to reduce adhesion to their own sticky lines. The mechanisms used by cribellate and "), _c('i', [_vm._v("Loxosceles")]), _vm._v(" spiders to avoid adhering to their own sticky silk, however, are still unknown.")]), _vm._v(" "), _c('p', [_vm._v("Finally, the ability to cut lines is also important in web construction. Cutting is probably accomplished enzymatically rather than mechanically, using special enzymes (typical proteolytic digestive enzymes are not effective with dragline silk). Cutting makes it possible for the spider to make fine adjustments in the tensions on lines and their attachments to each other, and to eliminate the preliminary lines that were laid during the exploratory phase of web construction (these preliminary lines, in turn, are necessary because the spider is unable to shoot new lines, and must instead produce them by pulling).")])])])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "header0301",
      "epub:type": "chapter",
      "id": "ch03",
      "role": "doc-chapter"
    }
  }, [_c('header', {
    attrs: {
      "id": "header0301"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "75",
      "id": "p75",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rch03"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("Functions of orb web designs")]), _vm._v(" "), _c('div', {
    staticClass: "epigraph",
    attrs: {
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "epf"
  }, [_vm._v("The difference between utility and utility plus beauty is the difference between telephone wires and the spider’s web. —Edwin Way Teale, 1953, Circle of the Seasons: The Journal of a Naturalist’s Year")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "sec03.01"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p75"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.01"
    }
  }, [_vm._v("3.1 Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("The function of a spider’s web is simple: increase the spider’s ability to capture prey. But judging the functionality of a given web design is complicated. A web can contribute to prey capture in several ways, and a design feature that increases the performance of one sub-function can decrease that of another. For instance, an orb like that in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0104"
    }
  }, [_vm._v("fig. 1.4")]), _vm._v(" will intercept more prey if it covers more area; but it needs physical strength to absorb the kinetic energy of fast-flying prey like a bee. Given a limited supply of silk, increasing the stopping ability by making thicker lines or spacing them closer together will increase the web’s stopping abilities, but will reduce the area it covers and thus the number of prey that it intercepts. Once a prey is intercepted and stopped, retaining it long enough for the spider to reach it requires still other design properties, which trade off in complex ways against the first two functions ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#tab0301"
    }
  }, [_vm._v("table 3.1")]), _vm._v("). A further complication is that not all web functions are of equal importance.")]), _vm._v(" "), _c('p', [_vm._v("This chapter will focus on the design implications of the functions of orbs rather than non-orbs, for the simple reason that there are very few experimental studies of how other types of webs function; undoubtedly many of the same functions performed by orbs must also be performed by other web types, but their relative importances and trade-offs are probably quite different.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "sec03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02"
    }
  }, [_vm._v("3.2 Correcting common misconceptions about orb webs")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("To begin, it will be helpful to discard some common misconceptions about how orb webs function. I will start with relatively simple problems and progress to more difficult topics. The discussions here are incomplete; logical and empirical reasons for some omissions are given in appendices O3.1 and O3.2.")]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec03.02.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.01"
    }
  }, [_vm._v("3.2.1 Orbs are neither sieves nor sound detectors")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The analogy between an orb and a sieve or fishing net is common, but inappropriate (Sensenig et al. 2012). Firstly, the individual lines of nets and sieves are, in contrast with the lines in orbs, essentially unbreakable for the objects they are designed to retain. Secondly, some lines in orb webs are sticky. An orb can capture a small, "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "76",
      "id": "p76",
      "role": "doc-pagebreak"
    }
  }), _vm._v("weak prey that contacts only a single sticky line, while the net or sieve analogy leads to the mistaken idea that a prey can only be captured if its diameter is greater than the space between lines (e.g., Witt et al. 1968; Denny 1976; Riechert and Łuczak 1982; Watanabe 2000b; Aoyanagi and Okumura 2010; Cranford et al. 2012). In addition, different lines in an orb have different mechanical properties. A radius can absorb about ten times more kinetic energy than can a sticky spiral line in the same web (Denny 1976; Eberhard 1986a). Sticky spiral lines, in contrast, are more important in determining the web’s ability to adhere to the prey and thus retain it (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03"
    }
  }, [_vm._v("section 3.3.3")]), _vm._v("). The only possible exception to the non-sieve function that I know is the untested hypothesis (Blackledge et al. 2011; J. Coddington pers. comm.) that some small, very tightly meshed symphytognathoid orbs are designed to sieve pollen or fungal spores from the air. Several types of data, including the sites where webs are built, the general lack of abundance of pollen and fungal spores in the air, and the adhesion of these objects to single sticky lines (rather than by sieving) argue against the importance of sieving (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.02.14"
    }
  }, [_vm._v("section 3.2.14")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("A second old idea is that orbs might detect or convey acoustic signals from prey flying in the neighborhood. This hypothesis was seemingly put to rest by the combination of theoretical calculations of transmission properties and resonant frequencies (Frohlich and Buskirk 1982), and direct measurements that showed virtually no web movements in sound fields <60 db SPL (Finck et al. 1975). Prior to the prey making contact with her web, it is imaginable that the spider might sense the prey’s presence via sound-induced vibrations of the radii near the prey and respond by jerking that area of the web before the prey contacts the web, making it harder for the prey to avoid the web. But I know of no reports of such behavior, and high-speed video recordings showed that even the very rapid spider "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(" (TET) turned and jerked only after contact had occurred (Briceño and Eberhard 2011). Once contact is made, direct movements of web lines generated by movements of the prey will induce much higher amplitude movements of the lines than any sound that the prey makes.")]), _vm._v(" "), _c('p', [_vm._v("Interest in the sonic properties of webs was recently revived by Mortimer et al. (2014), who proposed that silk fibers are “tuned” to a resonant frequency that the spider uses, through “plucking” behavior, to locate both prey and structural damage. But this study concentrated on measuring responses in single lines rather than in intact webs, and thus did not take into account the important effects of damping and dissipation of energy by other lines connected to radii (Landolfa and Barth 1996). In addition, it misinterpreted a crucial behavior pattern. When a prey strikes the web, an orb weaving spider does not pluck lines like a guitar player plucking a string. Video recordings of "), _c('i', [_vm._v("L. mariana")]), _vm._v(" (TET) and "), _c('i', [_vm._v("Micrathena duodecimspinosa")]), _vm._v(" (AR) (which confirmed direct observations of these and other species), showed that instead the spider jerked lines sharply. The tarsi remained in contact with the lines (Briceño and Eberhard 2011; WE), thus damping vibrations in the line.")]), _vm._v(" "), _c('p', [_vm._v("Sensitivity to airborne sounds generally seems to result from direct stimulation of sense organs such as trichobothria on the spider’s body (Barth 2002), and to be used by orb weavers to avoid predators, rather than to capture prey (Frings and Frings 1966). In several derived groups, including deinopids, theridiosomatids, and bolas spiders, however, spiders apparently use airborne vibrations to trigger attacks on prey ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#ch09"
    }
  }, [_vm._v("chapter 9")]), _vm._v(").")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec03.02.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.02"
    }
  }, [_vm._v("3.2.2 Orb webs are not the pinacle of web evolution")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The sophisticated and subtle morphological and behavioral capabilities that spiders employ to build orbs have tempted arachnologists to conclude that orb webs are somehow the most highly evolved pinnacle of spider web evolution. It has also long been clear, however, that this idea is untenable: some lineages in orb-weaving families have evolved reduced webs or have discarded webs entirely ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0301"
    }
  }, [_vm._v("fig. 3.1")]), _vm._v("). Several other more recently documented cases of this sort include the theridiosomatid genus "), _c('i', [_vm._v("Wendilgarda")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#fig1029"
    }
  }, [_vm._v("fig. 10.29")]), _vm._v("; Coddington and Valerio 1980; Coddington 1986a), and the araneids "), _c('i', [_vm._v("Poecilopachys australasia")]), _vm._v(" (Clyne 1973), "), _c('i', [_vm._v("Pasilobus")]), _vm._v(" sp. (Robinson and Robinson 1975), "), _c('i', [_vm._v("Paraplectana tsushimensis")]), _vm._v(" (Chigira 1978) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#fig0923"
    }
  }, [_vm._v("fig. 9.23")]), _vm._v("), "), _c('i', [_vm._v("Ocrepeira ectypa")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#fig0902"
    }
  }, [_vm._v("fig. 9.2")]), _vm._v("), and "), _c('i', [_vm._v("Kaira alba")]), _vm._v(" (Stowe 1985, 1986).")]), _vm._v(" "), _c('p', [_vm._v("Recent fossil data have pushed the origin of orbs back in time (Vollrath and Selden 2007), and phylogenetic studies have substantially increased the numbers of descendant groups that appear to have lost orb webs (Blackledge et al. 2009c; Bond et al. 2014; Fernández et al. 2014; Garrison et al. 2016). These include not only "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "77",
      "id": "p77",
      "role": "doc-pagebreak"
    }
  }), _vm._v("orb-less members of orb weaving families (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0301"
    }
  }, [_vm._v("fig. 3.1")]), _vm._v("), but also a major fraction of all modern species that belong to numerous other families whose modern species lack orbs or even webs altogether. It now seems that orb web construction is an ancient (though still successful) adaptation, and that orbs have repeatedly proven inferior in different lineages, and have been replaced by other prey capture strategies.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0301"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "452",
      "src": "images/chi-eberhard-fig0301.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p77"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.1.")]), _vm._v(" These venerable cases of species descended from orb-weaving ancestors in which orb webs have been lost and replaced by non-orb web designs were all discovered more than 80 years ago. They indicate that the orb is not an “evolutionary pinnacle”; the excuse for the mistaken pinnacle idea ran out long ago. The new contribution from recent phylogeny studies (e.g., Bond et al. 2014; Fernández et al. 2014; Garrison et al. 2016), is not that orb webs have repeatedly been lost; rather it is that a greater number of non-orb and webless modern groups may be descended from orb-weaving ancestors than was formerly believed. The drawings, in which sticky lines are indicated by thicker wavy lines, are based on the following: "), _c('i', [_vm._v("Deinopis")]), _vm._v(" (Akerman 1923 and Coddington and Sobrevila 1987); "), _c('i', [_vm._v("Miagrammopes")]), _vm._v(" (Lubin et al. 1978); "), _c('i', [_vm._v("Polenecia producta")]), _vm._v(" (Wiehle 1931 and Peters 1995a); "), _c('i', [_vm._v("Hyptiotes")]), _vm._v(" (Comstock 1967; Wiehle 1927 and Marples and Marples 1937); and "), _c('i', [_vm._v("Mastophora dizzydeani")]), _vm._v(" (Hutchinson 1903; Eberhard 1980a) (in this species the sticky silk forms a mass at the tip of the line; the modified, flattened silk line is tightly folded in the drop of glue, and the sticky mass elongates spring-like when, as in this drawing, the spider swings it at a nearby moth).")])]), _vm._v(" "), _c('p', [_vm._v("Why would such beautiful, efficient, and effective traps have so often been disadvantageous? There are numerous possible explanations. In some groups the reduction was accompanied by a clear “compensatory” adaptation, including the chemical prey attractants of the bolas spiders "), _c('i', [_vm._v("Mastophora")]), _vm._v(", "), _c('i', [_vm._v("Celaenia")]), _vm._v(" (AR) and their allies, and "), _c('i', [_vm._v("Kaira")]), _vm._v(", or the ability to make the web collapse around a prey that strikes it in "), _c('i', [_vm._v("Hyptiotes")]), _vm._v(" and "), _c('i', [_vm._v("Deinopis")]), _vm._v(". In some "), _c('i', [_vm._v("Tetragnatha")]), _vm._v(" spp. (Crome 1954; Gillespie 1999; Blackledge and Gillespie 2004) and the araneid "), _c('i', [_vm._v("Chorizopes")]), _vm._v(" sp. (Eberhard 1983) the spiders use quick reactions or powerful weapons to attack their prey directly. Others, like the symphytognathid "), _c('i', [_vm._v("Curimagua bayano")]), _vm._v(" (Vollrath 1978) and the mysmenid "), _c('i', [_vm._v("Mysmenopsis tengellacompa")]), _vm._v(" (Eberhard et al. 1993; see also Lopardo et al. 2011) have abandoned orbs to parasitize other web-building spiders.")]), _vm._v(" "), _c('p', [_vm._v("I speculate that one important problem with orbs is that they are fragile, high cost structures. They are often in tatters only a few hours after they are built ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0319"
    }
  }, [_vm._v("fig. 3.19")]), _vm._v("), and most species build a new orb every day (and some regularly build three or four). While a spider generally reingests her silk when replacing an orb ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.05"
    }
  }, [_vm._v("section 2.5")]), _vm._v("), her recycling efficiency is only about 30% (Townley and Tillinghast 1988), so each renovation represents a substantial loss. In addition, construction behavior often involves considerable exertion. For instance, a mature female "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" (AR) sometimes walked more than 63 m (!) in the process of exploring a site and then building an orb (Zschokke 1996); on a human scale, building a typical orb would involve running on the order of 8 km in the space of about 30 min ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.01.01"
    }
  }, [_vm._v("section 7.1.1")]), _vm._v("). "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "78",
      "id": "p78",
      "role": "doc-pagebreak"
    }
  }), _vm._v("In contrast, many non-orb spiders in the field generally make only small repairs and additions to their webs each night ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#tab0501"
    }
  }, [_vm._v("table 5.1")]), _vm._v("). Probably because of an orb’s coherent, unitary design, the common non-orb tactic of adding small increments to the web over many successive nights is not feasible (though a few orb weavers have evolved “repairs” that have this result—"), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#sec06.03.08"
    }
  }, [_vm._v("section 6.3.8")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("Another limitation is that orb webs can capture only airborne prey. At least three groups that abandoned orbs for alternative designs, the theridiosomatid "), _c('i', [_vm._v("Wendilgarda")]), _vm._v(" spp. ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#fig1029"
    }
  }, [_vm._v("fig 10.29")]), _vm._v("; Coddington 1986a; Eberhard 1989a, 2001a), the araneid "), _c('i', [_vm._v("Ocrepeira ectypa")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#fig0902"
    }
  }, [_vm._v("fig. 9.2")]), _vm._v(", Stowe 1978, 1986), and the highly successful gumfoot webs of theridiids ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#fig0907"
    }
  }, [_vm._v("figs. 9.7")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#fig0922"
    }
  }, [_vm._v("9.22")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#fig1030"
    }
  }, [_vm._v("10.30")]), _vm._v("; Eberhard et al. 2008b), gained access to the rich array of walking or floating prey as a result.")]), _vm._v(" "), _c('p', [_vm._v("One further possible reason for abandoning orbs has hardly been explored—the development of defenses by insect prey against being captured by orbs (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0016#sec04.11"
    }
  }, [_vm._v("section 4.11")]), _vm._v("). For instance, "), _c('i', [_vm._v("Drosophila")]), _vm._v(" flies perform precise flight maneuvers in the near vicinity of orb webs (Craig 1986, 1988) that enable them to avoid being captured. Whether this kind of behavior is common, and whether it might have made orbs unprofitable in some contexts, remain to be determined.")]), _vm._v(" "), _c('p', [_vm._v("In sum, there has clearly been “life after the orb” for spiders. Orb web construction is more stereotyped and complex in some respects than the construction behavior used to build many other types of webs; but this did not mean that orb weavers always outperformed other spiders that utilized different predatory tactics.")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec03.02.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.03"
    }
  }, [_vm._v("3.2.3 Orbs have never been demonstrated to be “optimum” structures")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Optimality in a structure that performs multiple functions is determined by the trade-offs among the different functions. There is a general consensus (Witt 1965; Chacón and Eberhard 1980; Eberhard 1986a; Craig 1987a, 2003; Bond and Opell 1998; Blackledge et al. 2011) that an orb web must perform several tasks: 1) it must be large enough to extend into the insect’s flight path; 2) the insect must fail to sense and avoid it; 3) the biomechanical properties of its lines and the connections between them must be strong enough to absorb the insect’s momentum on impact, stopping it without rupturing; 4) it must retain the prey long enough for the spider to arrive to attack; 5) the web lines must have survived previous stresses more or less intact, resisting or adjusting to both localized stresses that resulted from previous impacts of prey and detritus, and to generalized stresses resulting from wind and from movements of the objects to which the web is attached; and 6) the lines must provide a path for both the vibrations that will be transmitted from the prey to the spider and for the spider herself as she moves to attack the prey.")]), _vm._v(" "), _c('p', [_vm._v("Not only are there many functions and trade-offs between different orb web functions, there are many design features that can affect these tradeoffs ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#tab0301"
    }
  }, [_vm._v("table 3.1")]), _vm._v(" gives seven candidates). There are also “fabricational constraints” imposed by both geometry (Coddington 1986b; Zschokke 2002) and the biomechanical properties of the lines of a given type (which are not constant inter-specifically, intra-specifically, or even in some cases within a single orb; see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.09"
    }
  }, [_vm._v("section 3.2.9")]), _vm._v("). Clearly, there is a veritable minefield of variables that can affect the chances that a web will capture a prey. The selective regimes under which spider web designs have evolved are probably very complex.")]), _vm._v(" "), _c('p', [_vm._v("This complexity means that actually demonstrating that a given design is optimal for a particular species is very difficult. Nevertheless it is common to see statements claiming optimal designs for orbs, even in recent papers: “Spider webs . . . are characterized by a highly organized geometry that optimizes their function” (Cranford et al. 2012; p. 72); or “Orb web spiders, which rely on their webs being optimized for particular conditions,” (Harmer and Herberstein 2009; p. 499); “Thus, a suite of bio-mechanical traits interact with web spinning behaviors in optimizing orb web function” (Blackledge et al. 2012a; p. 4). I believe that claims regarding optimality are not well founded, and that optimality has never been demonstrated empirically in any species. Although I was formerly an enthusiastic participant in speculations about optimal orb designs (Eberhard 1986a), I am not not sure that convincing tests are even feasible. In order not to get bogged down in details but nevertheless discuss studies of this sort fairly, I have relegated most of this critical discussion to appendices O3.1 and O3.2. In short, I believe that different lines in an orb serve so many different functions, and that accomplishing the different functions so often involves multiple trade-offs ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#tab0301"
    }
  }, [_vm._v("table 3.1")]), _vm._v("), that it is extremely difficult to determine exactly "), _c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p80"
    }
  }), _vm._v("which design would be optimum under any given set of conditions.")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "tab0301"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "79",
      "id": "p79",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "thn"
  }, [_vm._v("Table 3.1.")]), _vm._v(" The basic lesson from this undoubtedly incomplete list of the possible trade-offs between advantages and disadvantages of alternative orb web designs and tensions on web lines is that the consequences of building orb webs with different designs is a complex tangle (see also Miyashita 1997; Blackledge and Eliason 2007). The trade-offs are based on the supposition that a spider has a fixed amount of resources (material and energy) that she can invest; they thus underestimate the array of possibilities if the sizes of silk glands relative to body size change over evolutionary time. The advantages and disadvantages marked with “+” are likely to be accentuated for “high energy” prey (that are larger or move more rapidly), many of which will be of greater nutritional value.")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Advantages")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Disadvantages")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Larger sticky spiral spacing (thus greater capture area)")])]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Increased interception (larger areas)")]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Increased interception (web less easily perceived by prey)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("+ Reduced ability to stop and retain prey")]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Reduced ability to survive environmental stresses such as wind"), _c('sup', [_vm._v("1")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Horizontal (rather than vertical)")])]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Less energy expended in construction")]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Reduce loading by wind"), _c('sup', [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("More rapid attack"), _c('sup', [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Greater portion of web can be close to some prey-rich horizontal habitat (e.g., surface of water)"), _c('sup', [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Less distortion of web by spider’s weight while building (more precise positions of lines)")]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Increased stopping and stability (more equitable distribution of the spider’s weight on radii)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Reduced interception"), _c('sup', [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("+ Reduced retention (prey encounter fewer lines as they struggle and fall free from the impact site)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Thinner lines")])]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Increased interception (larger area covered) and/or improved retention (+greater density of lines)")]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Increased interception (web less visible for prey)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("+ Reduced ability to stop and retain prey")]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Reduced ability to survive environmental stresses (e.g., wind)")]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Reduced ability to support spider")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Greater amount adhesive on sticky lines")])]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("+ Increased retention time")]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Increase prey attraction to “sparkly” droplets"), _c('sup', [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Decrease dehydration (and loss of stickiness) in wind"), _c('sup', [_vm._v("7")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Reduced sticky line length reduces numbers of prey intercepted")]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Web easier for prey to perceive")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Tighter web")])]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Increased stability (survive in wind because web flaps less)")]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Less distorted by spider’s weight during construction (more precise positions of lines)"), _c('sup', [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Improved transmission of vibrations"), _c('sup', [_vm._v("10")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("+ Reduced ability to stop and retain prey"), _c('sup', [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Reduced interception (?) (less web movement in light wind"), _c('sup', [_vm._v("9")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("More radii")])]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("+ Increased stopping")]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Increased stability (resist environmental stress such as wind)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Reduced interception (web smaller)")]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("Reduced interception (web more easily perceived visually by prey"), _c('sup', [_vm._v("11")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Nearer to approximately vertical substrate")])]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("More difficult for prey to perceive web")]), _vm._v(" "), _c('p', {
    staticClass: "td"
  }, [_vm._v("+ Increased stopping because of lower prey velocities")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Fewer interceptions (probably most prey arrive from one side)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "tn"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "80",
      "id": "p80",
      "role": "doc-pagebreak"
    }
  }), _c('sup', [_vm._v("1")]), _vm._v(" Judging by the facultative adjustments of "), _c('i', [_vm._v("Cyclosa mulmeinensis")]), _vm._v(" (AR) to windy conditions (Liao et al. 2009; Wu et al. 2013), wind damage will be reduced by larger spaces between sticky spiral loops, but increased by larger web size and longer total sticky spiral length.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("2")]), _vm._v(" This prediction assumes mostly horizontal flight paths of prey. This trend in flight paths is surprisingly uncertain, as horizontally oriented sticky traps did not consistently capture fewer prey (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.04"
    }
  }, [_vm._v("section 3.2.4")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("3")]), _vm._v(" Assumes wind direction is predominantly horizontal.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("4")]), _vm._v(" This is expected at least comparing prey impacts to the side of and above the spider in vertical orbs.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("5")]), _vm._v(" Greater prey concentration just above the surface of streams was documented by Buskirk (1975) near stream surfaces in Costa Rica for "), _c('i', [_vm._v("Metabus ocellatus")]), _vm._v("; a similar trend was clear in artificial traps hung just above a stream near Cali, Colombia (el. 1050 m) (WE). Importance of the ability to place horizontal orbs closer to the ground is implied by the vertical distribution of horizontal and vertical webs in the araneid "), _c('i', [_vm._v("Paraneus cyrtoscapus")]), _vm._v(" (Edmunds 1978). Contrary advantages of vertical orbs would be placing them closer to more or less planar vertical substrates such as tree trunks.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("6")]), _vm._v(" Only a single species of prey (a stingless bee) was tested for attraction to the sticky spiral “sparkle” (Craig and Freeman 1991).")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("7")]), _vm._v(" "), _c('i', [_vm._v("Cyclosa mulmeinensis")]), _vm._v(" (AR) facultatively increased droplet size in windy conditions (Wu et al. 2013), but this in turn would deplete the spider of sticky silk more rapidly.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("8")]), _vm._v(" The hypothesis that lower tension increases prey retention is supported by the independently evolved active reduction of web tension by several spiders when prey hit their webs ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.04.02"
    }
  }, [_vm._v("section 4.4.2")]), _vm._v("). For a discussion of the physics involved, see Craig 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("9")]), _vm._v(" This prediction is based on the hypothesis that irregular movements of an orb web in the wind increase its prey interception (the “encounter model” of Craig 1986 that is discussed in detail in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.11.03"
    }
  }, [_vm._v("section 3.2.11.3")]), _vm._v("; this hypothesis is likely to apply in some circumstances but not others).")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("10")]), _vm._v(" This is surely true in the extreme case: slack lines scarcely transmitted the longitudinal vibrations that were transmitted by lines under tension and that are used by spiders (see Landolfa and Barth 1996).")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("11")]), _vm._v(" Craig and Freeman (1991) state that the sticky spiral is largely responsible for determining an orb’s visibility; but, at least to the human eye, the glint of some radii that are illuminated at an appropriate angle is also visible.")])])])])])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec03.02.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.04"
    }
  }, [_vm._v("3.2.4 The trajectories, diameters, and velocities of prey are diverse and poorly known")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Many models and tests of how webs function mechanically to capture prey (e.g., Craig et al. 1985; Eberhard 1986a; Craig 1987a; Aoyanagi and Okumura 2010; Sensenig et al. 2010a; Cranford et al. 2012; Zaera et al. 2014) assume that prey strike orbs at 90° to the plane of the orb. The idea that theridiosomatids derive an advantage over planar orbs from pulling their orbs into cones because it makes them more difficult for prey to see because all parts of the orb are not in focus at once (Craig 1986) also assumes perpendicular encounters. But prey probably only occasionally strike an orb while moving perpendicular to its plane. Striking an orb at an angle of less than 90° will tend to reduce the effective spaces between lines, especially between sticky spiral lines. It will also alter the patterns of stress on radial, hub, and frame lines in ways that are not contemplated by some models. Some prey appear to sense orbs at a distance and attempt to evade them ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0302"
    }
  }, [_vm._v("fig. 3.2")]), _vm._v("), reducing their velocities and perhaps changing their angles of impact. The angle of impact with the orb’s plane could have important consequences for interception ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.01"
    }
  }, [_vm._v("section 3.3.1")]), _vm._v("), stopping ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.01"
    }
  }, [_vm._v("section 3.3.2.1")]), _vm._v("), and retention ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.01"
    }
  }, [_vm._v("section 3.3.3.1")]), _vm._v("), and the trade-offs in these functions ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#tab0301"
    }
  }, [_vm._v("table 3.1")]), _vm._v("). For instance, an orb could be less likely to intercept prey with flight angles oblique to the web plane, but better able to stop and retain them.")]), _vm._v(" "), _c('p', [_vm._v("A further complication is that “the” diameter of the prey, and thus the number of lines that it can be expected to contact, will be influenced not only by its general body shape at rest, but also by the positions of its legs, antennae, and wings while it flies, and also its flight path (Craig 2003). An insect flying in a straight line has a smaller effective diameter than one flying erratically in a bobbing path (such as, for example, that of many crane flies and mecopterans—Craig 2003; Blackledge and Zevenbergen 2006). Direct observations of the slow, hovering flight of some familiar insects reveals that some, perhaps many species extend their legs in flight. The legs of the paper wasps "), _c('i', [_vm._v("Polistes")]), _vm._v(" spp. and the honey bee "), _c('i', [_vm._v("Apis mellifera")]), _vm._v(" dangle ventrally; the legs of "), _c('i', [_vm._v("Panorpa")]), _vm._v(" scorpion flies and of several groups of nematoceran flies are spread, with legs I projecting anteriorly and legs III laterally and posteriorly (Blackledge and Zevenbergen 2006; WE). High-speed photography (see for instance, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.andresmorya.photoshelter.com/",
      "target": "_blank"
    }
  }, [_vm._v("andresmorya.photoshelter.com/")]), _vm._v(") reveals similar spread and extended positions in orthopterans, flies, and lacewings. The antennae of many of these insects are long and are extended during flight. In addition, some prey "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "81",
      "id": "p81",
      "role": "doc-pagebreak"
    }
  }), _vm._v("may alter their flight direction just as they reach an orb, altering the areas of their bodies that contact the web. The positions of a flying insect’s legs and antennae could have large effects on whether it was stopped by an orb and how long it was retained. In general terms, it appears that it is easier for an insect to free itself of sticky lines that adhere to its legs than to its body, and to distal rather than proximal portions of its legs (Suter 1978; Blackledge and Zevenbergen 2006).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0302"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-eberhard-fig0302.jpeg",
      "width": "470"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p81"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.2.")]), _vm._v(" The flight paths (arrows) of four "), _c('i', [_vm._v("Drosophila melanogaster")]), _vm._v(" flies as they approached a web line of "), _c('i', [_vm._v("Theridiosoma gibbosa")]), _vm._v(" (TSM) (dots) show how three of the four turned away sharply just before contacting the line; the fourth ("), _c('i', [_vm._v("b")]), _vm._v(") touched the web but did not adhere strongly, and then also moved rapidly away (after Craig 1986). These paths have potentially important implications for understanding how orb webs function. At least for prey such as these flies that have slow, hovering flight patterns, the assumption in some attempts to model orb web function that prey have high speed, linear trajectories (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#fig0323"
    }
  }, [_vm._v("fig. 3.23")]), _vm._v(") may be misleading. And, perhaps more seriously, attempts to quantify those prey that are truly available to spiders in nature by employing artificial traps (e.g., adhesive sheets, sampling insects in the air with suction devices) are imprecise ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.05.04"
    }
  }, [_vm._v("sections 3.2.5.4")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.09.02"
    }
  }, [_vm._v("8.9.2")]), _vm._v(", appendix O3.2.3).")])]), _vm._v(" "), _c('p', [_vm._v("The important point is that insects often extend their appendages during flight, and the details probably vary widely among species. Combining this variation with the effects of different velocities and angles of impact, ignorance regarding differences in the magnitudes of the effects on different species (especially in view of the possibility that only a small fraction of prey are crucial to determining the spider’s reproductive success—Venner and Casas 2005; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.02.02"
    }
  }, [_vm._v("section 4.2.2")]), _vm._v("), and our current ignorance of the shapes and the slopes of curves describing the effects of these variables on spider nutrition, makes even moderately precise modeling of the effects of different orb designs on prey capture extremely difficult ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.03"
    }
  }, [_vm._v("sections 3.2.3")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.15"
    }
  }, [_vm._v("7.15")]), _vm._v("). Parenthetically, understanding species that build orbs against tree trunks and across single curled leaves ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0403"
    }
  }, [_vm._v("figs. 4.3")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#fig0334"
    }
  }, [_vm._v("3.34d,e")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#fig0917"
    }
  }, [_vm._v("9.17a")]), _vm._v(") may be simpler, because impacts should tend to be slower and closer to 90°.")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec03.02.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.05"
    }
  }, [_vm._v("3.2.5 Most differences in orb designs are probably not specializations for particular prey")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("A glance at the figures in this book will show that spider orb webs differ in many design aspects, including the numbers and patterns of the spacing of sticky spiral loops and radii, the relative sizes of hubs, deviations from symmetry, and the numbers and relative lengths of frame and anchor lines. Different orb web designs are often said to represent specializations to capture different prey; statements to this effect (among many others) have been made by Łuczak (1970), Uetz et al. (1978), Chacón and Eberhard (1980), Olive (1980), Eberhard (1986), Stowe (1986), Craig (1987a), Uetz and Hartsock (1987), Opell (1997), Blackledge and Zevenbergen 2006, Gregorič et al. (2010), and Blackledge et al. (2003, 2011). Prey specialization offers an appealing explanation for the diversity of different orb designs, especially if designs have evolved as adaptations to avoid competition for prey with closely related species ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.06"
    }
  }, [_vm._v("section 3.2.6")]), _vm._v("). I will argue here, however, that current data are not sufficient to support typical prey specialization arguments.")]), _vm._v(" "), _c('p', [_vm._v("The word “specialized” can be interpreted for an orb in different ways. At one, inclusive extreme, the term implies only that the orb’s design imposes a non-random bias in the subsample of all of the potential prey present in a given habitat that a web captures. That webs have such general biases is undeniable: aerial webs tend to capture flying or jumping prey, while substrate or gumfoot webs tend to capture walking prey; neither type ever captures eagles, cladocerans, or amoebae. At the opposite, “strict” extreme, specialization implies much stronger biases. Closely related spider species could, due to relatively small design differences in their orbs, capture different arrays of prey in the same environment. "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "82",
      "id": "p82",
      "role": "doc-pagebreak"
    }
  }), _vm._v("There is obviously a continuum of intermediate interpretations of the word “specialized,” and interpretations undoubtedly varied among the authors I just cited. I suspect, however, that many of them used the word in a relatively strict rather than relaxed sense (I know that I did). I will discuss this more strict sense here because of its important implications regarding the evolutionary diversification of web designs (see appendix O3.2 for further discussion).")]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.05.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.05.01"
    }
  }, [_vm._v("3.2.5.1 Long lists of prey captured seem to argue against strong specialization")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("One serious problem for the prey specialization hypothesis is that the lists of prey that are captured by orb weavers typically include many different types of insects (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#tab0302"
    }
  }, [_vm._v("table 3.2")]), _vm._v("; Robinson and Robinson 1970b, 1973a; Nentwig 1985b; Higgins and Buskirk 1992; Blackledge and Wenzel 1999; Venner and Casas 2005; Calixto and Levi 2006). Aerial non-orb webs such as linyphiid sheet webs also captured long lists of diverse prey species (Turnbull 1960; Herberstein 1997a). It is of course true that occasional strays will show up if the sample is large enough (e.g., walking prey like worker ants or mites are occasionally captured in aerial webs), so simple lists of prey species can be misleading. Nevertheless, from the perspective of a spider, the longer the list of prey, the smaller the selective importance of capturing any given species of prey. Although prey lists often have several weaknesses (below), the typically large variety of prey observed ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#tab0302"
    }
  }, [_vm._v("table 3.2")]), _vm._v(") speaks against prey specialization.")]), _vm._v(" "), _c('p', [_vm._v("One comparative study (Craig 1987a) found patterns in prey capture that matched differences in orb designs in five species in a tropical forest understory; the two species with denser, more radius-rich orbs captured prey that were estimated (indirectly) to be heavier and to have higher impact energies. This association with differences in orb design per se, however, is uncertain because the same two species with “high-energy” webs are larger than the others, and thus produce thicker lines (Craig 1987a). The spiders’ biases with respect to higher-energy prey may thus have been due to their own sizes (or to differences in subhabitats where their webs were built—next section).")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.05.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.05.02"
    }
  }, [_vm._v("3.2.5.2 Strong habitat effects")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("More tellingly for the prey specialization hypothesis, the habitat of a web rather than its design seems to have special importance in determining which prey it captures. Thus, spiders with similar web designs but in different habitats captured widely different arrays of prey (e.g., the summary in Eberhard 1990a on ten studies of "), _c('i', [_vm._v("Argiope")]), _vm._v(" spp.). And species with quite different web designs (orb webs, tangles with gumfoot lines, funnel webs, and lampshade webs) that were built in the same habitat captured surprisingly similar arrays of prey ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0303"
    }
  }, [_vm._v("fig. 3.3")]), _vm._v(", Riechert and Cady 1983; see also Wise and Barata 1983). Both Riechert and Łuczak (1982) and Wise and Barata (1983) concluded, from their own data and reviews of other studies, that differences between microhabitats influence prey captures more than differences in web structure.")]), _vm._v(" "), _c('p', [_vm._v("These conclusions must be treated cautiously. Some differences did exist between web types ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0303"
    }
  }, [_vm._v("fig. 3.3")]), _vm._v("); prey identities were poorly resolved (generally only to order); and prey numbers were not adjusted for the undoubtedly different nutritional values of prey with different weights (e.g., Venner and Casas 2005; Blackledge 2011) and taxa (Toft 2013) (see next section). But it is also true that the relative uniformity occurred even though there were probably differences in details of the subhabitats where the different web types were built. In sum, the lesson is not that there were no differences between web types, but that the differences were less than might have been expected. The relative uniformity in prey captured by these very different web types reduces the expectation that minor changes in orb design, such as the number of sticky spiral loops or the number of radii, will have substantial impacts on which prey are captured.")]), _vm._v(" "), _c('p', [_vm._v("The study of Yamanoi and Miyashita (2005) on two sympatric araneids, "), _c('i', [_vm._v("Neoscona punctigera")]), _vm._v(" and "), _c('i', [_vm._v("N. mellotteei")]), _vm._v(", which build unremarkable orbs with only moderate structural differences in the same general habitat, is especially appropriate for the question of prey specialization. They found a trend for the two species to capture different prey (in this case, the fraction of weevils, elaterid, and carabid beetles as opposed to other insects). I believe, however, that even their data are open to alternative interpretations. The two spider species were said to inhabit the same microhabitat, but this similarity was measured only in terms of percent plant cover and "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "84",
      "id": "p84",
      "role": "doc-pagebreak"
    }
  }), _vm._v("web height, and several other aspects of their habitats that could have been important may have differed between the two species (e.g., species of plants, living vs. dead plants, the sizes of the open spaces in which webs were built). Their samples were also not large.")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "tab0302"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th",
    attrs: {
      "colspan": "5"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "83",
      "id": "p83",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "thn"
  }, [_vm._v("Table 3.2.")]), _vm._v(" This small, incomplete sample of studies of the prey captured by species that build non-orb and orb webs illustrates the wide diversity of prey types that are typically captured by any given type of web (see Blackledge 2011 for many other studies of orbs).")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Taxa")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Web type")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Range of prey")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Most common prey")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Reference")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Hypochilidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Hypochilus thorelli")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Substrate with lampshade sheet")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("7 insect orders, spiders, myriapods, opiliones")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Spiders")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Riechert and Cady 1983")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Filistatidae")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Pritha nana")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Substrate")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("13 orders")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Nematocera")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Nentwig 1982b")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Theridiidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Theridion evexum")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Aerial tangle")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("7 insect orders, centipedes")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("(not specified)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Barrantes and Weng 2007b")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Parasteatoda tepidariorum")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Gumfoot")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("7 insect orders, spiders, myriapods, opiliones"), _c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Coleopters, spiders"), _c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Riechert and Cady 1983")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Achaearanea globispira")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Gumfoot")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Mostly ants")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("96% ants")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Henschel and Jocqué 1994")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Agelenidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Coelotes montanus")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Funnel")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("6 insect orders, spiders, myriapods, opiliones1")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Lepidoptera, Diptera"), _c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Riechert and Cady 1983")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Pisauridae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Hygropoda dolomedes")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Sheet")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("9 insect orders, spiders")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Diptera")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Cerveira and Jackson 2002")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Dendrolycosa")]), _vm._v(" sp.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Sheet")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("9 insect orders, spiders")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Diptera")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Cerveira and Jackson 2002")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Araneidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Araneus cavaticus")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("6 insect orders"), _c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Diptera"), _c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Riechert and Cady 1983")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Argiope argentata")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8 insect orders")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orthoptera")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Robinson and Robinson 1970b")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Micrathena gracilis")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("4 insect orders")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Diptera")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Uetz and Hartsock 1987")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Nephilidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Nephila pilipes")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8 insect orders")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Coleoptera, Lepidoptera")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Robinson and Robinson 1973a")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("N. edulis")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("3 insect orders")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("90% leafhoppers"), _c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Austin and Anderson 1978")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Tetragnathidae")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Leucauge globosa")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("(not given)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Cecidomyid flies"), _c('sup', [_vm._v("3")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Craig 1987b")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Theridiosomatidae")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Epilineutes")]), _vm._v(" sp.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("(not given)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Cecidomyid flies")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Craig 1987b")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("1")]), _vm._v(" All prey were captured in the same overhanging rock ledge habitat.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("2")]), _vm._v(" The mix of prey was determined by checking stabilimenta (strings of dead prey hung near the hub). The possibility that this sample was biased by a preference by spiders to put certain types of prey in the stabilimentum was not checked.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("3")]), _vm._v(" Prey importance was determined from supposed relative abundance in the habitat, rather than from data on prey captured, and thus is not compelling.")])])])])]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0303"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "332",
      "src": "images/chi-eberhard-fig0303.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p84"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.3.")]), _vm._v(" The prey captured in the same habitat (rocky ledges) by four spider species that had very different web designs (an orb in "), _c('i', [_vm._v("Araneus")]), _vm._v(", an approximately cylindrical sticky lampshade attached to the substrate in "), _c('i', [_vm._v("Hypochilus")]), _vm._v(", a dense planar sheet in "), _c('i', [_vm._v("Coelotes")]), _vm._v(", and an aerial tangle with gumfoot lines in "), _c('i', [_vm._v("Achaearanea")]), _vm._v(") were nevertheless surprisingly similar. The overlaps in prey are illustrated in two ways: a principal components analysis ("), _c('i', [_vm._v("a")]), _vm._v("); and the relative proportions of different prey taxa ("), _c('i', [_vm._v("b")]), _vm._v(") (prey were identified only to Order) (from Riechert and Cady 1983).")])]), _vm._v(" "), _c('p', [_vm._v("This is not to say that important biases in the lists of prey captured by orb weavers do not occur. For instance, both "), _c('i', [_vm._v("Metabus ocellatus")]), _vm._v(" (Buskirk 1975) and "), _c('i', [_vm._v("Metleucauge")]), _vm._v(" spp. (Yoshida 1989) built their orbs just above the surfaces of streams, and captured mainly midges, mayflies, plecopterans, and other weak-flying insects that are associated with water. The orbs of "), _c('i', [_vm._v("M. ocellatus")]), _vm._v(" have relatively widely spaced sticky spiral lines, especially near the outer edge of the web), and only moderate numbers of radii and sticky spiral loops ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#fig0743"
    }
  }, [_vm._v("fig. 7.43")]), _vm._v("). These design details are appropriate for capturing slow, weak-flying, light bodied insects (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.02.01"
    }
  }, [_vm._v("sections 3.3.2.1")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.01"
    }
  }, [_vm._v("3.3.3.1")]), _vm._v("). But it is difficult to disentangle the effects of web designs from those of their websites.")]), _vm._v(" "), _c('p', [_vm._v("In sum, field data on the prey captured by different orb designs generally include large numbers of prey types, and show strong associations with differences between habitats, arguing against relatively strict prey specialization. Prey specialization resulting from small design details has not not been demonstrated convincingly, despite many confident statements that it occurs. Additional studies might help resolve these questions. For instance, spiders with different web designs that were induced to build webs in moveable supports (e.g., wooden or wire frames) (as was done with portions of webs by Miyashita and Shinkai 1995 and Opell et al. 2006) could be moved experimentally in the field, allowing interchanges of web types between exactly the same sites.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.05.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.05.03"
    }
  }, [_vm._v("3.2.5.3 Data from prey counts generally have serious flaws")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("It is not easy to determine the significance of the prey lists that were just cited for the evolution of different web designs, because it is often difficult to translate counts of prey (the most common type of data) to more biologically relevant variables such as nutrition for the spider. One major problem concerns prey weight, which varies enormously and surely has important effects on nutrition (e.g., Tso and Severinghaus 1998; Venner and Casas 2005; Blackledge 2011; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.05.03"
    }
  }, [_vm._v("sections 3.2.5.3")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.02.02"
    }
  }, [_vm._v("4.2.2")]), _vm._v(", appendix O3.2.3). A second major problem is that the nutritional values of prey vary substantially even after prey weight has been taken into account; a spider can even lose rather than gain weight from feeding on some kinds of prey (Toft 2013); spiders can starve in spite of an apparent abundance of prey, just as herbivores can starve in a green world (Toft and Wise 1999a,b; Toft 2013). This consideration may be important, as web spiders in nature rejected some prey they captured (e.g., Turnbull 1960 on "), _c('i', [_vm._v("Linyphia triangularis")]), _vm._v("; Robinson and Robinson 1973a on "), _c('i', [_vm._v("Nephila pilipes")]), _vm._v("). The overall conclusion is that the diversity of the prey species that are most responsible for a spider’s growth and reproduction is probably generally less than that suggested by prey lists.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "85",
      "id": "p85",
      "role": "doc-pagebreak"
    }
  }), _vm._v("One recent proposal (Sensenig et al. 2011; Blackledge 2011; Evans 2013) that was based on nutritional considerations linked to prey size, is that orb weavers are generally selected to capture the largest prey available because these prey represent disproportionately large nutritional payoffs (Venner and Casas 2005). In effect, the idea is that orbs in general are specialized to capture high-energy prey, and that the capture of many other, smaller prey is incidental and of little selective importance. This “large rare prey” hypothesis may be true in specific cases, but there is evidence against its generality ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.02.02"
    }
  }, [_vm._v("section 4.2.2")]), _vm._v("; Eberhard 2013a).")]), _vm._v(" "), _c('p', [_vm._v("One further complication is the possibility that the most important selection on orb designs does not involve the usual, day-to-day captures of prey, but rather the very occasional but nevertheless crucial, life-altering captures of one or a few very large prey; these could determine whether the spider will survive, or will be able to reproduce (e.g., Venner and Casas 2005; Blackledge 2011; Evans 2013). This would imply that nearly all of the many insects that are routinely counted in field studies are, in fact, only incidental by-products of web designs that were favored not by selection to capture these prey, but by selection to capture a few, rare, life-altering prey. The impression of generality derived from the day-to-day counts could thus be a unreliable guide to the selection that has molded these web designs.")]), _vm._v(" "), _c('p', [_vm._v("This rare, life-altering prey hypothesis for selection on orb designs was shown to be feasible in a modeling study (Evans 2013). Finding that something is feasible, however, is not equivalent to showing that it exists in nature. Several important simplifications and assumptions were made in the model, so it is not clear whether its results provide a reliable guide regarding what happens in nature. Unfortunately, the lower the frequency of the presumed crucial, life-altering events, the more difficult it is to empirically test whether they actually occur. The need for data to be from natural, unaltered habitats in which spiders evolved (rather than anthropogenic habitats) makes testing even more difficult. Empirical proof for the life-altering prey hypothesis is lacking; my own intuitive bias is to be guided by the data showing that orb weavers capture wide varieties of prey, but I have no confident, final solution.")]), _vm._v(" "), _c('p', [_vm._v("In sum, these problems with prey counts shake my confidence in drawing confident conclusions from the large majority of studies of the prey of web spiders. One general lesson is that the apparent ease with which biologically relevant and precise quantification of spider feeding can be obtained in the field by checking spiders and their webs may be an illusion. The sizes, qualities, and numbers of different prey are important, and these variables require additional data that are difficult to obtain and generally unavailable. In the end, the available data do not allow confidence in either accepting or rejecting general conclusions regarding the consequences of different details of orb designs for prey specialization.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.05.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.05.04"
    }
  }, [_vm._v("3.2.5.4 Measuring “available” prey is also difficult")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Another way to check for prey specialization is to compare the prey captured in webs with representative samples of the prey that are available in the spider’s habitat. At first glance this would seem relatively easy to accomplish by simply obtaining a reference sample of the prey that are in the air at a web’s site using sticky traps, vacuum samples of the air column, etc. This has given rise to a large literature, but, as discussed in detail in appendix O3.2, “available” is a very slippery concept; it is technically difficult to distinguish prey that are “available” in biologically appropriate sense. I believe all of the many published data of this sort are seriously flawed. The basic problem, discussed in a preliminary way here (see also "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.09.02"
    }
  }, [_vm._v("section 8.9.2")]), _vm._v(" and appendix O3.2.3), is that all known sampling methods take only biased samples of the prey that are present, that both spiders and their orbs are also biased, and these biases are seldom (if ever) the same (Castillo and Eberhard 1983; Eberhard 1990a). Some biases could be overcome if, as occurred in a study of social "), _c('i', [_vm._v("Anelosimus")]), _vm._v(" (THD), multiple sampling techniques were used and all the techniques showed the same trends (Guevara and Avilés 2007) (and even here, prey were lumped into such general categories that differences in both numbers and quality could be obscured). I know of no conclusive studies for different orb designs, and see little hope of precise quantification of specialization via comparisons with available prey.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.05.05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.05.05"
    }
  }, [_vm._v("3.2.5.5 Ontogenetic changes in web design (and lack of such changes) can introduce noise")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Ontogenetic changes (and lack of changes) present further questions regarding strict prey specialization. The prey that an individual orb-weaver captures during her "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "86",
      "id": "p86",
      "role": "doc-pagebreak"
    }
  }), _vm._v("lifetime undoubtedly change dramatically; but in general, these changes are accompanied by only relatively minor changes in web design. Individual orb weavers generally increase in weight by 1.5–2 orders of magnitude; in a giant species like "), _c('i', [_vm._v("Nephila")]), _vm._v(" spp. the change spans >3 orders of magnitude (Babu 1973; Quesada et al. 2011). It is simply physically impossible for a recently emerged spiderling to subdue the same prey that are used by adult conspecifics; and conversely, prey captured by small spiderlings are surely too small to be nutritionally significant for an adult. The sizes of webs and the diameters of their lines increase with the spider’s size (Le Guelte 1966; Craig 1987a,b; Blackledge et al. 2009c), but the changes in the designs of orbs often appear to be relatively minor. The orbs of first and second instar "), _c('i', [_vm._v("Argiope bruennichi")]), _vm._v(" (AR) averaged 22.0 radii, while those of adult females averaged 29.4 (Tilquin 1942), while "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" (AR) showed a trend in the opposite direction, from an average 36.6 to 29.4 radii (Witt et al. 1968); but the basic designs in both species changed little. For instance, the orb of a spiderling of "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" (NE) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0105"
    }
  }, [_vm._v("fig. 1.5")]), _vm._v(") has many of the same design features of an adult web ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0404"
    }
  }, [_vm._v("fig. 4.4")]), _vm._v("), including a tangle next to the orb, tertiary radii that are held nearly parallel to each other, intact temporary spiral lines, tight and relatively uniform spacing of the sticky spiral, and strong vertical asymmetry ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0105"
    }
  }, [_vm._v("fig. 1.5")]), _vm._v("). The designs of the orbs of early instar "), _c('i', [_vm._v("Zygiella x-notata")]), _vm._v(" (Le Guelte 1966), "), _c('i', [_vm._v("Allocyclosa bifurca")]), _vm._v(" (AR) (Eberhard 2007b; WE), and "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(" (TET) (Maroto 1981) were also similar in many respects (though not identical) to those of adults.")]), _vm._v(" "), _c('p', [_vm._v("While further studies of web ontogeny are needed, it is surely true that ontogenetic changes do occur in all orbs, if nothing else in the diameters of the fibers in the lines (Craig 1987a). The physiological demands on spiderlings probably also differ from those on adults, including greater problems with water loss due to their higher surface-to-volume ratios, and a greater need for energy due their disproportionately large nervous systems (Quesada et al. 2011; Eberhard and Wcislo 2011). Ontogenetic changes also occur in silk. In "), _c('i', [_vm._v("Neoscona arabesca")]), _vm._v(" (AR), silk investment increased isometrically with body size, but glue production was greater than expected in larger spiders, and the strength and toughness of sticky capture spiral thread increased during ontogeny (Sensenig et al. 2011). Larger spiders spun larger webs with smaller radii; but the increased volume of all silk types and the greater toughness of the capture spiral silk resulted in an isometric scaling of stopping potential. The material properties of dragline silk did not change over ontogeny.")]), _vm._v(" "), _c('p', [_vm._v("This topic is worthy of mention even in the absence of some crucial data, because some lifetime consistencies in web designs seem to be so clear. At a given site, it is often possible to confidently identify the webs of young spiderlings of many species, using their similar “overall design” to those of adults. Perhaps the major contribution I can make at the moment is to emphasize the neglected topic of the webs of immature spiders (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.02.14"
    }
  }, [_vm._v("section 3.2.14")]), _vm._v(").")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.05.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.05.06"
    }
  }, [_vm._v("3.2.5.6 Ecological settings of studies need to be evolutionarily realistic")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Looming behind attempts to study the prey specificity of spider webs is the probability that the conditions in most modern-day ecological settings differ from those under which the spiders and their webs evolved. This problem of “ecological realism” also crops up at other places in this book (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#sec03.03.04.02.02.02"
    }
  }, [_vm._v("section 3.3.4.2.2.2")]), _vm._v(", appendix O3.2.4), so I will examine it in detail here. Understanding the selective advantages that caused a given trait to evolve is a subtle, demanding task, and requires careful thought about sometimes difficult-to-know conditions in the past (Williams 1966; 1998). The organisms that we observe today evolved in the past, under conditions that may have been quite different in some respects but quite similar in others compared with those in the present. It has been common to extrapolate from observations of the selection that occurs in the present, and assume that similar selection occurred in the past. This assumption of uniformity is appropriate and powerful for some traits, but less so for others.")]), _vm._v(" "), _c('p', [_vm._v("For instance, it is reasonable to presume that the advantage of having a median tarsal claw for gripping silk lines ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#sec02.04.01"
    }
  }, [_vm._v("section 2.4.1")]), _vm._v(") and of having fewer sticky spiral loops to reduce the drag of an orb in windy conditions (Liao et al. 2009) selected for these traits in the past. Both advantages can be observed in present-day conditions, and can confidently be assumed to have occurred in the past. But data from some other types of ecological variables, such as relative numbers of potential prey or potential predators, provide less convincing "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "87",
      "id": "p87",
      "role": "doc-pagebreak"
    }
  }), _vm._v("arguments. Take, for instance, the fact that some orb designs are relatively better than others at capturing prey that fly faster and are larger. These traits involve trade-offs with capturing prey of different sizes (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#tab0301"
    }
  }, [_vm._v("table 3.1")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.02"
    }
  }, [_vm._v("section 4.2")]), _vm._v("). The overall payoffs from any given design will depend on the mix of numbers and nutritional payoffs from the different types of prey that are present at a given site. Present-day mixes are not necessarily the same as those in the past.")]), _vm._v(" "), _c('p', [_vm._v("To illustrate with a personal example, there was a particular mix of prey in the large open field of grass and weeds (set among large pastures and sugar cane fields) that was mowed once or twice a year, where my students and I studied a large population of "), _c('i', [_vm._v("Metazygia gregalis")]), _vm._v(" (AR) and its prey (Chacón and Eberhard 1980; Castillo and Eberhard 1983). Formerly there was extensive forest at this site, and "), _c('i', [_vm._v("M. gregalis")]), _vm._v(", a species that lives in early second growth habitats, probably only occurred in small, scattered, largely ephemeral patches of early second growth at recent tree falls, landslides, and along river banks. These patches probably resembled the modern field of grass and weeds in some respects, but they undoubtedly differed in others: for instance they surely lacked certain exotic species of grasses, and exotic insects such as honey bees, and they undoubtedly received potential prey that migrated or strayed from other, nearby forest or aquatic habitats not do not presently exist near this field. The fact that "), _c('i', [_vm._v("M. gregalis")]), _vm._v(" persisted in this field year after year is evidence that it can survive and reproduce successfully under modern conditions. But its persistence at this site is "), _c('i', [_vm._v("not")]), _vm._v(" evidence that it evolved under this particular set of conditions, nor that its orb design represents an adaptation to the modern conditions. Perhaps it survived at this site because of the particular design of its orb; perhaps it survived there in spite of its design.")]), _vm._v(" "), _c('p', [_vm._v("The limits of reasonable ecological realism are difficult to determine. The large majority of the earth’s surface has been modified by humans during the last 10,000 years. Truly “undisturbed” sites are rare or entirely gone in many areas of the world. In addition, the sweeping historical changes that accompanied glacial and inter-glacial periods probably resulted in substantial changes in the species of prey and predators that have co-occurred with a given spider species. Judging by the extensive shuffling of plant species species during the recent transition from glacial to inter-glacial conditions (Colinveaux et al. 2000; Betancourt et al. 1990), changes in community composition were likely substantial.")]), _vm._v(" "), _c('p', [_vm._v("Another species from the same field, the bolas spider "), _c('i', [_vm._v("Mastophora dizzydeani")]), _vm._v(", illustrates how the problems of ecological realism do not have the same effects on other types of deductions. This spider preyed exclusively on males of two species of noctuid moths. The behavior of the moths suggested that the spiders were luring them chemically. It was reasonable to conclude that these spiders used a pheromone mimic that evolved to trap male moths (Eberhard 1977b; Stowe et al. 1987); it would not be justifiable, however, to conclude that the particular mix of moth species observed in this field was the mix of prey under which the pheromone mimicry evolved.")]), _vm._v(" "), _c('p', [_vm._v("I emphasize that I am "), _c('i', [_vm._v("not")]), _vm._v(" saying that I know what the ecological conditions were for different species in the past; I "), _c('i', [_vm._v("am")]), _vm._v(" saying that it cannot be confidently assumed that present-day conditions are the same as those under which the traits of the spiders evolved. This means that hypotheses that depend on certain ecological variables, such as the relative numbers of potential prey insects that have different sizes, nutritional values, and flight speeds, cannot always be tested convincingly by observing modern-day populations. I realize that some ecologically oriented colleagues will see these arguments as nihilistic surrenders to hopeless ignorance. But intellectual rigor is useful; little is gained (and much is lost) by ignoring the limitations of data to support or discard particular conclusions.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.05.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.05.07"
    }
  }, [_vm._v("3.2.5.7 Flexible construction behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The wide range of intra-specific and even intra-individual facultative changes in the details of orb designs that are elicited by variables other than prey (e.g., see Herberstein and Tso 2011 and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#ch07"
    }
  }, [_vm._v("chapter 7")]), _vm._v(") constitutes still another reason to doubt the prey specialization hypothesis. For instance, the correlation between silk supplies and the substantial intra-individual variations in designs of orbs built at the same site on the same day by "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(" (TET), "), _c('i', [_vm._v("Metabus ocellatus")]), _vm._v(" (TET), and "), _c('i', [_vm._v("Micrathena sexspinosa")]), _vm._v(" (AR) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#fig0718"
    }
  }, [_vm._v("figs. 7.18")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#fig0743"
    }
  }, [_vm._v("7.43")]), _vm._v("; Eberhard 1988a), and by "), _c('i', [_vm._v("Zosis geniculata")]), _vm._v(" (UL) in the same portion of the same web from one day to the next ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#fig0719"
    }
  }, [_vm._v("fig. 7.19")]), _vm._v("), suggest that the amount of silk available in the spider’s silk glands has major effects on several aspects of orb design. One "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "88",
      "id": "p88",
      "role": "doc-pagebreak"
    }
  }), _vm._v("would have to accept the seemingly unlikely (though not impossible) supposition that when a spider has larger or smaller reserves of silk in her glands, the types of prey that are most advantageous for her to attempt to capture change, and that the altered web designs are appropriate to capture them. Many different factors induce alterations in orb designs ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#sec07.03"
    }
  }, [_vm._v("sections 7.3")]), _vm._v(", 8.2.1), making the array of suppositions of this sort that would be required by the prey specificity hypothesis even more unlikely.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0304"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "596",
      "src": "images/chi-eberhard-fig0304.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p88"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.4.")]), _vm._v(" The “true” ladder web of a mature female "), _c('i', [_vm._v("Scoloderus tuberculifer")]), _vm._v(" (AR), built late at night and removed at dawn, is probably a specialized trap for moths. These webs were not associated with tree trunks, as are the elongate “trunk” orbs of "), _c('i', [_vm._v("Herennia")]), _vm._v(" spp. and "), _c('i', [_vm._v("Clitaetra")]), _vm._v(" (NE) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0403"
    }
  }, [_vm._v("fig. 4.3")]), _vm._v(") and "), _c('i', [_vm._v("Telaprocera maudae")]), _vm._v(" (AR). The web’s elongate form and perfectly vertical orientation probably increase retention of moths, whose covering of detachable scales on the wings and body makes them difficult prey to retain (the scales adhere to the web but the moth falls free). A moth in a ladder web will shed scales ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0016#fig0420"
    }
  }, [_vm._v("fig. 4.20")]), _vm._v("), but then fall into additional web below until it is finally stripped of its scales and held fast. This web has several additional design features that are probably also associated with its vertical elongation. Most of the long upper radii are nearly perfectly vertical and parallel to each other for most of their length ("), _c('i', [_vm._v("a")]), _vm._v(", "), _c('i', [_vm._v("b")]), _vm._v("), only curving at their lower ends to converge at the hub ("), _c('i', [_vm._v("b")]), _vm._v("). These radii are held in these usual positions by the temporary spiral, much of which is left intact in the finished web (arrows in "), _c('i', [_vm._v("c")]), _vm._v("). In a spectacular convergence, the orb of the distantly related "), _c('i', [_vm._v("Tylorida")]), _vm._v(" sp. is similarly asymmetrical, but has the lower rather than the upper portion elongated (Robinson and Robinson 1972) (from Eberhard 1975).")])])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.05.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.05.08"
    }
  }, [_vm._v("3.2.5.8 Possible exceptions: relative prey specialization")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("There are a few extremely modified orbs that apparently represent specializations for certain types of prey. The most dramatic are the convergent “ladder” webs of "), _c('i', [_vm._v("Tylorida")]), _vm._v(" sp. (TET) in New Guinea (Robinson and Robinson 1972), and "), _c('i', [_vm._v("Scoloderus")]), _vm._v(" spp. (AR) in the Americas ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0304"
    }
  }, [_vm._v("fig. 3.4")]), _vm._v(") (Eberhard 1975; Stowe 1978; Traw 1995), which are probably specialized to capture moths. The elongate web form, their perfectly vertical orientations, construction late at night, and the prey records from "), _c('i', [_vm._v("S. cordatus")]), _vm._v(" (68% of 212 prey were moths; the percentage was apparently lower in more typical orbs of other species in the same habitat, though quantitative data were lacking) (Stowe 1978), make it likely that both represent adaptations to capture moths. Moths are difficult prey for orb weavers, due to their covering of detachable scales that adhere to the orb’s sticky spiral lines and allow the moth to fall free ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0016#fig0420"
    }
  }, [_vm._v("fig. 4.20")]), _vm._v("). Other vertically elongate tree trunk ladder webs, built by the nephilids "), _c('i', [_vm._v("Herennia")]), _vm._v(" and "), _c('i', [_vm._v("Clitaetra")]), _vm._v(" (Robinson and Lubin 1979a; Kuntner et al. 2008a,b) and the araneids "), _c('i', [_vm._v("Cryptaranea atrihastula")]), _vm._v(" (Forster and Forster 1985), "), _c('i', [_vm._v("Telaprocera maudae")]), _vm._v(" (Harmer and Herberstein 2009), and "), _c('i', [_vm._v("Eustala perfida")]), _vm._v(" and "), _c('i', [_vm._v("conformans")]), _vm._v(" (Messas et al. 2014), constitute a further striking convergence in design; these webs represent adaptations to build at similar sites (tree trunks) (Harmer 2009). These sites may result in prey specialization, or other advantages such as camouflaging the web or the spider.")]), _vm._v(" "), _c('p', [_vm._v("Less dramatic vertical elongations in one species of "), _c('i', [_vm._v("Eustala")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0310"
    }
  }, [_vm._v("fig. 3.10")]), _vm._v(") and in "), _c('i', [_vm._v("Spintharidius rhomboidalis")]), _vm._v(" (AR) (Levi 2008) may represent similar moth specializations. Other convergences on orbs that have extremely dense and numerous sticky spiral lines but are less elongate, such as "), _c('i', [_vm._v("Acacesia")]), _vm._v(" and "), _c('i', [_vm._v("Pozonia")]), _vm._v(" in the New World ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0305"
    }
  }, [_vm._v("figs. 3.5")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#fig0335"
    }
  }, [_vm._v("3.35")]), _vm._v("; Eberhard 1976a) and "), _c('i', [_vm._v("Deliochus")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0305"
    }
  }, [_vm._v("fig. 3.5")]), _vm._v(") and "), _c('i', [_vm._v("Poltys")]), _vm._v(" in Australia (Kuntner et al. 2008a; Smith 2006), may also represent specialization on moths.")]), _vm._v(" "), _c('p', [_vm._v("Four additional extreme specializations are the "), _c('i', [_vm._v("Ocrepeira")]), _vm._v(" (= "), _c('i', [_vm._v("Wixia")]), _vm._v(") (AR) “asterisk” webs ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#fig0902"
    }
  }, [_vm._v("fig. 9.2")]), _vm._v(") to capture walking prey (Stowe 1978), the "), _c('i', [_vm._v("Wendilgarda")]), _vm._v(" (TSM) webs with sticky lines attached to the surfaces of streams ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#fig1029"
    }
  }, [_vm._v("fig. 10.29")]), _vm._v("; Coddington and Valerio 1980; Eberhard 2001a) that capture prey on or just above the surface of the water (in one species 82 of 85 prey were water striders), the very sparse webs of "), _c('i', [_vm._v("Cyrtarachne")]), _vm._v(" (AR) and its close relatives "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "89",
      "id": "p89",
      "role": "doc-pagebreak"
    }
  }), _vm._v("that are also probably moth specialists ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#fig0923"
    }
  }, [_vm._v("fig. 9.23")]), _vm._v(", Stowe 1986) (they are made with especially strong and adhesive lines) (Cartan and Miyashita 2000), and the open-meshed design of webs that "), _c('i', [_vm._v("Parawixia bistriata")]), _vm._v(" (AR) builds only on days when flying termites are available (Sandoval 1994).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0305"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "440",
      "src": "images/chi-eberhard-fig0305.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p89"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.5.")]), _vm._v(" These beautiful “sticky spiral-rich” nocturnal orbs of mature females of the Australian "), _c('i', [_vm._v("Deliochus")]), _vm._v(" sp. (AR) ("), _c('i', [_vm._v("a")]), _vm._v(") and the neotropical "), _c('i', [_vm._v("Acacesia hamata")]), _vm._v(" (AR) ("), _c('i', [_vm._v("b")]), _vm._v(") are probably convergently specialized to capture moths. The webs of both species are built in large open spaces, and have relatively few radii compared with the large number of closely spaced sticky spiral loops (for still other probably convergent “moth webs,” see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0304"
    }
  }, [_vm._v("figs. 3.4")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#fig0335"
    }
  }, [_vm._v("3.35")]), _vm._v(") (from Kuntner et al. 2008a and Kuntner unpub., courtesy of Matjaž Kuntner).")])]), _vm._v(" "), _c('p', [_vm._v("There are also some non-orbs that capture highly specific types of prey. There are several ant specialist groups in Theridiidae that build their gumfoot webs over ant foraging trails (Cushing 2012). In the gumfoot building theridiid "), _c('i', [_vm._v("Achaearanea globispira")]), _vm._v(", for example, 96% of the prey were ants (Henschel and Jocqué 1994), and "), _c('i', [_vm._v("Dipoena banksii")]), _vm._v(" may capture nothing except "), _c('i', [_vm._v("Pheidole")]), _vm._v(" ants with its single gumfoot line webs that were placed near the entrances of ant nests (Gastreich 1999). Other specialist theridiids are "), _c('i', [_vm._v("Argyrodes attenuatus")]), _vm._v(", which appeared to capture only insects and spiders that used its long, sparse non-sticky lines as resting sites (Eberhard 1979a), "), _c('i', [_vm._v("Chrosiothes tonala")]), _vm._v(" that also built only non-sticky lines that it used to explore for termites foraging on the floor of the forest that it had sensed chemically (Eberhard 1991), and "), _c('i', [_vm._v("Thymoites melloleitaoni")]), _vm._v(" that has been found only inside termite nests (Bristowe 1939). Two preliminary impressions are that prey specialization in non-orbs seems to be associated with reduction of the complexity of the webs, and with building webs at very specific sites.")]), _vm._v(" "), _c('p', [_vm._v("In sum, prey specialization does exist; but it appears to be rare, and large confined to highly modified orbs or non-orb webs.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.05.09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.05.09"
    }
  }, [_vm._v("3.2.5.9 A summary regarding prey specialization in orb webs")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Summarizing the data from different techniques, the trends that have been identified in studies of typical orb webs tend to argue against rather than in favor of relatively strict prey specializations in orb designs. Although the techniques that have been used in attempts to quantify both prey that are available and those that are captured are often flawed, it is clear that orbs typically capture a wide diversity of prey. In addition, webs with quite different designs that were built in the same habitat captured rather similar arrays of prey. And webs built by different ontogenetic stages of the same species often have quite similar designs but undoubtedly capture very different arrays of prey (though the data here are scarce). A few studies that suggested that particular designs of more or less typical orbs are associated with captures of particular types of prey are weak because the biases in captures could be due either to biases in the prey present "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "90",
      "id": "p90",
      "role": "doc-pagebreak"
    }
  }), _vm._v("at the sites or to differences in the spiders’ sizes, rather than to differences in the orbs’ designs. In sum, a modified version of the conclusion of Riechert and Łuczak (1982) is most appropriate for orbs: differences in habitats where webs are built, rather than differences in design, are probably responsible for many differences in prey captured.")])])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec03.02.06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.06"
    }
  }, [_vm._v("3.2.6 Inter-specific competition for prey is probably not common")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Prey specialization, if it occurs, could result from competition with other species for prey. It is difficult to demonstrate, however, that differences in orb design are the result of selection due to such competition, as has frequently been supposed (see Wise 1995). While it is routine to find that different species in the same habitat differ with respect to the prey that they capture, there are reasons to be skeptical of the frequent supposition that web differences evolved to avoid competition for food with other species. The most convincing data come from experimental manipulations of the relative population densities in the field by David Wise and his colleagues. Careful field experiments showed that two congeneric araneids, "), _c('i', [_vm._v("Argiope trifasciata")]), _vm._v(" and "), _c('i', [_vm._v("A. aurantia")]), _vm._v(", which built webs with similar designs at similar old field sites (and whose small differences in website heights had in fact been attributed earlier to competitive displacement—Enders 1974), did not compete for prey in this habitat (Horton and Wise 1983). Other removal experiments led to similar conclusions. For instance, removal of individual species in the group of four species in different families that captured largely similar arrays of prey in the same subhabitat also failed to result in competitive release (Riechert and Cady 1983). A thorough analysis of published data led Wise (1995) to the conclusion that web-building spiders seldom experience inter-specific competition for prey. Even intra-specific competition for prey may be weak in some species. In at least some habitats, orb weaver populations are apparently limited by predators (Toft and Schoener 1983; Spiller and Schoener 1994) or parasites (Bianchi 1945), not by intra-specific competition for prey (Miyashita 1992) or space (Colebourn 1974).")]), _vm._v(" "), _c('p', [_vm._v("It should be noted that careful experimental tests of inter-specific competition are available, however, for only a few species, and some evidence from other, “inadvertent experiments” in which invasive species of web builders have displaced related native species appears to be contradictory. The clearest data come from a pair of linyphiids in North America. In plots in a recently invaded area in Maine (USA), the presence of the European and Asian "), _c('i', [_vm._v("Linyphia triangularis")]), _vm._v(" was associated with a reduced tendency of the native species "), _c('i', [_vm._v("Frontinella communis")]), _vm._v(" to build in the same plot, and also with an increased tendency for "), _c('i', [_vm._v("F. communis")]), _vm._v(" to abandon the plot (Bednarski et al. 2009). It also appears that the recent arrival of the invasive, anthropophilic African brown widow "), _c('i', [_vm._v("Latrodectus geometricus")]), _vm._v(" has been associated with the near disappearance of the native black widow "), _c('i', [_vm._v("L. “mactans”")]), _vm._v(" (species identification is uncertain) from similar habitats in northern Florida, USA (G. B. Edwards pers. comm. using data from both personal collecting and calls from residents regarding spiders in and around their houses). A similar, especially dramatic displacement of "), _c('i', [_vm._v("L. “mactans”")]), _vm._v(" by "), _c('i', [_vm._v("L. geometricus")]), _vm._v(" was described over 50 years ago in Hawaii (Bianchi 1945).")]), _vm._v(" "), _c('p', [_vm._v("At least in the case of the linyphiids, however, it appears that the displacement of the native species was due to direct aggressive interactions, not to competition for food (Bednarski et al. 2009). The invasive "), _c('i', [_vm._v("L. triangularis")]), _vm._v(" has similar competitive interactions in its native habitats, where it attacks a smaller congener (Toft 1987, 1989). These observations do not rule out the possibility that the selective advantage of the aggressive behavior is to win out in competition for food; but other possibilities, such as excluding other individuals from the web so as to avoid interference in attacks on prey, have not been eliminated. Nothing seems to be known regarding the mechanism of displacement in the "), _c('i', [_vm._v("Latrodectus")]), _vm._v(" species, and possible competition for food has not to my knowledge been tested.")]), _vm._v(" "), _c('p', [_vm._v("A second, less powerful technique to test for inter-specific competition is to look for inverse correlations in the distributions or population densities of different species in the field, and differences in the types of prey captured by different species (e.g., Enders 1974; Blackledge et al. 2003b). Though there are cases of such correlations and differences, reasonable alternative explanations were generally not eliminated, so these studies do not provide convincing demonstrations of competition for prey. "), _c('i', [_vm._v("Wendilgarda galapagensis")]), _vm._v(" (TSM), which is endemic to the isolated and depauperate (Hogue and "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "91",
      "id": "p91",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Miller 1981) oceanic island Isla del Coco, offers especially suggestive evidence favoring the importance of inter-specific competition: in addition to building genus-typical webs attached to the water in small streams (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#fig1029"
    }
  }, [_vm._v("fig. 10.29")]), _vm._v("), these spiders built quite different, apparently derived webs away from the water, where no other theridiosomatids and indeed few orb weavers were present, and these had quite different designs ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#fig0801"
    }
  }, [_vm._v("fig. 8.1")]), _vm._v(") (Eberhard 1989a). But again alternative explanations were not eliminated.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0306"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "417",
      "src": "images/chi-eberhard-fig0306.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p91"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.6.")]), _vm._v(" The edge-to-hub patterns of the mean standardized spaces between loops of the sticky spiral (distance/median space) in the orbs of six species of orb weavers in five families illustrate a common pattern: sticky spiral spacing tends to be larger near the outer edge of the web (left side of graph). The exception to this pattern, "), _c('i', [_vm._v("Metepeira")]), _vm._v(" sp., is also exceptional (along with "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v("—see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0404"
    }
  }, [_vm._v("fig. 4.4")]), _vm._v(") in capturing prey flying at relatively low velocities; the pattern and the exceptions favor the “prey stopping” explanation (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0307"
    }
  }, [_vm._v("fig. 3.7")]), _vm._v(" and text).")])]), _vm._v(" "), _c('p', [_vm._v("In sum, careful field experiments with pairs of web-building species revealed that they did not compete for prey: increasing or reducing the numbers of one species had no perceptible effect on the predatory success of the other. It is possible that the few species in these experiments are not representative, but the fact that some species pairs were especially selected as likely candidates for showing inter-specific competition argues otherwise. Given the low densities of many orb weaver populations in nature, the huge numbers of insects in flight, the wide spectrum of species that orb weavers prey on, and the probably largely stochastic encounters of prey with orbs, this lack of inter-specific competitive effects is not really surprising. Far-reaching consequences of the probable lack of importance of inter-specific competition for prey for understanding the evolution of webs are discussed in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.09"
    }
  }, [_vm._v("section 9.9")]), _vm._v(".")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec03.02.07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.07"
    }
  }, [_vm._v("3.2.7 Sticky spiral spacing is not uniform")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("One of the most striking geometric regularities in an orb web is the uniform spacing between the sticky spiral lines. Many authors refer to “the” sticky spiral spacing (or mesh size—see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#sec01.07"
    }
  }, [_vm._v("section 1.7")]), _vm._v(") of a given orb (appendix O3.2.1). Closer examination, however, shows that neither the distances between sticky spiral lines nor those between the radii are uniform in an orb (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0104"
    }
  }, [_vm._v("figs. 1.4b")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0306"
    }
  }, [_vm._v("3.6")]), _vm._v("; Nentwig 1983a); more importantly, there are consistent patterns in these differences, and the differences themselves appear to be part of the orb’s design ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03"
    }
  }, [_vm._v("section 4.3")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("Radii obviously converge near the hub. The distances between adjacent radii in the typical orbs were on average 4–5 times greater at the outer edge of the capture zone than at its inner edge (Eberhard 2014). In addition, there were also clear, consistent differences in sticky spiral spacing ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0104"
    }
  }, [_vm._v("figs. 1.4")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0306"
    }
  }, [_vm._v("3.6")]), _vm._v("). In a given orb, the largest spaces between sticky spiral loops was on the order 2–3 times the smallest ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0104"
    }
  }, [_vm._v("figs. 1.4")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0306"
    }
  }, [_vm._v("3.6")]), _vm._v(") (Peters 1939; Le Guelte 1966; Nentwig 1983a; Heiling and Herberstein 1998; Sensenig et al. 2012).")]), _vm._v(" "), _c('p', [_vm._v("These differences in sticky spiral spacing are not random, but show a pattern: larger distances generally occur in the outer portion of an orb ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0306"
    }
  }, [_vm._v("fig. 3.6")]), _vm._v(") (Peters 1939; Le Guelte 1966; Nentwig 1983a; Eberhard 2014). This pattern of larger distances near the outer edge appears to be very general, although to my knowledge there never has been a wide-ranging review of within-web variation in the distances between sticky spiral loops in different species. It occurred in published photos of the orbs of 14 "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "92",
      "id": "p92",
      "role": "doc-pagebreak"
    }
  }), _vm._v("genera of araneids, 3 tetragnathids, 2 uloborids, a theridiosomatid, and an anapid (Eberhard 2014) (generally there was only one photo/species, however, so further data are needed). There also appear to be inter-specific differences. For instance, the distances between loops below the hub in the web of the araneid "), _c('i', [_vm._v("Metepeira")]), _vm._v(" sp. and the nephilid "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" showed the opposite trend, increasing gradually from the edge to the hub ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0306"
    }
  }, [_vm._v("figs. 3.6")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0307"
    }
  }, [_vm._v("3.7")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0404"
    }
  }, [_vm._v("4.4")]), _vm._v("). Other species showed more complex patterns. For instance, in the vertical orbs of the araneids "), _c('i', [_vm._v("Zygiella x-notata")]), _vm._v(" (Le Guelte 1966) and "), _c('i', [_vm._v("Micrathena duodecimspinosa")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0104"
    }
  }, [_vm._v("figs. 1.4")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0306"
    }
  }, [_vm._v("3.6")]), _vm._v(") the spaces between loops below the hub tended to be somewhat larger near the outer edge of the orb, smallest midway toward the hub, and largest very near the hub; above the hub, in contrast, the spaces tended to be greatest near the edge but then decreased monotonically nearer the hub, with little or no increase near the hub.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0307"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "420",
      "src": "images/chi-eberhard-fig0307.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p92"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.7.")]), _vm._v(" These orbs of mature female "), _c('i', [_vm._v("Metepeira")]), _vm._v(" sp. (AR) and "), _c('i', [_vm._v("Araneus expletus")]), _vm._v(" (AR) are unusual in having smaller spaces between the sticky spiral loops near the lower edge of the orb (compare with "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0104"
    }
  }, [_vm._v("figs. 1.4")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0308"
    }
  }, [_vm._v("3.8")]), _vm._v("). In both species there is also reason to suspect that prey velocities may be relatively low. This association fits the predictions of the “prey stopping” hypothesis ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.02"
    }
  }, [_vm._v("section 4.3.2")]), _vm._v("). As in many other species, however, the "), _c('i', [_vm._v("A")]), _vm._v(". "), _c('i', [_vm._v("expletus")]), _vm._v(" sticky spiral lines in the upper portion of the orb were consistently farther apart near the edge. The arrows mark the "), _c('i', [_vm._v("M")]), _vm._v(". sp. radii that curved to fill larger inter-radial spaces (from Eberhard 2014).")])]), _vm._v(" "), _c('p', [_vm._v("Another pattern in some species is for the sticky spiral spacing near the lower edge of the capture zone to be especially small, while that near the upper edge of the capture zone is relatively large (see also "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.03.01"
    }
  }, [_vm._v("section 3.3.3.3.1")]), _vm._v(") This pattern occurred in several "), _c('i', [_vm._v("Cyclosa")]), _vm._v(" and "), _c('i', [_vm._v("Allocyclosa")]), _vm._v(" (AR) species ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#fig0327"
    }
  }, [_vm._v("fig. 3.27")]), _vm._v(") (Zschokke and Nakata 2015; WE), "), _c('i', [_vm._v("Metepeira")]), _vm._v(" sp. (AR) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0307"
    }
  }, [_vm._v("fig. 3.7")]), _vm._v(") (Eberhard 2014), "), _c('i', [_vm._v("Epeirotypus brevipes")]), _vm._v(" (TSM) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0308"
    }
  }, [_vm._v("fig. 3.8")]), _vm._v("), and "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" (NE) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0404"
    }
  }, [_vm._v("fig. 4.4")]), _vm._v(") (Eberhard 2014). As suggested by Champion de Crespigny et al. (2001) and Zschokke and Nakata (2015), the tight spacing at the bottom of the orb may be due to selection to prevent prey from escaping by tumbling down the web (see section 5.8).")]), _vm._v(" "), _c('p', [_vm._v("Still another pattern that was documented in "), _c('i', [_vm._v("Uloborus diversus")]), _vm._v(" (UL) (Eberhard 1969) and that seems to occur in other orb weavers was for sticky spiral spacing to be reduced at the point where it doubled back. This reduced the size of the hole in the array of stick lines at the turnback point ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0309"
    }
  }, [_vm._v("fig. 3.9")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("The existence of these patterns in the spacing suggests that the differences are not accidents, but part of the orb’s design. There are several possible explanations for why these patterns occur, and no single explanation works for all cases ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.05"
    }
  }, [_vm._v("section 4.3.5")]), _vm._v("). For the moment, the point is that sticky spiral spacing is not uniform in orbs, and that the variations in spacing are not simply mistakes.")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec03.02.08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.08"
    }
  }, [_vm._v("3.2.8 Orb designs are probably not taxon-specific")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "chaft",
    attrs: {
      "id": "sec03.02.08.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.08.01"
    }
  }, [_vm._v("3.2.8.1 Species-specificity")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("A common question asked about orbs is whether their designs are species-specific. Many arachnologists with extensive field experience at particular field sites might "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "93",
      "id": "p93",
      "role": "doc-pagebreak"
    }
  }), _vm._v("be tempted to answer yes; it is often possible to identify most if not all of the orb weavers at a site on the basis of their webs, without seeing the spider (e.g., Shear 1986). Bristowe (1941) noted that “the typical webs of most if not every species [of British araneids and tetragnathids] can be recognized without seeing the weaver herself” (p. 250–251). Similarly, species-specificity may occur in other web designs; for instance, Bristowe (1941) distinguished the funnel webs of four species of "), _c('i', [_vm._v("Tegenaria")]), _vm._v(" on the basis of the density and flatness of the sheet, the relative diameters of the tunnels, and silk color.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0308"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-eberhard-fig0308.jpeg",
      "width": "535"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p93"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.8.")]), _vm._v(" The upper portion of this orb of "), _c('i', [_vm._v("Epeirotypus brevipes")]), _vm._v(" (TSM) illustrates the common edge-to-hub pattern, with a gradual decrease in the spaces between sticky spiral lines nearer the hub. The spaces below the hub were much less variable, however. Webs of this species are often built near solid surfaces (this web was in the hollow trunk of a standing tree, with bats perched in the darkness above), so the velocities of prey impacts may often be relatively low. Wind velocities were also very low. On balance the prey-stopping hypothesis offers the best explanation for the edge-to-hub patterns. The two white objects are egg sacs that are hanging on the spring line that connected the hub to the trunk.")])]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0309"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "307",
      "src": "images/chi-eberhard-fig0309.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p93"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.9.")]), _vm._v(" The probable function of the typically reduced spacing at turnback sites (y) in uloborid webs was to reduce the sizes of the open spaces lacking sticky lines (from Eberhard 1969).")])]), _vm._v(" "), _c('p', [_vm._v("Perhaps field experience of this sort is responsible for the common published claims that orb webs are species-specific (one chapter of the Witt et al. 1968 book, for example, was titled “Specificity of the web”). But discrimination "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "94",
      "id": "p94",
      "role": "doc-pagebreak"
    }
  }), _vm._v("of local species usually involves comparing only a single species in each genus or, at best, only a few congeneric species. The term “species-specific” means much more; it means that the webs of a species can be distinguished from those of even closely related congeneric species. Are the orb designs of closely related species truly sufficiently different that they do not overlap, despite their usual substantial variation (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0412"
    }
  }, [_vm._v("fig. 4.12")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#ch07"
    }
  }, [_vm._v("chapters 7")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#ch08"
    }
  }, [_vm._v("8")]), _vm._v(")? I will argue that the data needed to give a confident general answer are not available, and that the probable answer is “no.”")]), _vm._v(" "), _c('p', [_vm._v("To illustrate with my own personal experience, I can confidently distinguish the orb webs of mature female "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(" from those of the approximately 30 other orb weaving species that are common in the Valle Central of Costa Rica. This, however, is the only common "), _c('i', [_vm._v("Leucauge")]), _vm._v(" species, and when I am faced with photos of the webs of other "), _c('i', [_vm._v("Leucauge")]), _vm._v(" species from other sites, I often cannot distinguish them from those of "), _c('i', [_vm._v("L. mariana")]), _vm._v(". I experience the same combination of confident local web identifications and inability to make confident distinctions between congeneric species in several other genera with which I have ample experience at this site, such as "), _c('i', [_vm._v("Araneus")]), _vm._v(", "), _c('i', [_vm._v("Eriophora")]), _vm._v(", "), _c('i', [_vm._v("Wagneriana")]), _vm._v(", "), _c('i', [_vm._v("Cyclosa")]), _vm._v(", "), _c('i', [_vm._v("Argiope")]), _vm._v(", "), _c('i', [_vm._v("Nephila")]), _vm._v(", "), _c('i', [_vm._v("Uloborus")]), _vm._v(", and "), _c('i', [_vm._v("Philoponella")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Thus, at least on the basis of the “gestalt” traits of orbs that I have learned to use, the webs of "), _c('i', [_vm._v("L. mariana")]), _vm._v(" are not species-specific. The possibility still exists that other more subtle traits will be found to distinguish species in the future, but there are presently few if any data that clearly document species-specificity. This would be a major undertaking. To be convincing, such a study would need to include substantial samples of the webs of each species, because of the considerable adaptive flexibility of orb weavers (Scharf et al. 2011; Herberstein and Tso 2011; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#ch07"
    }
  }, [_vm._v("chapters 7")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#ch08"
    }
  }, [_vm._v("8")]), _vm._v("). It would also have to include similar samples from an ample number of other species in the same genus. Due to the likelihood of design adjustments to environmental conditions (Sensenig et al. 2010b), comparisons would need to standardize the contexts in which orbs were built. There has never to my knowledge been a single study that convincingly tests web species-specificity in any orb-weaver genus. One preliminary attempt using radius number in six species in the large genus "), _c('i', [_vm._v("Araneus")]), _vm._v(", did not give encouraging results. Values for different species varied widely within each species, and overlapped broadly: 25–42 in "), _c('i', [_vm._v("A. diadematus")]), _vm._v("; 15–22 in "), _c('i', [_vm._v("Nuctenea umbricata")]), _vm._v("; 11–26 in "), _c('i', [_vm._v("A. quadratus")]), _vm._v("; 26–66 in "), _c('i', [_vm._v("A. diodius")]), _vm._v("; and 15–22 in "), _c('i', [_vm._v("Gibbaranea bituberculata")]), _vm._v(" (Savory 1952) (see also Wiehle 1927, 1928, 1929, and 1931 on "), _c('i', [_vm._v("Araneus")]), _vm._v(", and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0310"
    }
  }, [_vm._v("fig. 3.10")]), _vm._v(" for diversity in the genus "), _c('i', [_vm._v("Eustala")]), _vm._v("). A preliminary test in the "), _c('i', [_vm._v("republicana")]), _vm._v(" group of "), _c('i', [_vm._v("Philoponella")]), _vm._v(" (UL) also failed to reveal clear species-specific differences (Opell 1979).")]), _vm._v(" "), _c('p', [_vm._v("Probably the most complete study of possible species-specificity in orb designs came to a similar conclusion. Many species of the genus "), _c('i', [_vm._v("Tetragnatha")]), _vm._v(" are endemic to the Hawaiian islands; about 35 species that build orbs are probably all descendants of a single colonizing ancestor (Blackledge et al. 2003b; Blackledge and Gillespie 2004). Other species of this large genus (>100 species) are distributed worldwide, and most make flimsy, more or less horizontal orb webs with open hubs ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0318"
    }
  }, [_vm._v("fig. 3.18c")]), _vm._v(") (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0311"
    }
  }, [_vm._v("fig. 3.11j")]), _vm._v(" for an exception); they also have relatively wide spaces between sticky spiral loops (for an extreme, see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#fig0910"
    }
  }, [_vm._v("fig. 9.10")]), _vm._v("), and often but not always occur near bodies of water (Kaston 1948; Comstock 1967; Dąbrowska-Prot and Łuczak 1968; Shinkai 1979; Shinkai and Takano 1984; Eberhard 1986a; Gillespie and Caraco 1987; WE). The Hawaiian species of "), _c('i', [_vm._v("Tetragnatha")]), _vm._v(" are the only native nocturnal orb weavers on the islands, and have undergone a dramatic radiation. The orbs of up to four species were analyzed on each of three islands. On all three islands, the overall web architectures of the different sympatric species differed from one another (using a principal components analysis [PCA] of four web variables); but comparing different islands, there were three pairs of species on different islands that built similar orbs (at least partial overlap in mean ± 95% standard error in PCA analyses) (Blackledge and Gillespie 2004). It is possible that intra-specific variation (and thus overlap between species) was underestimated. The samples of webs were modest (10–28 individuals/species), and the studies were performed in small habitat patches, some only on the order of only 1 ha (Blackledge et al. 2003b). These limitations may be important, given the substantial intra-specific flexibility of orb designs in general (Herberstein and Tso 2011; Scharf et al. 2011; Sensenig et al. 2010b; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#ch07"
    }
  }, [_vm._v("chapters 7")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#ch08"
    }
  }, [_vm._v("8")]), _vm._v("). On the other hand, it is possible that inter-specific overlaps were overestimated, as "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "95",
      "id": "p95",
      "role": "doc-pagebreak"
    }
  }), _vm._v("many web variables, such as hub and free zone size and shape (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.08.03"
    }
  }, [_vm._v("section 3.2.8.3")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0310"
    }
  }, [_vm._v("figs. 3.10")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0315"
    }
  }, [_vm._v("3.15")]), _vm._v(") were not included in the analyses.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0310"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "447",
      "src": "images/chi-eberhard-fig0310.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p95"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.10.")]), _vm._v(" This sampler illustrates the orbs of mature females in the medium large, New World araneid genus "), _c('i', [_vm._v("Eustala")]), _vm._v(" (Platnick 2014 listed 85 named species). Although web forms are known for only about 10 species, great intra-generic variation has already been documented. In contrast with others, the web of "), _c('i', [_vm._v("E")]), _vm._v(". sp. #806 was nearly horizontal, and had many radii and many, closely spaced loops of sticky spiral. The great vertical asymmetry of the web "), _c('i', [_vm._v("E")]), _vm._v(". sp. #508 (which was not associated with a trunk) was much greater than that of other species, but it was nevertheless much less than the asymmetry of the trunk webs of "), _c('i', [_vm._v("E")]), _vm._v(". "), _c('i', [_vm._v("conformans")]), _vm._v(" and "), _c('i', [_vm._v("E. perfida")]), _vm._v(" (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0403"
    }
  }, [_vm._v("fig. 4.3"), _c('i', [_vm._v("c")])]), _vm._v("). The webs of "), _c('i', [_vm._v("E")]), _vm._v(". sp. #2345 lacked a sticky spiral, and sticky lines were laid instead on radii and frame lines. The webs of "), _c('i', [_vm._v("E")]), _vm._v(". "), _c('i', [_vm._v("fuscovittata")]), _vm._v(" differed in being built in especially open areas, often with tall grass (two webs are included to give an idea of intra-specific variation). It is not clear whether "), _c('i', [_vm._v("Eustala")]), _vm._v(" is atypical in showing such diversity.")])]), _vm._v(" "), _c('p', [_vm._v("Two other intra-generic comparisons, between "), _c('i', [_vm._v("Zygiella x-notata")]), _vm._v(" and "), _c('i', [_vm._v("Z. keyserlingi")]), _vm._v(" (of "), _c('i', [_vm._v("Zygiella")]), _vm._v(" sensu strictu) (Gregorič et al. 2010), and between "), _c('i', [_vm._v("Leucauge argyra")]), _vm._v(" and "), _c('i', [_vm._v("L. mariana")]), _vm._v(" (TET) (Triana-Cambronero et al. 2011; Barrantes et al. 2017), also showed differences in variables such as the number of primary radii, the number of horizontal sticky spiral loops, the size of the orb relative to the spider’s size, frequencies and sizes of tangles near the orb, and the rate at which orb area increased with spider size. Only two species were compared, however, in these studies.")]), _vm._v(" "), _c('p', [_vm._v("In sum, species-specificity in orb design has seldom been studied. The preliminary analyses available argue against species-specificity. It is possible that future studies that include additional web variables may discover as yet unappreciated subtle species-specific differences. There is no reason to expect, in any case, that all genera will show the same pattern. Given the present absence of data documenting specificity, and the extraordinarily large number of variables known to affect orb designs ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#tab0703"
    }
  }, [_vm._v("table 7.3")]), _vm._v("; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#sec07.21"
    }
  }, [_vm._v("section 7.21")]), _vm._v("), the best summary regarding species-specificity is that it is yet to be demonstrated. My own intuition agrees with that of Levi (1978; p. 2): “I would expect . . . that in many [genera] the variation of individual webs of a species is too great and the webs of related species [are] too similar to separate.”")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.08.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.08.02"
    }
  }, [_vm._v("3.2.8.2 Effects of intra-specific genetic differences")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Little is known regarding how much of the substantial intra-specific variation that is commonly observed is due to genetic differences among individuals, and how "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "96",
      "id": "p96",
      "role": "doc-pagebreak"
    }
  }), _vm._v("much is due to differences in the conditions in which the webs were built. While environmental effects can be large (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#fig0742"
    }
  }, [_vm._v("fig. 7.42")]), _vm._v("), the only systematic study I know of (Rawlings and Witt 1973) concluded that genetic effects are also important. The differences between spiderlings from eight different egg sacs laid by different females were clearest in measurements of aspects of the sizes of their webs, and least evident in measurements of the “regularity” of their designs (e.g., standard deviation of inter-radial angles, standard error of median spacing between sticky spiral loops). More data will be needed to judge whether these are general trends.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.08.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.08.03"
    }
  }, [_vm._v("3.2.8.3 Genus-specificity?")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("It is also possible that orb web designs differ at higher taxonomic levels. Craig (2003), for instance, speculated that orb designs are “often specific to a particular spider genus” (p. 65) (but gave no supporting data). The field experience of distinguishing the orbs at given sites (Shear 1986) is relevant here; I "), _c('i', [_vm._v("can")]), _vm._v(" distinguish the orbs of "), _c('i', [_vm._v("L. mariana")]), _vm._v(" webs from those of the species in the other 15–20 genera that are common in the Valle Central. But a local sample of this sort is again much too limited to justify strong conclusions, and a given site rarely has representatives of sister genera. The data needed to quantify both intra-specific and intra-generic variation are generally lacking (Craig 2003).")]), _vm._v(" "), _c('p', [_vm._v("Kuntner and colleagues (Gregorič et al. 2010) made a first step in genus-level characterizations by specifying web characters that may be sufficient to diagnose each of the four genera in the family Nephilidae (the webs of some species are not known, however, and the data were not all quantitative). Another recent pioneering quantitative study of Gregorič et al. (2010) also gave preliminary indications of genus-level specificity in the webs of five species in four newly proposed genera that were created by splitting up the old araneid genus "), _c('i', [_vm._v("Zygiella")]), _vm._v(" (mostly on the basis of differences in genital morphology) (Wunderlich 2004). They found web differences that characterized each species, and that 7 of the 16 web characters (selected from an unspecified larger number as being useful) showed statistically significant differences among species.")]), _vm._v(" "), _c('p', [_vm._v("Even though they used an admirably large sample (278 webs in the field from 25 localities), I would argue (as the authors themselves noted) that genus-specificity cannot be tested confidently until the range of intra-generic variation has been determined more completely; this would involve adding further species in each of the three genera that has multiple species. I would also note the prominent variation in the Gregorič et al. data. For instance, the web trait said to distinguish the entire group (an open sector in the orb with a signal line running from the hub to the spider’s retreat that is at or beyond the web’s edge) was sometimes absent in the webs of all four genera (ranging from 6% to 59% of the webs). As Gregorič et al. noted, it is difficult to deal taxonomically with traits that are inconsistent.")]), _vm._v(" "), _c('p', [_vm._v("It is useful to note that some of the traits that were found to differ between species are almost certainly influenced by the site at which the web was constructed, rather than by orb construction behavior per se (Gregorič et al. 2010). For instance, "), _c('i', [_vm._v("Leviellus stroemi")]), _vm._v(" was the only species in which “non-circulating” sticky spiral lines (an estimate of the relative number of turnbacks in the sticky spiral) were common above as well as below the hub (they occurred in 56.5% of the webs, as opposed to 0–5.5% in the others species) (Gregorič et al. 2010). Turnbacks are used throughout orb weavers to fill in asymmetric spaces with more or less spiral lines, and this "), _c('i', [_vm._v("L. stroemi")]), _vm._v(" trait probably resulted from the choice of website and retreat locations. An illustration of how important website shape can be comes from the elongate, ladder web araneid "), _c('i', [_vm._v("Telaprocera maudae")]), _vm._v(", which built a typical, oval web when obliged to build in a non-elongate space rather than on a tree trunk (Harmer and Herberstein 2009). This emphasizes the importance of documenting orbs in nature as well as in captivity (Sensenig et al. 2010b).")]), _vm._v(" "), _c('p', [_vm._v("The hubs and free zones of orbs, which may be more isolated from habitat-imposed variations, seem to be the most promising aspects of orbs for taxon-specificity. Preliminary surveys show clear variation between different genera in a given family ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0311"
    }
  }, [_vm._v("figs. 3.11–3.15")]), _vm._v("). They were highly consistent in one genus, "), _c('i', [_vm._v("Micrathena")]), _vm._v(" (AR) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0314"
    }
  }, [_vm._v("fig. 3.14")]), _vm._v("), and moderately consistent in "), _c('i', [_vm._v("Eustala")]), _vm._v(" (AR) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0310"
    }
  }, [_vm._v("fig. 3.10")]), _vm._v("); but they differed within others such as "), _c('i', [_vm._v("Alpaida")]), _vm._v(" (AR) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0315"
    }
  }, [_vm._v("fig. 3.15")]), _vm._v("), and "), _c('i', [_vm._v("Tetragnatha")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0311"
    }
  }, [_vm._v("figs. 3.11")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#fig0910"
    }
  }, [_vm._v("9.10")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#fig1024"
    }
  }, [_vm._v("10.24")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#fig1026"
    }
  }, [_vm._v("10.26")]), _vm._v("; see also Blackledge and Gillespie 2004). Careful measurements to quantify intra-specific and intra-generic variation in "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "99",
      "id": "p99",
      "role": "doc-pagebreak"
    }
  }), _vm._v("larger samples of species will be needed to test these possibilities. The incomplete nature of current data can only overemphasize the lack of overlap.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0311"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "97",
      "id": "p97",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "472",
      "src": "images/chi-eberhard-fig0311.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.11.")]), _vm._v(" The substantial variation in the designs of the hubs of genera in Tetragnathidae ("), _c('i', [_vm._v("a–j")]), _vm._v(") and Uloboridae ("), _c('i', [_vm._v("k-l")]), _vm._v(") suggest that there may be taxonomic patterns, perhaps at the level of families or genera, but the studies necessary to test this hypothesis have yet to be performed (to different scales; all are field webs except that of "), _c('i', [_vm._v("U")]), _vm._v(". "), _c('i', [_vm._v("glomosus")]), _vm._v(") (the spider was removed in all but "), _c('i', [_vm._v("U")]), _vm._v(". "), _c('i', [_vm._v("glomosus")]), _vm._v("; "), _c('i', [_vm._v("k")]), _vm._v(" courtesy of Brent Opell). "), _c('i', [_vm._v("a–Chrysometa alboguttata")]), _vm._v("; "), _c('i', [_vm._v("b–Cyrtognatha")]), _vm._v(" sp.; "), _c('i', [_vm._v("c–Tylorida")]), _vm._v(" sp. #1962; "), _c('i', [_vm._v("d–Dolichognatha")]), _vm._v(" sp.; "), _c('i', [_vm._v("e–Leucauge")]), _vm._v(" sp. D.; "), _c('i', [_vm._v("f–Opas")]), _vm._v(" sp.; "), _c('i', [_vm._v("g–Prolochus")]), _vm._v(" (= "), _c('i', [_vm._v("Dolichognatha")]), _vm._v("); "), _c('i', [_vm._v("h–Meta")]), _vm._v(" sp. #1232; "), _c('i', [_vm._v("i–Pachygnatha")]), _vm._v(" sp. #563; "), _c('i', [_vm._v("j–Tetragnatha")]), _vm._v(" sp. #2047; "), _c('i', [_vm._v("k–Waitkera waitakerensis")]), _vm._v("; "), _c('i', [_vm._v("l–Uloborus glomosus")]), _vm._v(".")])]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0312"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "463",
      "src": "images/chi-eberhard-fig0312.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p97"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.12.")]), _vm._v(" The substantial variation in the designs of the hubs of Araneidae ("), _c('i', [_vm._v("a–e")]), _vm._v("), Nephilidae ("), _c('i', [_vm._v("f–g")]), _vm._v("), Theridiosomatidae ("), _c('i', [_vm._v("h–i")]), _vm._v("), and symphytognatoids ("), _c('i', [_vm._v("j–l")]), _vm._v(") suggest that there may be taxonomic patterns, perhaps at the level of families or genera, but the studies necessary to test this hypothesis have yet to be performed (to different scales). "), _c('i', [_vm._v("a–Allowixia")]), _vm._v(" sp.; "), _c('i', [_vm._v("b–Argiope argentata")]), _vm._v("; "), _c('i', [_vm._v("c–Cyrtarachne")]), _vm._v(" sp.; "), _c('i', [_vm._v("d–Cyclosa")]), _vm._v(" sp.; "), _c('i', [_vm._v("e–Hypognatha mozamba")]), _vm._v("; "), _c('i', [_vm._v("f–Nephila clavipes")]), _vm._v("; "), _c('i', [_vm._v("g–Nephilengis malabarensis")]), _vm._v("; "), _c('i', [_vm._v("h–Epeirotypus brevipes")]), _vm._v("; "), _c('i', [_vm._v("i–Naatlo splendida")]), _vm._v("; "), _c('i', [_vm._v("j–Anapogonia")]), _vm._v(" (?) sp.; "), _c('i', [_vm._v("k–Anapisona simoni")]), _vm._v("; "), _c('i', [_vm._v("l–Maymena")]), _vm._v(" sp. #2168.")])]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0313"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "98",
      "id": "p98",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "474",
      "src": "images/chi-eberhard-fig0313.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.13.")]), _vm._v(" The substantial variation in the designs of the hubs of different genera of Araneidae ("), _c('i', [_vm._v("a–i")]), _vm._v(") suggest that there may be taxonomic patterns, but the studies necessary to test this hypothesis have yet to be performed (to different scales). "), _c('i', [_vm._v("a–Enacrosoma anomalum")]), _vm._v("; "), _c('i', [_vm._v("b–Spilasma duodecimguttata")]), _vm._v("; "), _c('i', [_vm._v("c–Bertrana laselva")]), _vm._v("; "), _c('i', [_vm._v("d–Eriophora nephiloides")]), _vm._v("; "), _c('i', [_vm._v("e–Mangora")]), _vm._v(" sp.; "), _c('i', [_vm._v("f–Araneus expletus")]), _vm._v("; "), _c('i', [_vm._v("g–Metazygia wittfeldae")]), _vm._v("; "), _c('i', [_vm._v("h–Gasteracantha")]), _vm._v(" sp.; "), _c('i', [_vm._v("i–Neoscona")]), _vm._v(" sp. #2002.")])]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0314"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "519",
      "src": "images/chi-eberhard-fig0314.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p98"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.14.")]), _vm._v(" The hub designs are very similar in 11 different species in the araneid genus "), _c('i', [_vm._v("Micrathena")]), _vm._v(" ("), _c('i', [_vm._v("a–k")]), _vm._v(") (see, in contrast, the intra-generic variation in "), _c('i', [_vm._v("Eustala")]), _vm._v(" in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0310"
    }
  }, [_vm._v("fig. 3.10")]), _vm._v(", "), _c('i', [_vm._v("Alpaida")]), _vm._v(" in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0315"
    }
  }, [_vm._v("fig. 3.15")]), _vm._v("). Although quantitative comparisons remain to be made, the hub holes were large, there was little if any free zone between the outer edge of the hub and the innermost loop of sticky spiral, and the hub lines spiraled outward slowly in a relatively circular path after one or a few tight loops at the edge of the hole. Even the hub of a species in the sister genus "), _c('i', [_vm._v("Chaetacis")]), _vm._v(" was similar ("), _c('i', [_vm._v("l")]), _vm._v("). In all of these species the spider rested at the hub, spanning the hub hole with her legs and tightening the web (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#fig0337"
    }
  }, [_vm._v("fig. 3.37")]), _vm._v(") (to different scales). "), _c('i', [_vm._v("a–M")]), _vm._v(". "), _c('i', [_vm._v("molesta")]), _vm._v("; "), _c('i', [_vm._v("b–M")]), _vm._v(". "), _c('i', [_vm._v("horrida")]), _vm._v("; "), _c('i', [_vm._v("c–M")]), _vm._v(". "), _c('i', [_vm._v("gracilis")]), _vm._v(" (?); d–"), _c('i', [_vm._v("M")]), _vm._v(". sp. nr. "), _c('i', [_vm._v("lucasi")]), _vm._v("; "), _c('i', [_vm._v("e–M")]), _vm._v(". "), _c('i', [_vm._v("plana")]), _vm._v("; "), _c('i', [_vm._v("f–M")]), _vm._v(". "), _c('i', [_vm._v("parallela")]), _vm._v("; "), _c('i', [_vm._v("g–M")]), _vm._v(". "), _c('i', [_vm._v("schreibersi")]), _vm._v("; "), _c('i', [_vm._v("h–M")]), _vm._v(". "), _c('i', [_vm._v("sexspinosa")]), _vm._v("; "), _c('i', [_vm._v("i–M")]), _vm._v(". "), _c('i', [_vm._v("bimucronota")]), _vm._v("; "), _c('i', [_vm._v("j–M")]), _vm._v(". "), _c('i', [_vm._v("duodecimspinosa")]), _vm._v("; "), _c('i', [_vm._v("k–M")]), _vm._v(". "), _c('i', [_vm._v("guerini")]), _vm._v("; "), _c('i', [_vm._v("l–Chaetacis cornuta")]), _vm._v(".")])]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0315"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "450",
      "src": "images/chi-eberhard-fig0315.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p99"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.15.")]), _vm._v(" There is substantial intra-generic variation in the hubs and free zones of these six species of the large Neotropical genus "), _c('i', [_vm._v("Alpaida")]), _vm._v(" (AR) (with 141 described species—Platnick 2014). Nevertheless, certain traits, such as locating the hub contiguous to or very near an adjoining support, may be typical of at least some species. It is not clear whether this genus is unusual in the degree to which hub and free zone designs vary. "), _c('i', [_vm._v("a–A")]), _vm._v(". "), _c('i', [_vm._v("truncata")]), _vm._v("; "), _c('i', [_vm._v("b–A")]), _vm._v(". "), _c('i', [_vm._v("anchicaya")]), _vm._v("; "), _c('i', [_vm._v("c–A")]), _vm._v(". "), _c('i', [_vm._v("acuta")]), _vm._v("; "), _c('i', [_vm._v("d–A")]), _vm._v(". "), _c('i', [_vm._v("niveosagillata")]), _vm._v("; "), _c('i', [_vm._v("e–A")]), _vm._v(". "), _c('i', [_vm._v("septemmammata")]), _vm._v("; "), _c('i', [_vm._v("f–A")]), _vm._v(". "), _c('i', [_vm._v("leucogramma")]), _vm._v(".")])]), _vm._v(" "), _c('p', [_vm._v("Summing up, I estimate from Platnick’s The World Spider Catalogue ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://research.amnh.org/iz/spiders/catalog/INTRO1.html",
      "target": "_blank"
    }
  }, [_vm._v("http://research.amnh.org/iz/spiders/catalog/INTRO1.html")]), _vm._v(") that the webs are entirely unknown, without even a single published photo or description, in about 56% of the approximately 170 genera of Araneidae. Probably the coverage is similar in Tetragnathidae, though it may be better in the smaller families Theridiosomatidae (Coddington 1986a), Uloboridae ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0113"
    }
  }, [_vm._v("fig. 1.13")]), _vm._v("), Nephilidae (Kuntner et al. 2008a), and the symphytognathoids (Lopardo et al. 2011). Web traits are mostly quantitative and vary continuously rather than qualitatively; thus substantial samples of species will be needed to confidently discuss intra-generic variation and whether there is overlap between genera.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.08.04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.08.04"
    }
  }, [_vm._v("3.2.8.4 Differences at higher taxonomic levels and a summary")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The possible importance of taxonomic constraints is illustrated by the small, simplified resting webs built by some mature male orb weavers ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#fig0904"
    }
  }, [_vm._v("fig. 9.4")]), _vm._v("). These webs serve not to capture prey, but presumably to protect the males from predation. Not surprisingly, the hubs of these webs resemble the orbs of conspecific females and immatures. The vertical orientation of webs of male "), _c('i', [_vm._v("Argiope argentata")]), _vm._v(" and their horizontal orientation in "), _c('i', [_vm._v("Mangora")]), _vm._v(" sp. seem unlikely to be related to differences in function, but rather to the orientations of the prey capture webs of conspecifics. Similarly, the lack in araneid species of the effective defense provided by the spring lines in theridiosomatid species is probably due to the lack of spring lines in the prey capture orbs of araneids.")]), _vm._v(" "), _c('p', [_vm._v("At the taxonomic level of families and subfamilies, I expect that there may be several distinguishing traits. For instance, uloborid orbs have several traits that are apparently widespread in this family and absent or nearly absent in the orbs of araneoids (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#fig0331"
    }
  }, [_vm._v("figs. 3.31")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#fig0724"
    }
  }, [_vm._v("7.24")]), _vm._v(", table in Lubin 1986). Nevertheless, the careful quantitative studies with substantial samples of species and genera needed to demonstrate this are lacking.")]), _vm._v(" "), _c('p', [_vm._v("Summarizing taxon-specificity in orb designs, it appears that species-specificity is rare. Genus-level specificity may be more common, and there are probably also family-level specificities. But we are a long way from documenting these specificities, if they exist.")])])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec03.02.09"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "100",
      "id": "p100",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.09"
    }
  }, [_vm._v("3.2.9 The properties of homologous lines are not invariable")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "chaft",
    attrs: {
      "id": "sec03.02.09.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.09.01"
    }
  }, [_vm._v("3.2.9.1 Differences between species")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Recent findings have confirmed early hints (e.g., Breed et al. 1964) that there is substantial variation in the mechanical and chemical properties of silk from homologous glands in different species ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#fig0925"
    }
  }, [_vm._v("fig. 9.25")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.09"
    }
  }, [_vm._v("sections 3.2.9")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0025#sec09.02.06"
    }
  }, [_vm._v("9.2.6")]), _vm._v("). It is now clear that previous studies (e.g., Eberhard 1986a) were incorrect in assuming that the properties documented in early studies of a few species (e.g., Denny 1976) are generally uniform throughout araneoid orb weavers. The mechanical properties of some lines from the same gland types are now known to vary substantially in different species ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#tab0303"
    }
  }, [_vm._v("table 3.3")]), _vm._v("). One particularly striking example is the sticky spiral baselines of "), _c('i', [_vm._v("Cyrtarachne bufo")]), _vm._v(" and "), _c('i', [_vm._v("nagasakiensis")]), _vm._v(", which have breaking strengths that are 7–10 times greater than those of the baselines of other araneids that build typical orbs (Cartan and Miyashita 2000). This difference illuminates the design of their webs, in which the sticky lines are so widely spaced that even large prey contact only a single line.")]), _vm._v(" "), _c('p', [_vm._v("Many differences between taxa are now known in scattered cases in temperate zone species. The greatest difference in the adhesive efficiencies of sticky spiral lines (µN of adhesive force/dry volume) in a sample of five different species was that "), _c('i', [_vm._v("Leucauge venusta")]), _vm._v(" (TET) was 18 times greater than "), _c('i', [_vm._v("Araneus marmoreus")]), _vm._v(" (AR) (Opell and Schwend 2009). The number of central nodules of glycoprotein in the droplets of glue on sticky spiral lines was double in "), _c('i', [_vm._v("Argiope trifasciata")]), _vm._v(" (AR) and single in "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" (AR) (Vollrath and Tillinghast 1991); Opell (pers. comm.) found that in another population of "), _c('i', [_vm._v("A. trifasciata")]), _vm._v(" they were single, while in "), _c('i', [_vm._v("Larinioides cornutus")]), _vm._v(" (AR) one web had 2–3 nodules/droplet but others had only 1. The mechanical properties of the sticky silk in the gumfoot lines of the theridiid "), _c('i', [_vm._v("Latrodectus hesperus")]), _vm._v(" differed from those of the sticky spiral silk in the orbs of the araneid "), _c('i', [_vm._v("Larinioides cornutus")]), _vm._v(" (Sahni et al. 2011). The stress-strain mechanical properties of major ampullate silk differed strikingly even among species in a single genus, "), _c('i', [_vm._v("Argiope")]), _vm._v(" (Blackledge et al. 2012b).")]), _vm._v(" "), _c('p', [_vm._v("Some species differences are correlated with environmental differences. There was a correlation between the chemical properties of the glue and the spider’s environment in the webs of "), _c('i', [_vm._v("Neoscona crucifera")]), _vm._v(" (AR), which builds in high humidity forest edge habitats at night, and "), _c('i', [_vm._v("Argiope aurantia")]), _vm._v(" (AR), which builds diurnal orbs in exposed, low humidity habitats. The glue droplets of "), _c('i', [_vm._v("A. aurantia")]), _vm._v(" had hygroscopic components (possibly glycoproteins or other low-molecular-mass compounds) that were not present in "), _c('i', [_vm._v("N. crucifera")]), _vm._v(" glue that made them more hygroscopic, and thus promoted sticky line function at lower humidities. At higher humidities (>60%) the "), _c('i', [_vm._v("A. aurantia")]), _vm._v(" droplets became saturated and adhesion decreased, possibly because their glycoproteins became over-lubricated, extended too readily, and released their adhesion to a surface (Sahni et al. 2011; Opell et al. 2013). In contrast, the energy needed to extend a "), _c('i', [_vm._v("N. crucifera")]), _vm._v(" droplet that had adhered to an object continued to increase at higher relative humidities (Sahni et al. 2011; Opell et al. 2013). Comparisons of the properties of the glue of five diverse araneoid species showed that the mix of organic salts and proteins in the glue was “tuned” to the typical humidities of their habitats to give maximum adhesion under natural conditions (Amarpuri et al. 2015).")]), _vm._v(" "), _c('p', [_vm._v("Presumably some of these differences in mechanical properties stem from differences in the chemical compositions of silk. The composition of even homologous lines from taxonomically close relatives sometimes differs strikingly. GABamide (4-aminobutyramide) is the predominant low weight organic compound in the sticky spiral glue in "), _c('i', [_vm._v("Argiope aurantia")]), _vm._v(" (and in "), _c('i', [_vm._v("Araneus")]), _vm._v(" spp. and "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v("), but in "), _c('i', [_vm._v("Argiope trifasciata")]), _vm._v(" the principle amine was N-acetylputrescine (N-acetyl-1,4-diaminobutane) (Townley et al. 1991). In three araneid species ("), _c('i', [_vm._v("A. trifasciata")]), _vm._v(", "), _c('i', [_vm._v("A. aurantia")]), _vm._v(", and "), _c('i', [_vm._v("Araneus cavaticus")]), _vm._v(") that varied substantially in four of the principal low weight water-soluble organic molecules in the sticky spiral glue, there were no differences in hygroscopic properties (which are key to maintaining stickiness and extensibility of the base line at different relative humidities because hydration of the droplet maintains both the supercontraction of the axial line and the extensibility of the glycoproteins in the glue droplet—Vollrath and Edmonds 1989; Townley et al. 1991; Opell et al. 2013, 2015). The differences may represent adaptations enabling lines to function at different temperatures.")]), _vm._v(" "), _c('p', [_vm._v("Correlations with environmental conditions can be complicated because of the large range of temperatures and humidities under which even a single web built at "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "103",
      "id": "p103",
      "role": "doc-pagebreak"
    }
  }), _vm._v("a sunny site will be called upon to function from dawn to mid-day (Townley et al. 1991). Because droplet extensibility affects the line’s ability to sum up the adhesive effects of multiple droplets when adhering to prey, daily changes in humidity may alter prey capture abilities of orbs significantly (Opell et al. 2011a). At high humidities, a sticky spiral line of "), _c('i', [_vm._v("A. diadematus")]), _vm._v(" can increase its glue volume by >40% by absorbing water from the atmosphere (Edmonds and Vollrath 1992). Higher humidity at the moment at which an "), _c('i', [_vm._v("A. diadematus")]), _vm._v(" spider produces a sticky line can also increase the size and the subsequent ability of its sticky droplets to absorb atmospheric water (Edmonds and Vollrath 1992). This raises the heretofore unrecognized possibility of effects on the timing of web construction during the day ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#tab0802"
    }
  }, [_vm._v("table 8.2")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.10"
    }
  }, [_vm._v("section 8.10")]), _vm._v("). The stickiness of the sticky spirals of the araneids "), _c('i', [_vm._v("Argiope")]), _vm._v(" spp. also varied seasonally (Opell et al. 2009). Environment-induced changes in stickiness also occur in cribellates. The stickiness of the cribellum silk of the uloborid "), _c('i', [_vm._v("Hyptiotes cavatus")]), _vm._v(" doubled when humidity was raised from 1–2% to 45% (Hawthorn and Opell 2003).")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "tab0303"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th",
    attrs: {
      "colspan": "6"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "101",
      "id": "p101",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "thn"
  }, [_vm._v("Table 3.3.")]), _vm._v(" The differences in the means of biomechanical properties of the major ampullate dragline silk lines of different species of spiders emphasize that the variability of this silk showed some logical patterns, but also some surprises. The species that do not build webs all have relatively less tough draglines, while the species with the most striking physical demands on its silk, "), _c('i', [_vm._v("Caerostris darwini")]), _vm._v(" (whose webs have bridge lines up to >20 m long), has the toughest silk. The next toughest silk, however, comes from "), _c('i', [_vm._v("Scytodes")]), _vm._v(" sp., a genus in which prey are restrained by spitting adhesive silk onto them and the spiders have no web or at most a loose tangle near the substrate (Eberhard 1973b, 1986a). The relatively high toughness of "), _c('i', [_vm._v("Kukulcania hibernalis")]), _vm._v(", whose substrate web ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0017#fig0510"
    }
  }, [_vm._v("fig. 5.10")]), _vm._v(") never has to absorb the impact of prey, is also unexpected. Some species also showed substantial intra-specific variations in mechanical properties ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.09"
    }
  }, [_vm._v("section 3.2.9")]), _vm._v("), and further surprises may be in store (after Agnarsson et al. 2010 with a few corrections of web classifications; references are the following: A = Swanson et al. 2006; B = Swanson et al. 2009; C = Agnarsson et al. 2008; D = Agnarsson et al. 2010).")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Taxa"), _c('br'), _vm._v("Stiffness"), _c('br'), _vm._v("(Gpa)")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Strength"), _c('br'), _vm._v("(Mpa)")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Extensibility"), _c('br'), _vm._v("(ln mm/mm)")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Toughness"), _c('br'), _vm._v("(MJ/m"), _c('sup', [_vm._v("3")]), _vm._v(")")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Web (reference)")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Liphistiidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Liphistius murphyorum")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5.0")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("130")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.05")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Burrow (B)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("L. mayalanus")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("3.5")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("100")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.1")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Burrow (B)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Theraphosidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Davus fasciatum")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1.5")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("50")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.3")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Burrow (?) (B)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Grammastola rosea")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1.0")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("20")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.65")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("15")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Burrow (B)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Aphonopelma seemanni")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1.5")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("90")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.35")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("25")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Burrow (B)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Cyriopagopus paganus")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("3.5")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("190")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.25")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("30")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Burrow (?) (B)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Pterinochilus murinus")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("2.5")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("110")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.3")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("35")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Burrow (?) (B)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Phormictopus cancerides")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("3.0")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("110")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.3")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("45")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Burrow (?) (B)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Poecilotheria regalis")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("4.5")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("210")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.35")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("70")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Burrow (?) (B)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Dysderidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Dysdera crocata")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8.0")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("545")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.177")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("48")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("None (A)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Lycosidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Schizocosa mccooki")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("4.6")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("553")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.242")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("60")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("None (A)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Hypochilidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Hypochilus pococki")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10.9")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("945")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.17")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("96")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Lampshade (A)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Agelenidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Agelenopsis aperta")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("12.1")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("958")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.183")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("101")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Sheet (A)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Oxyopidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Peucetia viridans")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10.1")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1089")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.178")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("108")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("None"), _c('sup', [_vm._v("1")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("P. viridans")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10.9")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1064")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.181")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("111")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("None"), _c('sup', [_vm._v("1")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Nephilidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Nephila clavipes")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("13.8")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1215")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.172")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("111")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb (A)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Plectreuridae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Plectreurys tristis")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("16.1")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("829")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.241")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("112")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Tangle"), _c('sup', [_vm._v("2")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Amphinectidae")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Metaltella simoni")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8.6")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("765")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.281")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("114")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Tangle"), _c('sup', [_vm._v("3")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Pholcidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Holocnemus pluchei")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("14.3")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1244")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.153")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("115")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Sheet+tangle (A,WE)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "102",
      "id": "p102",
      "role": "doc-pagebreak"
    }
  }), _c('b', [_vm._v("Salticidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Phidippus ardens")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("14.2")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("975")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.189")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("116")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("None (A)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Deinopidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Deinopis spinosa")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10.4")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1345")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.191"), _c('sup', [_vm._v("c")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("124")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Modified orb"), _c('sup', [_vm._v("4")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("D. spinosa")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("13.5")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1329")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.185"), _c('sup', [_vm._v("c")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("136")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Modified orb"), _c('sup', [_vm._v("4")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Uloboridae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Uloborus diversus")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("9.1")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1078")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.234")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("129")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb (A)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Filistatidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Kukulcania hibernalis")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("22.2")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1044")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.222")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("132")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Substrate (A)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Araneidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Argiope trifasciata")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("9.2")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1137")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.215")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("115")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb (C)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("A. argentata")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8.2")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1463")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.184")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("116")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb (A)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("A. argentata")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5.3")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1371")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.214")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("119")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb (C)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Metepeira grandiosa")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10.6")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1049")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.235")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("121")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb (A)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Mastophora hutchinsoni")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("9.4")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1137")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.268")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("140")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Bolas (A)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("M. hutchinsoni")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("9.8")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1152")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.280")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("161")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Bolas (C)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("M. phrynosoma")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11.3")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("698")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.340")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("156")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Bolas (C)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Araneus gemmoides")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8.3")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1376")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.224")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("141")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb (A)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("A. gemmoides")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8.6")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1414")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.237")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("164")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb (C)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Gasteracantha cancriformis")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8.0")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1315")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.301")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("178")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb"), _c('sup', [_vm._v("5")]), _vm._v(" (A)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("G. cancriformis")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("7.3")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1199")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.331")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("193")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb"), _c('sup', [_vm._v("5")]), _vm._v(" (C)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Caerostris darwini")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11.5")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1652")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.52")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("354")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb (D)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Tetragnathidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Leucauge venusta")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10.6")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1469")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.233")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("151")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Orb (A)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Theridiidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Latrodectus geometricus")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10.2")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("764")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.310")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("117")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Gumfoot (C)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("L. hesperus")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("9.5")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("959")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.224")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("132")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Gumfoot (C)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("L. hesperus")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10.2")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1441")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.303")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("181")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Gumfoot (A)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Scytodidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Scytodes")]), _vm._v(" sp.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10.7")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("1179")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("0.357")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("230")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Tangle"), _c('sup', [_vm._v("6")]), _vm._v(" (A)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("1")]), _vm._v(" Immature individuals have webs.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("2")]), _vm._v(" Small tangle webs at sheltered sites such as under rocks (WE).")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("3")]), _vm._v(" Web form according to Griswold et al. 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_vm._v("4 The non-sticky lines in the “hand-held” webs of this species are extremely elastic, so the lines whose elasticity was measured must not have been from webs, but rather from the draglines. The lines in the web may be from other glands opening on other spigots on the anterior spinnerets (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#sec10.09.03"
    }
  }, [_vm._v("section 10.9.3")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("5")]), _vm._v(" Some webs have very long frame lines, up to 5 m or more.")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("6")]), _vm._v(" One tropical social species has more or less extensive tangles, but most "), _c('i', [_vm._v("Scytodes")]), _vm._v(" have at most very sparse tangles.")])])])])]), _vm._v(" "), _c('p', [_vm._v("The upshot of the variations in silk properties is that the ability of a line to retain prey can be affected by the habitat and the time of day when the prey strikes the web. Possible correlations between different web designs and differences in the mechanical properties of homologous lines merit further exploration. Further integration of silk properties and differences in habitats in discussions of web designs, following the pioneering work of Miyashita (1997), Opell and Schwend (2009), Harmer et al. (2011), Sensenig et al. (2011), Blackledge et al. (2012a), and Amarpuri et al. (2015), is likely to be highly rewarding.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.09.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.09.02"
    }
  }, [_vm._v("3.2.9.2 Differences within species")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Even more surprising is the substantial degree of intra-specific “plasticity” (variation in the material properties of silk obtained from a single spider through different spinning methods) in the properties of lines from the same glands (Boutry et al. 2011). I will list a few scattered examples of this as yet largely unexplored field to give an idea of the surprising magnitudes and kinds of variation (see also "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02.09"
    }
  }, [_vm._v("section 3.2.9")]), _vm._v(" and Herberstein and Tso 2011).")]), _vm._v(" "), _c('p', [_vm._v("The vertical major ampullate gumfoot lines of "), _c('i', [_vm._v("Parasteatoda")]), _vm._v(" (= "), _c('i', [_vm._v("Achaearanea")]), _vm._v(") "), _c('i', [_vm._v("tepidariorum")]), _vm._v(" were more compliant than the horizontal major ampullate lines in the tangle used for support (Boutry and Blackledge 2009). There was also variation in the properties of dragline silk spun by spiders in three spider clades when they were in three different situations (line produced while dropping, while walking, and when forcibly extracted from an immobilized spider) (Boutry et al. 2011). Variation was compared between members of the RTA clade and orbicularians with respect their anatomy, silk biochemistry, and phylogenetic relations. The orbicularians seemed less dependent on external spinning conditions, and probably used a valve in their spinning duct to control friction forces and speed during spinning (Boutry et al. 2011). This plasticity probably resulted more from differences in processing the silk dope in the spinning duct than from differences in silk biochemistry.")]), _vm._v(" "), _c('p', [_vm._v("Regarding stickiness, in "), _c('i', [_vm._v("Cyclosa turbinata")]), _vm._v(" (AR), stickiness varied between individuals on the basis of the amount of silk available (Crews and Opell 2006), while the sticky spiral loops in the outer portions of orbs of "), _c('i', [_vm._v("Argiope")]), _vm._v(" spp. and "), _c('i', [_vm._v("C. turbinata")]), _vm._v(" were stickier than those near the hub (Blackledge et al. 2011; Crews and Opell 2006; Opell et al. 2009). After being exposed to continuous moderate wind (1.1 m/s) for seven days, "), _c('i', [_vm._v("C. mulmeinensis")]), _vm._v(" in still air built sticky spiral lines that had sticky droplets whose diameters were larger (had both greater volume and surface area) (Wu et al. 2013). The stickiness of the line remained unchanged, but its tendency to dehydrate was probably reduced, and the glue had greater amounts of hydrophilic low-molecular-weight compounds (Wu et al. 2013). There may even be individual differences in the amount of edge-to-hub change in diameters of the sticky spiral base line. When three webs were measured for each of eight individuals of "), _c('i', [_vm._v("Argiope argentata")]), _vm._v(" (four lines in each web), the mean diameter of the outermost sticky spiral lines averaged 233% of that of the innermost lines in one individual, but only 128% in another (Blackledge et al. 2011). The diameters of the sticky droplets on sticky spiral lines were greater below the hub than above the hub in the same webs of "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" (AR) (Edmonds and Vollrath 1992). The density of puffs of cribellum silk also varied in the same web of "), _c('i', [_vm._v("Uloborus diversus")]), _vm._v(" (UL) (fig. 4 of Langer and Eberhard 1969) and "), _c('i', [_vm._v("Thaida peculiaris")]), _vm._v(" (fig. 19F of Griswold et al. 2005), so some cribellates may also modulate the adhesiveness of their lines. The draglines that the araneid "), _c('i', [_vm._v("Argiope trifasciata")]), _vm._v(" produced when climbing vertically "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "104",
      "id": "p104",
      "role": "doc-pagebreak"
    }
  }), _vm._v("resisted larger loads than those produced when the spider moved horizontally (Garrido et al. 2002). "), _c('i', [_vm._v("Araneus ventricosus")]), _vm._v(" silk had higher tensile properties in webs higher above the ground (Pan et al. 2004). Exposure to constant wind during the preceding seven days induced the araneid "), _c('i', [_vm._v("Cyclosa mulmeinensis")]), _vm._v(" to produce dragline silk of greater strength, extensibility, toughness, ultimate tension, and breaking energy (Liao et al. 2009). Even the properties of the line produced during a single descent on a dragline can vary, because the speed at which a dragline was drawn correlated positively with its strength (Ortlepp and Gosline 2004; Pérez-Rigueiro et al. 2005). The diameters of the radii in orbs built in captivity by mature females of the araneid "), _c('i', [_vm._v("Larinioides cornutus")]), _vm._v(" averaged only 49.6% of the mean diameter of radii in field webs (Sensenig et al. 2010b). Hesselberg and Vollrath (2012) noted that in "), _c('i', [_vm._v("Nephila edulis")]), _vm._v(" (NE) “all of our reported silk mechanical properties showed large variations between different webs and spiders”; strain at breaking, breaking energy, initial Young’s modulus, and point of yielding all varied in this species with both rate of silk production and temperature (Vollrath et al. 2001). The diameters of non-sticky lines (presumably ampullate gland silk) also varied substantially (by a factor of >2 within a web and by about 6x between the webs of only 8 different individuals) in "), _c('i', [_vm._v("Latrodectus hesperus")]), _vm._v(" (THD) (Blackledge et al. 2005c). There was intra-web variation in the theridiid "), _c('i', [_vm._v("Parasteatoda")]), _vm._v(" (="), _c('i', [_vm._v("Achaearanea")]), _vm._v(") "), _c('i', [_vm._v("tepidariorum")]), _vm._v("; the supporting web lines were thicker, able to bear higher loads before deforming permanently and before breaking, and less elastic than other lines in the same web that bore droplets of sticky material (Boutry and Blackledge 2009).")]), _vm._v(" "), _c('p', [_vm._v("Feeding history sometimes affects the properties of lines. "), _c('i', [_vm._v("Latrodectus hesperus")]), _vm._v(" spiders that enjoyed a higher rate of feeding built webs in which the mean diameter of lines was double that of lines in the webs of poorly fed spiders (Blackledge and Zevenbergen 2007). A spider’s weight correlated with a line’s mechanical properties. The stiffness (Young’s modulus) of draglines produced by heavier "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" (AR) was lower than that of lighter individuals (Vollrath and Köhler 1996). The diameters of dragline fibers in the orb of "), _c('i', [_vm._v("A. diadematus")]), _vm._v(" correlated with the spider’s weight (Christiansen et al. 1962; Vollrath and Köhler 1996; Blackledge et al. 2011). Appendix O3.3 discusses the additional possibility (somewhat uncertain in my opinion) that orb weavers alter silk properties adaptively on the basis of the mechanical demands made by recent prey impacts (Tso et al. 2007).")]), _vm._v(" "), _c('p', [_vm._v("As might be expected from this variation, there are also intra-specific differences in silk chemistry. There was substantial variation in the low-molecular-weight organic compounds associated with sticky spiral glue in a single population of "), _c('i', [_vm._v("Argiope aurantia")]), _vm._v(", and low-molecular-weight components of the sticky spiral lines also varied among different populations of "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" (NE) (Higgins et al. 2001). The silk in the thicker dragline threads produced by heavier individuals of "), _c('i', [_vm._v("A. diadematus")]), _vm._v(" also had altered mechanical properties, with larger diameter lines having lower stiffness (Young’s modulus) (Vollrath and Köhler 1996).")]), _vm._v(" "), _c('p', [_vm._v("And even a single line, once it is produced, can show significant changes in its mechanical properties under different environmental conditions. For instance, the adhesive properties of sticky spiral lines changed when temperature and humidity changed. In "), _c('i', [_vm._v("Argiope aurantia")]), _vm._v(", which lives in open weedy habitats, the energy to extend a droplet on a sticky spiral line (an index of its ability to transfer adhesive force and to dissipate energy) was greatest under afternoon conditions (hot and dry), less under morning conditions (cool and humid), and least under hot and humid afternoon conditions (Stellwagen et al. 2014). Comparing several araneid species, changes induced by exposure to UV radiation reduced the energy to extend a droplet in the sticky spiral lines of a species with a nocturnal orb ("), _c('i', [_vm._v("Neoscona crucifera")]), _vm._v(" [AR]) and a diurnal forest species ("), _c('i', [_vm._v("Micrathena gracilis")]), _vm._v(" [AR]), but not in species that build diurnal webs in open habitats ("), _c('i', [_vm._v("Argiope aurantia")]), _vm._v(" [AR], "), _c('i', [_vm._v("Verrucosa arenata")]), _vm._v(" [AR], and "), _c('i', [_vm._v("Leucauge venusta")]), _vm._v(" [TET]) (Stellwagon et al. 2015). Environmental factors also induced changes in the mechanical properties of dragline silk that differed between species in apparently adaptive manners. Ecologically realistic intensities and durations of UV irradiation resulted in mechanical strengthening of the dragline silk of three diurnal araneoid orb weavers during the operating lifetimes of their orbs, but in weakening of the dragline silk of two nocturnal species (Osaki and Osaki 2011).")]), _vm._v(" "), _c('p', [_vm._v("In sum, orbs may be much more subtle traps than might have been supposed. It seems likely that spiders may fine-tune the properties of the materials in their "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "105",
      "id": "p105",
      "role": "doc-pagebreak"
    }
  }), _vm._v("orbs to be maximally effective under the environmental conditions at the time of day when their webs will be up, and perhaps even when particularly important prey are active.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.09.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.09.03"
    }
  }, [_vm._v("3.2.9.3 Consequences for understanding orb web designs")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The variations just described sound a strong cautionary note for attempts to understand the functional significance of different orb designs. Differences in the silk itself will clearly have to be taken into account in future attempts to understand the functions of different orb designs. The most promising step in this direction is the pioneering study of Sensenig et al. (2010a) of 24 species in 19 genera and 5 orbicularian families. The authors presented extensive data on the physical properties of the lines in their orbs corrected for the sizes of the adult spiders, and also attempted to correct for the possible effects of phylogeny. They concluded that evolutionary shifts to larger body sizes have been repeatedly accompanied by improved abilities to stop prey, due to changes in both silk material and web designs. Large spiders produced silk with improved material properties, and also used more silk, to make webs that have superior stopping abilities. For spiders of comparable size, those spinning “higher quality” silk build webs with more sparse arrays of lines. These conclusions all seem intuitively reasonable, but they are difficult to evaluate for several reasons (see appendix O3.3).")]), _vm._v(" "), _c('p', [_vm._v("The run-on lists in this section are designed to emphasize the possible importance of the hitherto unexpected extent of inter- and intra-specific variations. One logical consequence of all this variation would seem to be that spiders experience both mechanical constraints and trade-offs, with greater costs being associated some particular mechanical or chemical properties. Otherwise one might have expected them to consistently make the strongest and stickiest lines possible, something they are obviously not doing. These costs and their trade-offs remain to be quantified. Just as the study of spider venoms has been revolutionized by the discovery of striking, unexpected diversity (up to a thousand different toxin molecules in a single gland!) (G. Binford pers. comm.), so the chemical diversity of silk molecules promises to revolutionize understanding of the functional significance of differences in the designs of different webs.")])])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec03.02.10"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.10"
    }
  }, [_vm._v("3.2.10 Correlations between orb design and details of attack behavior are inconsistent")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("A spider and her web obviously act as a team in capturing prey (Robinson 1975), and it is reasonable to expect that the overall designs of the spiders’ webs and attack behavior and morphology should coevolve. Some spider groups provide beautiful examples of evolutionary adjustments of attack behavior and morphology to webs and prey. Atypids strike from within their tubular web at prey on the outer surface, using especially long, stilleto-like cheliceral fangs (Bradley 2013); tube-dwelling "), _c('i', [_vm._v("Segestria")]), _vm._v(" fold the dangerous mandibles and abdomen tip of stinging hymenopteran prey away from themselves by pulling the prey into the tunnel (Bristowe 1958); "), _c('i', [_vm._v("Oecobius annulipes")]), _vm._v(" utilized the open surfaces where they built webs to rapidly run over and around dangerous ant prey, spreading a swath of wrapping lines using special setae on the anal tubercle (Glatz 1967). The expectations of web design–attack behavior coevolution are only met partially, however, in orb webs. I will begin with some of the numerous cases that do not seem to fit predictions.")]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.10.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.10.01"
    }
  }, [_vm._v("3.2.10.1 Inconsistent relationships")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Two obvious variables in attack behavior are the speed with which the spider reaches the prey, and her ability to immobilize larger and more dangerous prey more quickly and securely by wrapping them as opposed to just biting. Both of these variables vary widely among orb weavers (e.g., Robinson and Olazarri 1971; Robinson and Mirick 1971; Robinson 1975; Suter 1978; Heiling 2004; Briceño and Eberhard 2011). Olive (1980), for instance, contrasted the effectiveness of attacks on a variety of prey by the araneids "), _c('i', [_vm._v("Araneus trifolium")]), _vm._v(" and "), _c('i', [_vm._v("Argiope trifasciata")]), _vm._v(", which co-occur in different subhabitats in old fields; he found that each species was especially effective in attacking the kinds of prey that were more common in its own subhabitat. "), _c('i', [_vm._v("Araneus trifolium")]), _vm._v(", which has large fangs and relatively short legs, were slower to reach prey; they built open-meshed webs that were higher above the ground, and specialized on innocuous but rapidly escaping prey such as Diptera and Lepidoptera. In contrast, "), _c('i', [_vm._v("A. trifasciata")]), _vm._v(" had relatively longer legs, smaller fangs, and more densely meshed orbs built near the ground, and specialized on dangerous, slowly escaping insects such as grasshoppers.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "106",
      "id": "p106",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Olive attempted to generalize from these correlations in his tiny sample of species, but the associations that he found between leg length, cheliceral size, and web design are not consistent in other species. For instance, the tetragnathid "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(" has relatively long, thin legs and attacks very rapidly (Briceño and Eberhard 2011), but has robust chelicerae. Using relative numbers of radii and sticky spiral loops as a guide ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0412"
    }
  }, [_vm._v("fig. 4.12")]), _vm._v("), its webs have moderate to open sticky spiral spacing and moderate numbers of radii. "), _c('i', [_vm._v("Cyclosa")]), _vm._v(" spp. and "), _c('i', [_vm._v("Allocyclosa bifurca")]), _vm._v(" have moderately short legs, moderately small chelicerae, and moderate attack times, but have dense sticky spiral loops and proportionally large numbers of radii (Peters 1954; Suter 1978; WE) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0019#fig0621"
    }
  }, [_vm._v("figs. 6.21")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#fig0741"
    }
  }, [_vm._v("7.41")]), _vm._v("). The short-legged, heavy-bodied "), _c('i', [_vm._v("Gasteracantha cancriformis")]), _vm._v(" has moderately-sized chelicerae, and executed slow attacks preceded by repeated web shakes (Eberhard 1989b), but it built webs with only moderate densities of radii and sticky spirals ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#fig0322"
    }
  }, [_vm._v("figs. 3.22")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0412"
    }
  }, [_vm._v("4.12")]), _vm._v(") (WE).")]), _vm._v(" "), _c('p', [_vm._v("Zschokke et al. (2006) also checked for correlations between orb properties and attack behavior. They found that the mean retention time for the fruit fly "), _c('i', [_vm._v("Anastrepha ludens")]), _vm._v(" in the webs of three orb weavers, "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" (NE), "), _c('i', [_vm._v("Verrucosa arenata")]), _vm._v(" (AR), and "), _c('i', [_vm._v("Leucauge venusta")]), _vm._v(" (TET), correlated with the mean time needed by the spider to bite or to begin to wrap it. Again, the sample of spider and prey species was small. Common retention times in the webs of the first two species were also more than an order of magnitude greater than the attack times, and retention times for other prey species were very different, so it is difficult to evaluate the general significance of these patterns.")]), _vm._v(" "), _c('p', [_vm._v("In general, the biological significance of means of the times to attack prey is uncertain, because attack speed varies widely with different prey (e.g., Robinson and Olazarri 1971; Robinson and Robinson 1973a on "), _c('i', [_vm._v("Argiope argentata")]), _vm._v(" and "), _c('i', [_vm._v("Nephila pilipes")]), _vm._v(", Zschokke et al. 2006 on "), _c('i', [_vm._v("N. clavipes")]), _vm._v(", "), _c('i', [_vm._v("L. venusta")]), _vm._v(", "), _c('i', [_vm._v("V. arenata")]), _vm._v(", and "), _c('i', [_vm._v("Nihonhimea tesselata")]), _vm._v("), with sites of the prey in the web, and also with differences in previous feeding success (Herberstein et al. 1998 on "), _c('i', [_vm._v("A. keyserlingi")]), _vm._v("). One simplifying step could be to use the maximum attack speeds, and ignore the long delays sometimes associated with dangerous prey or satiated spiders. Even using maximum speeds, however, it is clear that some predictions do not match observations. Spiders such as "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" (Landolfa and Barth 1996) and "), _c('i', [_vm._v("Mangora")]), _vm._v(" spp. (WE) with sticky spiral-rich webs ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0404"
    }
  }, [_vm._v("figs. 4.4")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0412"
    }
  }, [_vm._v("4.12")]), _vm._v(") are very quick to arrive at trapped prey. In "), _c('i', [_vm._v("N. clavipes")]), _vm._v(" 35% of attacks took <1 s, and the first response at the hub occurred in <40 ms in 58% of the trials (Landolfa and Barth 1996). These very rapid attacks are particularly dramatic in view of the very slow movements of "), _c('i', [_vm._v("Nephila")]), _vm._v(" spp. in other contexts. At the other extreme, attacks were consistently very slow in some species with sticky spiral-poor orbs such as the stubby-legged theridiosomatids "), _c('i', [_vm._v("Theridiosoma")]), _vm._v(" spp., "), _c('i', [_vm._v("Ogulnius")]), _vm._v(" sp., and "), _c('i', [_vm._v("Epeirotypus")]), _vm._v(" spp. (McCook 1889; Wiehle 1929; Coddington 1986a; WE).")]), _vm._v(" "), _c('p', [_vm._v("The araneids "), _c('i', [_vm._v("Micrathena gracilis")]), _vm._v(", "), _c('i', [_vm._v("M. duodecimspinosa")]), _vm._v(", and "), _c('i', [_vm._v("G. cancriformis")]), _vm._v(" were also slow (Uetz and Hartsock 1987; WE) ("), _c('i', [_vm._v("M. gracilis")]), _vm._v(" apparently never reached prey in less than 3 s), but they had intermediate orb designs ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0009#fig0104"
    }
  }, [_vm._v("figs. 1.4")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#fig0322"
    }
  }, [_vm._v("3.22")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0412"
    }
  }, [_vm._v("4.12")]), _vm._v("). In contrast, the tetragnathid "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(" also built intermediate web designs ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0412"
    }
  }, [_vm._v("figs. 4.12")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#fig0714"
    }
  }, [_vm._v("7.14d")]), _vm._v("), but executed extraordinarily rapid attacks that often took <0.5 s even when the spider had to turn >90° before running to attack (Briceño and Eberhard 2011). The fact that "), _c('i', [_vm._v("Arachnura melanura")]), _vm._v(" (AR) employed a jerky gait during attacks (probably as camouflage from predators—Robinson and Lubin 1979a) indicates that speed is not always of overriding importance.")]), _vm._v(" "), _c('p', [_vm._v("Another possible attack variable is the behavior used by the spider to restrain the prey: bite it with the chelicerae (common for most prey in tetragnathids, nephilids, and some araneids) (Robinson 1975; Kuntner et al. 2008a; WE); or wrap it in silk (common in uloborids and many araneids) (Robinson 1975; Lubin 1986; WE). But the web designs of species that attack prey by biting range widely, from the dense orbs of "), _c('i', [_vm._v("Nephila")]), _vm._v(" spp. (NE) that are rich in both radii and sticky spiral loops (Kuntner et al. 2008a), to the dense sticky spiral but only moderate number of radii in "), _c('i', [_vm._v("Dolichognatha")]), _vm._v(" spp. (TET) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#fig0343"
    }
  }, [_vm._v("figs. 3.43a")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0412"
    }
  }, [_vm._v("4.12")]), _vm._v(") (Eberhard 1986a), to the flimsy, open-meshed orbs of "), _c('i', [_vm._v("Tetragnatha")]), _vm._v(" spp. and "), _c('i', [_vm._v("Metabus ocellatus")]), _vm._v(" (TET) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0412"
    }
  }, [_vm._v("figs. 4.12")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#fig0743"
    }
  }, [_vm._v("7.43")]), _vm._v("). Likewise, the designs of the orbs of species that attack prey by wrapping them range from webs with dense sticky spirals araneids such as "), _c('i', [_vm._v("Acacesia hamata")]), _vm._v(" and "), _c('i', [_vm._v("Mangora")]), _vm._v(" spp. (Carico 1986; Eberhard 1986a), to the more or less typical designs of "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" and "), _c('i', [_vm._v("A. expletus")]), _vm._v(" (Witt et al. 1968; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0217"
    }
  }, [_vm._v("figs. 2.17")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0307"
    }
  }, [_vm._v("3.7")]), _vm._v("), to the sticky spiral-poor orbs of "), _c('i', [_vm._v("Uloborus")]), _vm._v(" spp. (UL) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#fig0331"
    }
  }, [_vm._v("fig. 3.31")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("A final possibility is that spiders respond more rapidly "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "107",
      "id": "p107",
      "role": "doc-pagebreak"
    }
  }), _vm._v("to prey in orbs with “higher regularity” (Zschokke and Vollrath 2000). This trend was documented only with two unpublished studies, however; further details will be necessary to evaluate this possibility.")]), _vm._v(" "), _c('p', [_vm._v("In sum, these failures to find correlations with attack behavior do not falsify the idea that retention times will tend to correlate positively with web design traits such as the relative density and strength of sticky lines. They suggest however that additional factors have also had important roles in the evolution of these designs. Uncertainty regarding cause and effect may also be involved. (Is the web of a spider that attacks slowly expected to be especially well designed regarding relative radius numbers and sticky spiral spacing for retaining prey? Or to other factors, such as thicker or more adhesive lines, or to weak, easy to retain prey that enable spiders to invest less in rapid attacks?) Perhaps with larger samples and corrections for other factors, predicted trends with attack behavior will be discovered. One possibility, a correlation between attack speeds in different portions of an orb and the degree of vertical asymmetry in orbs, is discussed in section 3.8. This topic is clearly complex and poorly understood.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.10.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.10.02"
    }
  }, [_vm._v("3.2.10.2 More likely correlations")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("One correlation is very likely to be consistent, even though only few published data are available at the moment: spiders with relatively stubby legs will tend to attack prey more slowly. Relatively long legs, in contrast, allow high running speeds, as in "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" and "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(" (though they do not guarantee rapid attacks, as illustrated by the slow cautious attacks of the long-legged theridiid "), _c('i', [_vm._v("Theridion evexum")]), _vm._v("—Barrantes and Weng 2007b). The median times to reach prey in the webs of three orb weavers with long, medium, and stubby legs were, respectively 1 s for "), _c('i', [_vm._v("L. mariana")]), _vm._v(" (TET), 4 s for "), _c('i', [_vm._v("Metazygia yobena")]), _vm._v(" (AR), and 8 s for "), _c('i', [_vm._v("Gasteracantha cancriformis")]), _vm._v(" (AR) (Eberhard 1989b). I know of no general study documenting attack time in stubby-legged species, but in my own incidental observations, the relatively short-legged araneids "), _c('i', [_vm._v("G. cancriformis")]), _vm._v(", "), _c('i', [_vm._v("Micrathena duodecimspinosa")]), _vm._v(", "), _c('i', [_vm._v("Hypognatha")]), _vm._v(" sp., theridosomatids in general, the uloborid "), _c('i', [_vm._v("Hyptiotes")]), _vm._v(", and the theridiids "), _c('i', [_vm._v("Phoroncidia")]), _vm._v(" spp. all approached prey slowly. Some, like "), _c('i', [_vm._v("M. duodecimspinosa")]), _vm._v(", routinely began attacks by turning at the hub and strongly jerking the sector of web containing the prey, rather than running toward it; perhaps the jerks increased the entanglement of the prey. It might be interesting to trace the evolution of stubby legs (presumably they are derived in some of these lineages) and to check for concomitant changes in web design that might make jerks more effective in entangling prey. In general, web traits favoring retention must be especially important in these groups.")]), _vm._v(" "), _c('p', [_vm._v("While short legs impede rapid attacks, they facilitate holding the web tense while waiting for prey to arrive (the legs of the theridiosomatid genera "), _c('i', [_vm._v("Epeirotypus")]), _vm._v(" and "), _c('i', [_vm._v("Theridiosoma")]), _vm._v(" and the uloborid "), _c('i', [_vm._v("Hyptiotes cavatus")]), _vm._v(", which tense their webs for hours at a time, are especially short and thick—Shinkai and Shinkai 1985; Coddington 1986a; Opell and Konur 1992). Tensing the web this way is undoubtedly costly in terms of energy and materials. In a sample of four species, the first anterior leg depressor muscles had denser arrays of mitochondria and tracheae in those species with more active web-monitoring behavior (Opell and Konur 1992). Increased strength to hold the web may also be favored in "), _c('i', [_vm._v("Hyptiotes")]), _vm._v(". Perhaps reeling in each radius during sticky spiral construction by "), _c('i', [_vm._v("G. cancriformis")]), _vm._v(", instead of walking outward along the radius ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#fig0325"
    }
  }, [_vm._v("fig. 3.25")]), _vm._v("; WE), also favors strong legs.")]), _vm._v(" "), _c('p', [_vm._v("Another seemingly consistent association related to attack behavior concerns orb symmetry. In those species in which the spider rests off the orb in a retreat, the hub is consistently displaced toward the side nearest the retreat ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0316"
    }
  }, [_vm._v("fig. 3.16")]), _vm._v("). An arbitrary sample includes "), _c('i', [_vm._v("Zygiella x-notata")]), _vm._v(" (AR) (Le Guelte 1966 and Endo 1988), "), _c('i', [_vm._v("Araneus legonensis")]), _vm._v(" (Edmunds and Edmunds 1986), "), _c('i', [_vm._v("Larinioides sclopetarius")]), _vm._v(" (Heiling 2004), "), _c('i', [_vm._v("Metazygia wittfeldae")]), _vm._v(" (WE), "), _c('i', [_vm._v("Metepeira")]), _vm._v(" spp. (AR) (WE), "), _c('i', [_vm._v("Araneus expletus")]), _vm._v(" (AR) (WE), "), _c('i', [_vm._v("Dolichognatha pentagona")]), _vm._v(" (TET) (WE), and "), _c('i', [_vm._v("Chrysometa")]), _vm._v(" spp. (TET) (WE). Peters (1937), Le Guelte (1966), and Heiling (2004) found that when they experimentally moved the position of the retreat relative to that of the orb by rotating the frame in which the spider was housed, "), _c('i', [_vm._v("Z. x-notata")]), _vm._v(" and "), _c('i', [_vm._v("L. sclopetarius")]), _vm._v(" responded by building orbs in which the hub was displaced toward the new site of the retreat. These asymmetries shorten the spider’s path in attacking prey, because spiders attacked prey by first going from the retreat to the hub and then to the prey. In "), _c('i', [_vm._v("L. sclopetarius")]), _vm._v(", the median attack time for a spider resting at the hub was 2 s, three times faster than than when the spider was in a retreat at the edge of the web (Heiling 2004). "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "108",
      "id": "p108",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Given the short retention times for the majority of prey stopped by orbs in the field ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03.01.01"
    }
  }, [_vm._v("section 3.3.3.1.1")]), _vm._v("), lowering the time needed to reach the hub could have a substantial impact on prey capture rates. A second likely correlation with these asymmetries is a reduction in the attenuation of vibratory signals that are transmitted along radii from the prey to the hub and then to the retreat; for instance, some failures of "), _c('i', [_vm._v("L. sclopetarius")]), _vm._v(" spiders in retreats to respond to prey may have been due to failure to sense the its presence in the web (Heiling 2004).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0316"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "477",
      "src": "images/chi-eberhard-fig0316.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p108"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.16.")]), _vm._v(" A “signal line” from the hub to the hidden retreat at the edge of the web where the spider rests during the day has been used successfully as a taxonomic character in "), _c('i', [_vm._v("Zygiella")]), _vm._v(" spp. (AR) (Gregorič et al. 2010), but the night-time orbs of mature female "), _c('i', [_vm._v("Metazygia")]), _vm._v(" (AR) illustrate the difficulty of distinguishing signal lines in other groups. The web of "), _c('i', [_vm._v("M. wittfeldae")]), _vm._v(" ("), _c('i', [_vm._v("a")]), _vm._v(", "), _c('i', [_vm._v("c")]), _vm._v(") has a relatively small hub ("), _c('i', [_vm._v("a")]), _vm._v(" is a view perpendicular to the web plane; "), _c('i', [_vm._v("c")]), _vm._v(" is from slightly from the side, with the focus on the signal line from the hub to the spider’s retreat that is slightly out of the plane of the orb, just beyond the upper edge of the web (thick arrow). Some sticky spiral lines were attached to the signal line as if to a radius, where it was closest to the plane of the orb ("), _c('i', [_vm._v("c")]), _vm._v("). In another species of this genus ("), _c('i', [_vm._v("M")]), _vm._v(". sp.) signal lines were often lacking when hubs were immediately adjacent to the spider’s retreat on a twig ("), _c('i', [_vm._v("b")]), _vm._v(") (similar to the twig webs of "), _c('i', [_vm._v("Tetragnatha")]), _vm._v(" [TET] and "), _c('i', [_vm._v("Uloborus")]), _vm._v(" [UL] in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#fig1024"
    }
  }, [_vm._v("figs. 10.24")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#fig1026"
    }
  }, [_vm._v("10.26")]), _vm._v("). In other genera such as "), _c('i', [_vm._v("Zygiella")]), _vm._v(" and "), _c('i', [_vm._v("Aculepeira")]), _vm._v(" (AR) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#fig0324"
    }
  }, [_vm._v("fig. 3.24")]), _vm._v("), spiders build in the early morning and frequently rest in retreats during the day, and the sticky spiral lines are not attached to the signal line, probably improving its ability to transmit prey vibrations to the spider. The legs RI and LI of a mature female "), _c('i', [_vm._v("M. wittfeldae")]), _vm._v(" ("), _c('i', [_vm._v("d")]), _vm._v(") also illustrate unusual positions, grasping lines at or just beyond the edge of the hub in the free zone. In contrast to many other araneids (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0010#fig0219"
    }
  }, [_vm._v("figs. 2.19b")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#fig0335"
    }
  }, [_vm._v("3.35")]), _vm._v("), legs RII, RIII, and LII grasped the outer hub loop, and the other legs grasped lines inside the hub (the arrows mark the positions of tarsi, the dots mark the outer edge of the hub). This spider readily fled to her retreat when disturbed.")])]), _vm._v(" "), _c('p', [_vm._v("Finally, there was a trend in the attack behavior of species with highly reduced webs (eight different groups in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#tab0304"
    }
  }, [_vm._v("table 3.4")]), _vm._v(") to manipulate web tensions when they attack prey. The spider did not run rapidly to the prey, but collapsed the web onto or around it before she began to bite or wrap it.")]), _vm._v(" "), _c('p', [_vm._v("In sum, a spider’s ability to capture prey is undeniably influenced by an intimate interaction between the design of her orb and her attack behavior, which is in turn influenced by her morphology. While attack behavior surely needs to be added to the biomechanical properties of silk lines and the phylogenetic relationships of different groups in comparative studies such as that of Sensenig et al. (2011) to understand orb designs, many details of how to do this are not clear. Some details of orb designs correlate with aspects of attack behavior such as "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "110",
      "id": "p110",
      "role": "doc-pagebreak"
    }
  }), _vm._v("speed or how prey are immobilized, but in general the expected correlations between orb design and attack speed (or leg length) occur only inconsistently. Attack behavior probably has further effects, but these are yet to be clarified.")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "tab0304"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th",
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "109",
      "id": "p109",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "thn"
  }, [_vm._v("Table 3.4.")]), _vm._v(" Derived attack behavior that has apparently coevolved with derived web designs.")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Spider")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Web")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Attack behavior")]), _vm._v(" "), _c('th', {
    staticClass: "tch",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("References")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Gradungulidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Progradungula carraiensis")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Small patch of sticky lines held by legs II and III ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#fig1009"
    }
  }, [_vm._v("fig. 10.9")]), _vm._v(")")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Scoop prey upward into web with anterior legs")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Gray 1983")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Theridiosomatidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Wendilgarda")]), _vm._v(" sp.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Sparse vertical lines with sticky tips attached below to a water surface ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#fig1029"
    }
  }, [_vm._v("fig. 10.29")]), _vm._v(")")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“Snow plow” attacks—gather together and move a cable of several sticky lines, sliding their tips on the water")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Coddington and Valerio 1980")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Theridiosoma")]), _vm._v(" spp, "), _c('i', [_vm._v("Epeirotypus")]), _vm._v(" spp., "), _c('i', [_vm._v("Naatlo splendida")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Ray web with spring line out of web plane that spider reels in, pulling orb into cone")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Release reeled up spring line, causing orb to spring backward when sense vibrations of nearby prey")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("McCook 1889, Comstock 1967, Shinkai and Shinkai 1985, Coddington 1986a, WE")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Araneidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Scoloderus tuberculifer")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Ladder web that is elongate above the hub ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0304"
    }
  }, [_vm._v("fig. 3.4")]), _vm._v(")")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Run past prey to get above it, then cut radii there, causing the prey to sag into contact with additional sticky lines below"), _c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Eberhard 1975")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Ocrepeira")]), _vm._v(" (= "), _c('i', [_vm._v("Wixia")]), _vm._v(") "), _c('i', [_vm._v("ectypa")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“asterisk” web of a few, short non-sticky lines that radiate from a central point spanning a fork of a branch")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Run to substrate and wrap prey that brushes against a line by rapidly circling it and the branch over and over")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Stowe 1978")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Mastophora")]), _vm._v(", "), _c('i', [_vm._v("Ordgarius")]), _vm._v(", "), _c('i', [_vm._v("Dichrostichus")]), _vm._v(", "), _c('i', [_vm._v("Cladomelea")]), _vm._v(", "), _c('i', [_vm._v("Agatostichus")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("One or a few large sticky droplets, each hanging free at the end of a single line")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Swing droplet toward nearby insect when sense vibrations")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Stowe 1986, Yeargan 1994")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Uloboridae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Hyptiotes")]), _vm._v(" spp. and "), _c('i', [_vm._v("Miagrammopes")]), _vm._v(" spp.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Spring line from apex of sector of orb or from end of one or a few sticky lines")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Release and reel up spring line repeatedly with legs IV, causing the web to collapse repeatedly around the prey")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Akerman 1932, Marples and Marples 1937, Comstock 1967, Lubin et al. 1978")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Miagrammopes")]), _vm._v(" sp.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Single vertical sticky line or lines")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Pack up long sticky line into sticky mass as descend and then apply it to the prey")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Lubin et al. 1978")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("Deinopidae")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Deinopis")]), _vm._v(" spp., "), _c('i', [_vm._v("Menneus")]), _vm._v(" spp.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Small rectangular array of parallel sticky lines on a network of highly elastic, non-sticky lines held at the corners by legs I and II")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Spread the web with legs I and II and lower it onto prey walking below, or expand it rapidly dorsally to trap prey flyng nearby; also repeatedly expand and partially collapse it after the prey is in contact to further enswathe it"), _c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Akerman 1926, Kaestner 1968, Robinson and Robinson 1971")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('sup', [_vm._v("1")]), _vm._v(" Similar behavior that causes prey to sag into additional sticky lines occurred independently in some uloborids with more or less vertical orbs (Lubin 1986), and in the non-orb theridiid "), _c('i', [_vm._v("Tidarren sisyphoides")]), _vm._v(" (G. Barrantes pers comm.).")]), _vm._v(" "), _c('p', {
    staticClass: "tn"
  }, [_c('sup', [_vm._v("2")]), _vm._v(" Robinson and Robinson hypothesized that the behavior served in addition to “straighten the net” so that it could be reused.")])])])])])])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec03.02.11"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.11"
    }
  }, [_vm._v("3.2.11 Orb movements in wind may not be generally significant in intercepting prey (but may affect orb designs)")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "chaft",
    attrs: {
      "id": "sec03.02.11.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.11.01"
    }
  }, [_vm._v("3.2.11.1 Web movements and the encounter model")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Erratic oscillatory movements in the wind could enhance the probability that a web will contact and capture nearby insects. Even if a potential prey can sense an orb web at a distance and take evasive action (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0302"
    }
  }, [_vm._v("fig. 3.2")]), _vm._v(", section 3.11), it might still have difficulty avoiding contact. Craig et al. (1985) argued that an orb’s ability to capture prey increases as a result of orb movements. Web movements are undoubtedly important in a few groups, including theridiosomatids (e.g., McCook 1889; Wiehle 1929; Coddington 1986a), "), _c('i', [_vm._v("Hyptiotes")]), _vm._v(" (UL) (Wiehle 1927; Marples and Marples 1937), and deinopids (Akerman 1926; Robinson and Robinson 1971; Coddington and Sobrevila 1987), in which spiders actively launch their webs rapidly toward nearby insects. The webs of many other species move passively in the wind. For instance, the widely spaced lax sticky lines of "), _c('i', [_vm._v("Ogulnius")]), _vm._v(" sp. (TSD) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#fig1022"
    }
  }, [_vm._v("fig. 10.22c")]), _vm._v("), when observed glinting in patches of sunlight in a tropical forest, swung erratically up to 0.8–1 cm in gentle, nearly imperceptible air movements (WE). Movements of this sort could increase the chances that the lines intercept insects. Craig et al. (1985) extended this idea to typical orbs, whose lines sag little or not at all. They argued that the passive movements when an orb sags and flutters in the wind are important, when combined with small fluctuations in an insect’s flight path, in increasing the likelihood that prey will be intercepted (the “encounter model”). Some movements of orbs that they measured were quite large, even in the gentle winds in tropical forest undergrowth; for example, the orbs of the relatively small (2.7 mg) tetragnathid "), _c('i', [_vm._v("Leucauge globosa")]), _vm._v(" moved up to 8 cm in winds of 0.05—0.1 m/s.")]), _vm._v(" "), _c('p', [_vm._v("Some subsequent reviews (e.g., Blackledge et al. 2009c, 2011) ignored the encounter model. I believe that there are serious problems with the data that were used to support the model, but that the basic idea is nevertheless important. The major empirical problem was that some (or perhaps many) of the web displacements that Craig et al. (1985) filmed and measured were artifacts. The webs were coated with white powder to make them visible in order to film their movements, and this powder surely caused the webs to sag (apparently substantially, judging by "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0417"
    }
  }, [_vm._v("fig. 4.17")]), _vm._v(" in Craig 2003). Long experience photographing powdered webs in the field leaves no doubt in my mind that greater sagging leads to larger movements in the wind. Nevertheless, further observations (below) showed that web movements were not entirely artifacts: uncoated web lines were also displaced in wind, though their movements were smaller and less consistent than those reported by Craig et al. (1985).")]), _vm._v(" "), _c('p', [_vm._v("An independent reason to wonder about the encounter model is that many spiders manipulate their orbs in exactly the opposite manner predicted by the model. The spiders tense rather than loosen their webs while they wait at the hub for prey to arrive ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#tab0403"
    }
  }, [_vm._v("table 4.3")]), _vm._v(") (section 3.4.2.3) (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#fig0334"
    }
  }, [_vm._v("figs. 3.34–3.37")]), _vm._v("); then, at the moment that a prey strikes the web, they release the tension. Tensing the web prior to prey impact would reduce the amplitude of its fluttering movements in the wind at the stage when the encounter model predicts that the spider would profit by increasing them.")]), _vm._v(" "), _c('p', [_vm._v("In sum, orb webs do at least sometimes move in the wind, but the distances are poorly documented, and web tensing behavior by the spider complicates interpretations; insect flight behavior near webs, especially under windy conditions, is also poorly known. These uncertainties led me to make a few additional, though only roughly quantitative field observations on how orbs move; the topic is complex (see also "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.12"
    }
  }, [_vm._v("section 8.4.3.2.12")]), _vm._v("), and what follows is only an exploratory sketch, not a finished study.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.11.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.11.02"
    }
  }, [_vm._v("3.2.11.2 Different types of orb web movement in the wind")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Preliminary observations in second growth in Costa Rica in the late wet season showed that orb movements in the wind occurred at four general levels: the web as a whole moved, including all the frames and anchors, due to movements of the substrate to which the anchors were attached (“substrate movements”); the web sagged and moved as a whole with respect to the supports to which the anchors were attached (“whole orb movement”); the capture area and hub moved with respect "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "111",
      "id": "p111",
      "role": "doc-pagebreak"
    }
  }), _vm._v("to the more rigid frame lines, like a sail with respect to a boom (“capture zone movement”) (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0317"
    }
  }, [_vm._v("fig. 3.17")]), _vm._v("); and the individual sticky spiral lines moved with respect to the more rigid radii to which they were attached (“sticky line movements”) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0318"
    }
  }, [_vm._v("fig. 3.18")]), _vm._v("; Triana-Cambronero et al. 2011). I will term, somewhat imprecisely, the first three categories as “entire web” movements. Recognition of these differences helps interpret some of the evidence mentioned above. The measurements of Craig et al. (1985) were of “entire web” movements, combining substrate, whole web, and capture area movements; sticky line movements were ignored. Spiders that tensed radial and hub lines while resting at the hub increased mainly radial tensions, and thus mainly reduced only capture area movements. Tensing behavior contradicted predictions regarding capture area movements, but (as will be seen below) had little relation to other web movements.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0317"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "485",
      "src": "images/chi-eberhard-fig0317.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p111"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.17.")]), _vm._v(" These three photos looking down on the same uncoated, approximately 70° web of a mature female "), _c('i', [_vm._v("Micrathena duodecimspinosa")]), _vm._v(" (AR) were taken in the afternoon when the web had accumulated detritus, making it easier to photograph, illustrate different types of web movement (only the upper frame line is clearly visible in "), _c('i', [_vm._v("a")]), _vm._v(" and "), _c('i', [_vm._v("c")]), _vm._v("). The moderate, erratic breeze of up to about 1–1.5 m/s first blew in one direction ("), _c('i', [_vm._v("a")]), _vm._v("); then was still ("), _c('i', [_vm._v("b")]), _vm._v("); and then blew briefly in approximately the opposite direction ("), _c('i', [_vm._v("c")]), _vm._v("). The bowing of the frame lines in "), _c('i', [_vm._v("a")]), _vm._v(" and "), _c('i', [_vm._v("c")]), _vm._v(" resulted from either whole web or substrate movements; it was greater than it appears because the anchor lines extended substantially beyond edges of the photos. The capture zone tended to curve more strongly than did the frame lines, due to “capture zone movements.” Places where the curve of the capture zone was not smooth in "), _c('i', [_vm._v("a")]), _vm._v(" and "), _c('i', [_vm._v("c")]), _vm._v(" were perhaps due to irregularities in air flow(?). Curves in some individual sticky spiral lines that were moving are also evident in "), _c('i', [_vm._v("a")]), _vm._v(".")])]), _vm._v(" "), _c('p', [_vm._v("Setting aside for the moment sticky line movements, gentle breezes (gusts of only about 1 m/s) displaced uncoated orbs of adult female "), _c('i', [_vm._v("Micrathena duodecimspinosa")]), _vm._v(" (AR) up to 1–2 cm. The orbs of this species generally have only three, relatively long anchor lines (typically each was approximately 1–2 times as long as the diameter of the capture zone). In stronger winds with gusts of about 5 m/s, webs moved up to about 5 cm ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0317"
    }
  }, [_vm._v("fig. 3.17")]), _vm._v("; WE). The web of a small, probably second instar spiderling (the first instar outside the egg sac) of this species moved up to 2–3 cm in weaker gusts of up to approximately 0.6 m/s. In addition to capture zone movements, these web movements included substrate and whole web movements: frame and anchor lines were curved in photos ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0317"
    }
  }, [_vm._v("fig. 3.17")]), _vm._v("); and in some cases leaves and other objects to which anchor lines were attached moved. When adult females were induced to walk away from the hub "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "112",
      "id": "p112",
      "role": "doc-pagebreak"
    }
  }), _vm._v("(where they had been tensing their webs), the distances that their webs moved in the wind did not change perceptibly. These wind velocities were 10–100 times higher than those in the encounter model study (Craig et al. 1985); uncoated "), _c('i', [_vm._v("M. duodecimspinosa")]), _vm._v(" orbs were relatively immobile at lower wind velocities.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0318"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "549",
      "src": "images/chi-eberhard-fig0318.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p112"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.18.")]), _vm._v(" The photos in "), _c('i', [_vm._v("a")]), _vm._v(" and "), _c('i', [_vm._v("b")]), _vm._v(" illustrate effects of gentle wind on uncoated lines near the edge of a newly constructed orb of a mature female "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(" (TET). The sticky spiral lines were bowed slightly by a weak (estimated <1 kmph) breeze ("), _c('i', [_vm._v("a")]), _vm._v("); damage occurred at two points where sticky lines adhered to each other or to a small piece of detritus when the same lines were blown somewhat more strongly ("), _c('i', [_vm._v("b")]), _vm._v(") (a weaker wind was blowing in a different direction when photo "), _c('i', [_vm._v("b")]), _vm._v(" was taken). The photos illustrate several points: the sticky spiral lines bowed much more strongly in the wind than did the radii; wind damage resulted when the fluttering movements of two segments of sticky line brought them into contact in their middle portions (a common pattern in relatively long segments in webs in the field); the irregular nature of the “fluttering” movements of the sticky lines in the wind introduces an element of chance in determining which lines will adhere to each other (note that the longest two segments did not stick to each other); small bits of detritus can increase the chances of adhesion damage, both because the detritus can project toward an adjacent line and because the weight of the detritus will increase the amplitudes of fluttering movements; and weak winds are often irregular in direction (compare "), _c('i', [_vm._v("a")]), _vm._v(" and "), _c('i', [_vm._v("b")]), _vm._v("). Still another type of damage occurred in the horizontal orb of "), _c('i', [_vm._v("Tetragnatha")]), _vm._v(" sp. (#517) when multiple sticky lines adhered to a frame line ("), _c('i', [_vm._v("c")]), _vm._v("). Wind sometimes produced damage of this sort when the frame line sagged briefly as a result of the supporting structures to which it was attached moving toward each other.")])]), _vm._v(" "), _c('p', [_vm._v("The orbs of other species at the same site moved in different ways under similar wind velocities. The orbs of mature females of "), _c('i', [_vm._v("Cyclosa jose")]), _vm._v(" (AR) and "), _c('i', [_vm._v("Allocyclosa bifurca")]), _vm._v(" (AR), which had more numerous and relatively shorter anchor lines (much less than the diameter of the capture zone) and that were consistently attached to relatively rigid supports, scarcely moved (though the egg sac + detritus stabilimenta [see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0014#fig0341"
    }
  }, [_vm._v("figs. 3.41")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#fig0741"
    }
  }, [_vm._v("7.41")]), _vm._v("] of these species vibrated with low amplitudes). Similarly, the orb of a mature female "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" (NE), which also had relatively short anchor and frame lines, moved very little in similar breezes. The orbs of mature females of still another species, "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(" (TET), which were slanted 30–60° with horizontal, moved with intermediate amplitudes. In gusts of about 1 m/s, mature females resting at the hubs of orbs moved up and down an estimated 5–10 mm. Some of these webs were attached to leaves that moved, so substrate movement may have been responsible for some of these movements. The webs of "), _c('i', [_vm._v("L. mariana")]), _vm._v(" were nearly immobile in low velocity breezes (est. <0.3 m/s).")]), _vm._v(" "), _c('p', [_vm._v("Sticky spiral movements occurred in lower wind velocities, including even very light, nearly imperceptible wind (<0.3 m/s) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0318"
    }
  }, [_vm._v("fig. 3.18")]), _vm._v("). The magnitudes of the displacements of the central portions of the longer segments of sticky lines in the webs of "), _c('i', [_vm._v("L. mariana")]), _vm._v(" were on the order of the distances between attachments of these loops to the radii in estimated 0.6–1.1 m/s winds. The amplitudes of sticky spiral line movements relative to the spaces between them were smaller in the other species.")]), _vm._v(" "), _c('p', [_vm._v("In sum, under some conditions in nature, the orbs of some species moved erratically up to a cm or more. Webs also moved at more usual wind conditions (at least at this particular site and season), but the amplitudes of entire orb movements were on the order of only one mm. Sticky spiral movements were greater in "), _c('i', [_vm._v("L. mariana")]), _vm._v(" than in the other species, and occurred even at low wind velocities.")])]), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "sec03.02.11.03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.11.03"
    }
  }, [_vm._v("3.2.11.3 Orb movements in the wind: are they important?")])]), _vm._v(" "), _c('section', [_c('h5', {
    staticClass: "dhaft",
    attrs: {
      "id": "sec03.02.11.03.01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.11.03.01"
    }
  }, [_vm._v("3.2.11.3.1 Prey capture")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The significance of the different web movements just described for intercepting prey probably depends on several presently little-studied factors, including the sizes, flight paths, and speeds of important prey insects in the field (section 3.11). The focus probably needs to be on possible evasive movements by large prey that may "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "113",
      "id": "p113",
      "role": "doc-pagebreak"
    }
  }), _vm._v("be rendered ineffectual by web movements, rather than on the less nutritionally important small prey that are capable of flying through the openings of the orb (Craig et al. 1985) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#sec03.02"
    }
  }, [_vm._v("section 3.2")]), _vm._v("). The magnitude of entire web movements per se may not be as important as their velocities relative to the velocities of potential prey as they maneuver in the wind to avoid the web. Similarly, it is not the magnitude of web responses to occasional gusts of wind (as in web damage—see next section), but the mean magnitudes of movements of uncoated webs, and not what happens on a single windy day but what occurs on average days. Data are apparently lacking on these topics, so it is uncertain whether entire web movements increase prey capture.")]), _vm._v(" "), _c('p', [_vm._v("The possible consequences of fluttering sticky line movements for prey capture have never to my knowledge been examined. Sticky spiral movements could play an important role in prey capture in some species but not others: they would seem especially likely to have effects on slowly flying prey, for smaller and more maneuverable prey, and in the outer portions of the orb where the sticky lines are longer. In still air and with well-lit webs, small flies turned away at distances of up to 5 mm from the web, or slowly approached closer, touched the web with only a single extended leg, and then rapidly accelerated away (Craig 1986) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0302"
    }
  }, [_vm._v("fig. 3.2")]), _vm._v("). Thus the behavior of both insect prey and sticky web lines is such that the encounter model could apply, but further information is needed to judge the possible biological importance of the encounter model for sticky line movements.")]), _vm._v(" "), _c('p', [_vm._v("Incidentally, sticky line movements of a different sort may sometimes increase the ability of lines to intercept prey. The sticky spiral lines of the araneid "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" were deflected toward several types of insect prey (and water droplets) that had been experimentally charged with static electricity (Ortega-Jiménez and Dudley 2013), thus increasing the web’s interception and adhesive properties. At least some insects become charged (up to several hundred volts) when they fly, due to friction with air molecules (Colin et al. 1991; Vaknin et al. 2000), so this effect may be biologically significant. Again, this effect is most likely to be important in longer segments of sticky lines, and ones that are under lower tensions.")]), _vm._v(" "), _c('p', [_vm._v("In sum, the possible importance of the encounter model for prey capture, both for entire web movements, and for sticky line movements, is still uncertain; but it cannot be ruled out, and it could be important for a variety of orb traits.")])]), _vm._v(" "), _c('section', [_c('h5', {
    staticClass: "dh",
    attrs: {
      "id": "sec03.02.11.03.02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.11.03.02"
    }
  }, [_vm._v("3.2.11.3.2 Web damage")])]), _vm._v(" "), _c('p', [_vm._v("Orbs gradually accumulate several types of damage in the field ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0319"
    }
  }, [_vm._v("fig. 3.19")]), _vm._v("). Substrate movements, even though brief, can cause multiple adhesions in large sectors of an orb, and thus alter the geometrically regular patterns of the original orb ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0318"
    }
  }, [_vm._v("fig. 3.18c")]), _vm._v("). Damage can result when the attachment point of an anchor line moves inward toward the rest of the orb, and reduces the tensions on many lines (Triana-Cambronero et al. 2011), or when sticky lines swing toward other lines and adhere to them when they flutter in the wind. The apparent preferences that some species show for more rigid attachment sites ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0022#sec08.04.03.02.02"
    }
  }, [_vm._v("section 8.4.3.2.2")]), _vm._v(") are probably adaptations to reduce substrate movement damage. The tangle built above the horizontal orbs of juvenile "), _c('i', [_vm._v("Leucauge argyra")]), _vm._v(" (TET) that tenses the orb with lines connected to the hub ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#fig1003"
    }
  }, [_vm._v("fig. 10.3")]), _vm._v(") (Triana-Cambronero et al. 2011) could have a similar function.")]), _vm._v(" "), _c('p', [_vm._v("A second type of damage can occur during whole orb and capture area movements, when some lines move relative to others, and sticky lines contact other lines such as frames ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0318"
    }
  }, [_vm._v("figs. 3.18"), _c('i', [_vm._v("c")])]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0026#fig1004"
    }
  }, [_vm._v("10.4")]), _vm._v("). Still another type of damage can result from sticky line movements when individual lines flutter in the wind. Fluttering sticky lines can contact other web lines and adhere to them (e.g., the “central adhesion damage” when sticky spiral lines make contact in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0318"
    }
  }, [_vm._v("figs. 3.18")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0319"
    }
  }, [_vm._v("3.19")]), _vm._v(") and even when tensions on other web lines are unaltered.")]), _vm._v(" "), _c('p', [_vm._v("The probabilities of these different types of contact depend on whether different lines in the orb move independently of each other, and on the amplitudes of such independent movements (which will in turn depend on the tensions on the lines and on their lengths). The danger of adhesions between web lines due to wind could thus affect selection acting on the distance between sticky spiral and frame lines, sticky spiral tensions, the lengths of sticky spiral segments (the distances between radii), and the spaces between adjacent loops. The general topic of damage from adhesions has received very little empirical attention (see, however, the “sticky spiral entanglement” hypothesis in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.02.04"
    }
  }, [_vm._v("section 4.3.2.4")]), _vm._v("), and I can give only a preliminary sketch of possibly important points.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0319"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "429",
      "src": "images/chi-eberhard-fig0319.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p114"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.19.")]), _vm._v(" It is useful to look at orbs from different angles. In contrast with nearly all of the other photos of freshly built and undamaged webs in this book (and in most of the published literature), this uncoated web of a mature female "), _c('i', [_vm._v("Micrathena duodecimspinosa")]), _vm._v(" was photographed late in the day (5:30 PM), after it had been up for about 11 hrs on a moderately windy day (with occasional gusts of up to perhaps 3 m/s). The web (seen from above) had numerous holes and contained many small bits of detritus. At least some of the holes were made by the spider herself as she removed larger bits of detritus that had blown into her web (she removed another piece soon after the photo was taken). Several types of damage can be seen: "), _c('i', [_vm._v("a")]), _vm._v(") “central adhesions” between adjacent segments of sticky spiral (see also "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0318"
    }
  }, [_vm._v("fig. 3.18")]), _vm._v("); "), _c('i', [_vm._v("b")]), _vm._v(") adhesions of sticky spiral lines to radii; "), _c('i', [_vm._v("c")]), _vm._v(") breakage of sticky spiral lines; "), _c('i', [_vm._v("d")]), _vm._v(") breakage of radii; "), _c('i', [_vm._v("e")]), _vm._v(") lateral displacements of radii to contact other radii; and "), _c('i', [_vm._v("f")]), _vm._v(") loading of the web by detritus. How well a web stands up under such a beating will obviously affect its ability to trap prey, but the patterns of web damage in nature are virtually unstudied, and even very basic questions remain to be answered. How common are the different types of damage, and what causes them? Are the different types of damage randomly distributed in different parts of orbs in the field? Do they vary with the slant of the web? with the rigidity of the supports to which the anchors are attached?")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "114",
      "id": "p114",
      "role": "doc-pagebreak"
    }
  }), _vm._v("The sticky lines are slack in some species that build orbs or derivatives of orbs, and form more or less shallow catenaries. These lines would be especially susceptible to damage from sticky line movements. Catenaries occured, for example, in the finished orb webs of "), _c('i', [_vm._v("Anapisona simoni")]), _vm._v(" (AN) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0020#fig0709"
    }
  }, [_vm._v("figs. 7.9")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0024#fig0904"
    }
  }, [_vm._v("9.4")]), _vm._v("), "), _c('i', [_vm._v("Conculus lyugadinus")]), _vm._v(" (Shinkai and Shinkai 1988), and "), _c('i', [_vm._v("Metabus ocellatus")]), _vm._v(" (TET) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0021#fig0743"
    }
  }, [_vm._v("fig. 7.43")]), _vm._v(") (WE). Slack sticky lines also occur in some reduced webs derived from orb, including those of "), _c('i', [_vm._v("Pasilobus")]), _vm._v(" sp. (Robinson and Robinson 1975), "), _c('i', [_vm._v("Poecilopachys australasia")]), _vm._v(" (Clyne 1973), "), _c('i', [_vm._v("Ogulnius")]), _vm._v(" (TSM) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#fig1022"
    }
  }, [_vm._v("fig. 10.22")]), _vm._v("), and "), _c('i', [_vm._v("Mysmena")]), _vm._v(" (MYS) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0027#fig1021"
    }
  }, [_vm._v("fig. 10.21")]), _vm._v(") (the webs of "), _c('i', [_vm._v("Ogulnius")]), _vm._v(" and "), _c('i', [_vm._v("Mysmena")]), _vm._v(" were coated with powder for photography, but uncoated sticky lines also sagged in both species [WE]). Only the outermost sticky spiral loop of an uncoated "), _c('i', [_vm._v("Epeirotypus brevipes")]), _vm._v(" (TMS) orb sagged perceptibly in still air, but other loops also sagged in very weak, scarcely perceptible air movements (WE). On the other hand, published photographs of uncoated orbs show no perceptible catenaries in several other species, including "), _c('i', [_vm._v("Nephila edulis")]), _vm._v(" (NE) (Hesselberg and Vollrath 2012), "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" (AR) (except under the influence of methamphetamine) (Hesselberg and Vollrath 2004), "), _c('i', [_vm._v("Eustala illicita")]), _vm._v(" (AR) (Hesselberg and Triana 2010), and "), _c('i', [_vm._v("Cyclosa caroli")]), _vm._v(" (AR) (Hesselberg 2013); the segments of the sticky spiral formed straight lines between attachments to radii. Catenaries were also lacking under windless conditions in even the longest sticky spiral segments of adult females of the Costa Rican species "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(" (TET), "), _c('i', [_vm._v("Allocyclosa bifurca")]), _vm._v(" (AR), "), _c('i', [_vm._v("Cyclosa jose")]), _vm._v(" (AR), "), _c('i', [_vm._v("Gasteracantha cancriformis")]), _vm._v(" (AR), "), _c('i', [_vm._v("Argiope argentata")]), _vm._v(" (AR), "), _c('i', [_vm._v("Micrathena duodecimspinosa")]), _vm._v(" (AR), and "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "115",
      "id": "p115",
      "role": "doc-pagebreak"
    }
  }), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" (NE) (WE). Thus, despite the fact that low tensions on sticky lines would seem likely to be advantageous in both stopping and retaining prey (they would increase the abilities of the lines to absorb stress without breaking) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#tab0301"
    }
  }, [_vm._v("table 3.1")]), _vm._v("), distinctly slack sticky lines are probably the exception rather than the rule among orb weavers, perhaps to reduce damage from sticky line movements in the wind.")]), _vm._v(" "), _c('p', [_vm._v("Nevertheless, tensions on the sticky lines were low enough in all of the Costa Rican species that even straight sticky lines sagged and moved in light breezes on the order of 0.6 m/s or less ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0318"
    }
  }, [_vm._v("fig. 3.18a")]), _vm._v("). Similar bowing in a light wind occurred even in short segments of the sticky spiral in the webs of "), _c('i', [_vm._v("Cyclosa turbinata")]), _vm._v(" and "), _c('i', [_vm._v("L. venusta")]), _vm._v(" (WE). Qualitative evaluations indicated that in comparable winds, the sticky lines moved more (relative to the distances between them) in the webs of "), _c('i', [_vm._v("L. mariana")]), _vm._v(" and "), _c('i', [_vm._v("G. cancriformis")]), _vm._v(", less in those of "), _c('i', [_vm._v("M. duodecimspinosa")]), _vm._v(", "), _c('i', [_vm._v("A. argentata")]), _vm._v(", and "), _c('i', [_vm._v("A. bifurca")]), _vm._v(" (AR), and least in those of "), _c('i', [_vm._v("N. clavipes")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("The sticky spiral segments in an orb tended to all sag in the same direction and in synchrony at low wind velocities ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0318"
    }
  }, [_vm._v("fig. 3.18")]), _vm._v("), and did not contact other lines; but at higher velocities (perhaps accompanied by increased turbulence, which was not measured), adjacent sticky lines often fluttered independently. When a segment of sticky line was long enough, and the bowing was substantial enough, the fluttering movements eventually brought adjacent lines into contact with each other, resulting in adhesion to an adjacent frame or radius (“adhesion damage”) (Fig 3.18b). Larger numbers of sticky lines suffered adhesion damage at higher wind velocities. These adhesions opened up holes in the array of sticky lines, reducing the geometric regularity that is probably a key trait of orbs favored by natural selection ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0013#sec03.03.03"
    }
  }, [_vm._v("section 3.3.3")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("Adhesion damage from wind has several important traits. Because a single touch is sufficient to cause a sticky line to adhere to another, it is not the mean wind velocity, but rather sudden changes in direction and the maximum velocities in irregular gusts (the “threads of stronger wind among lesser air movements”—Geiger 1965; p. 120) that determine the amount of damage done. The importance of extremes for damage contrasts with the effects of web movements on prey interception, where mean velocity is probably more important. A second difference is that winds that are more nearly parallel to the plane of the orb may be more likely to produce adhesion damage (though experimental data are lacking). Assuming that wind direction tends to be approximately horizontal, this would mean that more nearly horizontal orbs may be more susceptible to adhesion damage. Again, this contrasts with damage from movements of the entire web or most of it caused by drag in the wind, which seem likely to be greatest when the wind direction is perpendicular rather than parallel to the orb plane and to be greater in more nearly vertical orbs (Craig et al. 1985). One further complication is that a small piece of detritus that adheres to a single line can increase the likelihood of contact with adjacent lines in the wind ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0318"
    }
  }, [_vm._v("fig 3.18b")]), _vm._v("), but probably has little effect on prey capture.")]), _vm._v(" "), _c('p', [_vm._v("Although there are no quantitative studies of variation in these sorts of wind damage, preliminary observations suggest that even moderate winds can produce adhesion damage under natural conditions ("), _c('i', [_vm._v("a")]), _vm._v(" in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0319"
    }
  }, [_vm._v("fig. 3.19")]), _vm._v("). About 29% of 191 "), _c('i', [_vm._v("U. diversus")]), _vm._v(" webs spun on a given morning had at least an estimated 10% of the surface missing by late in the afternoon (Eberhard 1971a; wind damage was not distinguished, however, from other types).")]), _vm._v(" "), _c('p', [_vm._v("Many factors seem likely to affect the frequency with which adhesion damage will occur, including those in the following, probably incomplete list: tension on the sticky lines; the lengths of the segments of sticky lines (which of course vary widely in a given orb—see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03"
    }
  }, [_vm._v("section 4.3")]), _vm._v("); the distances between sticky lines; the angles of the wind with the plane of the orb; turbulence in air flow patterns (greater turbulence might increase the likelihood of sticky line contact); small scale irregularities in air velocities (which are common in nature) (Geiger 1965); the sizes of the glue droplets on the lines (Wu et al. 2013) (larger droplets tend to produce greater friction with the air, and thus greater bowing of lines) (Zaera et al. 2014); the extensibility of the lines themselves (greater extension under loading from the wind can result in reduction of the distances between lines and in additional friction); the time of day (for example, wind speeds near the ground tend to increase during the morning, and tend to be lower at night) (Geiger 1965); height over the ground (in the first several meters above the ground, wind speeds tend to increase as an exponential function of the height above the ground) (Geiger 1965); the presence of small pieces of detritus adhering to individual sticky "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "116",
      "id": "p116",
      "role": "doc-pagebreak"
    }
  }), _vm._v("lines ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0318"
    }
  }, [_vm._v("fig. 3.18")]), _vm._v("); and the rigidity of the supports to which the web is attached (greater flexibility and displacement of the supports will increase the chances of damage). At a larger scale, different environments also surely differ with respect to wind velocities (see Liao et al. 2009 on "), _c('i', [_vm._v("Cyclosa mulmeinensis")]), _vm._v(" and "), _c('i', [_vm._v("ginnaga")]), _vm._v(" in seashore vs. forest habitats, Tew and Hesselberg 2017).")]), _vm._v(" "), _c('p', [_vm._v("One further aspect of damage is the web maintenance behavior of spiders, including repair of damaged orbs to apparently avoid further damage. One aspect of web maintenance is removing fallen detritus such as leaves, flower petals, etc. from the web (Robinson and Robinson 1973a; Pasquet et al. 2007). Detritus removal entails the metabolic cost of the activity, the danger of breaking crypsis or emerging from a sheltered retreat, and the damage to the sticky spiral (the “tracks”—"), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#fig0419"
    }
  }, [_vm._v("fig. 4.19")]), _vm._v(") made by the spider as she moves across her orb. Removal of detritus is apparently important, as it often occurred within a few seconds after an object hit the web in "), _c('i', [_vm._v("Z. x-notata")]), _vm._v(" (AR) (Pasquet et al. 2007) and "), _c('i', [_vm._v("Leucauge mariana")]), _vm._v(" (TET) (Briceño and Eberhard 2011). The likely benefits include increased physical stability for the web, especially from stess as the detritus swings under windy conditions (Langer 1969), and possible defense against some predators (Pasquet et al. 2007 on the generalist vespid wasp predator, "), _c('i', [_vm._v("Vespula germanica")]), _vm._v("). Detritus is probably more often a problem in more nearly horizontal webs, but I know of no comparative empirical measurements.")]), _vm._v(" "), _c('p', [_vm._v("A preliminary list of possible examples of different aspects of orb design that affect an orb’s susceptibility to wind damage and are modified by spiders in response to wind includes the following. Captive "), _c('i', [_vm._v("Cyclosa mulmeinensis")]), _vm._v(" (AR) spiders that had experienced moderate, persistent wind (about 1.14 m/s) built orbs that were smaller and had fewer but stronger major ampullate lines; their drag in 1.14 m/s wind was reduced (Liao et al. 2009). The orbs of similarly wind-exposed spiders also had smaller capture areas, and shorter and more widely spaced sticky spiral lines with larger glue droplets (Wu et al. 2013). Wind during construction also induced "), _c('i', [_vm._v("Araneus diadematus")]), _vm._v(" (AR) to build smaller and rounder webs, with fewer, more widely spaced sticky spiral loops (Hieber 1984; Vollrath et al. 1997) (wind speeds in the two studies were 1.2 m/s and 0.5 m/s, respectively). Wind induced no changes in web design, however, in "), _c('i', [_vm._v("A. gemmoides")]), _vm._v(", other than a tendency to orient their approximately vertical orbs more nearly parallel to the wind (which could also reduce damage) (Hieber 1984).")]), _vm._v(" "), _c('p', [_vm._v("Field comparisons between "), _c('i', [_vm._v("Uloborus diversus")]), _vm._v(" (UL) spiders of different sizes showed that smaller individuals (with weaker webs) built more nearly horizontal webs, that they were closer to the ground, and that similarly-sized spiders in more windy habitats built smaller and more nearly horizontal webs (Eberhard 1971a). Field data in another species, however, showed few correlations with wind. When several aspects of orb designs (including web slant, orientation, area, height above the ground, the vertical asymmetry of the capture zone, and the vertical diameters of the capture zone, the hub, and the free zone) were compared between a windy and a less windy site (mean wind velocities were 1.30 ± 0.13 and 0.03 ± 0.13 m/s) in large samples of "), _c('i', [_vm._v("Metellina mengei")]), _vm._v(" webs (N = 430, 279), there were no differences in mean values or in variances, other than that webs were built higher above the ground in the sheltered habitat (Tew and Hesselberg 2017).")]), _vm._v(" "), _c('p', [_vm._v("There is other, less direct evidence that also suggests that wind can be important: the common limitation of the webs of some symphytognathoids, which have strongly sagging sticky lines, to microhabitats in the litter layer of forests (WE); the choice of relatively windless nights by "), _c('i', [_vm._v("Pasilobus")]), _vm._v(" sp. (Robinson and Robinson 1975) and "), _c('i', [_vm._v("Poecilopachys australasia")]), _vm._v(" (Clyne 1973) to build their webs (which also have long, strongly sagging sticky lines) (Robinson and Robinson 1975). Avoidance of wind damage to sticky lines may also help explain the general trend in orb web designs for the spaces between adjacent loops of sticky spiral to be greater near the outer edge of the orb and thus avoid adhesion damage even though they are longer (the “sticky line entanglement” hypothesis in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0015#sec04.03.02.04"
    }
  }, [_vm._v("section 4.3.2.4")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("In sum, the effects of web movements in the wind on prey capture and web damage are poorly documented. Selection to reduce wind damage undoubtedly varies greatly in intensity, and could affect numerous web traits. The absolute values of variables such as wind speeds, the distances that lines are displaced, the spaces between lines, and the heights above the ground likely affect the relative importance of these different factors for different species. The current lack of quantitative studies correlating these factors and wind damage makes it impossible to judge their relative importance in nature, and "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "117",
      "id": "p117",
      "role": "doc-pagebreak"
    }
  }), _vm._v("of wind damage in general; but wind damage is probably often substantial ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0319"
    }
  }, [_vm._v("fig. 3.19")]), _vm._v("). More precise measurements under more controlled conditions are needed, as are further field surveys including measurements of the frequencies of different types of damage in the field.")])])])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "sec03.02.12"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0008#rsec03.02.12"
    }
  }, [_vm._v("3.2.12 Prey are not defenseless: protection from the spider’s own prey")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("I include the topic of the danger to the spider from her own prey (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0320"
    }
  }, [_vm._v("fig. 3.20")]), _vm._v(") not because it has been well-studied, but because it seems to have hardly been discussed at all. There are nevertheless abundant data showing that danger from prey affects spider attack behavior, and it is reasonable to ask whether this danger has also influenced their web designs.")]), _vm._v(" "), _c('p', [_vm._v("The starting point is that it is very common for spiders to refrain from attacking some prey, or to make less than maximally rapid attacks after prey have been stopped and are entangled in the web. The frequencies of non-attacks are surprisingly high in a wide variety of different species. In riparian populations of the funnel web agelenid "), _c('i', [_vm._v("Agelenopsis aperta")]), _vm._v(", 41% of the prey that struck webs were not attacked (Riechert and Łuczak 1982). In the aerial sheet web linyphiid "), _c('i', [_vm._v("Linyphia triangularis")]), _vm._v(" in the undergrowth in a mixed deciduous wood in England, the corresponding figure was 17.7% of 581 prey that entered webs (Turnbull 1960). In three species inhabiting standstone rock faces, the funnel web agelenid "), _c('i', [_vm._v("Coelotes montanus")]), _vm._v(", the gumfoot tangle web theridiid "), _c('i', [_vm._v("Parasteatoda")]), _vm._v(" (= "), _c('i', [_vm._v("Achaearanea")]), _vm._v(") "), _c('i', [_vm._v("tepidariorum")]), _vm._v(", and the orb-weaving araneid "), _c('i', [_vm._v("Araneus cavaticus")]), _vm._v(", >50% of the individual prey of a given taxonomic group that entered the webs were not attacked in 9 of 20 comparisons that were made for the different taxonomic groups of prey that were important in the spider’s diet (Riechert and Łuczak 1982). Of 25 large acridid grasshoppers (with large mandibles and spiny posterior legs) that were placed in the webs of "), _c('i', [_vm._v("Nephila pilipes")]), _vm._v(" (= "), _c('i', [_vm._v("maculata")]), _vm._v(") (NE), nearly half (12) escaped during the spider’s slow, cautious attacks (Robinson and Robinson 1973a) (in some cases the spider’s first response was to flee). Bristowe (1941) noted that caution in attacks was especially common in tetragnathids and linyphiids. Given that large prey are rare and thought to be especially important in determining a spider’s survival and fitness (Venner and Casas 2005; Blackledge 2011; Evans 2013), these losses of large prey are especially dramatic.")]), _vm._v(" "), _c('p', [_vm._v("These dangers are not just hypothetical. The most commonly reported observation in this respect is the frequent reluctance of web spiders to attack large, dangerous prey ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chieberhard0012#fig0320"
    }
  }, [_vm._v("fig. 3.20"), _c('i', [_vm._v("b")])]), _vm._v("). In "), _c('i', [_vm._v("N. pilipes")]), _vm._v(" smaller, less well-armed prey were generally attacked more quickly (Robinson "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "118",
      "id": "p118",
      "role": "doc-pagebreak"
    }
  }), _vm._v("and Robinson 1973a). In general, attacks by orb weavers on more dangerous (larger or more heavily armed) prey tended to include slower, more hesitant approaches, more frequent pauses during the approach with apparent attempts to gather further information (e.g., jerk the web), raising the anterior legs away from the prey when biting it, biting and then backing away from the prey, and initiating wrapping from a greater distance (e.g., Robinson and Olazarri 1971; Robinson and Robinson 1973a; Lubin 1980). "), _c('i', [_vm._v("Argiope")]), _vm._v(" spp. (AR), which are at less risk because they wrap prey from a distance rather than biting them, attacked large prey more rapidly than did "), _c('i', [_vm._v("Nephila")]), _vm._v(" spp., which attacks prey by biting (Robinson et al. 1969; Robinson and Mirick 1971; Robinson and Robinson 1973a; Robinson 1975).")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig0320"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "282",
      "src": "images/chi-eberhard-fig0320.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p117"
    }
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("Fig. 3.20.")]), _vm._v(" Prey in webs can be dangerous. The predicament of a mature female "), _c('i', [_vm._v("Allocyclosa bifurca")]), _vm._v(" (AR), whose leg II was trapped in the powerful grip of the hind leg of a chalcidid wasp (probably "), _c('i', [_vm._v("Conura")]), _vm._v(") ("), _c('i', [_vm._v("a")]), _vm._v("), illustrates the dangers that an orb weaver must confront when she attacks a prey. The largely blind spider must make intimate contact with potentially dangerous insects that are in unpredictable orientations in order to bite and wrap them. The general importance of dangers from prey is suggested by the frequent hesitancy and apparent caution with which orb weavers attack some insects that is illustrated in "), _c('i', [_vm._v("b")]), _vm._v(". This penultimate female "), _c('i', [_vm._v("Nephila clavipes")]), _vm._v(" (NE) approached and repeatedly tapped a large solitary bee that had been stopped and retained by her web; but after >8 min of tapping, she returned to the hub without attacking it.")])])])])])])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9780226534749',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(154)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(156);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 156 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.6627e836f7e094195808.js